webpackJsonp([1],Array(18).concat([
/* 18 */
/***/ (function(module, exports) {


    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"User"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstname"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"lastname"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"email"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"fullname"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"avatar"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"phone"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"skype"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"icq"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"birthday"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"isAdmin"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"telegramUserId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"amoId"},"arguments":[],"directives":[]}]}}],"loc":{"start":0,"end":195}};
    doc.loc.source = {"body":"fragment UserFragment on User {\n    firstname,\n    lastname,\n    email,\n    id,\n    fullname,\n    avatar,\n    phone,\n    skype,\n    icq,\n    birthday,\n    isAdmin,\n    telegramUserId,\n    amoId\n}","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

      module.exports = doc;
    


/***/ }),
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return apiDomain; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return storageUrl; });
/* unused harmony export apiVersion */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return loginUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return remindEmailUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return resetPasswordUrl; });
/* unused harmony export userUrl */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return graphQlUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return exportUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return socketUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return yandexGeoCodeApiKey; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getHeader; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getAuthUser; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return logout; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__router__ = __webpack_require__(116);

var host = 'dev.alarmplan.ru';
var socketPort = '8888';
if (false) {
  host = 'dev.alarmplan.ru';
  socketPort = '8886';
}
if (true) {
  host = 'alarmplan.ru';
}
var apiDomain = 'https://' + host + '/';
var storageUrl = 'https://' + host;
var apiVersion = 'api/';
var loginUrl = apiDomain + apiVersion + 'login';
var remindEmailUrl = apiDomain + apiVersion + 'remind/email';
var resetPasswordUrl = apiDomain + apiVersion + 'reset/email';
var userUrl = apiDomain + apiVersion + 'user';
var graphQlUrl = apiDomain + 'graphql';
var exportUrl = apiDomain + apiVersion + 'orders/export-to-excel';
var socketUrl = host + ':' + socketPort;
var yandexGeoCodeApiKey = 'e9b992f7-8b3d-4557-938b-15e79ea38fa7';

var getHeader = function getHeader() {
  var authUser = null;
  if (window.localStorage.getItem('authUser')) {
    authUser = JSON.parse(window.localStorage.getItem('authUser'));
  } else {
    authUser = JSON.parse(window.sessionStorage.getItem('authUser'));
  }

  if (authUser) {
    var headers = {
      'Accept': 'application/json',
      'X-Api-Token': authUser.access_token
    };
    return headers;
  } else {
    return false;
  }
};
var getAuthUser = function getAuthUser() {
  var authUser = null;
  if (window.localStorage.getItem('authUser')) {
    authUser = JSON.parse(window.localStorage.getItem('authUser'));
  } else {
    authUser = JSON.parse(window.sessionStorage.getItem('authUser'));
  }

  return authUser;
};
var logout = function logout() {
  window.localStorage.removeItem('authUser');
  window.sessionStorage.removeItem('authUser');
  __WEBPACK_IMPORTED_MODULE_0__router__["a" /* default */].push({ name: 'Auth' });
};

/***/ }),
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */
/***/ (function(module, exports) {


    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrderFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Order"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"date"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"time"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"datetime"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"created"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"description"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"clientName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"clientPhone"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"sum"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"profit"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"status"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"class"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"code"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"sort"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"transitions"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"code"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"class"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"default"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"techcenter"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"address"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"color"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"city"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"company"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"canView"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"phone"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"user"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"firstname"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"lastname"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"commentsCount"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"commentsCountUnviewed"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"canOrderUpdate"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"canOrderAddComments"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"canOrderViewComments"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"canOrderToClose"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"canOrderDelete"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"canOrderUpdateStatus"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"canOrderFinanceControl"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"canViewCallHistory"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"problem"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"problemCause"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"canceled"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"cancelCause"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"movedOrder"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"techcenter"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"address"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"color"},"arguments":[],"directives":[]}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"closed"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"amoId"},"arguments":[],"directives":[]}]}}],"loc":{"start":0,"end":1063}};
    doc.loc.source = {"body":"fragment OrderFragment on Order {\n    id,\n    date,\n    time,\n    datetime,\n    created,\n    description,\n    clientName,\n    clientPhone,\n    sum,\n    profit,\n    status{\n        name,\n        class,\n        code,\n        sort,\n        id\n    },\n    transitions {\n        name\n        code\n        class\n        default\n    },\n    techcenter{\n        id,\n        address,\n        color,\n        name,\n        city{\n            name,\n            id\n        },\n        company{\n            name,\n            id\n        }\n        canView\n        phone\n    },\n    user{\n        id\n        firstname,\n        lastname\n    }\n    commentsCount,\n    commentsCountUnviewed,\n    canOrderUpdate,\n    canOrderAddComments,\n    canOrderViewComments,\n    canOrderToClose,\n    canOrderDelete,\n    canOrderUpdateStatus,\n    canOrderFinanceControl,\n    canViewCallHistory,\n    problem,\n    problemCause,\n    canceled,\n    cancelCause,\n    movedOrder{\n        id\n        techcenter{\n            id,\n            address,\n            color,\n        },\n    },\n    closed,\n    amoId\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

      module.exports = doc;
    


/***/ }),
/* 51 */
/***/ (function(module, exports) {


    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PaginatorFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Paginator"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total_count"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"is_first_page"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"is_last_page"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"page"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"pages_count"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"limit"},"arguments":[],"directives":[]}]}}],"loc":{"start":0,"end":134}};
    doc.loc.source = {"body":"fragment PaginatorFragment on Paginator {\n    total_count,\n    is_first_page,\n    is_last_page,\n    page,\n    pages_count,\n    limit\n}","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

      module.exports = doc;
    


/***/ }),
/* 52 */
/***/ (function(module, exports) {


    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserAdminFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"User"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"enabled"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"companies"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"techcenters"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"address"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"city"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"roles"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"description"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"permissions"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"description"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":330}};
    doc.loc.source = {"body":"fragment UserAdminFragment on User {\n    enabled,\n    companies{\n        id\n        name\n    }\n    techcenters{\n        id\n        address\n        city{\n            id\n            name\n        }\n    }\n    roles{\n        id\n        name\n        description\n    }\n    permissions{\n        id\n        name\n        description\n    }\n}","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

      module.exports = doc;
    


/***/ }),
/* 53 */
/***/ (function(module, exports) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getUsersForMultiselect"},"variableDefinitions":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"_all"},"value":{"kind":"BooleanValue","value":true}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fullname"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":93}};
    doc.loc.source = {"body":"query getUsersForMultiselect {\n    users( _all: true ){\n        fullname,\n        id\n    }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set(opRefs);
      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports["getUsersForMultiselect"] = oneQuery(doc, "getUsersForMultiselect");
        


/***/ }),
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */
/***/ (function(module, exports) {


    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CityFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"City"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"sort"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"enabled"},"arguments":[],"directives":[]}]}}],"loc":{"start":0,"end":70}};
    doc.loc.source = {"body":"fragment CityFragment on City {\n    id\n    name\n    sort\n    enabled\n}","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

      module.exports = doc;
    


/***/ }),
/* 67 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_apollo_client__ = __webpack_require__(302);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_apollo_link_http__ = __webpack_require__(310);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_apollo_cache_inmemory__ = __webpack_require__(291);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_apollo_link_error__ = __webpack_require__(307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_apollo_link__ = __webpack_require__(54);







// Create the subscription websocket client
// const wsClient = new SubscriptionClient('ws://localhost:3000/subscriptions', {
//   reconnect: true
// })

// Extend the network interface with the subscription client
// const networkInterfaceWithSubscriptions = addGraphQLSubscriptions(
//   networkInterface,
//   wsClient,
// )
var http = new __WEBPACK_IMPORTED_MODULE_2_apollo_link_http__["a" /* HttpLink */]({
  uri: __WEBPACK_IMPORTED_MODULE_0__config__["l" /* graphQlUrl */]
});

var tokenLink = new __WEBPACK_IMPORTED_MODULE_5_apollo_link__["a" /* ApolloLink */](function (operation, forward) {
  operation.setContext({
    headers: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__config__["d" /* getHeader */])()
  });
  return forward(operation);
});

var errorLink = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_apollo_link_error__["a" /* onError */])(function (_ref) {
  var networkError = _ref.networkError;

  if (networkError && networkError.statusCode >= 400 && networkError.statusCode !== 404 && networkError.statusCode < 500) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__config__["h" /* logout */])();
  }
});

var mainLink = tokenLink.concat(errorLink);

var apolloClient = new __WEBPACK_IMPORTED_MODULE_1_apollo_client__["a" /* ApolloClient */]({
  link: mainLink.concat(http),
  cache: new __WEBPACK_IMPORTED_MODULE_3_apollo_cache_inmemory__["a" /* InMemoryCache */](),
  connectToDevTools: true
});

/* harmony default export */ __webpack_exports__["a"] = (apolloClient);

/***/ }),
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */
/***/ (function(module, exports) {


    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TechcenterFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Techcenter"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"company"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"city"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"address"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"schedule"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"color"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"phone"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"description"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"link"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"workDateStart"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"workDateEnd"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"workTimeStart"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"workTimeEnd"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"commissionReclamation"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"commissionInstall"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"commissionRetail"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"tzOffset"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"enabled"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"maxOrders"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"canView"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"coords"},"arguments":[],"directives":[]}]}}],"loc":{"start":0,"end":413}};
    doc.loc.source = {"body":"fragment TechcenterFragment on Techcenter {\n    id\n    name\n    company{\n        id\n        name\n    }\n    city{\n        id\n        name\n    }\n    address\n    schedule\n    color\n    phone\n    description\n    link\n    workDateStart\n    workDateEnd\n    workTimeStart\n    workTimeEnd\n    commissionReclamation\n    commissionInstall\n    commissionRetail\n    tzOffset\n    enabled\n    maxOrders\n    canView\n    coords\n}","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

      module.exports = doc;
    


/***/ }),
/* 80 */
/***/ (function(module, exports) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getCompanies"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cityId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cityIds"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"all"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"companies"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"cityId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cityId"}}},{"kind":"Argument","name":{"kind":"Name","value":"cityIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cityIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"_all"},"value":{"kind":"Variable","name":{"kind":"Name","value":"all"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":158}};
    doc.loc.source = {"body":"query getCompanies($cityId: Int, $cityIds: [ID], $all: Boolean){\n    companies(cityId:$cityId, cityIds: $cityIds, _all: $all){\n        name\n        id\n    }\n}","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set(opRefs);
      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports["getCompanies"] = oneQuery(doc, "getCompanies");
        


/***/ }),
/* 81 */,
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(382),
  /* template */
  __webpack_require__(1067),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 83 */,
/* 84 */,
/* 85 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Поиск по свойству элемента в массиве
 * @param array
 * @param attr
 * @param value
 * @return {number}
 */
var indexOfProperty = function indexOfProperty(array, attr, value) {
  for (var i = 0; i < array.length; i += 1) {
    if (array[i][attr] === value) {
      return i;
    }
  }
  return -1;
};

/* harmony default export */ __webpack_exports__["a"] = (indexOfProperty);

/***/ }),
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */
/***/ (function(module, exports) {


    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PermissionFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Permission"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"description"},"arguments":[],"directives":[]}]}}],"loc":{"start":0,"end":77}};
    doc.loc.source = {"body":"fragment PermissionFragment on Permission {\n    id\n    name\n    description\n}","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

      module.exports = doc;
    


/***/ }),
/* 102 */
/***/ (function(module, exports) {


    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CustomFieldFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CustomField"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"code"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"amoId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"type"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"entityType"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"required"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"viewed"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"editable"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"sort"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"created"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"updated"},"arguments":[],"directives":[]}]}}],"loc":{"start":0,"end":177}};
    doc.loc.source = {"body":"fragment CustomFieldFragment on CustomField {\n    id\n    name\n    code\n    amoId\n    type\n    entityType\n    required\n    viewed\n    editable\n    sort\n    created\n    updated\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

      module.exports = doc;
    


/***/ }),
/* 103 */
/***/ (function(module, exports) {


    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"InternalNumberFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InternalNumber"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"number"},"arguments":[],"directives":[]}]}}],"loc":{"start":0,"end":71}};
    doc.loc.source = {"body":"fragment InternalNumberFragment on InternalNumber {\n    id\n    number\n}","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

      module.exports = doc;
    


/***/ }),
/* 104 */
/***/ (function(module, exports) {


    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"VirtualNumberFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"VirtualNumber"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"number"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"site"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"country"},"arguments":[],"directives":[]}]}}],"loc":{"start":0,"end":99}};
    doc.loc.source = {"body":"fragment VirtualNumberFragment on VirtualNumber {\n    id\n    name\n    number\n    site\n    country\n}","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

      module.exports = doc;
    


/***/ }),
/* 105 */
/***/ (function(module, exports) {


    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"StatusFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Status"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"class"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"sort"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"enabled"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"code"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"amoStatuses"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"amoId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"pipelineId"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":170}};
    doc.loc.source = {"body":"fragment StatusFragment on Status {\n    name,\n    class,\n    sort,\n    enabled,\n    code,\n    id,\n    amoStatuses {\n        name\n        amoId\n        pipelineId\n    }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

      module.exports = doc;
    


/***/ }),
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return workDates; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getDayName; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);

__WEBPACK_IMPORTED_MODULE_0_moment___default.a.locale('ru');

var workDates = function workDates() {
  var result = [];
  var time = __WEBPACK_IMPORTED_MODULE_0_moment___default()();
  time.minute(0).second(0);
  for (var i = 1; i <= 7; i++) {
    time.weekday(i - 1);
    time.minute(0).second(0);
    var item = {
      id: i,
      name: time.format('dddd').toString(),
      selected: false
    };
    result.push(item);
  }

  return result;
};
/**
 * Метод возвращает название дня по id
 * @param {Number} id
 * @param {Boolean} fullName - Полное ли название вернуть
 * @returns {String}
 */
var getDayName = function getDayName(id) {
  var fullName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var time = __WEBPACK_IMPORTED_MODULE_0_moment___default()();
  time.weekday(id - 1);
  time.minute(0).second(0);
  var format = fullName ? 'dddd' : 'dd';
  return time.format(format).toString();
};

/***/ }),
/* 115 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);


var workTimes = function workTimes() {
  var result = [];
  var time = __WEBPACK_IMPORTED_MODULE_0_moment___default()();
  time.minute(0).second(0);

  for (var i = 0; i < 24; i++) {
    time.hour(i);
    time.minute(0).second(0);
    var item = {
      id: time.format('HH:mm:ss').toString(),
      name: time.format('HH:mm').toString(),
      selected: false
    };
    result.push(item);
    var item30 = {
      id: time.minute(30).format('HH:mm:ss').toString(),
      name: time.minute(30).format('HH:mm').toString(),
      selected: false
    };

    result.push(item30);
  }

  return result;
};

/* harmony default export */ __webpack_exports__["a"] = (workTimes);

/***/ }),
/* 116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(1082);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_containers_Full__ = __webpack_require__(938);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_containers_Full___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_containers_Full__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_containers_Auth__ = __webpack_require__(937);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_containers_Auth___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_containers_Auth__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_views_Profile__ = __webpack_require__(964);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_views_Profile___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_views_Profile__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_views_Help__ = __webpack_require__(956);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_views_Help___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_views_Help__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_views_Orders_List__ = __webpack_require__(957);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_views_Orders_List___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_views_Orders_List__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_views_Orders_View__ = __webpack_require__(963);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_views_Orders_View___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_views_Orders_View__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_views_Techcenter_View__ = __webpack_require__(972);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_views_Techcenter_View___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_views_Techcenter_View__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_views_Techcenter_Edit__ = __webpack_require__(970);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_views_Techcenter_Edit___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_views_Techcenter_Edit__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_views_Techcenter_List__ = __webpack_require__(971);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_views_Techcenter_List___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_views_Techcenter_List__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_views_Admin_Index__ = __webpack_require__(944);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_views_Admin_Index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_views_Admin_Index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_views_Admin_Users__ = __webpack_require__(951);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_views_Admin_Users___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_views_Admin_Users__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_views_Admin_Cities__ = __webpack_require__(940);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_views_Admin_Cities___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_views_Admin_Cities__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_views_Admin_Companies__ = __webpack_require__(941);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_views_Admin_Companies___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_views_Admin_Companies__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_views_Admin_PBX_VirtualNumbers__ = __webpack_require__(947);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_views_Admin_PBX_VirtualNumbers___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_views_Admin_PBX_VirtualNumbers__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_views_Admin_PBX_InternalNumbers__ = __webpack_require__(946);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_views_Admin_PBX_InternalNumbers___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_views_Admin_PBX_InternalNumbers__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_views_Admin_PBX_IncomingCalls__ = __webpack_require__(945);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_views_Admin_PBX_IncomingCalls___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_views_Admin_PBX_IncomingCalls__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_views_Admin_Roles__ = __webpack_require__(948);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_views_Admin_Roles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_views_Admin_Roles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_views_Admin_CustomFields_CFList__ = __webpack_require__(943);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_views_Admin_CustomFields_CFList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_views_Admin_CustomFields_CFList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_views_Admin_CustomFields_CFEdit__ = __webpack_require__(942);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_views_Admin_CustomFields_CFEdit___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_views_Admin_CustomFields_CFEdit__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_views_Admin_Statuses_StatusList__ = __webpack_require__(950);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_views_Admin_Statuses_StatusList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_views_Admin_Statuses_StatusList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_views_Admin_Statuses_StatusEdit__ = __webpack_require__(949);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_views_Admin_Statuses_StatusEdit___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_views_Admin_Statuses_StatusEdit__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_views_Auth_Login__ = __webpack_require__(953);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_views_Auth_Login___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_views_Auth_Login__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_views_Auth_RemindPassword__ = __webpack_require__(954);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_views_Auth_RemindPassword___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24_views_Auth_RemindPassword__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_views_Auth_EmailLinkSend__ = __webpack_require__(952);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_views_Auth_EmailLinkSend___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25_views_Auth_EmailLinkSend__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_views_Auth_ResetPasswordEmail__ = __webpack_require__(955);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_views_Auth_ResetPasswordEmail___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26_views_Auth_ResetPasswordEmail__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_views_404__ = __webpack_require__(939);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_views_404___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27_views_404__);



// Containers



// Views



// Orders



// Techcenter




// Admins















// Auth







__WEBPACK_IMPORTED_MODULE_0_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  linkActiveClass: 'open active',
  scrollBehavior: function scrollBehavior() {
    return { y: 0 };
  },
  routes: [{
    path: '/auth',
    name: 'Auth',
    component: __WEBPACK_IMPORTED_MODULE_3_containers_Auth___default.a,
    redirect: '/auth/login',
    meta: { checkLogin: true },
    children: [{
      path: '/auth/login',
      name: 'Login',
      component: __WEBPACK_IMPORTED_MODULE_23_views_Auth_Login___default.a,
      meta: { label: 'Авторизация', checkLogin: true }
    }, {
      path: '/auth/remind-password',
      name: 'RemindPassword',
      component: __WEBPACK_IMPORTED_MODULE_24_views_Auth_RemindPassword___default.a,
      meta: { checkLogin: true, title: 'Забыли пароль?' }
    }, {
      path: '/auth/email-link-send',
      name: 'EmailLinkSend',
      component: __WEBPACK_IMPORTED_MODULE_25_views_Auth_EmailLinkSend___default.a,
      meta: { checkLogin: true, title: 'Ссылка отправлена' }
    }, {
      path: '/auth/reset-password-email/',
      name: 'ResetPasswordEmail',
      component: __WEBPACK_IMPORTED_MODULE_26_views_Auth_ResetPasswordEmail___default.a,
      meta: { checkLogin: true, title: 'Ссылка отправлена' }
    }]
  }, {
    path: '/',
    redirect: '/orders',
    name: 'Home',
    component: __WEBPACK_IMPORTED_MODULE_2_containers_Full___default.a,
    meta: { label: 'Аларм План' },
    children: [{
      path: 'orders',
      name: 'Orders',
      component: __WEBPACK_IMPORTED_MODULE_6_views_Orders_List___default.a,
      meta: { label: 'Заказы', requiresAuth: true },
      children: [{
        path: '/orders/:id',
        name: 'Order',
        component: __WEBPACK_IMPORTED_MODULE_7_views_Orders_View___default.a,
        meta: { label: 'Информация о заказе', requiresAuth: true }
      }, {
        path: '/orders/iframe/:id',
        name: 'OrderIframe',
        component: __WEBPACK_IMPORTED_MODULE_7_views_Orders_View___default.a,
        meta: { label: 'Информация о заказе', requiresAuth: true, isIframe: true }
      }]
    }, {
      path: 'profile',
      name: 'Profile',
      component: __WEBPACK_IMPORTED_MODULE_4_views_Profile___default.a,
      meta: { label: 'Ваш профиль', requiresAuth: true }
    }, {
      path: 'techcenters',
      name: 'Techcenters',
      component: __WEBPACK_IMPORTED_MODULE_10_views_Techcenter_List___default.a,
      meta: { label: 'Техцентры', requiresAuth: true },
      children: [{
        path: '/techcenters/card/:id',
        name: 'Techcenter',
        component: __WEBPACK_IMPORTED_MODULE_8_views_Techcenter_View___default.a,
        meta: { label: 'Информация о техцентре', requiresAuth: true },
        children: [{
          path: '/techcenters/edit/:id',
          name: 'TechcenterEdit',
          component: __WEBPACK_IMPORTED_MODULE_9_views_Techcenter_Edit___default.a,
          meta: { label: 'Изменить', requiresAuth: true }
        }, {
          path: '/techcenters/iframe/:id',
          name: 'TechcenterIframe',
          component: __WEBPACK_IMPORTED_MODULE_8_views_Techcenter_View___default.a,
          meta: { label: 'Информация о техцентре', requiresAuth: true, isIframe: true }
        }]
      }, {
        path: '/techcenters/create',
        name: 'TechcenterCreate',
        component: __WEBPACK_IMPORTED_MODULE_9_views_Techcenter_Edit___default.a,
        meta: { label: 'Добавить техцентр', requiresAuth: true }
      }]
    }, {
      path: 'help',
      component: __WEBPACK_IMPORTED_MODULE_5_views_Help___default.a,
      meta: { label: 'Помощь', requiresAuth: true }
    }, {
      path: 'help/*',
      name: 'Help',
      component: __WEBPACK_IMPORTED_MODULE_5_views_Help___default.a,
      meta: { label: 'Помощь', requiresAuth: true }
    },
    /**
     * Админка использует тот же общий контейнер,
     * поэтому является вложенным основого роута
     * При развитии проекта можно вынести в отдельный
     */
    {
      path: '/admin',
      name: 'Admin',
      component: __WEBPACK_IMPORTED_MODULE_11_views_Admin_Index___default.a,
      meta: { label: 'Админ Центр', requiresAuth: true },
      children: [{
        path: '/admin/users',
        name: 'Users',
        component: __WEBPACK_IMPORTED_MODULE_12_views_Admin_Users___default.a,
        meta: { label: 'Пользователи', requiresAuth: true }
      }, {
        path: '/admin/users/:id',
        name: 'ViewProfile',
        component: __WEBPACK_IMPORTED_MODULE_4_views_Profile___default.a,
        meta: { label: 'Профиль пользователя', requiresAuth: true }
      }, {
        path: '/admin/cities',
        name: 'Cities',
        component: __WEBPACK_IMPORTED_MODULE_13_views_Admin_Cities___default.a,
        meta: { label: 'Города', requiresAuth: true }
      }, {
        path: '/admin/companies',
        name: 'Companies',
        component: __WEBPACK_IMPORTED_MODULE_14_views_Admin_Companies___default.a,
        meta: { label: 'Компании', requiresAuth: true }
      }, {
        path: '/admin/roles',
        name: 'Roles',
        component: __WEBPACK_IMPORTED_MODULE_18_views_Admin_Roles___default.a,
        meta: { label: 'Роли пользователей', requiresAuth: true }
      }, {
        path: '/admin/pbx/virtual-numbers',
        name: 'VirtualNumbers',
        component: __WEBPACK_IMPORTED_MODULE_15_views_Admin_PBX_VirtualNumbers___default.a,
        meta: { label: 'Виртуальные номера', requiresAuth: true }
      }, {
        path: '/admin/pbx/internal-numbers',
        name: 'InternalNumbers',
        component: __WEBPACK_IMPORTED_MODULE_16_views_Admin_PBX_InternalNumbers___default.a,
        meta: { label: 'Внутренние номера', requiresAuth: true }
      }, {
        path: '/admin/pbx/incoming-calls',
        name: 'IncomingCalls',
        component: __WEBPACK_IMPORTED_MODULE_17_views_Admin_PBX_IncomingCalls___default.a,
        meta: { label: 'Статистика звонков', requiresAuth: true }
      }, {
        path: 'custom-fields',
        name: 'CustomFields',
        component: __WEBPACK_IMPORTED_MODULE_19_views_Admin_CustomFields_CFList___default.a,
        meta: { label: 'Кастамные поля', requiresAuth: true },
        children: [{
          path: '/custom-fields/edit/:id',
          name: 'CustomFieldsEdit',
          component: __WEBPACK_IMPORTED_MODULE_20_views_Admin_CustomFields_CFEdit___default.a,
          meta: { label: 'Изменить кастомное поле', requiresAuth: true }
        }, {
          path: '/custom-fields/create',
          name: 'CustomFieldsCreate',
          component: __WEBPACK_IMPORTED_MODULE_20_views_Admin_CustomFields_CFEdit___default.a,
          meta: { label: 'Добавить кастомное поле', requiresAuth: true }
        }]
      }, {
        path: 'statuses',
        name: 'Statuses',
        component: __WEBPACK_IMPORTED_MODULE_21_views_Admin_Statuses_StatusList___default.a,
        meta: { label: 'Статусы', requiresAuth: true },
        children: [{
          path: '/statuses/edit/:id',
          name: 'StatusEdit',
          component: __WEBPACK_IMPORTED_MODULE_22_views_Admin_Statuses_StatusEdit___default.a,
          meta: { label: 'Изменить статус', requiresAuth: true }
        }, {
          path: '/statuses/create',
          name: 'StatusCreate',
          component: __WEBPACK_IMPORTED_MODULE_22_views_Admin_Statuses_StatusEdit___default.a,
          meta: { label: 'Добавить статус', requiresAuth: true }
        }]
      }]
    }]
  }, { path: '*', component: __WEBPACK_IMPORTED_MODULE_27_views_404___default.a }]
}));

/***/ }),
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */
/***/ (function(module, exports) {


    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RoleFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Role"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"description"},"arguments":[],"directives":[]}]}}],"loc":{"start":0,"end":65}};
    doc.loc.source = {"body":"fragment RoleFragment on Role {\n    id\n    name\n    description\n}","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

      module.exports = doc;
    


/***/ }),
/* 155 */
/***/ (function(module, exports) {


    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CompanyFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Company"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"sort"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"enabled"},"arguments":[],"directives":[]}]}}],"loc":{"start":0,"end":76}};
    doc.loc.source = {"body":"fragment CompanyFragment on Company {\n    id\n    name\n    sort\n    enabled\n}","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

      module.exports = doc;
    


/***/ }),
/* 156 */
/***/ (function(module, exports) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getTechcenters"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cityId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyIds"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cityIds"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"all"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"enabled"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"techcenters"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"cityId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cityId"}}},{"kind":"Argument","name":{"kind":"Name","value":"companyId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyId"}}},{"kind":"Argument","name":{"kind":"Name","value":"companyIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"cityIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cityIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"_all"},"value":{"kind":"Variable","name":{"kind":"Name","value":"all"}}},{"kind":"Argument","name":{"kind":"Name","value":"enabled"},"value":{"kind":"Variable","name":{"kind":"Name","value":"enabled"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":283}};
    doc.loc.source = {"body":"query getTechcenters($cityId: Int, $companyId: Int, $companyIds: [ID], $cityIds: [ID], $all: Boolean, $enabled: Boolean){\n    techcenters(cityId:$cityId, companyId: $companyId, companyIds: $companyIds, cityIds: $cityIds _all: $all, enabled: $enabled){\n        name\n        id\n    }\n}","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set(opRefs);
      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports["getTechcenters"] = oneQuery(doc, "getTechcenters");
        


/***/ }),
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(811)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(383),
  /* template */
  __webpack_require__(1063),
  /* scopeId */
  "data-v-a5f571ce",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(387),
  /* template */
  __webpack_require__(1008),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(786)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(408),
  /* template */
  __webpack_require__(990),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__indexOfProperty__ = __webpack_require__(85);


/**
 * Созадние пользователя и добавление к нему методов для проверки прав доступа
 * @param userObj
 * @return {*}
 */
var createUserPolicies = function createUserPolicies(userObj) {
  var user = Object.assign({}, userObj);
  var variantsObj = ['his', 'techcenters', 'companies', 'company', 'all'];
  /**
   * Проверка наличия роли у пользователя
   * @param roleName
   * @return {boolean}
   */
  user.hasRole = function (roleName) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__indexOfProperty__["a" /* default */])(user.roles, 'name', roleName) !== -1;
  };
  /**
   * Проверка наличия разрешения у пользователя
   * @param permissionName
   * @return {boolean}
   */
  user.hasPermission = function (permissionName) {
    var permissionObj = permissionName.split('.');
    if (permissionObj[permissionObj.length - 1] === '*') {
      return variantsObj.some(function (item) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__indexOfProperty__["a" /* default */])(user.permissions, 'name', permissionName.replace(/\*/, item));
      });
    } else {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__indexOfProperty__["a" /* default */])(user.permissions, 'name', permissionName) !== -1;
    }
  };
  return user;
};

/* harmony default export */ __webpack_exports__["a"] = (createUserPolicies);

/***/ }),
/* 179 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Функция заменяет парметры в Url для фильтров
 * @param url
 * @param paramName
 * @param value
 * @returns {string}
 */
var replaceAnchorParams = function replaceAnchorParams(url, paramName, value) {
  url = url.split('#');
  if (url[1]) {
    var params = url[1].split('&');
    var isParam = false;
    params = params.map(function (item) {
      var origin = item;
      var param = item.split('=');
      if (param[0] === paramName) {
        isParam = true;
        origin = paramName + '=' + value;
      }
      return origin;
    });
    if (!isParam) {
      params.push(paramName + '=' + value);
    }
    return url[0] + '#' + params.join('&');
  }

  return url[0] + '#' + paramName + '=' + value;
};

/* harmony default export */ __webpack_exports__["a"] = (replaceAnchorParams);

/***/ }),
/* 180 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var tzOffsets = function tzOffsets() {
  return [{
    id: 'Europe/Kaliningrad',
    name: 'Калининградское время -1 MSK (+2 UTC)'
  }, {
    id: 'Europe/Moscow',
    name: 'Московское время (+3 UTC)'
  }, {
    id: 'Europe/Samara',
    name: 'Самарское время +1 MSK (+4 UTC)'
  }, {
    id: 'Asia/Yekaterinburg',
    name: 'Екатерингбургское время +2 MSK (+5 UTC)'
  }, {
    id: 'Asia/Omsk',
    name: 'Омское время +3 MSK (+6 UTC)'
  }, {
    id: 'Asia/Krasnoyarsk',
    name: 'Красноярское время +4 MSK (+7 UTC)'
  }, {
    id: 'Asia/Irkutsk',
    name: 'Иркутское время +5 MSK (+8 UTC)'
  }, {
    id: 'Asia/Yakutsk',
    name: 'Якутское время +6 MSK (+9 UTC)'
  }, {
    id: 'Asia/Vladivostok',
    name: 'Владивостокское время +7 MSK (+10 UTC)'
  }, {
    id: 'Asia/Srednekolymsk',
    name: 'Среднеколымское время +8 MSK (+11 UTC)'
  }, {
    id: 'Asia/Kamchatka',
    name: 'Камчатское время +9 MSK (+12 UTC)'
  }];
};

/* harmony default export */ __webpack_exports__["a"] = (tzOffsets);

/***/ }),
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */
/***/ (function(module, exports) {


    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CommentFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Comment"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"diffForHumans"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"text"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"date"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"time"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"user"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"fullname"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"avatar"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"isViewed"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"orderId"},"arguments":[],"directives":[]}]}}],"loc":{"start":0,"end":182}};
    doc.loc.source = {"body":"fragment CommentFragment on Comment {\n    id,\n    diffForHumans,\n    text,\n    date,\n    time,\n    user{\n        id,\n        fullname,\n        avatar\n    }\n    isViewed\n    orderId\n}","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

      module.exports = doc;
    


/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"enabled"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cityId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"address"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"phone"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"link"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"color"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"users"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workDateStart"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workDateEnd"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workTimeStart"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workTimeEnd"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"commissionInstall"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"commissionRetail"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"commissionReclamation"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"tzOffset"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"maxOrders"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"description"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"coords"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addTechcenter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}},{"kind":"Argument","name":{"kind":"Name","value":"enabled"},"value":{"kind":"Variable","name":{"kind":"Name","value":"enabled"}}},{"kind":"Argument","name":{"kind":"Name","value":"cityId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cityId"}}},{"kind":"Argument","name":{"kind":"Name","value":"companyId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyId"}}},{"kind":"Argument","name":{"kind":"Name","value":"address"},"value":{"kind":"Variable","name":{"kind":"Name","value":"address"}}},{"kind":"Argument","name":{"kind":"Name","value":"phone"},"value":{"kind":"Variable","name":{"kind":"Name","value":"phone"}}},{"kind":"Argument","name":{"kind":"Name","value":"link"},"value":{"kind":"Variable","name":{"kind":"Name","value":"link"}}},{"kind":"Argument","name":{"kind":"Name","value":"color"},"value":{"kind":"Variable","name":{"kind":"Name","value":"color"}}},{"kind":"Argument","name":{"kind":"Name","value":"users"},"value":{"kind":"Variable","name":{"kind":"Name","value":"users"}}},{"kind":"Argument","name":{"kind":"Name","value":"workDateStart"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workDateStart"}}},{"kind":"Argument","name":{"kind":"Name","value":"workDateEnd"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workDateEnd"}}},{"kind":"Argument","name":{"kind":"Name","value":"workTimeStart"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workTimeStart"}}},{"kind":"Argument","name":{"kind":"Name","value":"workTimeEnd"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workTimeEnd"}}},{"kind":"Argument","name":{"kind":"Name","value":"commissionInstall"},"value":{"kind":"Variable","name":{"kind":"Name","value":"commissionInstall"}}},{"kind":"Argument","name":{"kind":"Name","value":"commissionRetail"},"value":{"kind":"Variable","name":{"kind":"Name","value":"commissionRetail"}}},{"kind":"Argument","name":{"kind":"Name","value":"commissionReclamation"},"value":{"kind":"Variable","name":{"kind":"Name","value":"commissionReclamation"}}},{"kind":"Argument","name":{"kind":"Name","value":"tzOffset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"tzOffset"}}},{"kind":"Argument","name":{"kind":"Name","value":"maxOrders"},"value":{"kind":"Variable","name":{"kind":"Name","value":"maxOrders"}}},{"kind":"Argument","name":{"kind":"Name","value":"description"},"value":{"kind":"Variable","name":{"kind":"Name","value":"description"}}},{"kind":"Argument","name":{"kind":"Name","value":"coords"},"value":{"kind":"Variable","name":{"kind":"Name","value":"coords"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TechcenterFragment"},"directives":[]}]}}]}}],"loc":{"start":0,"end":1201}};
    doc.loc.source = {"body":"#import \"./../fragments/TechcenterFragment.graphql\"\n\nmutation (\n    $name: String!\n    $enabled: Boolean!\n    $cityId: Int!\n    $companyId: Int!\n    $address: String!\n    $phone: String!\n    $link: String!\n    $color: String!\n    $users: [ID]\n    $workDateStart: Int\n    $workDateEnd: Int\n    $workTimeStart: String\n    $workTimeEnd: String\n    $commissionInstall: Int\n    $commissionRetail: Int\n    $commissionReclamation: Int\n    $tzOffset: String\n    $maxOrders: Int\n    $description: String\n    $coords: String!\n) {\n    addTechcenter(\n        name: $name\n        enabled: $enabled\n        cityId: $cityId\n        companyId: $companyId\n        address: $address\n        phone: $phone\n        link: $link\n        color: $color\n        users: $users\n        workDateStart: $workDateStart\n        workDateEnd: $workDateEnd\n        workTimeStart: $workTimeStart\n        workTimeEnd: $workTimeEnd\n        commissionInstall: $commissionInstall\n        commissionRetail: $commissionRetail\n        commissionReclamation: $commissionReclamation\n        tzOffset: $tzOffset\n        maxOrders: $maxOrders\n        description: $description\n        coords: $coords\n    ) {\n        ...TechcenterFragment\n    }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  doc.definitions = doc.definitions.concat(unique(__webpack_require__(79).definitions));


    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set(opRefs);
      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    


/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"enabled"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"blockTechcenter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"enabled"},"value":{"kind":"Variable","name":{"kind":"Name","value":"enabled"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TechcenterFragment"},"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"users"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserFragment"},"directives":[]}]}}]}}]}}],"loc":{"start":0,"end":313}};
    doc.loc.source = {"body":"#import \"./../fragments/TechcenterFragment.graphql\"\n#import \"./../fragments/UserFragment.graphql\"\n\nmutation (\n    $id: ID!,\n    $enabled: Boolean!\n) {\n    blockTechcenter(\n        id: $id\n        enabled: $enabled\n    ) {\n        ...TechcenterFragment\n        users{\n            ...UserFragment\n        }\n    }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  doc.definitions = doc.definitions.concat(unique(__webpack_require__(79).definitions));
doc.definitions = doc.definitions.concat(unique(__webpack_require__(18).definitions));


    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set(opRefs);
      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    


/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"enabled"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"blockUser"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"enabled"},"value":{"kind":"Variable","name":{"kind":"Name","value":"enabled"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserFragment"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserAdminFragment"},"directives":[]}]}}]}}],"loc":{"start":0,"end":276}};
    doc.loc.source = {"body":"#import \"./../fragments/UserFragment.graphql\"\n#import \"./../fragments/UserAdminFragment.graphql\"\n\nmutation (\n    $id: ID!,\n    $enabled: Boolean!\n) {\n    blockUser(\n        id: $id\n        enabled: $enabled\n    ) {\n        ...UserFragment\n        ...UserAdminFragment\n    }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  doc.definitions = doc.definitions.concat(unique(__webpack_require__(18).definitions));
doc.definitions = doc.definitions.concat(unique(__webpack_require__(52).definitions));


    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set(opRefs);
      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    


/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"enabled"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cityId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"address"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"link"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"color"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"phone"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"description"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"users"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workDateStart"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workDateEnd"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workTimeStart"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workTimeEnd"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"commissionInstall"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"commissionRetail"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"commissionReclamation"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"tzOffset"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"maxOrders"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"coords"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateTechcenter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}},{"kind":"Argument","name":{"kind":"Name","value":"enabled"},"value":{"kind":"Variable","name":{"kind":"Name","value":"enabled"}}},{"kind":"Argument","name":{"kind":"Name","value":"cityId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cityId"}}},{"kind":"Argument","name":{"kind":"Name","value":"companyId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyId"}}},{"kind":"Argument","name":{"kind":"Name","value":"address"},"value":{"kind":"Variable","name":{"kind":"Name","value":"address"}}},{"kind":"Argument","name":{"kind":"Name","value":"link"},"value":{"kind":"Variable","name":{"kind":"Name","value":"link"}}},{"kind":"Argument","name":{"kind":"Name","value":"color"},"value":{"kind":"Variable","name":{"kind":"Name","value":"color"}}},{"kind":"Argument","name":{"kind":"Name","value":"phone"},"value":{"kind":"Variable","name":{"kind":"Name","value":"phone"}}},{"kind":"Argument","name":{"kind":"Name","value":"description"},"value":{"kind":"Variable","name":{"kind":"Name","value":"description"}}},{"kind":"Argument","name":{"kind":"Name","value":"users"},"value":{"kind":"Variable","name":{"kind":"Name","value":"users"}}},{"kind":"Argument","name":{"kind":"Name","value":"workDateStart"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workDateStart"}}},{"kind":"Argument","name":{"kind":"Name","value":"workDateEnd"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workDateEnd"}}},{"kind":"Argument","name":{"kind":"Name","value":"workTimeStart"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workTimeStart"}}},{"kind":"Argument","name":{"kind":"Name","value":"workTimeEnd"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workTimeEnd"}}},{"kind":"Argument","name":{"kind":"Name","value":"commissionInstall"},"value":{"kind":"Variable","name":{"kind":"Name","value":"commissionInstall"}}},{"kind":"Argument","name":{"kind":"Name","value":"commissionRetail"},"value":{"kind":"Variable","name":{"kind":"Name","value":"commissionRetail"}}},{"kind":"Argument","name":{"kind":"Name","value":"commissionReclamation"},"value":{"kind":"Variable","name":{"kind":"Name","value":"commissionReclamation"}}},{"kind":"Argument","name":{"kind":"Name","value":"tzOffset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"tzOffset"}}},{"kind":"Argument","name":{"kind":"Name","value":"maxOrders"},"value":{"kind":"Variable","name":{"kind":"Name","value":"maxOrders"}}},{"kind":"Argument","name":{"kind":"Name","value":"coords"},"value":{"kind":"Variable","name":{"kind":"Name","value":"coords"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TechcenterFragment"},"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"users"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserFragment"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"width"},"value":{"kind":"IntValue","value":"240"}},{"kind":"Argument","name":{"kind":"Name","value":"height"},"value":{"kind":"IntValue","value":"120"}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"savePath"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"fullPath"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"originPath"},"arguments":[],"directives":[]}]}}]}}]}}],"loc":{"start":0,"end":1456}};
    doc.loc.source = {"body":"#import \"./../fragments/TechcenterFragment.graphql\"\n#import \"./../fragments/UserFragment.graphql\"\n\nmutation (\n    $id: ID!\n    $name: String!\n    $enabled: Boolean!\n    $cityId: Int!\n    $companyId: Int!\n    $address: String!\n    $link: String!\n    $color: String!\n    $phone: String!\n    $description: String\n    $users: [ID]\n    $workDateStart: Int\n    $workDateEnd: Int\n    $workTimeStart: String\n    $workTimeEnd: String\n    $commissionInstall: Int\n    $commissionRetail: Int\n    $commissionReclamation: Int\n    $tzOffset: String\n    $maxOrders: Int\n    $coords: String!\n) {\n    updateTechcenter(\n        id: $id\n        name: $name\n        enabled: $enabled\n        cityId: $cityId\n        companyId: $companyId\n        address: $address\n        link: $link\n        color: $color\n        phone: $phone\n        description: $description\n        users: $users\n        workDateStart: $workDateStart\n        workDateEnd: $workDateEnd\n        workTimeStart: $workTimeStart\n        workTimeEnd: $workTimeEnd\n        commissionInstall: $commissionInstall\n        commissionRetail: $commissionRetail\n        commissionReclamation: $commissionReclamation\n        tzOffset: $tzOffset\n        maxOrders: $maxOrders\n        coords: $coords\n    ) {\n        ...TechcenterFragment\n        users{\n            ...UserFragment\n        }\n        images(width: 240, height: 120) {\n          id\n          savePath\n          fullPath\n          originPath\n        }\n    }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  doc.definitions = doc.definitions.concat(unique(__webpack_require__(79).definitions));
doc.definitions = doc.definitions.concat(unique(__webpack_require__(18).definitions));


    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set(opRefs);
      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    


/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getPermission"},"variableDefinitions":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"permissions"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PermissionFragment"},"directives":[]}]}}]}}],"loc":{"start":0,"end":137}};
    doc.loc.source = {"body":"#import \"./../../fragments/Acl/PermissionFragment.graphql\"\n\nquery getPermission {\n    permissions{\n        ...PermissionFragment\n    }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  doc.definitions = doc.definitions.concat(unique(__webpack_require__(101).definitions));


    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set(opRefs);
      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports["getPermission"] = oneQuery(doc, "getPermission");
        


/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getRoles"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"page"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"query"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"all"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"roles"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"_limit"},"value":{"kind":"IntValue","value":"10"}},{"kind":"Argument","name":{"kind":"Name","value":"_page"},"value":{"kind":"Variable","name":{"kind":"Name","value":"page"}}},{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}},{"kind":"Argument","name":{"kind":"Name","value":"_all"},"value":{"kind":"Variable","name":{"kind":"Name","value":"all"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RoleFragment"},"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"permissions"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PermissionFragment"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"users"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserFragment"},"directives":[]}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"paginator"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"StringValue","value":"roles","block":false}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PaginatorFragment"},"directives":[]}]}}]}}],"loc":{"start":0,"end":558}};
    doc.loc.source = {"body":"#import \"./../../fragments/Acl/RoleFragment.graphql\"\n#import \"./../../fragments/Acl/PermissionFragment.graphql\"\n#import \"./../../fragments/UserFragment.graphql\"\n#import \"./../../fragments/PaginatorFragment.graphql\"\n\nquery getRoles ($page: Int, $query: String, $all: Boolean) {\n    roles(_limit:10, _page: $page, query: $query, _all: $all){\n        ...RoleFragment\n        permissions{\n            ...PermissionFragment\n        }\n        users{\n            ...UserFragment\n        }\n    }\n    paginator (query: \"roles\") {\n        ...PaginatorFragment\n    }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  doc.definitions = doc.definitions.concat(unique(__webpack_require__(154).definitions));
doc.definitions = doc.definitions.concat(unique(__webpack_require__(101).definitions));
doc.definitions = doc.definitions.concat(unique(__webpack_require__(18).definitions));
doc.definitions = doc.definitions.concat(unique(__webpack_require__(51).definitions));


    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set(opRefs);
      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports["getRoles"] = oneQuery(doc, "getRoles");
        


/***/ }),
/* 253 */
/***/ (function(module, exports) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getAudioRecords"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pbxCallId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"audioRecords"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pbxCallId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pbxCallId"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":105}};
    doc.loc.source = {"body":"query getAudioRecords ($pbxCallId: String!) {\n    audioRecords(pbxCallId: $pbxCallId){\n       url\n    }\n}","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set(opRefs);
      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports["getAudioRecords"] = oneQuery(doc, "getAudioRecords");
        


/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getIncomingCall"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"page"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cityId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"virtualNumberId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"internalNumberId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"dateTimeFrom"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"dateTimeTo"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"query"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"all"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"incomingCalls"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"_limit"},"value":{"kind":"IntValue","value":"10"}},{"kind":"Argument","name":{"kind":"Name","value":"_page"},"value":{"kind":"Variable","name":{"kind":"Name","value":"page"}}},{"kind":"Argument","name":{"kind":"Name","value":"cityId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cityId"}}},{"kind":"Argument","name":{"kind":"Name","value":"virtualNumberId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"virtualNumberId"}}},{"kind":"Argument","name":{"kind":"Name","value":"internalNumberId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"internalNumberId"}}},{"kind":"Argument","name":{"kind":"Name","value":"dateTimeFrom"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dateTimeFrom"}}},{"kind":"Argument","name":{"kind":"Name","value":"dateTimeTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dateTimeTo"}}},{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}},{"kind":"Argument","name":{"kind":"Name","value":"_all"},"value":{"kind":"Variable","name":{"kind":"Name","value":"all"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"IncomingCallFragment"},"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"virtualNumber"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VirtualNumberFragment"},"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"city"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CityFragment"},"directives":[]}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"internalNumber"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalNumberFragment"},"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"users"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"fullname"},"arguments":[],"directives":[]}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"paginator"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"StringValue","value":"incomingCalls","block":false}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PaginatorFragment"},"directives":[]}]}}]}}],"loc":{"start":0,"end":1187}};
    doc.loc.source = {"body":"#import \"./../../fragments/PBX/IncomingCallFragment.graphql\"\n#import \"./../../fragments/PBX/VirtualNumberFragment.graphql\"\n#import \"./../../fragments/PBX/InternalNumberFragment.graphql\"\n#import \"./../../fragments/PaginatorFragment.graphql\"\n#import \"./../../fragments/CityFragment.graphql\"\n\nquery getIncomingCall (\n    $page: Int,\n    $cityId: Int,\n    $virtualNumberId: Int,\n    $internalNumberId: Int,\n    $dateTimeFrom: String,\n    $dateTimeTo: String,\n    $query: String,\n    $all: Boolean\n) {\n    incomingCalls(\n        _limit:10,\n        _page: $page,\n        cityId: $cityId,\n        virtualNumberId: $virtualNumberId,\n        internalNumberId: $internalNumberId,\n        dateTimeFrom: $dateTimeFrom,\n        dateTimeTo: $dateTimeTo,\n        query: $query,\n        _all: $all\n    ){\n        ...IncomingCallFragment\n        virtualNumber{\n            ...VirtualNumberFragment\n            city{\n                ...CityFragment\n            }\n        }\n        internalNumber{\n            ...InternalNumberFragment\n            users{\n                id\n                fullname\n            }\n        }\n    }\n    paginator (query: \"incomingCalls\") {\n        ...PaginatorFragment\n    }\n}","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  doc.definitions = doc.definitions.concat(unique(__webpack_require__(821).definitions));
doc.definitions = doc.definitions.concat(unique(__webpack_require__(104).definitions));
doc.definitions = doc.definitions.concat(unique(__webpack_require__(103).definitions));
doc.definitions = doc.definitions.concat(unique(__webpack_require__(51).definitions));
doc.definitions = doc.definitions.concat(unique(__webpack_require__(66).definitions));


    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set(opRefs);
      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports["getIncomingCall"] = oneQuery(doc, "getIncomingCall");
        


/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"geVirtualNumbers"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"page"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"query"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"all"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"internalNumbers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"_limit"},"value":{"kind":"IntValue","value":"10"}},{"kind":"Argument","name":{"kind":"Name","value":"_page"},"value":{"kind":"Variable","name":{"kind":"Name","value":"page"}}},{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}},{"kind":"Argument","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}},{"kind":"Argument","name":{"kind":"Name","value":"_all"},"value":{"kind":"Variable","name":{"kind":"Name","value":"all"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalNumberFragment"},"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"users"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserFragment"},"directives":[]}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"paginator"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"StringValue","value":"internalNumbers","block":false}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PaginatorFragment"},"directives":[]}]}}]}}],"loc":{"start":0,"end":512}};
    doc.loc.source = {"body":"#import \"./../../fragments/PBX/InternalNumberFragment.graphql\"\n#import \"./../../fragments/UserFragment.graphql\"\n#import \"./../../fragments/PaginatorFragment.graphql\"\n\nquery geVirtualNumbers ($page: Int, $query: String, $userId: Int, $all: Boolean) {\n    internalNumbers(_limit:10, _page: $page, query: $query, userId: $userId, _all: $all){\n        ...InternalNumberFragment\n        users{\n            ...UserFragment\n        }\n    }\n    paginator (query: \"internalNumbers\") {\n        ...PaginatorFragment\n    }\n}","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  doc.definitions = doc.definitions.concat(unique(__webpack_require__(103).definitions));
doc.definitions = doc.definitions.concat(unique(__webpack_require__(18).definitions));
doc.definitions = doc.definitions.concat(unique(__webpack_require__(51).definitions));


    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set(opRefs);
      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports["geVirtualNumbers"] = oneQuery(doc, "geVirtualNumbers");
        


/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"geVirtualNumbers"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"page"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"query"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cityId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"all"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"virtualNumbers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"_limit"},"value":{"kind":"IntValue","value":"10"}},{"kind":"Argument","name":{"kind":"Name","value":"_page"},"value":{"kind":"Variable","name":{"kind":"Name","value":"page"}}},{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}},{"kind":"Argument","name":{"kind":"Name","value":"cityId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cityId"}}},{"kind":"Argument","name":{"kind":"Name","value":"_all"},"value":{"kind":"Variable","name":{"kind":"Name","value":"all"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VirtualNumberFragment"},"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"city"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CityFragment"},"directives":[]}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"paginator"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"StringValue","value":"virtualNumbers","block":false}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PaginatorFragment"},"directives":[]}]}}]}}],"loc":{"start":0,"end":507}};
    doc.loc.source = {"body":"#import \"./../../fragments/PBX/VirtualNumberFragment.graphql\"\n#import \"./../../fragments/CityFragment.graphql\"\n#import \"./../../fragments/PaginatorFragment.graphql\"\n\nquery geVirtualNumbers ($page: Int, $query: String, $cityId: Int, $all: Boolean) {\n    virtualNumbers(_limit:10, _page: $page, query: $query, cityId: $cityId, _all: $all){\n        ...VirtualNumberFragment\n        city{\n            ...CityFragment\n        }\n    }\n    paginator (query: \"virtualNumbers\") {\n        ...PaginatorFragment\n    }\n}","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  doc.definitions = doc.definitions.concat(unique(__webpack_require__(104).definitions));
doc.definitions = doc.definitions.concat(unique(__webpack_require__(66).definitions));
doc.definitions = doc.definitions.concat(unique(__webpack_require__(51).definitions));


    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set(opRefs);
      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports["geVirtualNumbers"] = oneQuery(doc, "geVirtualNumbers");
        


/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"dateFrom"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"dateTo"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cityId"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"techcenterId"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyId"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"status"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"clientPhone"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"unclosed"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"problem"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"canceled"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"query"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"orders"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"dateFrom"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dateFrom"}}},{"kind":"Argument","name":{"kind":"Name","value":"dateTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dateTo"}}},{"kind":"Argument","name":{"kind":"Name","value":"cityId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cityId"}}},{"kind":"Argument","name":{"kind":"Name","value":"techcenterId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"techcenterId"}}},{"kind":"Argument","name":{"kind":"Name","value":"companyId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyId"}}},{"kind":"Argument","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}},{"kind":"Argument","name":{"kind":"Name","value":"status"},"value":{"kind":"Variable","name":{"kind":"Name","value":"status"}}},{"kind":"Argument","name":{"kind":"Name","value":"clientPhone"},"value":{"kind":"Variable","name":{"kind":"Name","value":"clientPhone"}}},{"kind":"Argument","name":{"kind":"Name","value":"unclosed"},"value":{"kind":"Variable","name":{"kind":"Name","value":"unclosed"}}},{"kind":"Argument","name":{"kind":"Name","value":"canceled"},"value":{"kind":"Variable","name":{"kind":"Name","value":"canceled"}}},{"kind":"Argument","name":{"kind":"Name","value":"problem"},"value":{"kind":"Variable","name":{"kind":"Name","value":"problem"}}},{"kind":"Argument","name":{"kind":"Name","value":"_limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"_query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrderFragment"},"directives":[]}]}}]}}],"loc":{"start":0,"end":774}};
    doc.loc.source = {"body":"#import \"./../fragments/OrderFragment.graphql\"\n\nquery (\n    $id: [ID],\n    $dateFrom: String, $dateTo: String\n    $cityId: [ID],\n    $techcenterId: [ID],\n    $companyId: [ID],\n    $userId: [ID],\n    $status: [ID],\n    $clientPhone: String\n    $unclosed: Boolean\n    $problem: Boolean\n    $canceled: Boolean\n    $limit: Int,\n    $query: String\n) {\n    orders (\n        id: $id,\n        dateFrom: $dateFrom, dateTo: $dateTo,\n        cityId: $cityId,\n        techcenterId: $techcenterId,\n        companyId: $companyId,\n        userId: $userId,\n        status: $status,\n        clientPhone: $clientPhone,\n        unclosed: $unclosed,\n        canceled: $canceled,\n        problem: $problem,\n        _limit: $limit,\n        _query: $query\n    ) {\n        ...OrderFragment\n    }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  doc.definitions = doc.definitions.concat(unique(__webpack_require__(50).definitions));


    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set(opRefs);
      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    


/***/ }),
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(356),
  /* template */
  __webpack_require__(1002),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(813)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(384),
  /* template */
  __webpack_require__(1073),
  /* scopeId */
  "data-v-ddb2e13c",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(385),
  /* template */
  __webpack_require__(1044),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(386),
  /* template */
  __webpack_require__(993),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(388),
  /* template */
  __webpack_require__(1045),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(407),
  /* template */
  __webpack_require__(1078),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(424),
  /* template */
  __webpack_require__(1023),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(913);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(321);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_axios__ = __webpack_require__(904);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__router__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__config__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_apollo__ = __webpack_require__(903);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__apolloClient__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__store__ = __webpack_require__(348);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_scrollto__ = __webpack_require__(1083);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_scrollto___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vue_scrollto__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vuelidate__ = __webpack_require__(1089);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vuelidate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_vuelidate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_v_mask__ = __webpack_require__(270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue_truncate_filter__ = __webpack_require__(1086);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue_truncate_filter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_vue_truncate_filter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue_yandex_maps__ = __webpack_require__(1087);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vue_strap__ = __webpack_require__(1085);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vue_strap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_vue_strap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__helpers_datepickerGetDateRangeMonkeyPath__ = __webpack_require__(343);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__filters__ = __webpack_require__(341);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_bootstrap_vue__ = __webpack_require__(548);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_vue_echo__ = __webpack_require__(905);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_vue_echo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_vue_echo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__echoClient__ = __webpack_require__(340);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_mavon_editor__ = __webpack_require__(888);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_mavon_editor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_mavon_editor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_mavon_editor_dist_css_index_css__ = __webpack_require__(784);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_mavon_editor_dist_css_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_mavon_editor_dist_css_index_css__);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
















 // Vue filters






__WEBPACK_IMPORTED_MODULE_0_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_3_vue_axios___default.a, __WEBPACK_IMPORTED_MODULE_2_axios___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_9_vue_scrollto___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_10_vuelidate___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_11_v_mask__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_12_vue_truncate_filter___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_13_vue_yandex_maps__["a" /* default */], {
  apiKey: __WEBPACK_IMPORTED_MODULE_5__config__["a" /* yandexGeoCodeApiKey */],
  lang: 'ru_RU',
  coordorder: 'latlong',
  version: '2.1'
});
__WEBPACK_IMPORTED_MODULE_0_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_20_mavon_editor___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_6_vue_apollo__["a" /* default */]);

var apolloProvider = new __WEBPACK_IMPORTED_MODULE_6_vue_apollo__["a" /* default */]({
  defaultClient: __WEBPACK_IMPORTED_MODULE_7__apolloClient__["a" /* default */]
});

// Global components
__WEBPACK_IMPORTED_MODULE_0_vue___default.a.component('loading', __webpack_require__(920));
__webpack_require__(890);
__webpack_require__(1084);
__WEBPACK_IMPORTED_MODULE_0_vue___default.a.component('dropdown', __WEBPACK_IMPORTED_MODULE_14_vue_strap__["dropdown"]);
__WEBPACK_IMPORTED_MODULE_14_vue_strap__["datepicker"].methods.getDateRange = __WEBPACK_IMPORTED_MODULE_15__helpers_datepickerGetDateRangeMonkeyPath__["a" /* default */];
__WEBPACK_IMPORTED_MODULE_0_vue___default.a.component('datepicker', __WEBPACK_IMPORTED_MODULE_14_vue_strap__["datepicker"]);

/**
 * remove after update bootstrap-bue beta-10
 * @see https://github.com/bootstrap-vue/bootstrap-vue/issues/1201#issuecomment-337663138
 */
var originalVueComponent = __WEBPACK_IMPORTED_MODULE_0_vue___default.a.component;
__WEBPACK_IMPORTED_MODULE_0_vue___default.a.component = function (name, definition) {
  if (name === 'bFormCheckboxGroup' || name === 'bCheckboxGroup' || name === 'bCheckGroup' || name === 'bFormRadioGroup') {
    definition.components = { bFormCheckbox: definition.components[0] };
  }
  originalVueComponent.apply(this, [name, definition]);
};
__WEBPACK_IMPORTED_MODULE_0_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_17_bootstrap_vue__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue___default.a.component = originalVueComponent;

__WEBPACK_IMPORTED_MODULE_4__router__["a" /* default */].beforeEach(function (to, from, next) {
  document.body.classList.remove('sidebar-mobile-show');
  if (to.meta.requiresAuth) {
    var authUser = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__config__["b" /* getAuthUser */])();
    if (authUser && authUser.access_token) {
      if (to.fullPath === '/') {
        next({ name: 'Dashboard' });
      } else {
        next();
      }
    } else {
      next({ name: 'Auth' });
    }
  }
  if (to.meta.checkLogin) {
    var _authUser = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__config__["b" /* getAuthUser */])();

    if (_authUser && _authUser.access_token) {
      next({ name: 'Dashboard' });
    } else {
      next();
    }
  }
  next();
});
__WEBPACK_IMPORTED_MODULE_0_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_18_vue_echo___default.a, __WEBPACK_IMPORTED_MODULE_19__echoClient__["a" /* default */]);

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue___default.a({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_4__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_8__store__["a" /* default */],
  apolloProvider: apolloProvider,
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App___default.a },
  template: '<App/>'
});

/***/ }),
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_laravel_echo__ = __webpack_require__(886);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_laravel_echo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_laravel_echo__);


window.io = __webpack_require__(896);
var EchoInstance = new __WEBPACK_IMPORTED_MODULE_1_laravel_echo___default.a({
  broadcaster: 'socket.io',
  host: 'https://' + __WEBPACK_IMPORTED_MODULE_0__config__["c" /* socketUrl */],
  auth: {
    headers: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__config__["d" /* getHeader */])()
  }
});

/* harmony default export */ __webpack_exports__["a"] = (EchoInstance);

/***/ }),
/* 341 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);


__WEBPACK_IMPORTED_MODULE_0_vue___default.a.filter('phoneRuFormatting', function (phone) {
  var regExp = /(...)(...)(..)(..)/;
  var phoneReg = regExp.exec(phone);
  if (phoneReg && phoneReg.length === 5) {
    var formatted = '+7';
    formatted += ' (' + phoneReg[1] + ')';
    formatted += ' ' + phoneReg[2];
    formatted += '-' + phoneReg[3] + '-';
    formatted += phoneReg[4];

    return formatted;
  }
  return phone;
});

/***/ }),
/* 342 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment_range__ = __webpack_require__(889);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment_range___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment_range__);


var moment = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_moment_range__["extendMoment"])(__WEBPACK_IMPORTED_MODULE_0_moment___default.a);

/**
 * Проверка входит ли указанная дата в диапазон
 *
 * @param dateFromString
 * @param dateToString
 * @param dateString
 * @param format
 */
var checkDateInRange = function checkDateInRange(dateFromString, dateToString, dateString) {
  var format = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'DD.MM.YYYY';

  var dateFrom = moment(dateFromString, format).startOf('day');
  var dateTo = moment(dateToString, format).endOf('day');
  var date = moment(dateString, format);
  var range = moment().range(dateFrom, dateTo);

  return range.contains(date);
};

/* harmony default export */ __webpack_exports__["a"] = (checkDateInRange);

/***/ }),
/* 343 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Monkey Path для метода getDateRange в компонент datepicker из коллекции vue-strap
 * Решает баг, с отображением первого дня недели, понедельник вместо воскресенья
 * Решение взято отсюда @see https://github.com/yuche/vue-strap/issues/155
 */
var getDateRange = function getDateRange() {
  this.dateRange = [];
  this.decadeRange = [];
  var time = {
    year: this.currDate.getFullYear(),
    month: this.currDate.getMonth(),
    day: this.currDate.getDate()
  };
  var yearStr = time.year.toString();
  var firstYearOfDecade = yearStr.substring(0, yearStr.length - 1) + 0 - 1;
  for (var i = 0; i < 12; i++) {
    this.decadeRange.push({
      text: firstYearOfDecade + i
    });
  }

  var currMonthFirstDay = new Date(time.year, time.month, 1);
  var firstDayWeek = currMonthFirstDay.getDay(); // remove + 1
  if (firstDayWeek === 0) {
    firstDayWeek = 7;
  }
  var dayCount = this.getDayCount(time.year, time.month);
  if (firstDayWeek > 1) {
    var preMonth = this.getYearMonth(time.year, time.month - 1);
    var prevMonthDayCount = this.getDayCount(preMonth.year, preMonth.month);
    for (var _i = 1; _i < firstDayWeek; _i++) {
      var dayText = prevMonthDayCount - firstDayWeek + _i; // remove + 1
      var date = new Date(preMonth.year, preMonth.month, dayText);
      var sclass = 'datepicker-item-gray';
      if (this.disabledDaysArray.indexOf(date.getDay()) > -1) {
        sclass = 'datepicker-item-disable';
      }
      this.dateRange.push({ text: dayText, date: date, sclass: sclass });
    }
  }

  for (var _i2 = 1; _i2 <= dayCount; _i2++) {
    var _date = new Date(time.year, time.month, _i2);
    var _sclass = '';
    if (this.disabledDaysArray.indexOf(_date.getDay()) > -1) {
      _sclass = 'datepicker-item-disable';
    }
    if (_i2 === time.day && _date.getFullYear() === time.year && _date.getMonth() === time.month) {
      _sclass = 'datepicker-dateRange-item-active';
    }
    this.dateRange.push({ text: _i2, date: _date, sclass: _sclass });
  }

  if (this.dateRange.length < 42) {
    var nextMonthNeed = 42 - this.dateRange.length;
    var nextMonth = this.getYearMonth(time.year, time.month + 1);

    for (var _i3 = 1; _i3 <= nextMonthNeed; _i3++) {
      var _date2 = new Date(nextMonth.year, nextMonth.month, _i3);
      var _sclass2 = 'datepicker-item-gray';
      if (this.disabledDaysArray.indexOf(_date2.getDay()) > -1) {
        _sclass2 = 'datepicker-item-disable';
      }
      this.dateRange.push({ text: _i3, date: _date2, sclass: _sclass2 });
    }
  }
};

/* harmony default export */ __webpack_exports__["a"] = (getDateRange);

/***/ }),
/* 344 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// import apolloClient from './../apolloClient.js'

var state = {
  showModal: false,
  editCity: null,
  editCompany: null,
  editTechcenter: null,
  editVirtualNumber: null,
  editInternalNumber: null,
  editRole: null
};

var mutations = {
  SET_ADMIN_MODAL: function SET_ADMIN_MODAL(state, value) {
    state.showModal = value;
  },
  SET_ADMIN_EDIT_CITY: function SET_ADMIN_EDIT_CITY(state, value) {
    state.editCity = value;
  },
  SET_ADMIN_EDIT_COMPANY: function SET_ADMIN_EDIT_COMPANY(state, value) {
    state.editCompany = value;
  },
  SET_ADMIN_EDIT_TECHCENTER: function SET_ADMIN_EDIT_TECHCENTER(state, value) {
    state.editTechcenter = value;
  },
  SET_ADMIN_EDIT_VIRTUAL_NUMBER: function SET_ADMIN_EDIT_VIRTUAL_NUMBER(state, value) {
    state.editVirtualNumber = value;
  },
  SET_ADMIN_EDIT_INTERNAL_NUMBER: function SET_ADMIN_EDIT_INTERNAL_NUMBER(state, value) {
    state.editInternalNumber = value;
  },
  SET_ADMIN_EDIT_ROLE: function SET_ADMIN_EDIT_ROLE(state, value) {
    state.editRole = value;
  }
};

var actions = {
  setAdminModal: function setAdminModal(_ref, value) {
    var commit = _ref.commit;

    commit('SET_ADMIN_MODAL', value);
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state, mutations: mutations, actions: actions
});

/***/ }),
/* 345 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__apolloClient_js__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__gql_queries_getComments_graphql__ = __webpack_require__(858);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__gql_queries_getComments_graphql___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__gql_queries_getComments_graphql__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__gql_mutations_AddComment_graphql__ = __webpack_require__(828);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__gql_mutations_AddComment_graphql___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__gql_mutations_AddComment_graphql__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__gql_mutations_MarkAsViewedComments_graphql__ = __webpack_require__(839);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__gql_mutations_MarkAsViewedComments_graphql___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__gql_mutations_MarkAsViewedComments_graphql__);


var state = {
  comments: null,
  loading: false
};

var mutations = {
  SET_COMMENTS: function SET_COMMENTS(state, comments) {
    state.comments = [];
    comments.forEach(function (comment) {
      state.comments.push(Object.assign({}, comment));
    });
  },
  ADD_COMMENT: function ADD_COMMENT(state, comment) {
    state.comments.push(comment);
  },
  SET_VIEWED_COMMENTS: function SET_VIEWED_COMMENTS(state) {
    state.comments.forEach(function (item, i) {
      state.comments[i].isViewed = true;
    });
  },
  CLEAR_COMMENTS: function CLEAR_COMMENTS(state) {
    state.comments = null;
  },
  SET_COMMENTS_LOADING: function SET_COMMENTS_LOADING(state, value) {
    state.loading = value;
  }
};





var actions = {
  /**
   * Получить список комментариев к заказу
   * @param commit
   * @param orderId
   */
  getComments: function getComments(_ref, orderId) {
    var commit = _ref.commit,
        dispatch = _ref.dispatch;

    commit('SET_COMMENTS_LOADING', true);
    commit('CLEAR_COMMENTS');
    __WEBPACK_IMPORTED_MODULE_0__apolloClient_js__["a" /* default */].query({
      query: __WEBPACK_IMPORTED_MODULE_1__gql_queries_getComments_graphql___default.a,
      variables: {
        orderId: orderId
      },
      fetchPolicy: 'network-only'
    }).then(function (result) {
      commit('SET_COMMENTS', result.data.comments);
      commit('SET_COMMENTS_LOADING', false);
      setTimeout(function () {
        dispatch('markAsViewed', orderId);
      }, 2000);
    }).catch(function (error) {
      console.log(error);
      commit('SET_COMMENTS_LOADING', false);
    });
  },
  markAsViewed: function markAsViewed(_ref2, orderId) {
    var commit = _ref2.commit;

    __WEBPACK_IMPORTED_MODULE_0__apolloClient_js__["a" /* default */].mutate({
      mutation: __WEBPACK_IMPORTED_MODULE_3__gql_mutations_MarkAsViewedComments_graphql___default.a,
      variables: {
        orderId: orderId
      }
    }).then(function (result) {
      commit('SET_VIEWED_COMMENTS');
      commit('COMMENTS_HAS_BEEN_VIEWED', orderId);
    }).catch(function (error) {
      console.log(error);
    });
  },

  sendComment: function sendComment(_ref3, params) {
    var commit = _ref3.commit;

    return new Promise(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_0__apolloClient_js__["a" /* default */].mutate({
        mutation: __WEBPACK_IMPORTED_MODULE_2__gql_mutations_AddComment_graphql___default.a,
        variables: {
          text: params.text,
          orderId: params.orderId
        }
      }).then(function (result) {
        commit('ADD_COMMENT', result.data.addComment);
        commit('COMMENT_HAS_BEEN_ADDED', result.data.addComment);
        resolve();
      }).catch(function (error) {
        reject(error);
      });
    });
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state, mutations: mutations, actions: actions
});

/***/ }),
/* 346 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// import apolloClient from './../apolloClient.js'

var state = {
  showModal: null,
  statisticParams: {
    dateFrom: '',
    dateTo: '',
    cityId: null,
    techcenterId: null,
    status: null,
    userId: null,
    mode: 'search'
  }
};

var mutations = {
  SET_DASHBOARD_SHOW_MODAL: function SET_DASHBOARD_SHOW_MODAL(state, value) {
    state.showModal = value;
  },
  SET_DASHBOARD_STATISTIC_PARAMS: function SET_DASHBOARD_STATISTIC_PARAMS(state, params) {
    state.statisticParams = params;
  }
};

var actions = {
  dashboardShowModal: function dashboardShowModal(_ref, value) {
    var commit = _ref.commit;

    commit('SET_DASHBOARD_SHOW_MODAL', value);
  },
  dashboardSetStatisticParams: function dashboardSetStatisticParams(_ref2, params) {
    var commit = _ref2.commit;

    commit('SET_DASHBOARD_STATISTIC_PARAMS', params);
  }
  // removeAvatar: ({commit}) => {
  //   Vue.http.post(apiDomain + 'api/user/upload-avatar', {}, {headers: getHeader()}).then((response) => {
  //     commit('SET_AVATAR', null)
  //   })
  //
  // }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state, mutations: mutations, actions: actions
});

/***/ }),
/* 347 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__apolloClient_js__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_createUserPolicies__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__gql_queries_getNotifications_graphql__ = __webpack_require__(862);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__gql_queries_getNotifications_graphql___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__gql_queries_getNotifications_graphql__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__gql_queries_initApp_graphql__ = __webpack_require__(871);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__gql_queries_initApp_graphql___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__gql_queries_initApp_graphql__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__gql_queries_updateNotification_graphql__ = __webpack_require__(872);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__gql_queries_updateNotification_graphql___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__gql_queries_updateNotification_graphql__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__gql_mutations_MarkAllNotificationsAsViewed_graphql__ = __webpack_require__(838);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__gql_mutations_MarkAllNotificationsAsViewed_graphql___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__gql_mutations_MarkAllNotificationsAsViewed_graphql__);



var state = {
  user: {},
  statuses: [],
  cities: [],
  loadingApp: false,
  errors: null,
  notifications: [],
  notificationsPaginator: {
    total_count: 0,
    page: 1
  }
};

var mutations = {
  SET_USER: function SET_USER(state, userObj) {
    state.user = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers_createUserPolicies__["a" /* default */])(userObj);
  },
  UPDATE_AVATAR: function UPDATE_AVATAR(state, filePath) {
    state.user.avatar = filePath;
  },
  UPDATE_USER: function UPDATE_USER(state, userObj) {
    state.user = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers_createUserPolicies__["a" /* default */])(userObj);
  },
  SET_STATUSES: function SET_STATUSES(state, statuses) {
    state.statuses = statuses;
  },
  SET_CITIES: function SET_CITIES(state, cities) {
    state.cities = cities;
  },
  SET_NOTIFICATIONS: function SET_NOTIFICATIONS(state, array) {
    state.notifications = [];
    for (var i in array) {
      state.notifications.push(Object.assign({}, array[i]));
    }
  },
  ADD_NOTIFICATIONS: function ADD_NOTIFICATIONS(state, array) {
    for (var i in array) {
      state.notifications.push(array[i]);
    }
  },
  SET_NOTIFICATIONS_PAGINATOR: function SET_NOTIFICATIONS_PAGINATOR(state, value) {
    var paginator = {
      totalCount: value.total_count,
      page: value.page
    };
    state.notificationsPaginator = Object.assign({}, paginator);
  },
  ADD_NOTIFICATION_FIRST: function ADD_NOTIFICATION_FIRST(state, notification) {
    state.notifications.unshift(notification);
    var totalCount = state.notificationsPaginator.totalCount + 1;
    state.notificationsPaginator.totalCount = totalCount;
  },
  SET_LOADING_APP: function SET_LOADING_APP(state, value) {
    state.loadingApp = value;
  },
  SET_ERROR: function SET_ERROR(state, value) {
    state.errors = value;
  }
};






var actions = {
  initApp: function initApp(_ref) {
    var commit = _ref.commit;

    commit('SET_LOADING_APP', true);
    return new Promise(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_0__apolloClient_js__["a" /* default */].query({
        query: __WEBPACK_IMPORTED_MODULE_3__gql_queries_initApp_graphql___default.a,
        fetchPolicy: 'network-only'
      }).then(function (result) {
        commit('SET_USER', result.data.user);
        commit('SET_STATUSES', result.data.statuses);
        commit('SET_CITIES', result.data.cities);
        commit('ADD_NOTIFICATIONS', result.data.notifications);
        commit('SET_NOTIFICATIONS_PAGINATOR', result.data.paginator);
        commit('SET_LOADING_APP', false);
        resolve();
      }).catch(function (error) {
        commit('SET_LOADING_APP', false);
        if (error.status < 400 || error.status === 404 || error.status >= 500) {
          commit('SET_ERROR', error);
        }
        reject();
      });
    });
  },
  loadNotifications: function loadNotifications(_ref2) {
    var commit = _ref2.commit,
        state = _ref2.state;

    return new Promise(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_0__apolloClient_js__["a" /* default */].query({
        query: __WEBPACK_IMPORTED_MODULE_2__gql_queries_getNotifications_graphql___default.a,
        variables: {
          page: state.notificationsPaginator.page + 1
        },
        fetchPolicy: 'network-only'
      }).then(function (result) {
        if (result.data.notifications.length > 0) {
          commit('ADD_NOTIFICATIONS', result.data.notifications);
          commit('SET_NOTIFICATIONS_PAGINATOR', result.data.paginator);
          resolve();
        } else {
          reject();
        }
      }).catch(function (error) {
        console.log(error);
        if (error.status !== 422 || error.status !== 401) {
          commit('SET_ERROR', error);
        }
        reject();
      });
    });
  },
  /**
   * Пометить все уведомления как прочитанные
   * @param state
   * @param commit
   * @param params
   * @return {Promise}
   */
  markAllNotificationsAsViewed: function markAllNotificationsAsViewed(_ref3, params) {
    var state = _ref3.state,
        commit = _ref3.commit;

    return new Promise(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_0__apolloClient_js__["a" /* default */].mutate({
        mutation: __WEBPACK_IMPORTED_MODULE_5__gql_mutations_MarkAllNotificationsAsViewed_graphql___default.a
      }).then(function (data) {
        if (data.data.markAsViewed) {
          var paginator = Object.assign({}, state.notificationsPaginator);
          paginator.total_count = 0;
          commit('SET_NOTIFICATIONS_PAGINATOR', paginator);
          var notifications = [];
          for (var notice in state.notifications) {
            var notification = Object.assign({}, notice);
            notification.isViewed = true;
            notifications.push(notification);
          }
          commit('SET_NOTIFICATIONS', notifications);
          resolve();
        } else {
          reject();
        }
      }).catch(function (error) {
        console.log(error);
        reject(error);
      });
    });
  },
  updateNotifications: function updateNotifications(_ref4) {
    var commit = _ref4.commit;

    return new Promise(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_0__apolloClient_js__["a" /* default */].query({
        query: __WEBPACK_IMPORTED_MODULE_4__gql_queries_updateNotification_graphql___default.a,
        fetchPolicy: 'network-only'
      }).then(function (result) {
        console.log(result);
        commit('SET_NOTIFICATIONS', result.data.notifications);
        commit('SET_NOTIFICATIONS_PAGINATOR', result.data.paginator);
        resolve();
      }).catch(function (error) {
        console.log(error);
        reject(error);
      });
    });
  }
  // clearAuthUser: ({commit}) => {
  //   commit('CLEAR_AUTH_USER')
  // },
  // removeAvatar: ({commit}) => {
  //   Vue.http.post(apiDomain + 'api/user/upload-avatar', {}, {headers: getHeader()}).then((response) => {
  //     commit('SET_AVATAR', null)
  //   })
  //
  // }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state, mutations: mutations, actions: actions
});

/***/ }),
/* 348 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex_toast__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex_toast___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vuex_toast__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__globalStore__ = __webpack_require__(347);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__orderStore__ = __webpack_require__(349);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__commentStore__ = __webpack_require__(345);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__adminStore__ = __webpack_require__(344);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__userStore__ = __webpack_require__(351);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__dashboardStore__ = __webpack_require__(346);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__techcenterStore__ = __webpack_require__(350);


__WEBPACK_IMPORTED_MODULE_0_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_1_vuex__["default"]);


var debug = "production" !== 'production';








// A Vuex instance is created by combining the state, mutations, actions,
// and getters.
/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["default"].Store({
  modules: {
    globalStore: __WEBPACK_IMPORTED_MODULE_3__globalStore__["a" /* default */],
    orderStore: __WEBPACK_IMPORTED_MODULE_4__orderStore__["a" /* default */],
    commentStore: __WEBPACK_IMPORTED_MODULE_5__commentStore__["a" /* default */],
    adminStore: __WEBPACK_IMPORTED_MODULE_6__adminStore__["a" /* default */],
    userStore: __WEBPACK_IMPORTED_MODULE_7__userStore__["a" /* default */],
    dashboardStore: __WEBPACK_IMPORTED_MODULE_8__dashboardStore__["a" /* default */],
    techcenterStore: __WEBPACK_IMPORTED_MODULE_9__techcenterStore__["a" /* default */],
    toast: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex_toast__["createModule"])({
      dismissInterval: 8000
    })
  },
  strict: debug
}));

/***/ }),
/* 349 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__apolloClient_js__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_checkDateInRange__ = __webpack_require__(342);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__gql_queries_getOrders_graphql__ = __webpack_require__(257);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__gql_queries_getOrders_graphql___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__gql_queries_getOrders_graphql__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__gql_queries_getOrderById_graphql__ = __webpack_require__(863);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__gql_queries_getOrderById_graphql___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__gql_queries_getOrderById_graphql__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__gql_mutations_AddOrder_graphql__ = __webpack_require__(831);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__gql_mutations_AddOrder_graphql___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__gql_mutations_AddOrder_graphql__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__gql_mutations_UpdateOrder_graphql__ = __webpack_require__(849);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__gql_mutations_UpdateOrder_graphql___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__gql_mutations_UpdateOrder_graphql__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__gql_mutations_CancelOrder_graphql__ = __webpack_require__(834);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__gql_mutations_CancelOrder_graphql___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__gql_mutations_CancelOrder_graphql__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__gql_mutations_ProblemOrder_graphql__ = __webpack_require__(845);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__gql_mutations_ProblemOrder_graphql___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__gql_mutations_ProblemOrder_graphql__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__gql_mutations_CloseOrder_graphql__ = __webpack_require__(836);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__gql_mutations_CloseOrder_graphql___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__gql_mutations_CloseOrder_graphql__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__gql_mutations_OrderTransition_graphql__ = __webpack_require__(840);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__gql_mutations_OrderTransition_graphql___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__gql_mutations_OrderTransition_graphql__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__gql_mutations_DeleteOrder_graphql__ = __webpack_require__(837);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__gql_mutations_DeleteOrder_graphql___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__gql_mutations_DeleteOrder_graphql__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__router__ = __webpack_require__(116);




var state = {
  orders: [],
  order: {},
  loading: false,
  params: {
    dateFrom: '',
    dateTo: '',
    mode: ''
  },
  showModal: null,
  confirmTransition: null,
  editOrder: null,
  activeOrderId: null
};

var mutations = {
  SET_ORDERS: function SET_ORDERS(state, orders) {
    state.orders = [];
    orders.forEach(function (order) {
      state.orders.push(Object.assign({}, order));
    });
  },
  ADD_ORDER: function ADD_ORDER(state, order) {
    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__helpers_checkDateInRange__["a" /* default */])(state.params.dateFrom, state.params.dateTo, order.date)) {
      state.orders.push(Object.assign({}, order));
    }
  },
  UPDATE_ORDER: function UPDATE_ORDER(state, order) {
    if (order.id === state.order.id) {
      state.order = Object.assign({}, order);
    }
    var index = state.orders.findIndex(function (o) {
      return o.id === order.id;
    });
    if (index !== -1) {
      __WEBPACK_IMPORTED_MODULE_1_vue___default.a.set(state.orders, index, Object.assign({}, order));
    }
  },
  DELETE_ORDER: function DELETE_ORDER(state, id) {
    var index = state.orders.findIndex(function (o) {
      return o.id === id;
    });
    if (index !== -1) {
      __WEBPACK_IMPORTED_MODULE_1_vue___default.a.delete(state.orders, index);
    }
  },
  SET_CONFIRM_TRANSITION: function SET_CONFIRM_TRANSITION(state, value) {
    state.confirmTransition = value;
  },

  // CANCEL_ORDER (state, id) {
  //   let index = state.orders.findIndex(o => o.id === id)
  //   if (index !== -1) {
  //     state.orders[index].status = {
  //       __typename: 'Status',
  //       class: 'btn-danger',
  //       code: 'canceled',
  //       id: 4,
  //       name: 'Отменен'
  //     }
  //   }
  // },
  COMMENT_HAS_BEEN_ADDED: function COMMENT_HAS_BEEN_ADDED(state, comment) {
    var index = state.orders.findIndex(function (o) {
      return o.id === comment.orderId;
    });
    if (index !== -1) {
      state.orders[index].commentsCount += 1;
    }
  },
  COMMENT_HAS_BEEN_UNVIEWED: function COMMENT_HAS_BEEN_UNVIEWED(state, comment) {
    var index = state.orders.findIndex(function (o) {
      return o.id === comment.orderId;
    });
    if (index !== -1) {
      state.orders[index].commentsCountUnviewed += 1;
    }
  },
  COMMENTS_HAS_BEEN_VIEWED: function COMMENTS_HAS_BEEN_VIEWED(state, orderId) {
    var index = state.orders.findIndex(function (o) {
      return o.id === orderId;
    });
    if (index !== -1) {
      state.orders[index].commentsCountUnviewed = 0;
    }
  },
  SET_LOADING: function SET_LOADING(state, value) {
    state.loading = value;
  },
  SET_PARAMS: function SET_PARAMS(state, params) {
    state.params = params;
  },
  SET_SHOW_ORDER_MODAL: function SET_SHOW_ORDER_MODAL(state, value) {
    state.showModal = value;
  },
  SET_EDIT_ORDER: function SET_EDIT_ORDER(state, order) {
    state.editOrder = order;
  },
  SET_ACTIVE_ORDER_ID: function SET_ACTIVE_ORDER_ID(state, id) {
    state.activeOrderId = id;
  },
  SET_ORDER: function SET_ORDER(state, order) {
    state.order = Object.assign({}, order);
  },
  CLEAR_ORDER_DATA: function CLEAR_ORDER_DATA(state) {
    state.order = {};
  }
};











var actions = {
  /**
   * Получить список заказов
   * @param commit
   * @param params Параметры поиска заказов
   */
  getOrders: function getOrders(_ref, params) {
    var commit = _ref.commit;

    return new Promise(function (resolve, reject) {
      commit('SET_LOADING', true);
      commit('SET_PARAMS', {});
      __WEBPACK_IMPORTED_MODULE_0__apolloClient_js__["a" /* default */].query({
        query: __WEBPACK_IMPORTED_MODULE_3__gql_queries_getOrders_graphql___default.a,
        variables: {
          id: params.id,
          dateFrom: params.dateFrom,
          dateTo: params.dateTo,
          cityId: params.cityId,
          companyId: params.companyId,
          techcenterId: params.techcenterId,
          userId: params.userId,
          status: params.status,
          clientPhone: params.clientPhone,
          canceled: params.canceled,
          problem: params.problem
        },
        fetchPolicy: 'network-only'
      }).then(function (result) {
        commit('SET_ORDERS', result.data.orders);
        commit('SET_PARAMS', params);
        commit('SET_LOADING', false);
        resolve(result);
      }).catch(function (error) {
        console.log(error);
        commit('SET_LOADING', false);
        reject(error);
      });
    });
  },
  /**
   * Добавить заказ
   * @param commit
   * @param order
   * @return {Promise}
   */
  addOrder: function addOrder(_ref2, order) {
    var commit = _ref2.commit;

    return new Promise(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_0__apolloClient_js__["a" /* default */].mutate({
        mutation: __WEBPACK_IMPORTED_MODULE_5__gql_mutations_AddOrder_graphql___default.a,
        variables: {
          orderDate: order.orderDate,
          orderTime: order.orderTime,
          techcenterId: order.techcenterId,
          description: order.description,
          clientName: order.clientName,
          clientPhone: order.clientPhone,
          sum: order.sum
        }
      }).then(function (result) {
        commit('ADD_ORDER', result.data.addOrder);
        resolve(result);
      }).catch(function (error) {
        console.log(error);
        reject(error);
      });
    });
  },
  /**
   * Обновить заказ
   * @param commit
   * @param order
   * @return {Promise}
   */
  updateOrder: function updateOrder(_ref3, order) {
    var commit = _ref3.commit;

    return new Promise(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_0__apolloClient_js__["a" /* default */].mutate({
        mutation: __WEBPACK_IMPORTED_MODULE_6__gql_mutations_UpdateOrder_graphql___default.a,
        variables: {
          id: order.id,
          orderDate: order.orderDate,
          orderTime: order.orderTime,
          techcenterId: order.techcenterId,
          description: order.description,
          clientName: order.clientName,
          clientPhone: order.clientPhone,
          sum: order.sum
        }
      }).then(function (result) {
        // Если номер заказа не совпадает, значит это была перезапись в другой техцентр и заказ был отменен
        // Вместо обновления данных в store ловим обновление заказа через web socket
        if (order.id !== result.data.updateOrder.id) {
          // order.status = {
          //   __typename: 'Status',
          //   class: 'btn-danger',
          //   code: 'canceled',
          //   id: 4,
          //   name: 'Отменен'
          // }
          // commit('CANCEL_ORDER', order.id)
          commit('ADD_ORDER', result.data.updateOrder);
        } else {
          commit('UPDATE_ORDER', result.data.updateOrder);
        }
        resolve(result);
      }).catch(function (error) {
        console.log(error);
        reject(error);
      });
    });
  },
  /**
   * Удаление заказа
   * @param commit
   * @param id
   * @return {Promise}
   */
  deleteOrder: function deleteOrder(_ref4, id) {
    var commit = _ref4.commit;

    return new Promise(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_0__apolloClient_js__["a" /* default */].mutate({
        mutation: __WEBPACK_IMPORTED_MODULE_11__gql_mutations_DeleteOrder_graphql___default.a,
        variables: {
          id: id
        }
      }).then(function (result) {
        if (result.data) {
          commit('DELETE_ORDER', id);
          resolve(result);
        } else {
          console.log(result);
          reject(result);
        }
      }).catch(function (error) {
        console.log(error);
        reject(error);
      });
    });
  },
  /**
   * Установка Состояния заказа
   * @param state
   * @param commit
   * @param dispatch
   * @param params
   * @return {Promise}
   */
  setOrderTransition: function setOrderTransition(_ref5, params) {
    var state = _ref5.state,
        commit = _ref5.commit,
        dispatch = _ref5.dispatch;

    return new Promise(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_0__apolloClient_js__["a" /* default */].mutate({
        mutation: __WEBPACK_IMPORTED_MODULE_10__gql_mutations_OrderTransition_graphql___default.a,
        variables: {
          code: params.code,
          orderId: params.orderId,
          sum: params.sum,
          profit: params.profit,
          comment: params.comment
        }
      }).then(function (result) {
        commit('UPDATE_ORDER', result.data.orderTransition);
        resolve(result);
      }).catch(function (error) {
        console.log(error);
        reject(error);
      });
    });
  },
  /**
   * Закрыть заказ
   * @param state
   * @param commit
   * @param params
   * @return {Promise}
   */
  closeOrder: function closeOrder(_ref6, params) {
    var state = _ref6.state,
        commit = _ref6.commit;

    return new Promise(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_0__apolloClient_js__["a" /* default */].mutate({
        mutation: __WEBPACK_IMPORTED_MODULE_9__gql_mutations_CloseOrder_graphql___default.a,
        variables: {
          orderId: params.orderId,
          sum: params.sum,
          profit: params.profit
        }
      }).then(function (result) {
        commit('UPDATE_ORDER', result.data.closeOrder);
        resolve(result);
      }).catch(function (error) {
        console.log(error);
        reject(error);
      });
    });
  },
  /**
   * Отменить заказ
   * @param state
   * @param commit
   * @param params
   * @return {Promise}
   */
  cancelOrder: function cancelOrder(_ref7, params) {
    var state = _ref7.state,
        commit = _ref7.commit;

    return new Promise(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_0__apolloClient_js__["a" /* default */].mutate({
        mutation: __WEBPACK_IMPORTED_MODULE_7__gql_mutations_CancelOrder_graphql___default.a,
        // Parameters
        variables: {
          orderId: params.orderId,
          value: params.value,
          cause: params.cause
        }
      }).then(function (result) {
        commit('UPDATE_ORDER', result.data.cancelOrder);
        resolve(result);
      }).catch(function (error) {
        console.log(error);
        reject(error);
      });
    });
  },
  /**
   * Проблемный заказ
   * @param state
   * @param commit
   * @param params
   * @return {Promise}
   */
  problemOrder: function problemOrder(_ref8, params) {
    var state = _ref8.state,
        commit = _ref8.commit;

    return new Promise(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_0__apolloClient_js__["a" /* default */].mutate({
        mutation: __WEBPACK_IMPORTED_MODULE_8__gql_mutations_ProblemOrder_graphql___default.a,
        // Parameters
        variables: {
          orderId: params.orderId,
          value: params.value,
          cause: params.cause
        }
      }).then(function (result) {
        commit('UPDATE_ORDER', result.data.problemOrder);
        resolve(result);
      }).catch(function (error) {
        console.log(error);
        reject(error);
      });
    });
  },
  /**
   * Добавление заказа в store по id, вызывается в случае евента о новом заказе
   * @param state
   * @param commit
   * @param orderId
   * @return {Promise}
   */
  addOrderStoreById: function addOrderStoreById(_ref9, orderId) {
    var state = _ref9.state,
        commit = _ref9.commit;

    return new Promise(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_0__apolloClient_js__["a" /* default */].query({
        query: __WEBPACK_IMPORTED_MODULE_3__gql_queries_getOrders_graphql___default.a,
        variables: {
          id: [orderId]
        },
        fetchPolicy: 'network-only'
      }).then(function (result) {
        if (result.data.orders[0]) {
          commit('ADD_ORDER', result.data.orders[0]);
          resolve(result.data.orders[0]);
        } else {
          console.log(result);
          reject(result);
        }
      }).catch(function (error) {
        console.log(error);
        reject(error);
      });
    });
  },
  /**
   * Обновление заказа в store по id, вызывается в случае евента о изменении заказа
   * @param state
   * @param commit
   * @param orderId
   * @return {Promise}
   */
  updateOrderStoreById: function updateOrderStoreById(_ref10, orderId) {
    var state = _ref10.state,
        commit = _ref10.commit;

    return new Promise(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_0__apolloClient_js__["a" /* default */].query({
        query: __WEBPACK_IMPORTED_MODULE_3__gql_queries_getOrders_graphql___default.a,
        variables: {
          id: [orderId]
        },
        fetchPolicy: 'network-only'
      }).then(function (result) {
        if (result.data.orders[0]) {
          commit('UPDATE_ORDER', result.data.orders[0]);
          resolve(result.data.orders[0]);
        } else {
          console.log(result);
          reject(result);
        }
      }).catch(function (error) {
        console.log(error);
        reject(error);
      });
    });
  },
  setActiveOrderId: function setActiveOrderId(_ref11, id) {
    var commit = _ref11.commit;

    commit('SET_ACTIVE_ORDER_ID', id);
  },
  setEditOrder: function setEditOrder(_ref12, order) {
    var commit = _ref12.commit;

    commit('SET_EDIT_ORDER', order);
  },
  setConfirmTransition: function setConfirmTransition(_ref13, transition) {
    var commit = _ref13.commit;

    commit('SET_CONFIRM_TRANSITION', transition);
  },
  showOrderDetail: function showOrderDetail(_ref14, id) {
    var commit = _ref14.commit,
        dispatch = _ref14.dispatch;

    var params = {
      id: [id],
      mode: 'search'
    };
    window.localStorage.setItem('displayMode', 'search');
    window.localStorage.setItem('displayModeParams', JSON.stringify(params));
    dispatch('setActiveOrderId', id);
    if (__WEBPACK_IMPORTED_MODULE_12__router__["a" /* default */].currentRoute.name !== 'Orders') {
      __WEBPACK_IMPORTED_MODULE_12__router__["a" /* default */].push({ name: 'Orders' });
    } else {
      dispatch('getOrders', params);
    }
  },

  /**
   * Получение заказа детально
   * @param commit
   * @param id
   * @param imgWidth
   * @param imgHeight
   * @returns {Promise<any>}
   */
  getOrderById: function getOrderById(_ref15, _ref16) {
    var commit = _ref15.commit;
    var id = _ref16.id;

    return new Promise(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_0__apolloClient_js__["a" /* default */].query({
        query: __WEBPACK_IMPORTED_MODULE_4__gql_queries_getOrderById_graphql___default.a,
        variables: {
          id: [id]
        },
        fetchPolicy: 'network-only'
      }).then(function (result) {
        if (result.data.orders[0]) {
          commit('SET_ORDER', result.data.orders[0]);
        }
        resolve(result);
      }).catch(function (error) {
        console.warn(error);
        reject();
      });
    });
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state, mutations: mutations, actions: actions
});

/***/ }),
/* 350 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__apolloClient_js__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__gql_queries_getTechcenterById_graphql__ = __webpack_require__(866);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__gql_queries_getTechcenterById_graphql___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__gql_queries_getTechcenterById_graphql__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__gql_mutations_BlockTechcenter_graphql__ = __webpack_require__(248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__gql_mutations_BlockTechcenter_graphql___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__gql_mutations_BlockTechcenter_graphql__);


var state = {
  techcenter: {}
};

var mutations = {
  SET_TECHCENTER: function SET_TECHCENTER(state, techcenter) {
    state.techcenter = Object.assign({}, techcenter);
  },
  CLEAR_TECHCENTER_DATA: function CLEAR_TECHCENTER_DATA(state) {
    state.techcenter = {};
  }
};



var actions = {
  getTechcenterById: function getTechcenterById(_ref, _ref2) {
    var commit = _ref.commit;
    var id = _ref2.id,
        imgWidth = _ref2.imgWidth,
        imgHeight = _ref2.imgHeight;

    return new Promise(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_0__apolloClient_js__["a" /* default */].query({
        query: __WEBPACK_IMPORTED_MODULE_1__gql_queries_getTechcenterById_graphql___default.a,
        variables: {
          id: [id],
          imgWidth: imgWidth,
          imgHeight: imgHeight
        },
        fetchPolicy: 'network-only'
      }).then(function (result) {
        if (result.data.techcenters[0]) {
          commit('SET_TECHCENTER', result.data.techcenters[0]);
        }
        resolve(result);
      }).catch(function (error) {
        console.warn(error);
        reject();
      });
    });
  },
  blockTechcenter: function blockTechcenter(_ref3, params) {
    var commit = _ref3.commit;

    return new Promise(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_0__apolloClient_js__["a" /* default */].mutate({
        mutation: __WEBPACK_IMPORTED_MODULE_2__gql_mutations_BlockTechcenter_graphql___default.a,
        variables: {
          id: params.id,
          enabled: params.enabled
        }
      }).then(function (result) {
        commit('SET_TECHCENTER', result.data.blockTechcenter);
        resolve(result);
      }).catch(function (error) {
        console.warn(error);
        reject(error);
      });
    });
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state, mutations: mutations, actions: actions
});

/***/ }),
/* 351 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__apolloClient_js__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_createUserPolicies__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__gql_queries_getUserById_graphql__ = __webpack_require__(867);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__gql_queries_getUserById_graphql___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__gql_queries_getUserById_graphql__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__gql_mutations_UpdateUserProfile_graphql__ = __webpack_require__(852);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__gql_mutations_UpdateUserProfile_graphql___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__gql_mutations_UpdateUserProfile_graphql__);



var state = {
  user: {}
};

var mutations = {
  SET_VIEWED_USER: function SET_VIEWED_USER(state, userObj) {
    state.user = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers_createUserPolicies__["a" /* default */])(userObj);
  },
  UPDATE_VIEWED_AVATAR: function UPDATE_VIEWED_AVATAR(state, filePath) {
    state.user.avatar = filePath;
  },
  UPDATE_VIEWED_USER: function UPDATE_VIEWED_USER(state, userObj) {
    state.user = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers_createUserPolicies__["a" /* default */])(userObj);
  }
  // SET_VIEWED_USER_IS_ADMIN (state, value) {
  //   state.user.isAdmin = value
  // },
  // SET_VIEWED_USER_ROLE (state, value) {
  //   state.user.role = value
  // }

};




var actions = {
  getUserById: function getUserById(_ref, id) {
    var commit = _ref.commit;

    return new Promise(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_0__apolloClient_js__["a" /* default */].query({
        query: __WEBPACK_IMPORTED_MODULE_2__gql_queries_getUserById_graphql___default.a,
        variables: {
          id: id
        }
      }).then(function (result) {
        commit('SET_VIEWED_USER', result.data.user);
        resolve();
      }).catch(function (error) {
        console.log(error);
        reject();
      });
    });
  },
  updateUserProfile: function updateUserProfile(_ref2, params) {
    var state = _ref2.state,
        commit = _ref2.commit;

    return new Promise(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_0__apolloClient_js__["a" /* default */].mutate({
        mutation: __WEBPACK_IMPORTED_MODULE_3__gql_mutations_UpdateUserProfile_graphql___default.a,
        variables: params
      }).then(function (result) {
        commit('UPDATE_VIEWED_USER', result.data.updateUserProfile);
        resolve(result.data.updateUserProfile);
      }).catch(function (error) {
        console.log(error);
        reject(error);
      });
    });
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state, mutations: mutations, actions: actions
});

/***/ }),
/* 352 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex_toast__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex_toast___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vuex_toast__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex_toast_dist_vuex_toast_css__ = __webpack_require__(785);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex_toast_dist_vuex_toast_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuex_toast_dist_vuex_toast_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(3);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'App',
  components: {
    Toast: __WEBPACK_IMPORTED_MODULE_0_vuex_toast__["Toast"]
  },
  computed: _extends({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["mapState"])({
    errors: function errors(state) {
      return state.globalStore.errors;
    }
  }))
});

/***/ }),
/* 353 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_v_mask__ = __webpack_require__(270);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ApInputPhone',
  props: {
    value: {
      type: String,
      default: ''
    },
    advancedErrorClass: {
      type: String,
      default: ''
    },
    error: {
      type: Boolean,
      default: false
    },
    errorText: {
      type: String,
      default: 'Введите правильный номер телефона'
    },
    inputId: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      phone: this.value
    };
  },

  computed: {
    formattedPhone: function formattedPhone() {
      return this.phone.replace(/\D+/g, '');
    }
  },
  directive: __WEBPACK_IMPORTED_MODULE_0_v_mask__["b" /* VueMaskDirective */]
});

/***/ }),
/* 354 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_easy_lightbox__ = __webpack_require__(272);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_easy_lightbox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_easy_lightbox__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ApGallery',
  props: {
    images: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  components: {
    Lightbox: __WEBPACK_IMPORTED_MODULE_0_vue_easy_lightbox___default.a
  },
  data: function data() {
    return {
      visible: false,
      index: 0
    };
  },

  computed: {
    imgUrls: function imgUrls() {
      var urls = [];
      this.images.forEach(function (item) {
        urls.push(item.originPath);
      });
      return urls;
    }
  },
  methods: {
    handleImage: function handleImage(url) {
      var _this = this;

      if (url === '') {
        this.visible = false;
        return true;
      }
      this.images.forEach(function (item, index) {
        if (item.fullPath === url) {
          _this.index = index;
        }
      });
      this.visible = !this.visible;
    }
  }
});

/***/ }),
/* 355 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    separator: String
  },
  computed: {
    list: function list() {
      return this.$route.matched;
    }
  },
  methods: {
    isLast: function isLast(index) {
      return index === this.list.length - 1;
    },
    showName: function showName(item) {
      if (!item.name) {
        return false;
      }

      if (item.meta && item.meta.label) {
        item = item.meta && item.meta.label;
      }
      if (item.name) {
        item = item.name;
      }
      return item;
    }
  }
});

/***/ }),
/* 356 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex_toast__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex_toast___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuex_toast__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'comments',
  props: ['order'],
  data: function data() {
    return {
      sendLoading: false,
      commentText: ''
    };
  },

  computed: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["mapState"])({
    user: function user(state) {
      return state.globalStore.user;
    },
    loading: function loading(state) {
      return state.commentStore.loading;
    },
    comments: function comments(state) {
      return state.commentStore.comments;
    }
  }),
  methods: _extends({
    /**
     * Метод возвращает полный пут к аватарке пользователя
     * @param path
     * @return {string}
     */
    getAvatarPath: function getAvatarPath(path) {
      return __WEBPACK_IMPORTED_MODULE_0__config__["e" /* storageUrl */] + path;
    },

    /**
     * Метод проверяет предыдущее сообщение того же пользователя или нет
     * @param user
     * @param index
     * @return bool
     */
    firstCommentUser: function firstCommentUser(user, index) {
      var comment = this.comments[index - 1];
      if (comment !== undefined && comment.user.id === user.id) {
        return false;
      } else {
        return true;
      }
    },

    /**
     * Валидация формы перед отправкой
     */
    beforeSend: function beforeSend() {
      this.$v.commentText.$touch();
      if (!this.$v.commentText.$error) {
        this.sendComment();
      }
    },

    /**
     * Отправка комментария
     */
    sendComment: function sendComment() {
      var _this = this;

      this.sendLoading = true;
      var newComment = this.commentText;
      this.commentText = '';
      this.$store.dispatch('sendComment', {
        text: newComment,
        orderId: this.order.id
      }).then(function () {
        _this.sendLoading = false;
        _this.addToast({
          text: 'Комментарий успешно опубликован',
          type: 'success',
          position: 'se',
          dismissAfter: 3000
        });
        _this.$v.commentText.$reset();
      }).catch(function (error) {
        console.log(error);
        _this.addToast({
          text: 'Ошибка отправки комментария: ' + error,
          type: 'danger',
          position: 'se',
          dismissAfter: 3000
        });
        _this.sendLoading = false;
        _this.commentText = newComment.text;
      });
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["mapActions"])({
    addToast: __WEBPACK_IMPORTED_MODULE_3_vuex_toast__["ADD_TOAST_MESSAGE"]
  })),
  mounted: function mounted() {
    if (this.order.canOrderViewComments) {
      this.$store.dispatch('getComments', this.order.id);
    }
  },

  validations: {
    commentText: {
      required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"],
      minLength: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["minLength"])(2)
    }
  }
});

/***/ }),
/* 357 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'footer'
});

/***/ }),
/* 358 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_infinite_loading__ = __webpack_require__(907);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_infinite_loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_infinite_loading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Navbar__ = __webpack_require__(935);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Navbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Navbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__HeaderSearchInput_vue__ = __webpack_require__(919);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__HeaderSearchInput_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__HeaderSearchInput_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex_toast__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex_toast___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vuex_toast__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'header',
  computed: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["mapState"])({
    user: function user(state) {
      return state.globalStore.user;
    },
    notifications: function notifications(state) {
      return state.globalStore.notifications;
    },
    paginator: function paginator(state) {
      return state.globalStore.notificationsPaginator;
    }
  }),
  components: {
    navbar: __WEBPACK_IMPORTED_MODULE_1__Navbar___default.a,
    HeaderSearchInput: __WEBPACK_IMPORTED_MODULE_2__HeaderSearchInput_vue___default.a,
    InfiniteLoading: __WEBPACK_IMPORTED_MODULE_0_vue_infinite_loading___default.a
  },
  data: function data() {
    return {
      showNotifications: false,
      loadingMarkAsRead: false
    };
  },

  methods: _extends({
    showOrderDetail: function showOrderDetail(id) {
      this.showNotifications = false;
      this.$store.dispatch('showOrderDetail', id);
    },
    click: function click() {
      // do nothing
    },
    sidebarToggle: function sidebarToggle(e) {
      e.preventDefault();
      document.body.classList.toggle('sidebar-hidden');
    },
    mobileSidebarToggle: function mobileSidebarToggle(e) {
      e.preventDefault();
      document.body.classList.toggle('sidebar-mobile-show');
    },
    asideToggle: function asideToggle(e) {
      e.preventDefault();
      document.body.classList.toggle('aside-menu-hidden');
    },

    /**
     * Выход из CRM
     */
    logout: function logout() {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__config__["h" /* logout */])();
    },
    /**
     * Метод возвращает полный пут к аватарке пользователя
     * @param path
     * @return {string}
     */
    getAvatarPath: function getAvatarPath(path) {
      return __WEBPACK_IMPORTED_MODULE_3__config__["e" /* storageUrl */] + path;
    },

    /**
     * Подгрузка уведомлений
     */
    infiniteHandler: function infiniteHandler($state) {
      this.$store.dispatch('loadNotifications').then(function () {
        $state.loaded();
      }).catch(function () {
        $state.complete();
      });
    },

    /**
     * Помеить все сообщения как прочитанные
     */
    markAllAsViewed: function markAllAsViewed() {
      var _this = this;

      this.loadingMarkAsRead = true;
      this.$store.dispatch('markAllNotificationsAsViewed').then(function () {
        _this.addToast({
          text: 'Все сообщения помечены как прочитанные',
          type: 'success',
          dismissAfter: 3000
        });
        _this.loadingMarkAsRead = false;
        _this.showNotifications = false;
      }).catch(function () {
        _this.loadingMarkAsRead = false;
        _this.addToast({
          text: 'Произошла ошибка. Попробуйте еще раз или обратитесь к администратору',
          type: 'error',
          dismissAfter: 3000
        });
      });
    },

    /**
     * Показать модальное окно добавления заказа
     */
    showEditModal: function showEditModal() {
      this.$store.commit('SET_SHOW_ORDER_MODAL', 'addEditOrder');
    },
    goToProfile: function goToProfile() {
      this.$router.push({ name: 'Profile' });
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["mapActions"])({
    addToast: __WEBPACK_IMPORTED_MODULE_5_vuex_toast__["ADD_TOAST_MESSAGE"]
  }))
});

/***/ }),
/* 359 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex_toast__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex_toast___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuex_toast__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_multiselect__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_multiselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_multiselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue2_datepicker__ = __webpack_require__(989);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue2_datepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue2_datepicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_gql_queries_getTechcenters_graphql__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_gql_queries_getTechcenters_graphql___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_gql_queries_getTechcenters_graphql__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_gql_queries_getCompanies_graphql__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_gql_queries_getCompanies_graphql___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_gql_queries_getCompanies_graphql__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_gql_queries_getUsersForMultiselect_graphql__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_gql_queries_getUsersForMultiselect_graphql___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_gql_queries_getUsersForMultiselect_graphql__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_gql_queries_getOrders_graphql__ = __webpack_require__(257);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_gql_queries_getOrders_graphql___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_gql_queries_getOrders_graphql__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__views_Orders_OrderStatus_vue__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__views_Orders_OrderStatus_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__views_Orders_OrderStatus_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_moment__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vuelidate_lib_validators__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_vuelidate_lib_validators__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//












/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'header-search-input',
  computed: _extends({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["mapState"])({
    cities: function cities(state) {
      return state.globalStore.cities;
    },
    statuses: function statuses(state) {
      return state.globalStore.statuses;
    }
  })),
  components: {
    Multiselect: __WEBPACK_IMPORTED_MODULE_2_vue_multiselect___default.a,
    DateRangePicker: __WEBPACK_IMPORTED_MODULE_3_vue2_datepicker___default.a,
    OrderStatus: __WEBPACK_IMPORTED_MODULE_8__views_Orders_OrderStatus_vue___default.a
  },
  watch: {
    query: function query(queryString) {
      var _this = this;

      if (queryString.length > 1) {
        this.loading.search = true;
        this.$apollo.query({
          query: __WEBPACK_IMPORTED_MODULE_7_gql_queries_getOrders_graphql___default.a,
          variables: {
            query: queryString,
            limit: 20
          }
        }).then(function (result) {
          _this.loading.search = false;
          _this.result = result.data.orders;
        }).catch(function (error) {
          _this.loading.search = true;
          console.log(error);
        });
      }
    }
  },
  data: function data() {
    return {
      format: 'DD/MM/YYYY',
      query: '',
      show: false,
      companies: [],
      techcenters: [],
      users: [],
      result: [],
      formParams: {
        ordersIds: [],
        cities: [],
        companies: [],
        techcenters: [],
        users: [],
        statuses: [],
        dates: {},
        problem: null,
        canceled: null
      },
      activeFilterIndex: null,
      filters: [],
      loading: {
        companies: false,
        techcenters: false,
        users: false,
        search: false
      },
      newFilterName: ''
    };
  },

  methods: _extends({
    showOrderDetail: function showOrderDetail(id) {
      this.show = false;
      this.$store.dispatch('setActiveOrderId', null);
      this.$router.push({ name: 'Order', params: { id: id } });
    },
    addOrderId: function addOrderId(id) {
      id = parseInt(id);
      if (id > 0) {
        var OrderId = {
          id: parseInt(id),
          name: '№' + parseInt(id)
        };
        this.formParams.ordersIds.push(OrderId);
        this.$v.formParams.ordersIds.$touch();
      } else {
        this.addToast({
          text: 'Номер заказа должен состоять из цифр',
          type: 'danger',
          dismissAfter: 2000
        });
      }
    },
    clearFiltersParams: function clearFiltersParams() {
      this.formParams = {
        ordersIds: [],
        cities: [],
        companies: [],
        techcenters: [],
        users: [],
        statuses: [],
        dates: {},
        problem: null,
        canceled: null
      };
      this.activeFilterIndex = null;
    },
    activeFilter: function activeFilter(filter, index) {
      this.activeFilterIndex = index;
      this.formParams = Object.assign({}, filter.params);
    },
    removeFilter: function removeFilter(index) {
      this.filters.splice(index, 1);
      window.localStorage.setItem('filters', JSON.stringify(this.filters));
    },
    saveFilter: function saveFilter() {
      if (this.newFilterName.length > 0) {
        var filter = {
          name: this.newFilterName,
          params: this.formParams,
          active: false
        };
        this.filters.push(filter);
        window.localStorage.setItem('filters', JSON.stringify(this.filters));
        this.newFilterName = '';
      }
    },
    focusFilterItemInput: function focusFilterItemInput() {
      this.$refs.focusModalThis.focus();
    },
    focusSearchInput: function focusSearchInput() {
      this.$refs.focusThis.focus();
    },
    search: function search() {
      var _this2 = this;

      this.$router.push({ name: 'Orders' });
      var params = {
        dateFrom: null,
        dateTo: null,
        id: this.formParams.ordersIds.map(function (item) {
          return item.id;
        }),
        cityId: this.formParams.cities.map(function (item) {
          return item.id;
        }),
        companyId: this.formParams.companies.map(function (item) {
          return item.id;
        }),
        techcenterId: this.formParams.techcenters.map(function (item) {
          return item.id;
        }),
        userId: this.formParams.users.map(function (item) {
          return item.id;
        }),
        status: this.formParams.statuses.map(function (item) {
          return item.code;
        }),
        problem: this.formParams.problem ? true : null,
        canceled: this.formParams.canceled ? true : null
      };
      if (this.formParams.dates[0]) {
        params.dateFrom = __WEBPACK_IMPORTED_MODULE_9_moment___default()(this.formParams.dates[0], this.format).format('DD.MM.YYYY').toString();
      }
      if (this.formParams.dates[0]) {
        params.dateTo = __WEBPACK_IMPORTED_MODULE_9_moment___default()(this.formParams.dates[1], this.format).format('DD.MM.YYYY').toString();
      }
      this.$store.dispatch('getOrders', params).then(function () {
        window.localStorage.setItem('displayModeParams', JSON.stringify(params));
        window.localStorage.setItem('displayMode', 'search');
      }).catch(function (error) {
        _this2.addToast({
          text: 'Произошла ошибка при загрузке заказов:' + error + '. Отображается результат предыдущего поиска',
          type: 'danger',
          dismissAfter: 10000
        });
      });
      this.show = false;
    },
    loadFilters: function loadFilters() {
      if (window.localStorage.getItem('filters')) {
        this.filters = JSON.parse(window.localStorage.getItem('filters'));
      }
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["mapActions"])({
    addToast: __WEBPACK_IMPORTED_MODULE_1_vuex_toast__["ADD_TOAST_MESSAGE"]
  })),
  apollo: {
    companies: {
      query: __WEBPACK_IMPORTED_MODULE_5_gql_queries_getCompanies_graphql___default.a,
      variables: function variables() {
        return {
          cityIds: this.formParams.cities.map(function (item) {
            return item.id;
          }),
          all: true
        };
      },
      watchLoading: function watchLoading(isLoading) {
        this.loading.companies = isLoading;
      },
      error: function error(_error) {
        console.error('We\'ve got an error!', _error);
      }
    },
    techcenters: {
      query: __WEBPACK_IMPORTED_MODULE_4_gql_queries_getTechcenters_graphql___default.a,
      variables: function variables() {
        return {
          cityIds: this.formParams.cities.map(function (item) {
            return item.id;
          }),
          companyIds: this.formParams.companies.map(function (item) {
            return item.id;
          }),
          all: true
        };
      },
      watchLoading: function watchLoading(isLoading) {
        this.loading.techcenters = isLoading;
      },
      error: function error(_error2) {
        console.error('We\'ve got an error!', _error2);
      }
    },
    users: {
      query: __WEBPACK_IMPORTED_MODULE_6_gql_queries_getUsersForMultiselect_graphql___default.a,
      watchLoading: function watchLoading(isLoading) {
        this.loading.users = isLoading;
      },
      error: function error(_error3) {
        console.error('We\'ve got an error!', _error3);
      }
    }
  },
  validations: function validations() {
    var _this3 = this;

    return {
      formParams: {
        dates: {
          required: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_vuelidate_lib_validators__["requiredIf"])(function (ordersIds) {
            return _this3.formParams.ordersIds.length === 0;
          })
        },
        ordersIds: {
          required: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_vuelidate_lib_validators__["requiredIf"])(function (ordersIds) {
            return !_this3.formParams.dates;
          })
        }
      }
    };
  },
  created: function created() {
    this.loadFilters();
    this.clearFiltersParams();
    this.$root.$on('focusOnHeaderSearchInput', this.focusSearchInput);
  }
});

/***/ }),
/* 360 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      loading: true
    };
  },

  props: {
    size: {
      default: '6'
    },
    message: {
      default: 'Подождите, Аларм План загружает данные...'
    },
    color: {
      type: String,
      default: '#36a9e1'
    }
  },
  methods: {
    getSize: function getSize() {
      return this.size + 10 + 'px';
    }
  },
  computed: {
    diamondStyle: function diamondStyle() {
      var size = parseInt(this.size) * 20;
      return {
        width: size / 4 + 'px',
        height: size / 4 + 'px'
      };
    },
    styles: function styles() {
      var size = parseInt(this.size) * 20;
      return {
        width: this.size * 20 + 'px',
        height: size / 4 + 'px'
      };
    }
  }
});

/***/ }),
/* 361 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__gql_mutations_AddCity_graphql__ = __webpack_require__(827);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__gql_mutations_AddCity_graphql___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__gql_mutations_AddCity_graphql__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__gql_mutations_UpdateCity_graphql__ = __webpack_require__(846);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__gql_mutations_UpdateCity_graphql___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__gql_mutations_UpdateCity_graphql__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex_toast__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex_toast___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vuex_toast__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




//  import modal from 'vue-strap/src/modal'


/* harmony default export */ __webpack_exports__["default"] = ({
  computed: _extends({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["mapState"])({
    showAdminModal: function showAdminModal(state) {
      return state.adminStore.showModal;
    },
    item: function item(state) {
      return state.adminStore.editCity;
    }
  })),
  watch: {
    showAdminModal: function showAdminModal(val) {
      if (val === 'addEditCity' && this.item) {
        this.setNewDataItem();
      }
      if (val === 'addEditCity' && !this.item) {
        this.clearData();
      }
    }
  },
  data: function data() {
    return {
      loading: false,
      newDataItem: {
        id: null,
        name: '',
        sort: 100,
        enabled: true
      }
    };
  },

  methods: _extends({
    setNewDataItem: function setNewDataItem() {
      this.newDataItem = Object.assign({}, this.item);
    },
    beforeUpdateForm: function beforeUpdateForm() {
      this.$v.newDataItem.$touch();
      if (this.$v.newDataItem.$error) {
        return;
      }
      if (this.item) {
        this.updateItem();
      } else {
        this.addItem();
      }
    },
    addItem: function addItem() {
      var _this = this;

      this.loading = true;
      this.$apollo.mutate({
        mutation: __WEBPACK_IMPORTED_MODULE_1__gql_mutations_AddCity_graphql___default.a,
        variables: {
          name: this.newDataItem.name,
          sort: this.newDataItem.sort,
          enabled: this.newDataItem.enabled
        }
      }).then(function (data) {
        _this.loading = false;
        _this.addToast({
          text: 'Город успешно добавлен',
          type: 'success',
          dismissAfter: 3000
        });
        _this.clearData();
        _this.hideModal();
      }).catch(function (error) {
        console.error(error);
        _this.addToast({
          text: 'Произошла ошибка:' + error,
          type: 'danger',
          dismissAfter: 10000
        });
        _this.loading = false;
      });
    },
    updateItem: function updateItem() {
      var _this2 = this;

      this.loading = true;
      this.$apollo.mutate({
        mutation: __WEBPACK_IMPORTED_MODULE_2__gql_mutations_UpdateCity_graphql___default.a,
        variables: {
          id: this.item.id,
          name: this.newDataItem.name,
          sort: this.newDataItem.sort,
          enabled: this.newDataItem.enabled
        }
      }).then(function (data) {
        _this2.loading = false;
        _this2.addToast({
          text: 'Город успешно обновлен',
          type: 'success',
          dismissAfter: 3000
        });
        _this2.clearData();
        _this2.hideModal();
      }).catch(function (error) {
        console.error(error);
        _this2.addToast({
          text: 'Произошла ошибка:' + error,
          type: 'danger',
          dismissAfter: 10000
        });
        _this2.loading = false;
      });
    },
    hideModal: function hideModal() {
      this.$store.commit('SET_ADMIN_EDIT_CITY', null);
      this.$store.dispatch('setAdminModal', false);
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["mapActions"])({
    addToast: __WEBPACK_IMPORTED_MODULE_4_vuex_toast__["ADD_TOAST_MESSAGE"]
  }), {
    clearData: function clearData() {
      this.newDataItem = {
        id: null,
        name: '',
        sort: 100,
        enabled: true
      };
      this.$v.newDataItem.$reset();
    }
  }),
  components: {
    //      modal
  },
  validations: {
    newDataItem: {
      name: {
        required: __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["required"],
        minLength: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["minLength"])(2)
      },
      sort: {
        required: __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["required"],
        numeric: __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["numeric"]
      }
    }
  }
});

/***/ }),
/* 362 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__gql_mutations_AddCompany_graphql__ = __webpack_require__(829);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__gql_mutations_AddCompany_graphql___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__gql_mutations_AddCompany_graphql__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__gql_mutations_UpdateCompany_graphql__ = __webpack_require__(847);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__gql_mutations_UpdateCompany_graphql___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__gql_mutations_UpdateCompany_graphql__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__gql_queries_getUsersForMultiselect_graphql__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__gql_queries_getUsersForMultiselect_graphql___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__gql_queries_getUsersForMultiselect_graphql__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex_toast__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex_toast___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vuex_toast__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_multiselect__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_multiselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_multiselect__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["default"] = ({
  computed: _extends({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["mapState"])({
    showAdminModal: function showAdminModal(state) {
      return state.adminStore.showModal;
    },
    item: function item(state) {
      return state.adminStore.editCompany;
    }
  })),
  watch: {
    showAdminModal: function showAdminModal(val) {
      var _this = this;

      if (val === 'addEditCompany') {
        this.loading = true;
        this.$apollo.query({
          query: __WEBPACK_IMPORTED_MODULE_3__gql_queries_getUsersForMultiselect_graphql___default.a
        }).then(function (result) {
          _this.loading = false;
          _this.additionalData = result.data;
        });
        if (this.item) {
          this.setNewDataItem();
        } else {
          this.clearData();
        }
      }
    }
  },
  data: function data() {
    return {
      loading: false,
      additionalData: {
        users: []
      },
      newDataItem: {
        id: null,
        name: '',
        sort: 100,
        enabled: true,
        users: []
      }
    };
  },

  methods: _extends({
    setNewDataItem: function setNewDataItem() {
      this.newDataItem = Object.assign({}, this.item);
    },
    beforeUpdateForm: function beforeUpdateForm() {
      this.$v.newDataItem.$touch();
      if (this.$v.newDataItem.$error) {
        return;
      }
      if (this.item) {
        this.updateItem();
      } else {
        this.addItem();
      }
    },
    addItem: function addItem() {
      var _this2 = this;

      this.loading = true;
      this.$apollo.mutate({
        mutation: __WEBPACK_IMPORTED_MODULE_1__gql_mutations_AddCompany_graphql___default.a,
        variables: {
          name: this.newDataItem.name,
          sort: this.newDataItem.sort,
          enabled: this.newDataItem.enabled,
          users: this.getCollectionIds(this.newDataItem.users)
        }
      }).then(function (data) {
        _this2.loading = false;
        _this2.addToast({
          text: 'Компания успешно добавлена',
          type: 'success',
          dismissAfter: 3000
        });
        _this2.clearData();
        _this2.hideModal();
      }).catch(function (error) {
        console.error(error);
        _this2.addToast({
          text: 'Произошла ошибка:' + error,
          type: 'danger',
          dismissAfter: 10000
        });
        _this2.loading = false;
      });
    },
    updateItem: function updateItem() {
      var _this3 = this;

      this.loading = true;
      this.$apollo.mutate({
        mutation: __WEBPACK_IMPORTED_MODULE_2__gql_mutations_UpdateCompany_graphql___default.a,
        variables: {
          id: this.item.id,
          name: this.newDataItem.name,
          sort: this.newDataItem.sort,
          enabled: this.newDataItem.enabled,
          users: this.getCollectionIds(this.newDataItem.users)
        }
      }).then(function (data) {
        _this3.loading = false;
        _this3.addToast({
          text: 'Компания успешно обновлена',
          type: 'success',
          dismissAfter: 3000
        });
        _this3.clearData();
        _this3.hideModal();
      }).catch(function (error) {
        console.error(error);
        _this3.addToast({
          text: 'Произошла ошибка:' + error,
          type: 'danger',
          dismissAfter: 10000
        });
        _this3.loading = false;
      });
    },
    getCollectionIds: function getCollectionIds(collection) {
      return collection.map(function (item) {
        return item.id;
      });
    },
    hideModal: function hideModal() {
      this.$store.commit('SET_ADMIN_EDIT_COMPANY', null);
      this.$store.dispatch('setAdminModal', false);
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["mapActions"])({
    addToast: __WEBPACK_IMPORTED_MODULE_5_vuex_toast__["ADD_TOAST_MESSAGE"]
  }), {
    clearData: function clearData() {
      this.newDataItem = {
        id: null,
        name: '',
        sort: 100,
        enabled: true,
        users: []
      };
      this.$v.newDataItem.$reset();
    }
  }),
  components: {
    Multiselect: __WEBPACK_IMPORTED_MODULE_6_vue_multiselect___default.a
  },
  validations: {
    newDataItem: {
      name: {
        required: __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["required"],
        minLength: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["minLength"])(2)
      },
      sort: {
        required: __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["required"],
        numeric: __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["numeric"]
      }
    }
  }
});

/***/ }),
/* 363 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__gql_mutations_PBX_AddInternalNumber_graphql__ = __webpack_require__(841);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__gql_mutations_PBX_AddInternalNumber_graphql___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__gql_mutations_PBX_AddInternalNumber_graphql__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__gql_mutations_PBX_UpdateInternalNumber_graphql__ = __webpack_require__(843);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__gql_mutations_PBX_UpdateInternalNumber_graphql___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__gql_mutations_PBX_UpdateInternalNumber_graphql__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_multiselect__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_multiselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_multiselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex_toast__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex_toast___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vuex_toast__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__gql_queries_getUsersForMultiselect_graphql__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__gql_queries_getUsersForMultiselect_graphql___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__gql_queries_getUsersForMultiselect_graphql__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["default"] = ({
  computed: _extends({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["mapState"])({
    showAdminModal: function showAdminModal(state) {
      return state.adminStore.showModal;
    },
    item: function item(state) {
      return state.adminStore.editInternalNumber;
    }
  })),
  watch: {
    showAdminModal: function showAdminModal(val) {
      if (val === 'addEditInternalNumber' && this.item) {
        this.setNewDataItem();
      }
      if (val === 'addEditInternalNumber' && !this.item) {
        this.clearData();
      }
    }
  },
  data: function data() {
    return {
      loading: false,
      newDataItem: {
        id: null,
        number: '',
        users: []
      },
      loadingUsers: false,
      users: [],
      selectedUsers: null
    };
  },

  methods: _extends({
    setNewDataItem: function setNewDataItem() {
      var _this = this;

      var item = this.item;
      this.newDataItem = Object.assign({}, item);
      this.selectedUsers = item.users;
      this.newDataItem.users = [];
      if (item.users) {
        item.users.forEach(function (user) {
          _this.newDataItem.users.push(user.id);
        });
      }
    },
    beforeUpdateForm: function beforeUpdateForm() {
      this.$v.newDataItem.$touch();
      if (this.$v.newDataItem.$error) {
        return;
      }
      if (this.item) {
        this.updateItem();
      } else {
        this.addItem();
      }
    },
    addItem: function addItem() {
      var _this2 = this;

      this.loading = true;
      this.$apollo.mutate({
        mutation: __WEBPACK_IMPORTED_MODULE_1__gql_mutations_PBX_AddInternalNumber_graphql___default.a,
        variables: this.newDataItem
      }).then(function (data) {
        _this2.loading = false;
        _this2.addToast({
          text: 'Внутренний номер успешно добавлен',
          type: 'success',
          dismissAfter: 3000
        });
        _this2.hideModal();
      }).catch(function (error) {
        console.error(error);
        _this2.addToast({
          text: 'Произошла ошибка:' + error,
          type: 'danger',
          dismissAfter: 10000
        });
        _this2.loading = false;
      });
    },
    updateItem: function updateItem() {
      var _this3 = this;

      this.loading = true;
      this.$apollo.mutate({
        mutation: __WEBPACK_IMPORTED_MODULE_2__gql_mutations_PBX_UpdateInternalNumber_graphql___default.a,
        variables: this.newDataItem
      }).then(function (data) {
        _this3.loading = false;
        _this3.addToast({
          text: 'Внутренний успешно обновлен',
          type: 'success',
          dismissAfter: 3000
        });
        _this3.hideModal();
      }).catch(function (error) {
        console.error(error);
        _this3.addToast({
          text: 'Произошла ошибка:' + error,
          type: 'danger',
          dismissAfter: 10000
        });
        _this3.loading = false;
      });
    },
    hideModal: function hideModal() {
      this.clearData();
      this.$store.commit('SET_ADMIN_EDIT_INTERNAL_NUMBER', null);
      this.$store.dispatch('setAdminModal', false);
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["mapActions"])({
    addToast: __WEBPACK_IMPORTED_MODULE_5_vuex_toast__["ADD_TOAST_MESSAGE"]
  }), {
    clearData: function clearData() {
      this.newDataItem = {
        id: null,
        number: '',
        users: []
      };
      this.$v.newDataItem.$reset();
      this.selectedUsers = null;
    },

    /**
     * Подргрузка менеджеров
     * активируется при открытии селекта
     */
    loadUsers: function loadUsers() {
      var _this4 = this;

      this.loadingUsers = true;
      this.$apollo.query({
        query: __WEBPACK_IMPORTED_MODULE_6__gql_queries_getUsersForMultiselect_graphql___default.a
      }).then(function (result) {
        _this4.users = result.data.users;
        _this4.loadingUsers = false;
      }).catch(function (error) {
        console.log(error);
        _this4.loadingUsers = false;
      });
    },
    attachUser: function attachUser(user) {
      this.newDataItem.users.push(user.id);
    },
    detachUser: function detachUser(user) {
      var index = this.newDataItem.users.indexOf(user.id);
      this.newDataItem.users.splice(index, 1);
    }
  }),
  components: {
    Multiselect: __WEBPACK_IMPORTED_MODULE_4_vue_multiselect___default.a
  },
  validations: {
    newDataItem: {
      number: {
        required: __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["required"],
        numeric: __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["numeric"],
        minLength: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["minLength"])(3),
        maxLength: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["maxLength"])(3)
      }
    }
  }
});

/***/ }),
/* 364 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__gql_mutations_Acl_AddRole_graphql__ = __webpack_require__(822);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__gql_mutations_Acl_AddRole_graphql___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__gql_mutations_Acl_AddRole_graphql__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__gql_mutations_Acl_UpdateRole_graphql__ = __webpack_require__(824);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__gql_mutations_Acl_UpdateRole_graphql___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__gql_mutations_Acl_UpdateRole_graphql__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__gql_queries_Acl_getPermissions_graphql__ = __webpack_require__(251);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__gql_queries_Acl_getPermissions_graphql___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__gql_queries_Acl_getPermissions_graphql__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_multiselect__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_multiselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_multiselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__gql_queries_getUsersForMultiselect_graphql__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__gql_queries_getUsersForMultiselect_graphql___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__gql_queries_getUsersForMultiselect_graphql__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuex_toast__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuex_toast___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vuex_toast__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["default"] = ({
  computed: _extends({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["mapState"])({
    showAdminModal: function showAdminModal(state) {
      return state.adminStore.showModal;
    },
    item: function item(state) {
      return state.adminStore.editRole;
    }
  })),
  watch: {
    showAdminModal: function showAdminModal(val) {
      if (val === 'addEditRole' && this.item) {
        this.setNewDataItem();
      }
      if (val === 'addEditRole' && !this.item) {
        this.clearData();
      }
      if (val === 'addEditRole') {
        this.getPermissions();
      }
    }
  },
  data: function data() {
    return {
      loading: false,
      newDataItem: {
        id: null,
        name: '',
        description: '',
        permissions: [],
        users: []
      },
      loadingUsers: false,
      loadingPermissions: false,
      permissions: [],
      selectedUsers: [],
      users: []
    };
  },

  methods: _extends({
    setNewDataItem: function setNewDataItem() {
      var _this = this;

      var item = this.item;
      this.selectedUsers = item.users;
      this.newDataItem = Object.assign({}, item);
      this.newDataItem.permissions = [];
      item.permissions.forEach(function (permission) {
        _this.newDataItem.permissions.push(permission.id);
      });
      this.newDataItem.users = [];
      item.users.forEach(function (user) {
        _this.newDataItem.users.push(user.id);
      });
    },
    beforeUpdateForm: function beforeUpdateForm() {
      this.$v.newDataItem.$touch();
      if (this.$v.newDataItem.$error) {
        return;
      }
      if (this.item) {
        this.updateItem();
      } else {
        this.addItem();
      }
    },
    addItem: function addItem() {
      var _this2 = this;

      this.loading = true;
      this.$apollo.mutate({
        mutation: __WEBPACK_IMPORTED_MODULE_1__gql_mutations_Acl_AddRole_graphql___default.a,
        variables: this.newDataItem
      }).then(function (data) {
        _this2.loading = false;
        _this2.addToast({
          text: 'Роль успешно добавлена',
          type: 'success',
          dismissAfter: 3000
        });
        _this2.clearData();
        _this2.hideModal();
      }).catch(function (error) {
        console.error(error);
        _this2.addToast({
          text: 'Произошла ошибка:' + error,
          type: 'danger',
          dismissAfter: 10000
        });
        _this2.loading = false;
      });
    },
    updateItem: function updateItem() {
      var _this3 = this;

      this.loading = true;
      this.$apollo.mutate({
        mutation: __WEBPACK_IMPORTED_MODULE_2__gql_mutations_Acl_UpdateRole_graphql___default.a,
        variables: this.newDataItem
      }).then(function (data) {
        _this3.loading = false;
        _this3.addToast({
          text: 'Роль успешно обновлена',
          type: 'success',
          dismissAfter: 3000
        });
        _this3.clearData();
        _this3.hideModal();
      }).catch(function (error) {
        console.error(error);
        _this3.addToast({
          text: 'Произошла ошибка:' + error,
          type: 'danger',
          dismissAfter: 10000
        });
        _this3.loading = false;
      });
    },
    hideModal: function hideModal() {
      this.$store.commit('SET_ADMIN_EDIT_ROLE', null);
      this.$store.dispatch('setAdminModal', false);
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["mapActions"])({
    addToast: __WEBPACK_IMPORTED_MODULE_7_vuex_toast__["ADD_TOAST_MESSAGE"]
  }), {
    clearData: function clearData() {
      this.newDataItem = {
        id: null,
        name: '',
        description: '',
        permissions: [],
        users: []
      };
      this.selectedUsers = [];
      this.$v.newDataItem.$reset();
    },
    getPermissions: function getPermissions() {
      var _this4 = this;

      this.loadingPermissions = true;
      this.$apollo.query({
        query: __WEBPACK_IMPORTED_MODULE_3__gql_queries_Acl_getPermissions_graphql___default.a
      }).then(function (result) {
        _this4.permissions = result.data.permissions;
        _this4.loadingPermissions = false;
      }).catch(function (error) {
        console.error(error);
        _this4.addToast({
          text: 'Произошла ошибка:' + error,
          type: 'danger',
          dismissAfter: 10000
        });
        _this4.loadingPermissions = false;
      });
    },
    changePermission: function changePermission(index, id) {
      if (index !== -1) {
        this.newDataItem.permissions.splice(index, 1);
      } else {
        this.newDataItem.permissions.push(id);
      }
    },

    /**
     * Подргрузка менеджеров
     * активируется при открытии селекта
     */
    loadUsers: function loadUsers() {
      var _this5 = this;

      this.loadingUsers = true;
      this.$apollo.query({
        query: __WEBPACK_IMPORTED_MODULE_5__gql_queries_getUsersForMultiselect_graphql___default.a
      }).then(function (result) {
        _this5.users = result.data.users;
        _this5.loadingUsers = false;
      }).catch(function (error) {
        console.log(error);
        _this5.loadingUsers = false;
      });
    },
    attachUser: function attachUser(user) {
      this.newDataItem.users.push(user.id);
    },
    detachUser: function detachUser(user) {
      var index = this.newDataItem.users.indexOf(user.id);
      this.newDataItem.users.splice(index, 1);
    }
  }),
  components: {
    Multiselect: __WEBPACK_IMPORTED_MODULE_4_vue_multiselect___default.a
  },
  validations: {
    newDataItem: {
      name: {
        required: __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["required"],
        minLength: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["minLength"])(2)
      }
    }
  }
});

/***/ }),
/* 365 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__gql_mutations_AddTechcenter_graphql__ = __webpack_require__(247);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__gql_mutations_AddTechcenter_graphql___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__gql_mutations_AddTechcenter_graphql__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__gql_mutations_UpdateTechcenter_graphql__ = __webpack_require__(250);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__gql_mutations_UpdateTechcenter_graphql___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__gql_mutations_UpdateTechcenter_graphql__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__gql_queries_getCompanies_graphql__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__gql_queries_getCompanies_graphql___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__gql_queries_getCompanies_graphql__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__gql_queries_getUsersForMultiselect_graphql__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__gql_queries_getUsersForMultiselect_graphql___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__gql_queries_getUsersForMultiselect_graphql__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex_toast__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex_toast___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vuex_toast__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_multiselect__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_multiselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_multiselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__helpers_workDates__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__helpers_workTimes__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__helpers_tzOffsets__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_moment__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue_color__ = __webpack_require__(271);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue_color___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_vue_color__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//














/* harmony default export */ __webpack_exports__["default"] = ({
  computed: _extends({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["mapState"])({
    showAdminModal: function showAdminModal(state) {
      return state.adminStore.showModal;
    },
    item: function item(state) {
      return state.adminStore.editTechcenter;
    },
    cities: function cities(state) {
      return state.globalStore.cities;
    }
  }), {
    color: function color() {
      return {
        hex: this.newDataItem.color
      };
    }
  }),
  watch: {
    showAdminModal: function showAdminModal(val) {
      if (val === 'addEditTechcenter' && this.item) {
        this.setNewDataItem();
      }
      if (val === 'addEditTechcenter' && !this.item) {
        this.clearData();
      }
    }
  },
  data: function data() {
    return {
      loading: false,
      newDataItem: {},
      coords: [55.751242, 37.620686],
      loadingCompanies: false,
      loadingUsers: false,
      companies: [],
      users: [],
      workDates: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__helpers_workDates__["a" /* workDates */])(),
      workTimes: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__helpers_workTimes__["a" /* default */])(),
      tzOffsets: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__helpers_tzOffsets__["a" /* default */])(),
      selected: {
        city: null,
        company: null,
        users: []
      },
      placemarks: [{
        coords: [55.751242, 37.620686],
        options: { draggable: true },
        callbacks: { dragend: this.setNewCoord }
      }]
    };
  },

  methods: _extends({
    setNewDataItem: function setNewDataItem() {
      var _this = this;

      var item = this.item;
      this.selected = {
        city: item.city,
        company: item.company,
        users: item.users
      };
      this.newDataItem = Object.assign({}, item);
      delete this.newDataItem.city;
      delete this.newDataItem.company;
      this.newDataItem.cityId = item.city.id;
      this.newDataItem.companyId = item.company.id;
      var coords = this.item.coords.split(', ');
      this.coords = [parseFloat(coords[0]), parseFloat(coords[1])];
      this.placemarks.splice(0, 1, {
        coords: [coords[0], coords[1]],
        options: { draggable: true },
        callbacks: { dragend: this.setNewCoord }
      });
      this.newDataItem.users = [];
      item.users.forEach(function (user) {
        _this.newDataItem.users.push(user.id);
      });
      this.newDataItem.workTimeEnd = __WEBPACK_IMPORTED_MODULE_11_moment___default()(item.workTimeEnd, 'HH:mm').format('HH:mm:ss').toString();
      this.newDataItem.workTimeStart = __WEBPACK_IMPORTED_MODULE_11_moment___default()(item.workTimeStart, 'HH:mm').format('HH:mm:ss').toString();
    },
    beforeUpdateForm: function beforeUpdateForm() {
      this.$v.newDataItem.$touch();
      if (this.$v.newDataItem.$error) {
        return;
      }
      if (this.item) {
        this.updateItem();
      } else {
        this.addItem();
      }
    },
    addItem: function addItem() {
      var _this2 = this;

      this.loading = true;
      this.$apollo.mutate({
        mutation: __WEBPACK_IMPORTED_MODULE_1__gql_mutations_AddTechcenter_graphql___default.a,
        variables: this.newDataItem
      }).then(function (data) {
        _this2.loading = false;
        _this2.addToast({
          text: 'Техцентр успешно добавлен',
          type: 'success',
          dismissAfter: 3000
        });
        _this2.hideModal();
      }).catch(function (error) {
        console.error(error);
        _this2.addToast({
          text: 'Произошла ошибка:' + error,
          type: 'danger',
          dismissAfter: 10000
        });
        _this2.loading = false;
      });
    },
    updateItem: function updateItem() {
      var _this3 = this;

      this.loading = true;
      this.$apollo.mutate({
        mutation: __WEBPACK_IMPORTED_MODULE_2__gql_mutations_UpdateTechcenter_graphql___default.a,
        variables: this.newDataItem
      }).then(function (result) {
        _this3.loading = false;
        _this3.addToast({
          text: 'Техцентр успешно обновлен',
          type: 'success',
          dismissAfter: 3000
        });
        if (_this3.$route.name === 'Techcenter') {
          _this3.$store.commit('SET_TECHCENTER', result.data.updateTechcenter);
        }
        _this3.hideModal();
      }).catch(function (error) {
        console.error(error);
        _this3.addToast({
          text: 'Произошла ошибка:' + error,
          type: 'danger',
          dismissAfter: 10000
        });
        _this3.loading = false;
      });
    },
    hideModal: function hideModal() {
      this.clearData();
      this.$store.commit('SET_ADMIN_EDIT_TECHCENTER', null);
      this.$store.dispatch('setAdminModal', false);
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["mapActions"])({
    addToast: __WEBPACK_IMPORTED_MODULE_6_vuex_toast__["ADD_TOAST_MESSAGE"]
  }), {
    clearData: function clearData() {
      this.newDataItem = {
        id: null,
        name: '',
        enabled: true,
        cityId: null,
        companyId: null,
        address: '',
        link: '',
        color: '#000000',
        users: [],
        workDateStart: 1,
        workDateEnd: 7,
        workTimeStart: '10:00:00',
        workTimeEnd: '20:00:00',
        commissionReclamation: 40,
        commissionInstall: 40,
        commissionRetail: 50,
        maxOrders: 2,
        tzOffset: 'Europe/Moscow',
        description: '',
        coords: ''
      };
      this.$v.newDataItem.$reset();
      this.selected = {
        city: null,
        company: null,
        users: []
      };
      this.coords = [55.751242, 37.620686];
      this.placemarks.splice(0, 1, {
        coords: [55.751242, 37.620686],
        options: { draggable: true },
        callbacks: { dragend: this.setNewCoord }
      });
    },

    /**
     * Подргрузка Компаний
     * активируется при открытии селекта
     */
    loadCompanies: function loadCompanies() {
      var _this4 = this;

      this.loadingCompanies = true;
      this.$apollo.query({
        query: __WEBPACK_IMPORTED_MODULE_3__gql_queries_getCompanies_graphql___default.a,
        variables: {
          all: true
        }
      }).then(function (result) {
        _this4.companies = result.data.companies;
        _this4.loadingCompanies = false;
      }).catch(function (error) {
        console.log(error);
        _this4.loadingCompanies = false;
      });
    },
    changeCity: function changeCity(city) {
      if (city) {
        this.newDataItem.cityId = city.id;
      } else {
        this.newDataItem.cityId = null;
      }
      this.$v.newDataItem.cityId.$touch();
      this.setMapCoordsByAddress();
    },
    changeCompany: function changeCompany(company) {
      if (company) {
        this.newDataItem.companyId = company.id;
      } else {
        this.newDataItem.companyId = null;
      }
      this.$v.newDataItem.companyId.$touch();
    },

    /**
     * Подргрузка менеджеров
     * активируется при открытии селекта
     */
    loadUsers: function loadUsers() {
      var _this5 = this;

      this.loadingUsers = true;
      this.$apollo.query({
        query: __WEBPACK_IMPORTED_MODULE_4__gql_queries_getUsersForMultiselect_graphql___default.a
      }).then(function (result) {
        _this5.users = result.data.users;
        _this5.loadingUsers = false;
      }).catch(function (error) {
        console.log(error);
        _this5.loadingUsers = false;
      });
    },
    attachUser: function attachUser(user) {
      this.newDataItem.users.push(user.id);
    },
    detachUser: function detachUser(user) {
      var index = this.newDataItem.users.indexOf(user.id);
      this.newDataItem.users.splice(index, 1);
    },
    updateColorValue: function updateColorValue(value) {
      this.newDataItem.color = value.hex;
    },
    setNewCoord: function setNewCoord(e) {
      var thisPlacemark = e.get('target');
      var coords = thisPlacemark.geometry.getCoordinates();
      this.newDataItem.coords = +coords[0] + ', ' + coords[1];
    },
    changeAddress: function changeAddress() {
      this.$v.newDataItem.address.$touch();
      this.setMapCoordsByAddress();
    },
    setMapCoordsByAddress: function setMapCoordsByAddress() {
      var _this6 = this;

      var city = this.selected.city.name;
      var address = this.newDataItem.address;
      var url = 'https://geocode-maps.yandex.ru/1.x/?format=json&sco=latlong&geocode=' + city + ' ' + address;
      this.$http.get(url).then(function (response) {
        var coords = response.data.response.GeoObjectCollection.featureMember[0].GeoObject.Point.pos.split(' ');
        coords = coords.map(function (coord) {
          return parseFloat(coord);
        });
        _this6.coords = [coords[1], coords[0]];
        _this6.placemarks.splice(0, 1, {
          coords: [coords[1], coords[0]],
          options: { draggable: true },
          callbacks: { dragend: _this6.setNewCoord }
        });
        _this6.newDataItem.coords = +coords[1] + ', ' + coords[0];
      }).catch(function (error) {
        console.log(error);
        _this6.addToast({
          text: 'Ошибка при загрузке карты: ' + error,
          type: 'danger',
          dismissAfter: 3000
        });
        _this6.loadingMap = false;
      });
    }
  }),
  created: function created() {
    this.clearData();
  },

  components: {
    Multiselect: __WEBPACK_IMPORTED_MODULE_7_vue_multiselect___default.a,
    'color-picker': __WEBPACK_IMPORTED_MODULE_12_vue_color__["Sketch"]
  },
  validations: {
    newDataItem: {
      name: {
        required: __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["required"],
        minLength: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["minLength"])(2)
      },
      cityId: {
        required: __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["required"]
      },
      companyId: {
        required: __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["required"]
      },
      address: {
        required: __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["required"],
        minLength: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["minLength"])(2)
      },
      phone: {
        required: __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["required"],
        numeric: __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["numeric"],
        maxLength: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["maxLength"])(10),
        minLength: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["minLength"])(10)
      },
      link: {
        required: __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["required"],
        url: __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["url"]
      },
      maxOrders: {
        required: __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["required"],
        numeric: __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["numeric"]
      },
      commissionReclamation: {
        required: __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["required"],
        numeric: __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["numeric"]
      },
      commissionInstall: {
        required: __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["required"],
        numeric: __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["numeric"]
      },
      commissionRetail: {
        required: __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["required"],
        numeric: __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["numeric"]
      }
    }
  }
});

/***/ }),
/* 366 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__gql_mutations_PBX_AddVirtualNumber_graphql__ = __webpack_require__(842);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__gql_mutations_PBX_AddVirtualNumber_graphql___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__gql_mutations_PBX_AddVirtualNumber_graphql__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__gql_mutations_PBX_UpdateVirtualNumber_graphql__ = __webpack_require__(844);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__gql_mutations_PBX_UpdateVirtualNumber_graphql___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__gql_mutations_PBX_UpdateVirtualNumber_graphql__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_multiselect__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_multiselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_multiselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex_toast__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex_toast___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vuex_toast__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["default"] = ({
  computed: _extends({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["mapState"])({
    showAdminModal: function showAdminModal(state) {
      return state.adminStore.showModal;
    },
    item: function item(state) {
      return state.adminStore.editVirtualNumber;
    },
    cities: function cities(state) {
      return state.globalStore.cities;
    }
  }), {
    color: function color() {
      return {
        hex: this.newDataItem.color
      };
    }
  }),
  watch: {
    showAdminModal: function showAdminModal(val) {
      if (val === 'addEditVirtualNumber' && this.item) {
        this.setNewDataItem();
      }
      if (val === 'addEditVirtualNumber' && !this.item) {
        this.clearData();
      }
    }
  },
  data: function data() {
    return {
      loading: false,
      newDataItem: {},
      selected: {
        city: null
      }
    };
  },

  methods: _extends({
    setNewDataItem: function setNewDataItem() {
      var item = this.item;
      this.selected = {
        city: item.city
      };
      this.newDataItem = Object.assign({}, item);
      delete this.newDataItem.city;
      if (item.city) {
        this.newDataItem.cityId = item.city.id;
      }
    },
    beforeUpdateForm: function beforeUpdateForm() {
      this.$v.newDataItem.$touch();
      if (this.$v.newDataItem.$error) {
        return;
      }
      if (this.item) {
        this.updateItem();
      } else {
        this.addItem();
      }
    },
    addItem: function addItem() {
      var _this = this;

      this.loading = true;
      this.$apollo.mutate({
        mutation: __WEBPACK_IMPORTED_MODULE_1__gql_mutations_PBX_AddVirtualNumber_graphql___default.a,
        variables: this.newDataItem
      }).then(function (data) {
        _this.loading = false;
        _this.addToast({
          text: 'Виртуальный номер успешно добавлен',
          type: 'success',
          dismissAfter: 3000
        });
        _this.hideModal();
      }).catch(function (error) {
        console.error(error);
        _this.addToast({
          text: 'Произошла ошибка:' + error,
          type: 'danger',
          dismissAfter: 10000
        });
        _this.loading = false;
      });
    },
    updateItem: function updateItem() {
      var _this2 = this;

      this.loading = true;
      this.$apollo.mutate({
        mutation: __WEBPACK_IMPORTED_MODULE_2__gql_mutations_PBX_UpdateVirtualNumber_graphql___default.a,
        variables: this.newDataItem
      }).then(function (data) {
        _this2.loading = false;
        _this2.addToast({
          text: 'Виртуальный успешно обновлен',
          type: 'success',
          dismissAfter: 3000
        });
        _this2.hideModal();
      }).catch(function (error) {
        console.error(error);
        _this2.addToast({
          text: 'Произошла ошибка:' + error,
          type: 'danger',
          dismissAfter: 10000
        });
        _this2.loading = false;
      });
    },
    hideModal: function hideModal() {
      this.clearData();
      this.$store.commit('SET_ADMIN_EDIT_VIRTUAL_NUMBER', null);
      this.$store.dispatch('setAdminModal', false);
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["mapActions"])({
    addToast: __WEBPACK_IMPORTED_MODULE_5_vuex_toast__["ADD_TOAST_MESSAGE"]
  }), {
    clearData: function clearData() {
      this.newDataItem = {
        id: null,
        name: '',
        number: '',
        country: '',
        site: '',
        cityId: null
      };
      this.$v.newDataItem.$reset();
      this.selected = {
        city: null
      };
    },
    changeCity: function changeCity(city) {
      if (city) {
        this.newDataItem.cityId = city.id;
      } else {
        this.newDataItem.cityId = null;
      }
    }
  }),
  components: {
    Multiselect: __WEBPACK_IMPORTED_MODULE_4_vue_multiselect___default.a
  },
  validations: {
    newDataItem: {
      name: {
        required: __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["required"],
        minLength: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["minLength"])(2)
      },
      number: {
        required: __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["required"],
        numeric: __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["numeric"],
        minLength: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["minLength"])(7)
      },
      site: {
        required: __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["required"]
      }
    }
  }
});

/***/ }),
/* 367 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__gql_queries_getAdditionalDataForUserAdd_graphql__ = __webpack_require__(853);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__gql_queries_getAdditionalDataForUserAdd_graphql___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__gql_queries_getAdditionalDataForUserAdd_graphql__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__gql_mutations_AddUser_graphql__ = __webpack_require__(833);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__gql_mutations_AddUser_graphql___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__gql_mutations_AddUser_graphql__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex_toast__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex_toast___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vuex_toast__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_multiselect__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_multiselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_multiselect__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["default"] = ({
  computed: _extends({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["mapState"])({
    showAdminModal: function showAdminModal(state) {
      return state.adminStore.showModal;
    }
  })),
  watch: {
    showAdminModal: function showAdminModal(val) {
      var _this = this;

      if (val === 'addUser') {
        this.loading = true;
        this.$apollo.query({
          query: __WEBPACK_IMPORTED_MODULE_1__gql_queries_getAdditionalDataForUserAdd_graphql___default.a,
          variables: {
            all: true
          }
        }).then(function (result) {
          _this.loading = false;
          _this.additionalData = result.data;
        });
        this.clearUserData();
      }
    }
  },
  data: function data() {
    return {
      loading: false,
      passwordType: 'password',
      userData: {},
      additionalData: {
        techcenters: [],
        roles: [],
        companies: []
      }
    };
  },

  methods: _extends({
    beforeUpdateForm: function beforeUpdateForm() {
      this.$v.userData.$touch();
      if (!this.$v.userData.$error) {
        this.addUser();
      }
    },

    /**
     * Добаление заказа
     */
    addUser: function addUser() {
      var _this2 = this;

      this.loading = true;
      this.$apollo.mutate({
        mutation: __WEBPACK_IMPORTED_MODULE_2__gql_mutations_AddUser_graphql___default.a,
        variables: {
          firstname: this.userData.firstname,
          lastname: this.userData.lastname,
          email: this.userData.email,
          phone: this.userData.phone,
          password: this.userData.password,
          roles: this.getCollectionIds(this.userData.roles),
          techcenters: this.getCollectionIds(this.userData.techcenters),
          companies: this.getCollectionIds(this.userData.companies),
          notifyEmail: this.userData.notifyEmail
        }
      }).then(function (data) {
        _this2.loading = false;
        _this2.addToast({
          text: 'Пользователь успешно добавлен',
          type: 'success',
          dismissAfter: 3000
        });
        _this2.clearUserData();
        _this2.hideModal();
      }).catch(function (error) {
        console.error(error);
        _this2.addToast({
          text: 'Произошла ошибка:' + error,
          type: 'danger',
          dismissAfter: 10000
        });
        _this2.loading = false;
      });
    },
    getCollectionIds: function getCollectionIds(collection) {
      return collection.map(function (item) {
        return item.id;
      });
    },
    hideModal: function hideModal() {
      this.$store.dispatch('setAdminModal', false);
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["mapActions"])({
    addToast: __WEBPACK_IMPORTED_MODULE_4_vuex_toast__["ADD_TOAST_MESSAGE"]
  }), {
    setPassword: function setPassword(e) {
      this.userData.password = e.target.value;
      this.$v.userData.password.$touch();
    },
    generatePassword: function generatePassword() {
      this.userData.password = Math.random().toString(36).slice(-8);
      this.passwordType = 'text';
      this.$v.userData.password.$touch();
    },
    clearUserData: function clearUserData() {
      this.userData = {
        firstname: '',
        lastname: '',
        email: '',
        phone: '',
        password: '',
        techcenters: [],
        companies: [],
        roles: [],
        notifyEmail: true
      };
      this.$v.userData.$reset();
    }
  }),
  components: {
    Multiselect: __WEBPACK_IMPORTED_MODULE_5_vue_multiselect___default.a
  },
  validations: {
    userData: {
      lastname: {
        required: __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["required"],
        minLength: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["minLength"])(2)
      },
      firstname: {
        required: __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["required"],
        minLength: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["minLength"])(2)
      },
      email: {
        required: __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["required"],
        email: __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["email"]
      },
      phone: {
        required: __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["required"],
        numeric: __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["numeric"],
        maxLength: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["maxLength"])(10),
        minLength: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["minLength"])(10)
      },
      password: {
        required: __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["required"],
        minLength: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["minLength"])(6)
      },
      roles: {
        required: __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["required"]
      },
      techcenters: {
        required: __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["required"]
      }
    }
  }
});

/***/ }),
/* 368 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex_toast__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex_toast___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vuex_toast__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  computed: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["mapState"])({
    showModal: function showModal(state) {
      return state.orderStore.showModal;
    },
    order: function order(state) {
      return state.orderStore.editOrder;
    }
  }),
  data: function data() {
    return {
      text: '',
      loading: false
    };
  },

  methods: _extends({
    cancel: function cancel() {
      var _this = this;

      this.loading = true;
      this.$store.dispatch('cancelOrder', {
        cause: this.text,
        value: true,
        orderId: this.order.id
      }).then(function (data) {
        _this.loading = false;
        _this.text = '';
        _this.$store.commit('SET_SHOW_ORDER_MODAL', null);
        _this.addToast({
          text: 'Заказ отменен',
          type: 'success',
          dismissAfter: 3000
        });
      }).catch(function (error) {
        _this.loading = false;
        _this.addToast({
          text: 'Произошла ошибка при отмене заказа:' + error,
          type: 'danger',
          dismissAfter: 10000
        });
      });
    },
    hideCancelModal: function hideCancelModal(e) {
      this.$store.dispatch('setEditOrder', null);
      this.$store.commit('SET_SHOW_ORDER_MODAL', null);
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["mapActions"])({
    addToast: __WEBPACK_IMPORTED_MODULE_2_vuex_toast__["ADD_TOAST_MESSAGE"]
  })),
  validations: {
    text: {
      required: __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["required"],
      minLength: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["minLength"])(5)
    }
  }
});

/***/ }),
/* 369 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex_toast__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex_toast___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vuex_toast__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  computed: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["mapState"])({
    showModal: function showModal(state) {
      return state.orderStore.showModal;
    },
    order: function order(state) {
      return state.orderStore.editOrder;
    }
  }),
  directives: {
    focus: {
      inserted: function inserted(el) {
        el.focus();
      }
    }
  },
  data: function data() {
    return {
      sum: null,
      profit: null,
      loading: false
    };
  },

  methods: _extends({
    close: function close() {
      var _this = this;

      this.loading = true;
      this.$store.dispatch('closeOrder', {
        sum: this.sum,
        profit: this.profit,
        orderId: this.order.id
      }).then(function (data) {
        _this.sum = null;
        _this.profit = null;
        _this.loading = false;
        _this.$store.commit('SET_SHOW_ORDER_MODAL', null);
        _this.addToast({
          text: 'Заказ успешно закрыт',
          type: 'success',
          dismissAfter: 3000
        });
      }).catch(function (error) {
        _this.loading = false;
        _this.addToast({
          text: 'Произошла ошибка при закрытии заказа:' + error,
          type: 'danger',
          dismissAfter: 3000
        });
      });
    },
    hideCloseModal: function hideCloseModal() {
      this.$store.dispatch('setEditOrder', null);
      this.$store.commit('SET_SHOW_ORDER_MODAL', null);
    },
    initModal: function initModal() {
      this.sum = this.order.sum;
      this.profit = this.order.profit;
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["mapActions"])({
    addToast: __WEBPACK_IMPORTED_MODULE_2_vuex_toast__["ADD_TOAST_MESSAGE"]
  })),
  validations: {
    sum: {
      numeric: __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["numeric"],
      required: __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["required"],
      minValue: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["minValue"])(0)
    },
    profit: {
      numeric: __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["numeric"],
      required: __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["required"],
      minValue: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["minValue"])(0)
    }
  }
});

/***/ }),
/* 370 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex_toast__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex_toast___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vuex_toast__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_multiselect__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_multiselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_multiselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__gql_queries_getTechcenters_graphql__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__gql_queries_getTechcenters_graphql___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__gql_queries_getTechcenters_graphql__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
  computed: _extends({
    cities: function cities() {
      return this.citiesOriginal.filter(function (item) {
        return item.enabled === true;
      });
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["mapState"])({
    order: function order(state) {
      return state.orderStore.editOrder;
    },
    citiesOriginal: function citiesOriginal(state) {
      return state.globalStore.cities;
    }
  })),
  data: function data() {
    return {
      newOrderData: {},
      loading: false,
      timeOptions: ['09:00', '09:30', '10:00', '10:30', '11:00', '11:30', '12:00', '12:30', '13:00', '13:30', '14:00', '14:30', '14:00', '14:30', '15:00', '15:30', '16:00', '16:30', '17:00', '17:30', '18:00', '18:30', '19:00', '19:30', '20:00', '20:30'],
      techcenters: [],
      techcenterSelected: null,
      citySelected: null,
      loadingTechcenters: false
    };
  },

  methods: _extends({
    /**
     * Валидация и выбор что делаем
     */
    beforeUpdateForm: function beforeUpdateForm() {
      this.$v.newOrderData.$touch();
      if (this.$v.newOrderData.$error) {
        return;
      }
      if (this.newOrderData.id) {
        this.updateOrder();
      } else {
        this.addOrder();
      }
    },

    /**
     * Добаление заказа
     */
    addOrder: function addOrder() {
      var _this = this;

      this.loading = true;
      this.$store.dispatch('addOrder', this.newOrderData).then(function () {
        _this.loading = false;
        _this.addToast({
          text: 'Заказ успешно добавлен',
          type: 'success',
          dismissAfter: 3000
        });
        _this.setClearNewOrder();
        _this.$refs.ModalEditOrder.hide();
      }).catch(function (error) {
        _this.loading = false;
        _this.addToast({
          text: 'Произошла ошибка при добавлении заказа:' + error,
          type: 'danger',
          dismissAfter: 3000
        });
      });
    },
    updateOrder: function updateOrder() {
      var _this2 = this;

      this.loading = true;
      this.$store.dispatch('updateOrder', this.newOrderData).then(function () {
        _this2.loading = false;
        _this2.addToast({
          text: 'Заказ успешно обновлен',
          type: 'success',
          dismissAfter: 3000
        });
        _this2.$refs.ModalEditOrder.hide();
      }).catch(function (error) {
        _this2.loading = false;
        _this2.addToast({
          text: 'Произошла ошибка при обвнолении заказа:' + error,
          type: 'danger',
          dismissAfter: 3000
        });
      });
    },
    setClearNewOrder: function setClearNewOrder() {
      this.newOrderData = {
        id: null,
        orderDate: __WEBPACK_IMPORTED_MODULE_4_moment___default()().format('DD/MM/YYYY').toString(),
        orderTime: '10:00',
        cityId: null,
        techcenterId: null,
        description: '',
        clientPhone: '',
        clientName: '',
        sum: 0
      };
      this.citySelected = this.cities[0];
      this.newOrderData.cityId = this.cities[0].id;
      this.loadTechcenters(this.citySelected);
      this.$v.newOrderData.$reset();
    },
    modalHasBeenHidden: function modalHasBeenHidden() {
      if (this.order) {
        this.$store.commit('SET_EDIT_ORDER', null);
        this.setClearNewOrder();
      }
    },

    /**
     * Загрузка техцентров для выбранного города
     * @param city
     */
    loadTechcenters: function loadTechcenters(city) {
      var _this3 = this;

      this.loadingTechcenters = true;
      this.newOrderData.cityId = city.id;
      this.techcenters = [];
      this.newOrderData.techcenterId = null;
      this.techcenterSelected = null;
      this.$apollo.query({
        query: __WEBPACK_IMPORTED_MODULE_5__gql_queries_getTechcenters_graphql___default.a,
        variables: {
          cityId: city.id,
          all: true,
          enabled: true
        }
      }).then(function (result) {
        _this3.techcenters = result.data.techcenters;
        _this3.loadingTechcenters = false;
        if (!_this3.order) {
          _this3.techcenterSelected = null;
          _this3.newOrderData.techcenterId = null;
        }
      }).catch(function (error) {
        console.log(error);
        _this3.loadingTechcenters = false;
      });
    },

    /**
     * Установка техцентра
     * @param techcenter
     */
    setTechcneter: function setTechcneter(techcenter) {
      if (techcenter) {
        this.newOrderData.techcenterId = techcenter.id;
      } else {
        this.newOrderData.techcenterId = null;
      }
      this.$v.newOrderData.techcenterId.$touch();
    },
    initEditOrder: function initEditOrder() {
      if (this.order) {
        var editOrder = this.order;
        this.citySelected = editOrder.techcenter.city;
        this.loadTechcenters(this.citySelected);
        this.techcenterSelected = editOrder.techcenter;
        this.newOrderData = {
          id: editOrder.id,
          orderDate: __WEBPACK_IMPORTED_MODULE_4_moment___default()(editOrder.date, 'DD.MM.YYYY').format('DD/MM/YYYY').toString(),
          orderTime: editOrder.time,
          cityId: editOrder.techcenter.city.id,
          techcenterId: editOrder.techcenter.id,
          description: editOrder.description,
          clientPhone: editOrder.clientPhone,
          clientName: editOrder.clientName,
          sum: editOrder.sum
        };
      }
      //        else {
      //          /**
      //           * Fix bug
      //           * TODO remove after reliase bootstrab-vue package v 1 stable
      //           * @see https://github.com/bootstrap-vue/bootstrap-vue/issues/1034
      //           * @type {Element}
      //           */
      //          let dialog = document.getElementById('addEditOrderModal')
      //          if (!dialog.classList.contains('show')) {
      //            dialog.classList.add('show')
      //          }
      //        }
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["mapActions"])({
    addToast: __WEBPACK_IMPORTED_MODULE_2_vuex_toast__["ADD_TOAST_MESSAGE"]
  })),
  created: function created() {
    this.setClearNewOrder();
  },

  components: {
    Multiselect: __WEBPACK_IMPORTED_MODULE_3_vue_multiselect___default.a
  },
  validations: {
    newOrderData: {
      orderDate: {
        required: __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["required"]
      },
      orderTime: {
        required: __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["required"]
      },
      techcenterId: {
        required: __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["required"]
      },
      description: {
        required: __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["required"],
        minLength: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["minLength"])(6)
      },
      clientName: {
        required: __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["required"],
        minLength: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["minLength"])(2)
      },
      clientPhone: {
        required: __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["required"],
        minLength: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["minLength"])(15)
      },
      sum: {
        required: __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["required"],
        minValue: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["minValue"])(1)
      }
    }
  }
});

/***/ }),
/* 371 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex_toast__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex_toast___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vuex_toast__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  computed: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["mapState"])({
    showModal: function showModal(state) {
      return state.orderStore.showModal;
    },
    order: function order(state) {
      return state.orderStore.editOrder;
    }
  }),
  data: function data() {
    return {
      text: '',
      loading: false
    };
  },

  methods: _extends({
    problem: function problem() {
      var _this = this;

      this.loading = true;
      this.$store.dispatch('problemOrder', {
        cause: this.text,
        value: true,
        orderId: this.order.id
      }).then(function (data) {
        _this.loading = false;
        _this.text = '';
        _this.$store.commit('SET_SHOW_ORDER_MODAL', null);
        _this.addToast({
          text: 'Заказ успешно переведен в проблемные',
          type: 'success',
          dismissAfter: 3000
        });
      }).catch(function (error) {
        _this.loading = false;
        _this.addToast({
          text: 'Произошла ошибка при установке статуса проблемный:' + error,
          type: 'danger',
          dismissAfter: 10000
        });
      });
    },
    hideProblemModal: function hideProblemModal(e) {
      this.$store.dispatch('setEditOrder', null);
      this.$store.commit('SET_SHOW_ORDER_MODAL', null);
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["mapActions"])({
    addToast: __WEBPACK_IMPORTED_MODULE_2_vuex_toast__["ADD_TOAST_MESSAGE"]
  })),
  validations: {
    text: {
      required: __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["required"],
      minLength: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["minLength"])(5)
    }
  }
});

/***/ }),
/* 372 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex_toast__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex_toast___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vuex_toast__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  computed: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["mapState"])({
    showModal: function showModal(state) {
      return state.orderStore.showModal;
    },
    order: function order(state) {
      return state.orderStore.editOrder;
    },
    transition: function transition(state) {
      return state.orderStore.confirmTransition;
    }
  }),
  data: function data() {
    return {
      loading: false,
      sum: 0,
      profit: 0,
      comment: ''
    };
  },

  methods: _extends({
    setTransition: function setTransition() {
      var _this = this;

      switch (this.transition.code) {
        case 'accept':
          this.$v.sum.$touch();
          if (this.$v.sum.$error) {
            return;
          }
          break;
        case 'complete':
          this.$v.sum.$touch();
          if (this.$v.sum.$error) {
            return;
          }
          break;
        case 'calculate':
          this.$v.$touch();
          if (this.$v.sum.$error || this.$v.profit.$error || this.$v.comment.$error) {
            return;
          }
          break;
      }
      this.loading = true;
      this.$store.dispatch('setOrderTransition', {
        orderId: this.order.id,
        code: this.transition.code,
        sum: this.sum,
        profit: this.profit,
        comment: this.comment
      }).then(function (data) {
        _this.loading = false;
        _this.sum = 0;
        _this.profit = 0;
        _this.comment = '';
        _this.$v.$reset();
        _this.$store.commit('SET_SHOW_ORDER_MODAL', null);
        _this.addToast({
          text: 'Статус успешно изменен',
          type: 'success',
          dismissAfter: 3000
        });
      }).catch(function (error) {
        _this.loading = false;
        _this.addToast({
          text: 'Произошла ошибка при смене статуса заказа: ' + error,
          type: 'danger',
          dismissAfter: 3000
        });
      });
    },
    initModal: function initModal() {
      this.sum = this.order.sum;
      this.profit = this.order.profit;
    },
    hideModal: function hideModal(e) {
      this.$store.dispatch('setEditOrder', null);
      this.$store.commit('SET_SHOW_ORDER_MODAL', null);
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["mapActions"])({
    addToast: __WEBPACK_IMPORTED_MODULE_2_vuex_toast__["ADD_TOAST_MESSAGE"]
  })),
  validations: {
    sum: {
      numeric: __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["numeric"],
      required: __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["required"],
      minValue: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["minValue"])(1)
    },
    profit: {
      numeric: __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["numeric"],
      required: __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["required"],
      minValue: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["minValue"])(1)
    },
    comment: {
      required: __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["required"],
      minLength: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["minLength"])(5)
    }
  }
});

/***/ }),
/* 373 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(3);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['show'],
  computed: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["mapState"])({
    user: function user(state) {
      return state.globalStore.user;
    }
  }),
  data: function data() {
    return {};
  },

  methods: {
    updatePage: function updatePage() {
      this.$router.go();
    },
    updatePageEventListner: function updatePageEventListner(event) {
      console.log('Необходимо обновить страницу');
      this.$refs.ModalUpdatePage.show();
    }
  },
  components: {
    //
  },
  created: function created() {
    var _this = this;

    this.$echo.private('user.' + this.user.id).listen('.Illuminate\\Notifications\\Events\\BroadcastNotificationCreated', function (event) {
      switch (event.type) {
        case 'App\\Notifications\\UpdateFrontend':
          _this.updatePageEventListner(event);
          break;
      }
    });
  }
});

/***/ }),
/* 374 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_multiselect__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_multiselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_multiselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex_toast__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex_toast___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuex_toast__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__gql_queries_getTechcenters_graphql__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__gql_queries_getTechcenters_graphql___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__gql_queries_getTechcenters_graphql__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__gql_queries_getCompanies_graphql__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__gql_queries_getCompanies_graphql___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__gql_queries_getCompanies_graphql__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__gql_queries_getUsersForMultiselect_graphql__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__gql_queries_getUsersForMultiselect_graphql___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__gql_queries_getUsersForMultiselect_graphql__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["default"] = ({
  computed: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["mapState"])({
    showModal: function showModal(state) {
      return state.dashboardStore.showModal;
    },
    cities: function cities(state) {
      return state.globalStore.cities;
    },
    statuses: function statuses(state) {
      return state.globalStore.statuses;
    }
  }),
  data: function data() {
    return {
      format: 'DD/MM/YYYY',
      params: {
        dateFrom: '',
        dateTo: '',
        cityId: null,
        techcenterId: null,
        status: null,
        mode: 'search'
      },
      status: null,
      techcenters: [],
      techcenterSelected: null,
      loadingTechcenters: false,
      companies: [],
      companySelected: null,
      loadingCompanies: false,
      users: [],
      loadingUsers: false
    };
  },

  methods: _extends({
    hideSearchModal: function hideSearchModal() {
      this.$store.dispatch('dashboardShowModal', null);
    },
    search: function search() {
      var params = Object.assign({}, this.params);
      if (params.dateFrom.trim() !== '') {
        params.dateFrom = __WEBPACK_IMPORTED_MODULE_2_moment___default()(params.dateFrom, this.format).format('DD.MM.YYYY').toString();
      } else {
        return this.showError('Параметр дата c обязательно должен быть указан');
      }
      if (params.dateTo.trim() !== '') {
        params.dateTo = __WEBPACK_IMPORTED_MODULE_2_moment___default()(params.dateTo, this.format).format('DD.MM.YYYY').toString();
      } else {
        return this.showError('Параметр дата по обязательно должен быть указан');
      }
      this.$store.dispatch('dashboardSetStatisticParams', params);
      this.hideSearchModal();
    },
    showError: function showError(error) {
      this.addToast({
        text: 'Произошла ошибка: ' + error,
        type: 'danger',
        dismissAfter: 10000
      });
    },
    changeCity: function changeCity(city) {
      this.companySelected = null;
      this.params.companyId = null;
      this.techcenterSelected = null;
      this.params.techcenterId = null;
      if (city) {
        this.params.cityId = city.id;
        this.loadCompanies(city.id);
        this.loadTechcenters(city.id);
      } else {
        this.params.cityId = null;
        this.loadCompanies();
        this.loadTechcenters();
      }
    },
    changeCompany: function changeCompany(company) {
      this.techcenterSelected = null;
      this.params.techcenterId = null;
      if (company) {
        this.params.companyId = company.id;
        this.loadTechcenters(this.params.cityId, company.id);
      } else {
        this.params.companyId = null;
        this.loadTechcenters(this.params.cityId);
      }
    },

    /**
     * Загрузка техцентров
     */
    loadTechcenters: function loadTechcenters() {
      var _this = this;

      var cityId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var companyId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      this.loadingTechcenters = true;
      this.techcenters = [];
      this.params.techcenterId = null;
      this.techcenterSelected = null;
      var variables = {
        all: true
      };
      if (cityId) {
        variables.cityId = cityId;
      }
      if (companyId) {
        variables.companyId = companyId;
      }
      this.$apollo.query({
        query: __WEBPACK_IMPORTED_MODULE_4__gql_queries_getTechcenters_graphql___default.a,
        variables: variables
      }).then(function (result) {
        _this.techcenters = result.data.techcenters;
        _this.loadingTechcenters = false;
      }).catch(function (error) {
        console.log(error);
        _this.loadingTechcenters = false;
      });
    },

    /**
     * Загрузка компаний для выбранного города
     */
    loadCompanies: function loadCompanies() {
      var _this2 = this;

      var cityId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      this.loadingCompanies = true;
      var variables = {
        all: true
      };
      if (cityId) {
        variables.cityId = cityId;
      }
      this.$apollo.query({
        query: __WEBPACK_IMPORTED_MODULE_5__gql_queries_getCompanies_graphql___default.a,
        variables: variables
      }).then(function (result) {
        _this2.companies = result.data.companies;
        _this2.loadingCompanies = false;
      }).catch(function (error) {
        console.log(error);
        _this2.loadingCompanies = false;
      });
    },

    /**
     * Установка статуса в параметры
     * @param status
     */
    setStatus: function setStatus(status) {
      if (status !== null) {
        this.params.status = status.code;
      } else {
        this.params.status = null;
      }
    },

    /**
     * Установка пользователя в параметры
     * @param user
     */
    setUserId: function setUserId(user) {
      if (user !== null) {
        this.params.userId = user.id;
      } else {
        this.params.user = null;
      }
    },

    /**
     * Подргрузка менеджеров
     * активируется при открытии селекта
     */
    loadUsers: function loadUsers() {
      var _this3 = this;

      this.loadingUsers = true;
      this.$apollo.query({
        query: __WEBPACK_IMPORTED_MODULE_6__gql_queries_getUsersForMultiselect_graphql___default.a
      }).then(function (result) {
        _this3.users = result.data.users;
        _this3.loadingUsers = false;
      }).catch(function (error) {
        console.log(error);
        _this3.loadingUsers = false;
      });
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["mapActions"])({
    addToast: __WEBPACK_IMPORTED_MODULE_3_vuex_toast__["ADD_TOAST_MESSAGE"]
  })),
  components: {
    //      modal,
    //      datepicker,
    Multiselect: __WEBPACK_IMPORTED_MODULE_0_vue_multiselect___default.a
  }
});

/***/ }),
/* 375 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'navbar',
  created: function created() {
    this._navbar = true;
  }
});

/***/ }),
/* 376 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(3);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Sidebar',
  computed: _extends({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["mapState"])({
    user: function user(state) {
      return state.globalStore.user;
    }
  })),
  data: function data() {
    return {
      scrolled: false,
      scrollToPrev: false
    };
  },
  created: function created() {
    window.addEventListener('scroll', this.handleScroll);
  },
  destroyed: function destroyed() {
    window.removeEventListener('scroll', this.handleScroll);
  },

  methods: {
    handleScroll: function handleScroll() {
      this.scrolled = window.scrollY > 1;
      if (window.scrollY === 0) {
        this.scrollToPrev = false;
      }
    },
    handleClick: function handleClick(e) {
      e.preventDefault();
      e.target.parentElement.classList.toggle('open');
    },
    scrollToTopAction: function scrollToTopAction() {
      this.scrollToPrev = window.scrollY;
      this.$scrollTo('body', 500, {
        offset: 1
      });
    },
    scrollToPrevAction: function scrollToPrevAction() {
      this.$scrollTo('body', 500, {
        offset: this.scrollToPrev
      });
    }
  }
});

/***/ }),
/* 377 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'auth',
  components: {}
});

/***/ }),
/* 378 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Header__ = __webpack_require__(918);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Header___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Header__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Sidebar__ = __webpack_require__(936);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Sidebar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Sidebar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Footer__ = __webpack_require__(917);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Footer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_Footer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Breadcrumb__ = __webpack_require__(916);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Breadcrumb___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_Breadcrumb__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Modals_ModalCloseOrder__ = __webpack_require__(929);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Modals_ModalCloseOrder___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_Modals_ModalCloseOrder__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Modals_ModalCancelOrder__ = __webpack_require__(928);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Modals_ModalCancelOrder___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_Modals_ModalCancelOrder__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Modals_ModalProblemOrder__ = __webpack_require__(931);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Modals_ModalProblemOrder___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_Modals_ModalProblemOrder__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Modals_ModalTransitionOrderConfirm_vue__ = __webpack_require__(932);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Modals_ModalTransitionOrderConfirm_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_Modals_ModalTransitionOrderConfirm_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Modals_ModalEditOrder__ = __webpack_require__(930);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Modals_ModalEditOrder___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_Modals_ModalEditOrder__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Modals_ModalAdminAddUser__ = __webpack_require__(927);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Modals_ModalAdminAddUser___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_Modals_ModalAdminAddUser__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_Modals_ModalAdminAddEditCity_vue__ = __webpack_require__(921);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_Modals_ModalAdminAddEditCity_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_Modals_ModalAdminAddEditCity_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_Modals_ModalAdminAddEditCompany_vue__ = __webpack_require__(922);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_Modals_ModalAdminAddEditCompany_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_Modals_ModalAdminAddEditCompany_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_Modals_ModalAdminAddEditRole_vue__ = __webpack_require__(924);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_Modals_ModalAdminAddEditRole_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__components_Modals_ModalAdminAddEditRole_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_Modals_ModalAdminAddEditTechcenter_vue__ = __webpack_require__(925);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_Modals_ModalAdminAddEditTechcenter_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__components_Modals_ModalAdminAddEditTechcenter_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_Modals_ModalAdminAddEditVirtualNumber_vue__ = __webpack_require__(926);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_Modals_ModalAdminAddEditVirtualNumber_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__components_Modals_ModalAdminAddEditVirtualNumber_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_Modals_ModalAdminAddEditInternalNumber_vue__ = __webpack_require__(923);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_Modals_ModalAdminAddEditInternalNumber_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__components_Modals_ModalAdminAddEditInternalNumber_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_Modals_ModalsOrdersStatisticParams_vue__ = __webpack_require__(934);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_Modals_ModalsOrdersStatisticParams_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__components_Modals_ModalsOrdersStatisticParams_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_Modals_ModalUpdatePage_vue__ = __webpack_require__(933);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_Modals_ModalUpdatePage_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__components_Modals_ModalUpdatePage_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_vuex_toast__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_vuex_toast___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_vuex_toast__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__config__ = __webpack_require__(23);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






















/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'full',
  components: {
    AppHeader: __WEBPACK_IMPORTED_MODULE_1__components_Header___default.a,
    Sidebar: __WEBPACK_IMPORTED_MODULE_2__components_Sidebar___default.a,
    AppFooter: __WEBPACK_IMPORTED_MODULE_3__components_Footer___default.a,
    Breadcrumb: __WEBPACK_IMPORTED_MODULE_4__components_Breadcrumb___default.a,
    ModalCloseOrder: __WEBPACK_IMPORTED_MODULE_5__components_Modals_ModalCloseOrder___default.a,
    ModalCancelOrder: __WEBPACK_IMPORTED_MODULE_6__components_Modals_ModalCancelOrder___default.a,
    ModalProblemOrder: __WEBPACK_IMPORTED_MODULE_7__components_Modals_ModalProblemOrder___default.a,
    ModalTransitionOrderConfirm: __WEBPACK_IMPORTED_MODULE_8__components_Modals_ModalTransitionOrderConfirm_vue___default.a,
    ModalEditOrder: __WEBPACK_IMPORTED_MODULE_9__components_Modals_ModalEditOrder___default.a,
    ModalAdminAddUser: __WEBPACK_IMPORTED_MODULE_10__components_Modals_ModalAdminAddUser___default.a,
    ModalAdminAddEditCity: __WEBPACK_IMPORTED_MODULE_11__components_Modals_ModalAdminAddEditCity_vue___default.a,
    ModalAdminAddEditCompany: __WEBPACK_IMPORTED_MODULE_12__components_Modals_ModalAdminAddEditCompany_vue___default.a,
    ModalAdminAddEditRole: __WEBPACK_IMPORTED_MODULE_13__components_Modals_ModalAdminAddEditRole_vue___default.a,
    ModalAdminAddEditTechcenter: __WEBPACK_IMPORTED_MODULE_14__components_Modals_ModalAdminAddEditTechcenter_vue___default.a,
    ModalsOrdersStatisticParams: __WEBPACK_IMPORTED_MODULE_17__components_Modals_ModalsOrdersStatisticParams_vue___default.a,
    ModalAdminAddEditVirtualNumber: __WEBPACK_IMPORTED_MODULE_15__components_Modals_ModalAdminAddEditVirtualNumber_vue___default.a,
    ModalAdminAddEditInternalNumber: __WEBPACK_IMPORTED_MODULE_16__components_Modals_ModalAdminAddEditInternalNumber_vue___default.a,
    ModalUpdatePage: __WEBPACK_IMPORTED_MODULE_18__components_Modals_ModalUpdatePage_vue___default.a
  },
  computed: _extends({
    name: function name() {
      return this.$route.name;
    },
    list: function list() {
      return this.$route.matched;
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["mapState"])({
    loading: function loading(state) {
      return state.globalStore.loadingApp;
    },
    user: function user(state) {
      return state.globalStore.user;
    },
    activeOrderId: function activeOrderId(state) {
      return state.orderStore.activeOrderId;
    },
    orders: function orders(state) {
      return state.orderStore.orders;
    }
  })),
  methods: _extends({
    newCommentEventListner: function newCommentEventListner(comment) {
      var _this = this;

      var text = comment.user.fullname + ' добавил комментарий к заказу №' + comment.orderId + ': ' + comment.text;
      this.addToast({
        text: text,
        type: 'info',
        dismissAfter: 10000
      });
      if (this.activeOrderId === comment.orderId) {
        this.$store.commit('ADD_COMMENT', {
          id: comment.id,
          diffForHumans: comment.diffForHumans,
          text: comment.text,
          date: comment.date,
          time: comment.time,
          user: {
            id: comment.user.id,
            fullname: comment.user.fullname,
            avatar: comment.user.avatar
          }
        });
        setTimeout(function () {
          _this.$store.dispatch('markAsViewed', comment.orderId);
        }, 2000);
      }
      this.$store.commit('COMMENT_HAS_BEEN_ADDED', comment);
      this.$store.commit('COMMENT_HAS_BEEN_UNVIEWED', comment);
    },
    changeStatusEventListner: function changeStatusEventListner(order, notification, user) {
      var text = user.fullname + ' изменил статус заказа №' + order.id + ' на ' + order.status.name;
      this.addToast({
        text: text,
        type: 'info',
        dismissAfter: 10000
      });
      this.$store.commit('UPDATE_ORDER', order);
      if (notification) {
        this.$store.commit('ADD_NOTIFICATION_FIRST', notification);
      }
    },
    updateOrderEventListner: function updateOrderEventListner(orderId, user) {
      var _this2 = this;

      this.$store.dispatch('updateOrderStoreById', orderId).then(function (order) {
        var text = user + ' изменил заказ №' + order.id;
        _this2.addToast({
          text: text,
          type: 'success',
          dismissAfter: 10000
        });
      });
    },
    phoneVisibleEventListner: function phoneVisibleEventListner(orderId) {
      var _this3 = this;

      var filteredOrders = this.orders.filter(function (order) {
        return order.id === orderId && order.clientPhone === '**********';
      });
      if (filteredOrders.length > 0) {
        this.$store.dispatch('updateOrderStoreById', orderId).then(function (order) {
          var text = 'Доступен к просмотру номер телефона по заказу №' + order.id;
          _this3.addToast({
            text: text,
            type: 'success',
            dismissAfter: 10000
          });
        });
      }
    },
    updateOrderStateEventListner: function updateOrderStateEventListner(orderId, user) {
      var _this4 = this;

      this.$store.dispatch('updateOrderStoreById', orderId).then(function (order) {
        var text = user + ' изменил статус заказа №' + order.id + ' на ' + order.status.name;
        _this4.addToast({
          text: text,
          type: 'success',
          dismissAfter: 10000
        });
      });
    },
    updateOrderProblemEventListner: function updateOrderProblemEventListner(orderId, user, problem) {
      var _this5 = this;

      this.$store.dispatch('updateOrderStoreById', orderId).then(function (order) {
        if (problem) {
          var text = user + ' пометил заказ №' + order.id + ' как проблемный';
          _this5.addToast({
            text: text,
            type: 'danger',
            dismissAfter: 10000
          });
        } else {
          var _text = user + ' решил проблему с заказом №' + order.id;
          _this5.addToast({
            text: _text,
            type: 'success',
            dismissAfter: 10000
          });
        }
      });
    },
    updateOrderCancelEventListner: function updateOrderCancelEventListner(orderId, user, cancel) {
      var _this6 = this;

      this.$store.dispatch('updateOrderStoreById', orderId).then(function (order) {
        if (cancel) {
          var text = user + ' отменил заказ №' + order.id;
          _this6.addToast({
            text: text,
            type: 'danger',
            dismissAfter: 10000
          });
        } else {
          var _text2 = user + ' снял отмену заказа №' + order.id;
          _this6.addToast({
            text: _text2,
            type: 'success',
            dismissAfter: 10000
          });
        }
      });
    },
    deleteOrderEventListner: function deleteOrderEventListner(orderId, user) {
      var text = user + ' удалил заказ №' + orderId;
      this.addToast({
        text: text,
        type: 'danger',
        dismissAfter: 10000
      });
      this.$store.commit('DELETE_ORDER', orderId);
    },
    addedNewOrderEventListner: function addedNewOrderEventListner(orderId, user) {
      var _this7 = this;

      this.$store.dispatch('addOrderStoreById', orderId).then(function (order) {
        var text = user + ' добавил новый заказ №' + order.id;
        _this7.addToast({
          text: text,
          type: 'success',
          dismissAfter: 10000
        });
      });
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["mapActions"])({
    addToast: __WEBPACK_IMPORTED_MODULE_19_vuex_toast__["ADD_TOAST_MESSAGE"]
  })),
  created: function created() {
    var _this8 = this;

    this.$store.dispatch('initApp').then(function () {
      _this8.$echo.options.auth.headers = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20__config__["d" /* getHeader */])();
      _this8.$echo.private('user.' + _this8.user.id).listen('.Illuminate\\Notifications\\Events\\BroadcastNotificationCreated', function (event) {
        if (event.updateNotification) {
          _this8.$store.dispatch('updateNotifications');
        }
        switch (event.type) {
          case 'App\\Notifications\\Orders\\User\\CommentAdded':
            _this8.newCommentEventListner(event.comment);
            break;
          case 'App\\Notifications\\Orders\\User\\OrderStatusHasBeenChanged':
            _this8.changeStatusEventListner(event.order, event.notification, event.user);
            break;
          case 'App\\Notifications\\Orders\\User\\OrderHasBeenChanged':
            _this8.updateOrderEventListner(event.orderId, event.user);
            break;
          case 'App\\Notifications\\Orders\\User\\OrderHasBeenDeleted':
            _this8.deleteOrderEventListner(event.orderId, event.user);
            break;
          case 'App\\Notifications\\Orders\\User\\AddedNewOrderNotification':
            _this8.addedNewOrderEventListner(event.orderId, event.user);
            break;
          case 'App\\Notifications\\Orders\\User\\OrderHasBeenChangedProblem':
            _this8.updateOrderProblemEventListner(event.orderId, event.user, event.problem);
            break;
          case 'App\\Notifications\\Orders\\User\\OrderHasBeenChangedCancel':
            _this8.updateOrderCancelEventListner(event.orderId, event.user, event.cancel);
            break;
          case 'App\\Notifications\\Orders\\User\\OrderHasBeenChangedState':
            _this8.updateOrderStateEventListner(event.orderId, event.user);
            break;
          case 'App\\Notifications\\Orders\\User\\PhoneIsVisible':
            _this8.phoneVisibleEventListner(event.orderId);
            break;
          default:
            console.log(event);
        }
      });
    });
  }
});

/***/ }),
/* 379 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'NotFoundComponent',
  components: {},
  data: function data() {
    return {};
  },

  methods: {
    goHome: function goHome() {
      this.$router.push({ name: 'Home' });
    }
  }
});

/***/ }),
/* 380 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__gql_queries_getAllCities_graphql__ = __webpack_require__(854);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__gql_queries_getAllCities_graphql___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__gql_queries_getAllCities_graphql__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex_toast__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex_toast___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vuex_toast__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  computed: {
    items: function items() {
      return this.itemsPage.cities;
    }
  },
  data: function data() {
    return {
      params: {
        page: 1,
        query: ''
      },
      itemsPage: {
        cities: null,
        paginator: {
          total_count: 10
        }
      },
      showFilter: false,
      loading: false
    };
  },

  name: 'cities',
  components: {
    //
  },
  methods: _extends({
    showModal: function showModal() {
      this.$store.dispatch('setAdminModal', 'addEditCity');
    },
    editItem: function editItem(item) {
      this.$store.commit('SET_ADMIN_EDIT_CITY', item);
      this.showModal();
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["mapActions"])({
    addToast: __WEBPACK_IMPORTED_MODULE_2_vuex_toast__["ADD_TOAST_MESSAGE"]
  })),
  apollo: {
    itemsPage: {
      query: __WEBPACK_IMPORTED_MODULE_0__gql_queries_getAllCities_graphql___default.a,
      variables: function variables() {
        return {
          page: this.params.page,
          query: this.params.query
        };
      },

      fetchPolicy: 'network-only',
      watchLoading: function watchLoading(isLoading, countModifier) {
        this.loading = isLoading;
      },

      update: function update(data) {
        return data;
      }
    }
  }
});

/***/ }),
/* 381 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__gql_queries_getAllCompanies_graphql__ = __webpack_require__(855);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__gql_queries_getAllCompanies_graphql___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__gql_queries_getAllCompanies_graphql__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex_toast__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex_toast___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vuex_toast__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  computed: _extends({
    items: function items() {
      return this.itemsPage.companies;
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["mapState"])({
    currentUser: function currentUser(state) {
      return state.globalStore.user;
    }
  })),
  data: function data() {
    return {
      params: {
        page: 1,
        query: ''
      },
      itemsPage: {
        cities: null,
        paginator: {
          total_count: 10
        }
      },
      showFilter: false,
      loading: false
    };
  },

  name: 'companies',
  components: {
    //
  },
  methods: _extends({
    showModal: function showModal() {
      this.$store.dispatch('setAdminModal', 'addEditCompany');
    },
    editItem: function editItem(item) {
      this.$store.commit('SET_ADMIN_EDIT_COMPANY', item);
      this.showModal();
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["mapActions"])({
    addToast: __WEBPACK_IMPORTED_MODULE_2_vuex_toast__["ADD_TOAST_MESSAGE"]
  })),
  apollo: {
    itemsPage: {
      query: __WEBPACK_IMPORTED_MODULE_0__gql_queries_getAllCompanies_graphql___default.a,
      variables: function variables() {
        return {
          page: this.params.page,
          query: this.params.query
        };
      },

      fetchPolicy: 'network-only',
      watchLoading: function watchLoading(isLoading, countModifier) {
        this.loading = isLoading;
      },

      update: function update(data) {
        return data;
      }
    }
  }
});

/***/ }),
/* 382 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'AdminCard'
});

/***/ }),
/* 383 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_multiselect_src_Multiselect__ = __webpack_require__(280);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_multiselect_src_Multiselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_multiselect_src_Multiselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_helpers_replaceAnchorParams__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_helpers_indexOfProperty__ = __webpack_require__(85);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'AdminFilter',
  components: { VueMultiselect: __WEBPACK_IMPORTED_MODULE_0_vue_multiselect_src_Multiselect___default.a },
  props: {
    value: {
      type: Array,
      required: true
    }
  },
  watch: {
    '$route': function $route(to, from) {
      this.anchorFilter();
    }
  },
  methods: {
    anchorFilter: function anchorFilter() {
      var _this = this;

      var url = decodeURI(window.location.href).split('#');
      var newParams = this.value;
      if (url[1]) {
        var params = url[1].split('&');
        params.forEach(function (item) {
          var value = item.split('=');
          _this.value.forEach(function (param, index) {
            if (value[0] === 'filter-' + param.code) {
              newParams[index].value = value[1];
            }
          });
        });
      }
      this.$emit('input', newParams);
    },
    updateParams: function updateParams(event, param, index) {
      var params = this.value;
      if (param.type === 'text') {
        params[index].value = encodeURIComponent(event.target.value);
      }
      if (param.type === 'select') {
        params[index].value = event.value;
      }
      window.location.href = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_helpers_replaceAnchorParams__["a" /* default */])(window.location.href, 'filter-' + params[index].code, params[index].value);
      this.$emit('input', params);
    },
    getSelectedMultiselectByValue: function getSelectedMultiselectByValue(value, options, property) {
      var index = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_helpers_indexOfProperty__["a" /* default */])(options, property, value);
      if (index > -1) {
        return options[index];
      }
      return null;
    }
  },
  created: function created() {
    this.anchorFilter();
  }
});

/***/ }),
/* 384 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'AdminFormCheckBox',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    labelText: {
      type: String,
      default: ''
    },
    labelId: {
      type: String,
      default: 'label' + Math.random()
    }
  },
  data: function data() {
    return {
      enabled: this.value
    };
  }
});

/***/ }),
/* 385 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'AdminFormInput',
  props: {
    value: {
      type: [String, Number],
      default: null
    },
    error: {
      type: Boolean,
      default: false
    },
    inputRequire: {
      type: Boolean,
      default: false
    },
    errorText: {
      type: String,
      default: 'Неправильно заполнено поле'
    },
    labelText: {
      type: String,
      default: ''
    },
    labelId: {
      type: String,
      default: 'label' + Math.random()
    },
    inputType: {
      type: String,
      default: 'text'
    }
  },
  methods: {
    changeValue: function changeValue(val) {
      this.$emit('input', this.inputType === 'text' ? val : parseInt(val));
    }
  }
});

/***/ }),
/* 386 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_multiselect_src_Multiselect__ = __webpack_require__(280);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_multiselect_src_Multiselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_multiselect_src_Multiselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_helpers_indexOfProperty__ = __webpack_require__(85);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'AdminFormMultiSelect',
  components: { VueMultiselect: __WEBPACK_IMPORTED_MODULE_0_vue_multiselect_src_Multiselect___default.a },
  props: {
    value: {
      default: null
    },
    options: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    error: {
      type: Boolean,
      default: false
    },
    allowEmpty: {
      type: Boolean,
      default: true
    },
    errorText: {
      type: String,
      default: 'Неправильно заполнено поле'
    },
    searchable: {
      type: Boolean,
      default: true
    },
    multiple: {
      type: Boolean,
      default: false
    },
    labelText: {
      type: String,
      default: ''
    },
    labelId: {
      type: String,
      default: 'label' + Math.random()
    },
    trackBy: {
      type: String || null,
      default: 'value'
    },
    label: {
      type: String,
      default: 'name'
    },
    taggable: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    changeValue: function changeValue(object) {
      if (!this.taggable && !this.multiple) {
        this.$emit('input', object ? object[this.trackBy] : null);
      } else if (this.multiple) {
        this.$emit('input', object);
      }
    },
    getSelectedMultiselectByValue: function getSelectedMultiselectByValue(value, options, property) {
      if (this.taggable || this.multiple) {
        return value;
      }
      var index = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_helpers_indexOfProperty__["a" /* default */])(options, property, value);
      if (index > -1) {
        return options[index];
      }
      return null;
    },
    addTag: function addTag(tag) {
      var tags = Object.assign([], this.value);
      tags.push(tag);
      this.$emit('input', tags);
    },
    remove: function remove(object) {
      if (this.taggable) {
        var tags = Object.assign([], this.value);
        var index = tags.indexOf(object);
        if (index !== -1) {
          tags.splice(index, 1);
          this.$emit('input', tags);
        }
      }
    }
  }
});

/***/ }),
/* 387 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'AdminList',
  props: {
    items: {
      type: Array,
      required: true
    },
    loading: {
      type: Boolean,
      default: false
    }
  }
});

/***/ }),
/* 388 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_helpers_replaceAnchorParams__ = __webpack_require__(179);
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    paginator: {
      type: Object,
      required: true
    },
    value: {
      type: Number,
      required: true
    }
  },
  computed: {
    page: {
      get: function get() {
        return this.value;
      },
      set: function set(value) {
        window.location.href = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_helpers_replaceAnchorParams__["a" /* default */])(window.location.href, 'page', value);
        this.$emit('input', value);
      }
    }
  },
  watch: {
    '$route': function $route(to, from) {
      this.anchorPaginate();
    }
  },
  name: 'AdminPagination',
  methods: {
    anchorPaginate: function anchorPaginate() {
      var _this = this;

      var url = window.location.href.split('#');
      if (url[1]) {
        var params = url[1].split('&');
        params.forEach(function (item) {
          var value = item.split('=');
          if (value[0] === 'page') {
            var page = parseInt(value[1]);
            _this.page = page;
          }
        });
      }
    }
  },
  created: function created() {
    this.anchorPaginate();
  }
});

/***/ }),
/* 389 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Components_AdminCard__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Components_AdminCard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Components_AdminCard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Components_AdminFormComponents_AdminFormInput__ = __webpack_require__(275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Components_AdminFormComponents_AdminFormInput___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Components_AdminFormComponents_AdminFormInput__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex_toast__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex_toast___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vuex_toast__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_gql_queries_getCustomFieldById_graphql__ = __webpack_require__(859);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_gql_queries_getCustomFieldById_graphql___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_gql_queries_getCustomFieldById_graphql__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Components_AdminFormComponents_AdminFormMultiSelect__ = __webpack_require__(276);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Components_AdminFormComponents_AdminFormMultiSelect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__Components_AdminFormComponents_AdminFormMultiSelect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Components_AdminFormComponents_AdminFormCheckBox__ = __webpack_require__(274);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Components_AdminFormComponents_AdminFormCheckBox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__Components_AdminFormComponents_AdminFormCheckBox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_gql_mutations_AddCustomField_graphql__ = __webpack_require__(830);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_gql_mutations_AddCustomField_graphql___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_gql_mutations_AddCustomField_graphql__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_gql_mutations_UpdateCustomField_graphql__ = __webpack_require__(848);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_gql_mutations_UpdateCustomField_graphql___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_gql_mutations_UpdateCustomField_graphql__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//











/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'CFEdit',
  components: {
    AdminFormCheckBox: __WEBPACK_IMPORTED_MODULE_7__Components_AdminFormComponents_AdminFormCheckBox___default.a,
    AdminFormMultiSelect: __WEBPACK_IMPORTED_MODULE_6__Components_AdminFormComponents_AdminFormMultiSelect___default.a,
    AdminCard: __WEBPACK_IMPORTED_MODULE_0__Components_AdminCard___default.a,
    AdminFormInput: __WEBPACK_IMPORTED_MODULE_2__Components_AdminFormComponents_AdminFormInput___default.a
  },
  watch: {
    'item.customFields': function itemCustomFields() {
      this.newDataItem = Object.assign({}, this.item.customFields[0]);
    }
  },
  data: function data() {
    return {
      loading: false,
      saving: false,
      newDataItem: {
        id: null,
        name: null,
        entityType: null,
        code: null,
        type: null,
        sort: null,
        required: false,
        viewed: false,
        editable: false
      },
      entityTypeOptions: [{
        name: 'Техцентр',
        value: 'techcenter'
      }, {
        name: 'Заказ',
        value: 'order'
      }, {
        name: 'Компания',
        value: 'company'
      }],
      typeOptions: [{
        name: 'Флаг',
        value: 'checkbox'
      }, {
        name: 'Число',
        value: 'number'
      }, {
        name: 'Текст',
        value: 'text'
      }, {
        name: 'Текстовая область',
        value: 'textarea'
      }]
    };
  },

  validations: {
    newDataItem: {
      name: {
        required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"],
        minLength: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["minLength"])(2)
      },
      code: {
        required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"],
        minLength: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["minLength"])(2)
      },
      entityType: {
        required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"]
      },
      type: {
        required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"]
      },
      amoId: {
        numeric: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["numeric"]
      },
      sort: {
        numeric: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["numeric"]
      }
    }
  },
  methods: _extends({
    beforeUpdateForm: function beforeUpdateForm() {
      this.$v.newDataItem.$touch();
      if (this.$v.newDataItem.$error) {
        return;
      }
      if (this.$route.params.id) {
        this.updateItem();
      } else {
        this.addItem();
      }
    },
    addItem: function addItem() {
      var _this = this;

      this.saving = true;
      this.$apollo.mutate({
        mutation: __WEBPACK_IMPORTED_MODULE_8_gql_mutations_AddCustomField_graphql___default.a,
        variables: this.newDataItem
      }).then(function (result) {
        _this.saving = false;
        _this.addToast({
          text: 'Кастомное поле успешно добавлено',
          type: 'success',
          dismissAfter: 3000
        });
        _this.$router.push({ name: 'CustomFieldsEdit', params: { id: result.data.addCustomField.id } });
      }).catch(function (error) {
        console.error(error);
        _this.addToast({
          text: 'Прооизошла ошибка:' + error,
          type: 'danger',
          dismissAfter: 10000
        });
        _this.saving = false;
      });
    },
    updateItem: function updateItem() {
      var _this2 = this;

      this.saving = true;
      this.$apollo.mutate({
        mutation: __WEBPACK_IMPORTED_MODULE_9_gql_mutations_UpdateCustomField_graphql___default.a,
        variables: this.newDataItem
      }).then(function (result) {
        _this2.saving = false;
        _this2.addToast({
          text: 'Кастомное поле успешно обновлено',
          type: 'success',
          dismissAfter: 3000
        });
      }).catch(function (error) {
        _this2.addToast({
          text: 'Прооизошла ошибка:' + error,
          type: 'danger',
          dismissAfter: 10000
        });
        _this2.saving = false;
      });
    },
    clearData: function clearData() {
      this.newDataItem = {
        id: null,
        name: null,
        entityType: null,
        code: null,
        type: null,
        sort: null,
        required: false,
        viewed: false,
        editable: false
      };
      this.$v.newDataItem.$reset();
    },
    loadData: function loadData() {
      this.$apollo.queries.item.skip = false;
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["mapActions"])({
    addToast: __WEBPACK_IMPORTED_MODULE_4_vuex_toast__["ADD_TOAST_MESSAGE"]
  })),
  apollo: {
    item: {
      skip: true,
      query: __WEBPACK_IMPORTED_MODULE_5_gql_queries_getCustomFieldById_graphql___default.a,
      variables: function variables() {
        return {
          id: this.$route.params.id
        };
      },

      fetchPolicy: 'network-only',
      watchLoading: function watchLoading(isLoading, countModifier) {
        this.loading = isLoading;
      },

      update: function update(data) {
        return data;
      }
    }
  },
  created: function created() {
    if (this.$route.params.id) {
      this.loadData();
    } else {
      this.clearData();
    }
  }
});

/***/ }),
/* 390 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_gql_queries_getCustomFields_graphql__ = __webpack_require__(860);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_gql_queries_getCustomFields_graphql___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_gql_queries_getCustomFields_graphql__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Components_AdminCard__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Components_AdminCard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Components_AdminCard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Components_AdminFilter__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Components_AdminFilter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Components_AdminFilter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Components_AdminList__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Components_AdminList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Components_AdminList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Components_AdminPagination__ = __webpack_require__(277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Components_AdminPagination___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__Components_AdminPagination__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'CFList',
  components: { AdminPagination: __WEBPACK_IMPORTED_MODULE_4__Components_AdminPagination___default.a, AdminList: __WEBPACK_IMPORTED_MODULE_3__Components_AdminList___default.a, AdminFilter: __WEBPACK_IMPORTED_MODULE_2__Components_AdminFilter___default.a, AdminCard: __WEBPACK_IMPORTED_MODULE_1__Components_AdminCard___default.a },
  computed: {
    items: function items() {
      return this.itemsPage.customFields !== undefined ? this.itemsPage.customFields : [];
    }
  },
  data: function data() {
    return {
      showFilter: false,
      loading: false,
      filterParams: [{
        name: 'Название',
        code: 'query',
        type: 'text',
        value: null
      }, {
        name: 'К чему относится',
        code: 'entityType',
        type: 'select',
        value: null,
        multiple: false,
        options: [{ name: 'Техцентр', value: 'techcenter' }, { name: 'Заказ', value: 'order' }, { name: 'Компания', value: 'company' }]
      }, {
        name: 'Тип поля',
        code: 'type',
        type: 'select',
        value: null,
        multiple: false,
        options: [{
          name: 'Флаг',
          value: 'checkbox'
        }, {
          name: 'Число',
          value: 'number'
        }, {
          name: 'Текст',
          value: 'text'
        }, {
          name: 'Текстовая область',
          value: 'textarea'
        }]
      }],
      page: 1,
      itemsPage: {
        paginator: {
          total_count: 1000,
          limit: 10
        }
      }
    };
  },

  apollo: {
    itemsPage: {
      query: __WEBPACK_IMPORTED_MODULE_0_gql_queries_getCustomFields_graphql___default.a,
      variables: function variables() {
        return {
          page: this.page,
          query: this.filterParams[0].value,
          entityType: this.filterParams[1].value,
          type: this.filterParams[2].value
        };
      },

      fetchPolicy: 'network-only',
      watchLoading: function watchLoading(isLoading, countModifier) {
        this.loading = isLoading;
      },

      update: function update(data) {
        return data;
      }
    }
  }
});

/***/ }),
/* 391 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'AdminIndex'
});

/***/ }),
/* 392 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_multiselect__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_multiselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_multiselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__gql_queries_PBX_getIncomingCalls_graphql__ = __webpack_require__(254);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__gql_queries_PBX_getIncomingCalls_graphql___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__gql_queries_PBX_getIncomingCalls_graphql__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__gql_queries_PBX_getVirtualNumbers_graphql__ = __webpack_require__(256);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__gql_queries_PBX_getVirtualNumbers_graphql___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__gql_queries_PBX_getVirtualNumbers_graphql__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__gql_queries_PBX_getInternalNumbers_graphql__ = __webpack_require__(255);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__gql_queries_PBX_getInternalNumbers_graphql___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__gql_queries_PBX_getInternalNumbers_graphql__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__gql_queries_PBX_getAudioRecords_graphql__ = __webpack_require__(253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__gql_queries_PBX_getAudioRecords_graphql___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__gql_queries_PBX_getAudioRecords_graphql__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex_toast__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex_toast___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vuex_toast__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["default"] = ({
  computed: _extends({
    items: function items() {
      this.incomingCallsCache = JSON.parse(JSON.stringify(this.itemsPage.incomingCalls));
      return this.incomingCallsCache;
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["mapState"])({
    cities: function cities(state) {
      return state.globalStore.cities;
    }
  })),
  data: function data() {
    return {
      params: {
        page: 1,
        cityId: null,
        virtualNumberId: null,
        internalNumberId: null,
        dateTimeFrom: null,
        dateTimeTo: null,
        query: null
      },
      itemsPage: {
        incomingCalls: null,
        paginator: {
          total_count: 10
        }
      },
      incomingCallsCache: [],
      blockLoading: false,
      showFilter: false,
      loading: false,
      loadingRecords: false,
      virtualNumbers: [],
      loadingVirtualNumbers: false,
      internalNumbers: [],
      loadingInternalNumbers: false
    };
  },

  name: 'incomingCalls',
  components: {
    Multiselect: __WEBPACK_IMPORTED_MODULE_0_vue_multiselect___default.a
  },
  methods: _extends({
    loadRecords: function loadRecords(pbxCallId, index) {
      var _this = this;

      this.loadingRecords = pbxCallId;
      this.$apollo.query({
        query: __WEBPACK_IMPORTED_MODULE_4__gql_queries_PBX_getAudioRecords_graphql___default.a,
        variables: {
          pbxCallId: pbxCallId
        }
      }).then(function (result) {
        _this.incomingCallsCache[index].records = result.data.audioRecords;
        _this.loadingRecords = false;
      }).catch(function (error) {
        console.log(error);
        _this.addToast({
          text: 'Произошла ошибка:' + error,
          type: 'danger',
          dismissAfter: 10000
        });
        _this.loadingRecords = false;
      });
    },
    changeCity: function changeCity(city) {
      if (city) {
        this.params.cityId = city.id;
      } else {
        this.params.cityId = null;
      }
    },
    changeVirtualNumber: function changeVirtualNumber(number) {
      if (number) {
        this.params.virtualNumberId = number.id;
      } else {
        this.params.virtualNumberId = null;
      }
    },
    changeInternalNumber: function changeInternalNumber(number) {
      if (number) {
        this.params.internalNumberId = number.id;
      } else {
        this.params.internalNumberId = null;
      }
    },
    loadVirtualNumbers: function loadVirtualNumbers() {
      var _this2 = this;

      this.loadingVirtualNumbers = true;
      this.$apollo.query({
        query: __WEBPACK_IMPORTED_MODULE_2__gql_queries_PBX_getVirtualNumbers_graphql___default.a,
        variables: {
          all: true
        }
      }).then(function (result) {
        _this2.virtualNumbers = result.data.virtualNumbers;
        _this2.loadingVirtualNumbers = false;
      }).catch(function (error) {
        console.log(error);
        _this2.loadingVirtualNumbers = false;
      });
    },
    loadInternalNumbers: function loadInternalNumbers() {
      var _this3 = this;

      this.loadingInternalNumbers = true;
      this.$apollo.query({
        query: __WEBPACK_IMPORTED_MODULE_3__gql_queries_PBX_getInternalNumbers_graphql___default.a,
        variables: {
          all: true
        }
      }).then(function (result) {
        _this3.internalNumbers = result.data.internalNumbers;
        _this3.loadingInternalNumbers = false;
      }).catch(function (error) {
        console.log(error);
        _this3.loadingInternalNumbers = false;
      });
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["mapActions"])({
    addToast: __WEBPACK_IMPORTED_MODULE_6_vuex_toast__["ADD_TOAST_MESSAGE"]
  })),
  apollo: {
    itemsPage: {
      query: __WEBPACK_IMPORTED_MODULE_1__gql_queries_PBX_getIncomingCalls_graphql___default.a,
      variables: function variables() {
        return {
          page: this.params.page,
          cityId: this.params.cityId,
          virtualNumberId: this.params.virtualNumberId,
          internalNumberId: this.params.internalNumberId,
          dateTimeFrom: this.params.dateTimeFrom,
          dateTimeTo: this.params.dateTimeTo,
          query: this.params.query
        };
      },

      fetchPolicy: 'network-only',
      watchLoading: function watchLoading(isLoading, countModifier) {
        this.loading = isLoading;
      },

      update: function update(data) {
        return data;
      }
    }
  }
});

/***/ }),
/* 393 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_multiselect__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_multiselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_multiselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__gql_queries_PBX_getInternalNumbers_graphql__ = __webpack_require__(255);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__gql_queries_PBX_getInternalNumbers_graphql___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__gql_queries_PBX_getInternalNumbers_graphql__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__gql_queries_getUsersForMultiselect_graphql__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__gql_queries_getUsersForMultiselect_graphql___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__gql_queries_getUsersForMultiselect_graphql__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex_toast__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex_toast___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vuex_toast__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  computed: {
    items: function items() {
      return this.itemsPage.internalNumbers;
    }
  },
  data: function data() {
    return {
      params: {
        page: 1,
        query: '',
        userId: null
      },
      users: [],
      itemsPage: {
        internalNumbers: null,
        paginator: {
          total_count: 10
        }
      },
      blockLoading: false,
      showFilter: false,
      loading: false,
      loadingUsers: false
    };
  },

  name: 'internalNumbers',
  components: {
    Multiselect: __WEBPACK_IMPORTED_MODULE_0_vue_multiselect___default.a
  },
  methods: _extends({
    showModal: function showModal() {
      this.$store.dispatch('setAdminModal', 'addEditInternalNumber');
    },
    editItem: function editItem(item) {
      this.$store.commit('SET_ADMIN_EDIT_INTERNAL_NUMBER', item);
      this.showModal();
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["mapActions"])({
    addToast: __WEBPACK_IMPORTED_MODULE_4_vuex_toast__["ADD_TOAST_MESSAGE"]
  }), {
    changeUser: function changeUser(user) {
      if (user) {
        this.params.userId = user.id;
      } else {
        this.params.userId = null;
      }
    },

    /**
     * Подргрузка менеджеров
     * активируется при открытии селекта
     */
    loadUsers: function loadUsers() {
      var _this = this;

      this.loadingUsers = true;
      this.$apollo.query({
        query: __WEBPACK_IMPORTED_MODULE_2__gql_queries_getUsersForMultiselect_graphql___default.a
      }).then(function (result) {
        _this.users = result.data.users;
        _this.loadingUsers = false;
      }).catch(function (error) {
        console.log(error);
        _this.loadingUsers = false;
      });
    }
  }),
  apollo: {
    itemsPage: {
      query: __WEBPACK_IMPORTED_MODULE_1__gql_queries_PBX_getInternalNumbers_graphql___default.a,
      variables: function variables() {
        return {
          page: this.params.page,
          query: this.params.query,
          userId: this.params.userId
        };
      },

      fetchPolicy: 'network-only',
      watchLoading: function watchLoading(isLoading, countModifier) {
        this.loading = isLoading;
      },

      update: function update(data) {
        return data;
      }
    }
  }
});

/***/ }),
/* 394 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_multiselect__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_multiselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_multiselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__gql_queries_PBX_getVirtualNumbers_graphql__ = __webpack_require__(256);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__gql_queries_PBX_getVirtualNumbers_graphql___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__gql_queries_PBX_getVirtualNumbers_graphql__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex_toast__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex_toast___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuex_toast__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  computed: _extends({
    items: function items() {
      return this.itemsPage.virtualNumbers;
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["mapState"])({
    cities: function cities(state) {
      return state.globalStore.cities;
    }
  })),
  data: function data() {
    return {
      params: {
        page: 1,
        query: '',
        cityId: null
      },
      itemsPage: {
        virtualNumbers: null,
        paginator: {
          total_count: 10
        }
      },
      companies: [],
      blockLoading: false,
      showFilter: false,
      loading: false
    };
  },

  name: 'virtualNumbers',
  components: {
    Multiselect: __WEBPACK_IMPORTED_MODULE_0_vue_multiselect___default.a
  },
  methods: _extends({
    showModal: function showModal() {
      this.$store.dispatch('setAdminModal', 'addEditVirtualNumber');
    },
    editItem: function editItem(item) {
      this.$store.commit('SET_ADMIN_EDIT_VIRTUAL_NUMBER', item);
      this.showModal();
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["mapActions"])({
    addToast: __WEBPACK_IMPORTED_MODULE_3_vuex_toast__["ADD_TOAST_MESSAGE"]
  }), {
    changeCity: function changeCity(city) {
      this.params.companyId = null;
      if (city) {
        this.params.cityId = city.id;
      } else {
        this.params.cityId = null;
      }
    }
  }),
  apollo: {
    itemsPage: {
      query: __WEBPACK_IMPORTED_MODULE_1__gql_queries_PBX_getVirtualNumbers_graphql___default.a,
      variables: function variables() {
        return {
          page: this.params.page,
          query: this.params.query,
          cityId: this.params.cityId
        };
      },

      fetchPolicy: 'network-only',
      watchLoading: function watchLoading(isLoading, countModifier) {
        this.loading = isLoading;
      },

      update: function update(data) {
        return data;
      }
    }
  }
});

/***/ }),
/* 395 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__gql_queries_Acl_getRoles_graphql__ = __webpack_require__(252);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__gql_queries_Acl_getRoles_graphql___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__gql_queries_Acl_getRoles_graphql__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex_toast__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex_toast___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vuex_toast__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  computed: {
    items: function items() {
      return this.itemsPage.roles;
    }
  },
  data: function data() {
    return {
      params: {
        page: 1,
        query: ''
      },
      itemsPage: {
        roles: null,
        paginator: {
          total_count: 10
        }
      },
      showFilter: false,
      loading: false
    };
  },

  name: 'roles',
  components: {
    //
  },
  methods: _extends({
    showModal: function showModal() {
      this.$store.dispatch('setAdminModal', 'addEditRole');
    },
    editItem: function editItem(item) {
      this.$store.commit('SET_ADMIN_EDIT_ROLE', item);
      this.showModal();
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["mapActions"])({
    addToast: __WEBPACK_IMPORTED_MODULE_2_vuex_toast__["ADD_TOAST_MESSAGE"]
  })),
  apollo: {
    itemsPage: {
      query: __WEBPACK_IMPORTED_MODULE_0__gql_queries_Acl_getRoles_graphql___default.a,
      variables: function variables() {
        return {
          page: this.params.page,
          query: this.params.query,
          all: false
        };
      },

      fetchPolicy: 'network-only',
      watchLoading: function watchLoading(isLoading, countModifier) {
        this.loading = isLoading;
      },

      update: function update(data) {
        return data;
      }
    }
  }
});

/***/ }),
/* 396 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Components_AdminCard__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Components_AdminCard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Components_AdminCard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Components_AdminFormComponents_AdminFormInput__ = __webpack_require__(275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Components_AdminFormComponents_AdminFormInput___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Components_AdminFormComponents_AdminFormInput__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex_toast__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex_toast___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vuex_toast__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_gql_queries_getStatusById_graphql__ = __webpack_require__(864);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_gql_queries_getStatusById_graphql___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_gql_queries_getStatusById_graphql__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Components_AdminFormComponents_AdminFormMultiSelect__ = __webpack_require__(276);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Components_AdminFormComponents_AdminFormMultiSelect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__Components_AdminFormComponents_AdminFormMultiSelect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Components_AdminFormComponents_AdminFormCheckBox__ = __webpack_require__(274);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Components_AdminFormComponents_AdminFormCheckBox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__Components_AdminFormComponents_AdminFormCheckBox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_gql_mutations_AddStatus_graphql__ = __webpack_require__(832);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_gql_mutations_AddStatus_graphql___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_gql_mutations_AddStatus_graphql__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_gql_mutations_UpdateStatus_graphql__ = __webpack_require__(850);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_gql_mutations_UpdateStatus_graphql___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_gql_mutations_UpdateStatus_graphql__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_gql_queries_getAmoStatuses_graphql__ = __webpack_require__(857);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_gql_queries_getAmoStatuses_graphql___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_gql_queries_getAmoStatuses_graphql__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//













/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'StatusEdit',
  components: {
    AdminFormCheckBox: __WEBPACK_IMPORTED_MODULE_7__Components_AdminFormComponents_AdminFormCheckBox___default.a,
    AdminFormMultiSelect: __WEBPACK_IMPORTED_MODULE_6__Components_AdminFormComponents_AdminFormMultiSelect___default.a,
    AdminCard: __WEBPACK_IMPORTED_MODULE_0__Components_AdminCard___default.a,
    AdminFormInput: __WEBPACK_IMPORTED_MODULE_2__Components_AdminFormComponents_AdminFormInput___default.a
  },
  watch: {
    'item.statuses': function itemStatuses() {
      this.newDataItem = Object.assign({}, this.item.statuses[0]);
    }
  },
  data: function data() {
    return {
      loading: false,
      saving: false,
      newDataItem: {
        id: null,
        name: null,
        code: null,
        class: null,
        sort: 100,
        amoStatuses: [],
        enabled: false
      },
      amoStatuses: []
    };
  },

  validations: {
    newDataItem: {
      name: {
        required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"],
        minLength: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["minLength"])(2)
      },
      code: {
        required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"],
        minLength: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["minLength"])(2)
      },
      class: {
        required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"],
        minLength: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["minLength"])(2)
      },
      sort: {
        required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"],
        numeric: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["numeric"]
      }
    }
  },
  methods: _extends({
    beforeUpdateForm: function beforeUpdateForm() {
      this.$v.newDataItem.$touch();
      if (this.$v.newDataItem.$error) {
        return;
      }
      if (this.$route.params.id) {
        this.updateItem();
      } else {
        this.addItem();
      }
    },
    addItem: function addItem() {
      var _this = this;

      this.saving = true;
      this.$apollo.mutate({
        mutation: __WEBPACK_IMPORTED_MODULE_8_gql_mutations_AddStatus_graphql___default.a,
        variables: this.newDataItem
      }).then(function (result) {
        _this.saving = false;
        _this.addToast({
          text: 'Статус успешно добавлен',
          type: 'success',
          dismissAfter: 3000
        });
        _this.$router.push({ name: 'StatusEdit', params: { id: result.data.addStatus.id } });
      }).catch(function (error) {
        console.error(error);
        _this.addToast({
          text: 'Прооизошла ошибка:' + error,
          type: 'danger',
          dismissAfter: 10000
        });
        _this.saving = false;
      });
    },
    updateItem: function updateItem() {
      var _this2 = this;

      this.saving = true;
      this.$apollo.mutate({
        mutation: __WEBPACK_IMPORTED_MODULE_9_gql_mutations_UpdateStatus_graphql___default.a,
        variables: this.newDataItem
      }).then(function (result) {
        _this2.saving = false;
        _this2.addToast({
          text: 'Статус успешно обновлен',
          type: 'success',
          dismissAfter: 3000
        });
      }).catch(function (error) {
        console.log(error);
        _this2.addToast({
          text: 'Прооизошла ошибка:' + error,
          type: 'danger',
          dismissAfter: 10000
        });
        _this2.saving = false;
      });
    },
    clearData: function clearData() {
      this.newDataItem = {
        id: null,
        name: null,
        class: null,
        sort: 100,
        code: null,
        amoStatuses: []
      };
      this.$v.newDataItem.$reset();
    },
    loadData: function loadData() {
      this.$apollo.queries.item.skip = false;
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["mapActions"])({
    addToast: __WEBPACK_IMPORTED_MODULE_4_vuex_toast__["ADD_TOAST_MESSAGE"]
  })),
  apollo: {
    item: {
      skip: true,
      query: __WEBPACK_IMPORTED_MODULE_5_gql_queries_getStatusById_graphql___default.a,
      variables: function variables() {
        return {
          id: this.$route.params.id
        };
      },

      fetchPolicy: 'network-only',
      watchLoading: function watchLoading(isLoading, countModifier) {
        this.loading = isLoading;
      },

      update: function update(data) {
        return data;
      }
    },
    amoStatuses: {
      query: __WEBPACK_IMPORTED_MODULE_10_gql_queries_getAmoStatuses_graphql___default.a,
      fetchPolicy: 'network-only',
      watchLoading: function watchLoading(isLoading, countModifier) {
        this.loading = isLoading;
      },

      update: function update(data) {
        return data.amoStatuses;
      }
    }
  },
  created: function created() {
    if (this.$route.params.id) {
      this.loadData();
    } else {
      this.clearData();
    }
  }
});

/***/ }),
/* 397 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_gql_queries_getStatuses_graphql__ = __webpack_require__(865);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_gql_queries_getStatuses_graphql___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_gql_queries_getStatuses_graphql__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Components_AdminCard__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Components_AdminCard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Components_AdminCard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Components_AdminFilter__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Components_AdminFilter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Components_AdminFilter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Components_AdminList__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Components_AdminList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Components_AdminList__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'StatusList',
  components: { AdminList: __WEBPACK_IMPORTED_MODULE_3__Components_AdminList___default.a, AdminFilter: __WEBPACK_IMPORTED_MODULE_2__Components_AdminFilter___default.a, AdminCard: __WEBPACK_IMPORTED_MODULE_1__Components_AdminCard___default.a },
  computed: {
    items: function items() {
      return this.itemsPage.statuses !== undefined ? this.itemsPage.statuses : [];
    }
  },
  data: function data() {
    return {
      showFilter: false,
      loading: false,
      filterParams: [],
      page: 1,
      itemsPage: {
        paginator: {
          total_count: 1000,
          limit: 10
        }
      }
    };
  },

  apollo: {
    itemsPage: {
      query: __WEBPACK_IMPORTED_MODULE_0_gql_queries_getStatuses_graphql___default.a,
      variables: function variables() {
        return {};
      },

      fetchPolicy: 'network-only',
      watchLoading: function watchLoading(isLoading, countModifier) {
        this.loading = isLoading;
      },

      update: function update(data) {
        return data;
      }
    }
  }
});

/***/ }),
/* 398 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__gql_queries_getUsers_graphql__ = __webpack_require__(870);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__gql_queries_getUsers_graphql___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__gql_queries_getUsers_graphql__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__gql_mutations_BlockUser_graphql__ = __webpack_require__(249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__gql_mutations_BlockUser_graphql___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__gql_mutations_BlockUser_graphql__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex_toast__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex_toast___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vuex_toast__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  computed: _extends({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["mapState"])({
    currentUser: function currentUser(state) {
      return state.globalStore.user;
    }
  }), {
    users: function users() {
      return this.usersPage.users;
    }
  }),
  data: function data() {
    return {
      params: {
        page: 1,
        all: false,
        query: ''
      },
      usersPage: {
        users: null,
        paginator: {
          total_count: 10
        }
      },
      blockUserLoading: false,
      showFilter: false,
      loadingUsers: false
    };
  },

  name: 'users',
  components: {
    //
  },
  methods: _extends({
    search: function search() {
      //        this.$apollo.queries.usersPage.refetch()
    },

    /**
     * Блокировка/разблокировка пользователя
     * @param user
     * @param enabled
     */
    blockUser: function blockUser(user, enabled) {
      var _this = this;

      this.blockUserLoading = user.id;
      this.$apollo.mutate({
        mutation: __WEBPACK_IMPORTED_MODULE_1__gql_mutations_BlockUser_graphql___default.a,
        variables: {
          id: user.id,
          enabled: enabled
        }
      }).then(function (data) {
        _this.addToast({
          text: 'Изменения сохранены',
          type: 'success',
          dismissAfter: 3000
        });
        _this.blockUserLoading = false;
      }).catch(function (error) {
        console.error(error);
        _this.addToast({
          text: 'Произошла ошибка:' + error,
          type: 'danger',
          dismissAfter: 10000
        });
        _this.blockUserLoading = false;
      });
    },

    /**
     * Открепить/прикрепить техцентр к пользователю
     * @param user
     * @param techcenter
     */
    //      attachDetachTechcenter (user, techcenter, attach) {
    //        this.$apollo.mutate({
    //          mutation: attachDetachTechcenterByUserMutate,
    //          variables: {
    //            userId: user.id,
    //            techcenterId: techcenter.id,
    //            attach: attach
    //          }
    //        }).then((data) => {
    //          this.addToast({
    //            text: 'Изменения сохранены',
    //            type: 'success',
    //            dismissAfter: 3000
    //          })
    //        }).catch((error) => {
    //          console.error(error)
    //          this.addToast({
    //            text: 'Произошла ошибка:' + error,
    //            type: 'danger',
    //            dismissAfter: 10000
    //          })
    //          this.blockUserLoading = false
    //        })
    //      },
    showModalAddUser: function showModalAddUser() {
      this.$store.dispatch('setAdminModal', 'addUser');
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["mapActions"])({
    addToast: __WEBPACK_IMPORTED_MODULE_4_vuex_toast__["ADD_TOAST_MESSAGE"]
  }), {
    getAvatarPath: function getAvatarPath(path) {
      return __WEBPACK_IMPORTED_MODULE_2__config__["e" /* storageUrl */] + path;
    }
  }),
  apollo: {
    usersPage: {
      query: __WEBPACK_IMPORTED_MODULE_0__gql_queries_getUsers_graphql___default.a,
      variables: function variables() {
        return {
          page: this.params.page,
          all: this.params.all,
          query: this.params.query
        };
      },

      fetchPolicy: 'network-only',
      watchLoading: function watchLoading(isLoading, countModifier) {
        this.loadingUsers = isLoading;
      },

      update: function update(data) {
        return data;
      }
    }
  }
});

/***/ }),
/* 399 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'login',
  components: {},
  computed: {
    name: function name() {
      return this.$route.name;
    },
    list: function list() {
      return this.$route.matched;
    }
  },
  data: function data() {
    return {
      login: {
        email: null,
        password: null,
        remember: false
      },
      error: false,
      loading: false
    };
  },

  methods: {
    handleLoginFormSubmit: function handleLoginFormSubmit() {
      var _this = this;

      this.error = false;
      this.loading = true;
      var postData = {
        email: this.login.email,
        password: this.login.password
      };
      var authUser = {};
      this.$http.post(__WEBPACK_IMPORTED_MODULE_0__config__["k" /* loginUrl */], postData).then(function (response) {
        if (response.status === 200) {
          authUser.access_token = response.data.meta.token;
          if (_this.login.remember) {
            window.localStorage.setItem('authUser', JSON.stringify(authUser));
          } else {
            window.sessionStorage.setItem('authUser', JSON.stringify(authUser));
          }
          _this.loading = false;
          _this.$router.push({ name: 'Orders' });
        }
      }, function (response) {
        _this.error = true;
        _this.loading = false;
        console.log(response.data);
      });
    }
  },
  validations: {
    login: {
      email: {
        required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"],
        email: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["email"]
      },
      password: {
        required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"],
        minLength: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["minLength"])(6)
      }
    }
  }
});

/***/ }),
/* 400 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'RemindPassword',
  components: {},
  computed: {
    name: function name() {
      return this.$route.name;
    },
    list: function list() {
      return this.$route.matched;
    }
  },
  data: function data() {
    return {
      remind: {
        email: null,
        phone: null
      },
      error: false,
      loading: false,
      type: 'email'
    };
  },

  methods: {
    remindEmail: function remindEmail() {
      var _this = this;

      this.error = false;
      this.loading = true;
      var postData = {
        email: this.remind.email
        //        const authUser = {}
      };this.$http.post(__WEBPACK_IMPORTED_MODULE_0__config__["j" /* remindEmailUrl */], postData).then(function (response) {
        console.log(response);
        _this.loading = false;
        if (response.status === 200) {
          _this.remind.email = null;
          _this.$router.push({ name: 'EmailLinkSend' });
        }
      }, function (response) {
        _this.error = true;
        _this.loading = false;
        console.log(response.data);
      });
    }
  },
  validations: {
    remind: {
      email: {
        required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"],
        email: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["email"]
      }
    }
  }
});

/***/ }),
/* 401 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ResetPasswordEmail',
  data: function data() {
    return {
      loading: false,
      error: false,
      newPassword: null,
      remindNewPassword: null
    };
  },

  methods: {
    resetPassword: function resetPassword() {
      var _this = this;

      this.error = false;
      this.loading = true;
      var postData = {
        token: this.$route.query.token,
        email: this.$route.query.email,
        password: this.newPassword,
        password_confirmation: this.remindNewPassword
      };
      this.$http.post(__WEBPACK_IMPORTED_MODULE_0__config__["i" /* resetPasswordUrl */], postData).then(function (response) {
        _this.loading = false;
        if (response.status === 200) {
          var authUser = {};
          authUser.access_token = response.data.meta.token;
          window.sessionStorage.setItem('authUser', JSON.stringify(authUser));
          _this.loading = false;
          _this.$router.push({ name: 'Dashboard' });
        }
      }, function (response) {
        _this.error = response.response.data.message;
        _this.loading = false;
        console.log(response.response.data);
      });
    }
  },
  validations: {
    newPassword: {
      required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"],
      minLength: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["minLength"])(6)
    },
    remindNewPassword: {
      sameAsPassword: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["sameAs"])('newPassword')
    }
  }
});

/***/ }),
/* 402 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex_toast__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex_toast___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuex_toast__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_marked__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_marked___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_marked__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__gql_queries_getDocument_graphql__ = __webpack_require__(861);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__gql_queries_getDocument_graphql___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__gql_queries_getDocument_graphql__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  computed: _extends({
    compiledSidebarMarkdown: function compiledSidebarMarkdown() {
      return __WEBPACK_IMPORTED_MODULE_2_marked___default()(this.sideBarContent, { sanitize: true });
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["mapState"])({
    currentUser: function currentUser(state) {
      return state.globalStore.user;
    }
  })),
  watch: {
    '$route': 'loadData'
  },
  data: function data() {
    return {
      loadingSidebar: false,
      loadingDocument: false,
      sidebar: '',
      document: '',
      documentUri: 'README'
    };
  },

  name: 'profile',
  components: {
    //
  },
  methods: _extends({
    loadData: function loadData(to, from) {
      if (to.params[0]) {
        this.documentUri = to.params[0];
      } else {
        this.documentUri = 'README';
      }
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["mapActions"])({
    addToast: __WEBPACK_IMPORTED_MODULE_1_vuex_toast__["ADD_TOAST_MESSAGE"]
  }), {
    isSameDomain: function isSameDomain(path) {
      return path.indexOf(location.host) !== -1;
    },
    getPath: function getPath(path) {
      var l = document.createElement('a');
      l.href = path;
      return l.pathname;
    }
  }),
  apollo: {
    sidebar: {
      query: __WEBPACK_IMPORTED_MODULE_3__gql_queries_getDocument_graphql___default.a,
      variables: {
        uri: '_sidebar'
      },
      watchLoading: function watchLoading(isLoading, countModifier) {
        this.loadingSidebar = isLoading;
      },

      update: function update(data) {
        return data.document;
      }
    },
    document: {
      query: __WEBPACK_IMPORTED_MODULE_3__gql_queries_getDocument_graphql___default.a,
      variables: function variables() {
        return {
          uri: this.documentUri
        };
      },
      watchLoading: function watchLoading(isLoading, countModifier) {
        this.loadingDocument = isLoading;
      },

      update: function update(data) {
        return data.document;
      }
    }
  },
  created: function created() {
    if (this.$route.params[0]) {
      this.documentUri = this.$route.params[0];
    }
  },
  mounted: function mounted() {
    var _this = this;

    document.getElementById('help__page').addEventListener('click', function (event) {
      var target = event.target;
      while (target && target.tagName !== 'A') {
        target = target.parentNode;
      }
      event.preventDefault();
      if (target && target.href && _this.isSameDomain(target.href)) {
        event.preventDefault();
        _this.$router.push(_this.getPath(target.href));
      }
    });
  }
});

/***/ }),
/* 403 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__OrderStatus_vue__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__OrderStatus_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__OrderStatus_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__OrderTopPanel_vue__ = __webpack_require__(962);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__OrderTopPanel_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__OrderTopPanel_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__OrderActions_vue__ = __webpack_require__(958);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__OrderActions_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__OrderActions_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__OrderClientInfo_vue__ = __webpack_require__(960);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__OrderClientInfo_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__OrderClientInfo_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__OrderTechcenterInfo_vue__ = __webpack_require__(961);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__OrderTechcenterInfo_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__OrderTechcenterInfo_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Comments_vue__ = __webpack_require__(273);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Comments_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_Comments_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__OrderHistory_vue__ = __webpack_require__(278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__OrderHistory_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__OrderHistory_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__OrderCallHistory_vue__ = __webpack_require__(959);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__OrderCallHistory_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__OrderCallHistory_vue__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//











/* harmony default export */ __webpack_exports__["default"] = ({
  computed: _extends({
    showAlertNoOrders: function showAlertNoOrders() {
      return this.orders.length === 0 && !this.loading;
    },
    ordersDays: function ordersDays() {
      return this.orders.map(function (item) {
        return item.date;
      }).filter(function (value, index, self) {
        return self.indexOf(value) === index;
      }).sort(function (a, b) {
        var dateA = __WEBPACK_IMPORTED_MODULE_1_moment___default()(a, 'DD.MM.YYYY');
        var dateB = __WEBPACK_IMPORTED_MODULE_1_moment___default()(b, 'DD.MM.YYYY');
        return dateB.isBefore(dateA) ? 1 : -1;
      });
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["mapState"])({
    orders: function orders(state) {
      return state.orderStore.orders;
    },
    currentUser: function currentUser(state) {
      return state.globalStore.user;
    },
    loading: function loading(state) {
      return state.orderStore.loading;
    },
    activeOrderId: function activeOrderId(state) {
      return state.orderStore.activeOrderId;
    }
  })),
  name: 'Orders',
  data: function data() {
    return {
      showCanceled: true
    };
  },

  methods: {
    getCommission: function getCommission(sum, profit) {
      if (sum !== null && profit !== null && this.userCanSeeCommission()) {
        return parseInt(profit / sum * 100);
      }
      return -1;
    },
    userCanSeeCommission: function userCanSeeCommission() {
      return this.currentUser || this.currentUser.hasPermission('order.finance.all') || this.currentUser.hasPermission('order.finance.companies') || this.currentUser.hasPermission('order.finance.techcenters') || this.currentUser.hasPermission('order.finance.his');
    },
    getOrdersByDate: function getOrdersByDate(date) {
      var _this = this;

      return this.orders.filter(function (order) {
        if (_this.showCanceled) {
          return order.date === date;
        } else {
          return order.date === date && !order.canceled;
        }
      }).sort(function (a, b) {
        if (a.time > b.time) {
          return 1;
        } else if (a.time < b.time) {
          return -1;
        } else if (a.id > b.id) {
          return 1;
        } else if (a.id < b.id) {
          return -1;
        } else {
          console.error('error');
          return 0;
        }
      });
    },
    getOrdersCanceledByDate: function getOrdersCanceledByDate(date) {
      return this.orders.filter(function (order) {
        return order.date === date && order.canceled;
      });
    },
    convertDataToString: function convertDataToString(date) {
      __WEBPACK_IMPORTED_MODULE_1_moment___default.a.locale('ru');
      var dateString = __WEBPACK_IMPORTED_MODULE_1_moment___default()(date, 'DD.MM.YYYY').format('dddd D MMMM Y').toString();
      dateString = dateString.charAt(0).toUpperCase() + dateString.substr(1);
      return dateString;
    },
    showOrderDetail: function showOrderDetail(id) {
      // if (this.activeOrderId !== id) {
      //   this.$store.dispatch('setActiveOrderId', id)
      //   this.$scrollTo('#order_' + id, 500, {
      //     offset: -50
      //   })
      // } else {
      //   this.$store.dispatch('setActiveOrderId', null)
      // }
      this.$store.dispatch('setActiveOrderId', null);
      this.$router.push({ name: 'Order', params: { id: id } });
    },
    getIdElement: function getIdElement(id) {
      return 'order_' + id;
    },
    getCommentsDescr: function getCommentsDescr(count) {
      if (count) {
        return 'Непрочитанных комментариев: ' + count;
      } else {
        return 'Непрочитанных комментариев нет';
      }
    },
    getCreatedDescr: function getCreatedDescr(order) {
      var text = 'Заказ был добавлен ' + order.date;
      if (order.closed) {
        text += ' и закрыт ' + order.closed;
      }
      return text;
    },
    showMovedOrderDetail: function showMovedOrderDetail(id) {
      this.$store.dispatch('showOrderDetail', id);
    },
    getAmoLeadUrl: function getAmoLeadUrl(id) {
      return 'https://alarmru.amocrm.ru/leads/detail/' + id;
    }
  },
  components: {
    OrderStatus: __WEBPACK_IMPORTED_MODULE_2__OrderStatus_vue___default.a,
    OrderTopPanel: __WEBPACK_IMPORTED_MODULE_3__OrderTopPanel_vue___default.a,
    OrderActions: __WEBPACK_IMPORTED_MODULE_4__OrderActions_vue___default.a,
    Comments: __WEBPACK_IMPORTED_MODULE_7__components_Comments_vue___default.a,
    OrderHistory: __WEBPACK_IMPORTED_MODULE_8__OrderHistory_vue___default.a,
    OrderCallHistory: __WEBPACK_IMPORTED_MODULE_9__OrderCallHistory_vue___default.a,
    OrderClientInfo: __WEBPACK_IMPORTED_MODULE_5__OrderClientInfo_vue___default.a,
    OrderTechcenterInfo: __WEBPACK_IMPORTED_MODULE_6__OrderTechcenterInfo_vue___default.a
  }
});

/***/ }),
/* 404 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex_toast__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex_toast___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuex_toast__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['order'],
  data: function data() {
    return {
      loading: false
    };
  },

  methods: _extends({
    initEditOrder: function initEditOrder() {
      this.$store.commit('SET_EDIT_ORDER', this.order);
    },
    removeOrder: function removeOrder() {
      var _this = this;

      this.loading = true;
      this.$store.dispatch('deleteOrder', this.order.id).then(function () {
        _this.loading = false;
        _this.addToast({
          text: 'Заказ удален',
          type: 'success',
          dismissAfter: 3000
        });
      }).catch(function (error) {
        _this.loading = false;
        _this.addToast({
          text: 'Произошла ошибка при удалении заказа: ' + error,
          type: 'danger',
          dismissAfter: 3000
        });
      });
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["mapActions"])({
    addToast: __WEBPACK_IMPORTED_MODULE_1_vuex_toast__["ADD_TOAST_MESSAGE"]
  }))
});

/***/ }),
/* 405 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex_toast__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex_toast___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuex_toast__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__gql_queries_PBX_getIncomingCalls_graphql__ = __webpack_require__(254);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__gql_queries_PBX_getIncomingCalls_graphql___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__gql_queries_PBX_getIncomingCalls_graphql__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__gql_queries_PBX_getAudioRecords_graphql__ = __webpack_require__(253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__gql_queries_PBX_getAudioRecords_graphql___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__gql_queries_PBX_getAudioRecords_graphql__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'history',
  props: ['order'],
  data: function data() {
    return {
      loading: false,
      itemsPage: {
        incomingCalls: null,
        paginator: {
          total_count: 10
        }
      },
      params: {
        page: 1
      },
      loadingRecords: false
    };
  },

  computed: _extends({
    items: function items() {
      this.incomingCallsCache = JSON.parse(JSON.stringify(this.itemsPage.incomingCalls));
      return this.incomingCallsCache;
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["mapState"])({
    currentUser: function currentUser(state) {
      return state.globalStore.user;
    }
  })),
  methods: _extends({
    loadRecords: function loadRecords(pbxCallId, index) {
      var _this = this;

      this.loadingRecords = pbxCallId;
      this.$apollo.query({
        query: __WEBPACK_IMPORTED_MODULE_3__gql_queries_PBX_getAudioRecords_graphql___default.a,
        variables: {
          pbxCallId: pbxCallId
        }
      }).then(function (result) {
        _this.incomingCallsCache[index].records = result.data.audioRecords;
        _this.loadingRecords = false;
      }).catch(function (error) {
        console.log(error);
        _this.addToast({
          text: 'Произошла ошибка:' + error,
          type: 'danger',
          dismissAfter: 10000
        });
        _this.loadingRecords = false;
      });
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["mapActions"])({
    addToast: __WEBPACK_IMPORTED_MODULE_1_vuex_toast__["ADD_TOAST_MESSAGE"]
  })),
  mounted: function mounted() {
    if (this.order.clientPhone.length > 3) {
      this.$apollo.queries.itemsPage.skip = false;
    }
  },

  apollo: {
    itemsPage: {
      query: __WEBPACK_IMPORTED_MODULE_2__gql_queries_PBX_getIncomingCalls_graphql___default.a,
      variables: function variables() {
        return {
          page: this.params.page,
          query: this.order.clientPhone
        };
      },
      watchLoading: function watchLoading(isLoading) {
        this.loading = isLoading;
      },

      fetchPolicy: 'network-only',
      update: function update(data) {
        return data;
      },
      skip: true
    }
  }
});

/***/ }),
/* 406 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['order'],
  computed: {
    //
  },
  data: function data() {
    return {
      loading: false,
      progressBarWidth: 0
    };
  },

  methods: {
    //
  },
  created: function created() {
    //
  }
});

/***/ }),
/* 407 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_graphql_tag__ = __webpack_require__(873);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_graphql_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_graphql_tag__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(3);
var _templateObject = _taggedTemplateLiteral(['\n  query getLogs ($objectId: Int!) {\n      logs (objectId: $objectId, objectType: "order"){\n          id,\n          diffForHumans,\n          text,\n          date,\n          time,\n          user{\n              id,\n              fullname,\n              avatar\n          }\n      }\n  }'], ['\n  query getLogs ($objectId: Int!) {\n      logs (objectId: $objectId, objectType: "order"){\n          id,\n          diffForHumans,\n          text,\n          date,\n          time,\n          user{\n              id,\n              fullname,\n              avatar\n          }\n      }\n  }']);

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





var getLogsQuery = __WEBPACK_IMPORTED_MODULE_0_graphql_tag___default()(_templateObject);

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'order-history',
  props: ['order'],
  data: function data() {
    return {
      loading: false
    };
  },

  computed: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["mapState"])({
    user: function user(state) {
      return state.globalStore.user;
    }
  }),
  apollo: {
    logs: {
      query: getLogsQuery,
      variables: function variables() {
        return {
          objectId: this.order.id
        };
      },
      watchLoading: function watchLoading(isLoading) {
        this.loading = isLoading;
      },

      fetchPolicy: 'network-only'
    }
  },
  methods: {
    /**
     * Метод возвращает полный пут к аватарке пользователя
     * @param path
     * @return {string}
     */
    getAvatarPath: function getAvatarPath(path) {
      return __WEBPACK_IMPORTED_MODULE_1__config__["e" /* storageUrl */] + path;
    }
  }
});

/***/ }),
/* 408 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex_toast__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex_toast___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuex_toast__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__tweenjs_tween_js__ = __webpack_require__(288);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__tweenjs_tween_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__tweenjs_tween_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    order: {
      type: Object,
      required: true
    },
    commission: Number,
    showSum: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  computed: _extends({
    commissionShow: function commissionShow() {
      return this.commission === 0 ? '<1' : this.commission;
    },

    firstTransition: function firstTransition() {
      if (this.order.transitions.length > 0) {
        var transitions = this.order.transitions.map(function (a) {
          return Object.assign({}, a);
        }).sort(function (item) {
          return item.default ? -1 : 1;
        });
        return transitions[0];
      } else {
        return false;
      }
    },
    otherTransitions: function otherTransitions() {
      var _this = this;

      if (this.order.transitions.length > 1) {
        var transitions = this.order.transitions.map(function (a) {
          return Object.assign({}, a);
        }).filter(function (item) {
          return item.code !== _this.firstTransition.code;
        });
        return transitions;
      } else {
        return false;
      }
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["mapState"])({
    statuses: function statuses(state) {
      return state.globalStore.statuses;
    }
  })),
  watch: {
    order: function order(newOrder, oldOrder) {
      var vm = this;
      var oldValue = { tweeningNumber: 100 / this.statuses.length * oldOrder.status.id };
      var newValue = { tweeningNumber: 100 / this.statuses.length * newOrder.status.id };
      function animate() {
        if (__WEBPACK_IMPORTED_MODULE_2__tweenjs_tween_js___default.a.update()) {
          requestAnimationFrame(animate);
        }
      }
      new __WEBPACK_IMPORTED_MODULE_2__tweenjs_tween_js___default.a.Tween(oldValue).easing(__WEBPACK_IMPORTED_MODULE_2__tweenjs_tween_js___default.a.Easing.Quadratic.Out).to(newValue, 500).onUpdate(function () {
        vm.progressBarWidth = oldValue.tweeningNumber;
      }).start();
      animate();
    }
  },
  data: function data() {
    return {
      loading: false,
      progressBarWidth: 0,
      todayCheck: true
    };
  },

  methods: _extends({
    beforeSetOrderTransition: function beforeSetOrderTransition(transition) {
      switch (transition.code) {
        case 'closing':
          this.$store.dispatch('setEditOrder', this.order);
          this.$store.commit('SET_SHOW_ORDER_MODAL', 'closeOrder');
          break;
        case 'cancel':
          this.$store.dispatch('setEditOrder', this.order);
          this.$store.commit('SET_SHOW_ORDER_MODAL', 'cancelOrder');
          break;
        case 'problem':
          this.$store.dispatch('setEditOrder', this.order);
          this.$store.commit('SET_SHOW_ORDER_MODAL', 'problemOrder');
          break;
        case 'noProblem':
          this.setNoProblem();
          break;
        case 'noCancel':
          this.setNoCancel();
          break;
        case 'accept':
          this.$store.dispatch('setEditOrder', this.order);
          this.$store.dispatch('setConfirmTransition', transition);
          this.$store.commit('SET_SHOW_ORDER_MODAL', 'transitionOrderConfirm');
          break;
        case 'calculate':
          this.$store.dispatch('setEditOrder', this.order);
          this.$store.dispatch('setConfirmTransition', transition);
          this.$store.commit('SET_SHOW_ORDER_MODAL', 'transitionOrderConfirm');
          break;
        case 'complete':
          this.$store.dispatch('setEditOrder', this.order);
          this.$store.dispatch('setConfirmTransition', transition);
          this.$store.commit('SET_SHOW_ORDER_MODAL', 'transitionOrderConfirm');
          break;
        default:
          this.setOrderTransition(transition.code);
      }
    },
    setOrderTransition: function setOrderTransition(code) {
      var _this2 = this;

      this.loading = true;
      this.$store.dispatch('setOrderTransition', {
        orderId: this.order.id,
        code: code
      }).then(function (data) {
        _this2.loading = false;
        _this2.addToast({
          text: 'Статус успешно изменен',
          type: 'success',
          dismissAfter: 3000
        });
      }).catch(function (error) {
        _this2.loading = false;
        _this2.addToast({
          text: 'Произошла ошибка при смене статуса заказа: ' + error,
          type: 'danger',
          dismissAfter: 3000
        });
      });
    },
    setNoCancel: function setNoCancel() {
      var _this3 = this;

      this.loading = true;
      this.$store.dispatch('cancelOrder', {
        value: false,
        orderId: this.order.id
      }).then(function (data) {
        _this3.loading = false;
        _this3.addToast({
          text: 'Отмена заказа снята',
          type: 'success',
          dismissAfter: 3000
        });
      }).catch(function (error) {
        _this3.loading = false;
        _this3.addToast({
          text: 'Произошла ошибка при отмене заказа:' + error,
          type: 'danger',
          dismissAfter: 10000
        });
      });
    },
    setNoProblem: function setNoProblem() {
      var _this4 = this;

      this.loading = true;
      this.$store.dispatch('problemOrder', {
        value: false,
        orderId: this.order.id
      }).then(function (data) {
        _this4.loading = false;
        _this4.addToast({
          text: 'Проблема успешно разрешена',
          type: 'success',
          dismissAfter: 3000
        });
      }).catch(function (error) {
        _this4.loading = false;
        _this4.addToast({
          text: 'Произошла ошибка при решении проблемы:' + error,
          type: 'danger',
          dismissAfter: 10000
        });
      });
    },

    //      canOrderUpdateStatus () {
    //        if (this.order.status.code === 'closed' && !this.order.canOrderFinanceControl) {
    //          return false
    //        }
    //        return this.order.canOrderUpdateStatus
    //      },
    getTransitionClass: function getTransitionClass(transition) {
      if (transition.default) {
        return 'md ' + transition.class;
      }
      return 'secondary';
    },

    isClientComeToday: function isClientComeToday() {
      var today = __WEBPACK_IMPORTED_MODULE_3_moment___default()();
      var date = __WEBPACK_IMPORTED_MODULE_3_moment___default()(this.order.date, 'DD.MM.YYYY');
      return today.isSameOrAfter(date);
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["mapActions"])({
    addToast: __WEBPACK_IMPORTED_MODULE_1_vuex_toast__["ADD_TOAST_MESSAGE"]
  })),
  created: function created() {
    var _this5 = this;

    this.progressBarWidth = 100 / this.statuses.length * this.order.status.sort;
    this.todayCheck = this.isClientComeToday();
    setInterval(function () {
      _this5.todayCheck = _this5.isClientComeToday();
    }, 1000 * 60 * 15);
  }
});

/***/ }),
/* 409 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['order'],
  computed: {
    tooltipTitle: function tooltipTitle() {
      var phone = 'не указан';
      if (this.order.techcenter.phone) {
        phone = '+7' + this.order.techcenter.phone;
      }
      var title = 'Номер телефона техцентра ' + phone;
      if (this.order.techcenter.canView) {
        title += ' для просмотра детальной информации о техцентре кликните по бейджу с адресом ниже';
      }
      return title;
    }
  },
  data: function data() {
    return {
      loading: false,
      progressBarWidth: 0
    };
  },

  methods: {
    viewTechcenter: function viewTechcenter() {
      if (this.order.techcenter.canView) {
        this.$router.push({ name: 'Techcenter', params: { id: this.order.techcenter.id } });
      }
    }
  },
  created: function created() {
    //
  }
});

/***/ }),
/* 410 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_file_download__ = __webpack_require__(893);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_file_download___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_file_download__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex_toast__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex_toast___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vuex_toast__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
  computed: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["mapState"])({
    viewParams: function viewParams(state) {
      return state.orderStore.params;
    }
  }),
  data: function data() {
    return {
      params: {},
      format: 'DD.MM.YYYY',
      mode: '',
      exportLoading: false
    };
  },

  methods: _extends({
    switchDisplayMode: function switchDisplayMode(mode) {
      if (mode === 'search') {
        this.params = JSON.parse(window.localStorage.getItem('displayModeParams'));
        console.log(this.params);
        this.$store.dispatch('getOrders', this.params);
        return;
      }
      this.mode = mode;
      this.params = {};
      switch (mode) {
        case 'today':
          this.params.dateFrom = __WEBPACK_IMPORTED_MODULE_0_moment___default()().format(this.format).toString();
          this.params.dateTo = __WEBPACK_IMPORTED_MODULE_0_moment___default()().format(this.format).toString();
          break;
        case 'week':
          this.params.dateFrom = __WEBPACK_IMPORTED_MODULE_0_moment___default()().startOf('week').format(this.format).toString();
          this.params.dateTo = __WEBPACK_IMPORTED_MODULE_0_moment___default()().endOf('week').format(this.format).toString();
          break;
        case 'two-week':
          this.params.dateFrom = __WEBPACK_IMPORTED_MODULE_0_moment___default()().startOf('week').format(this.format).toString();
          this.params.dateTo = __WEBPACK_IMPORTED_MODULE_0_moment___default()().endOf('week').add(1, 'week').format(this.format).toString();
          break;
        case 'month':
          this.params.dateFrom = __WEBPACK_IMPORTED_MODULE_0_moment___default()().startOf('month').format(this.format).toString();
          this.params.dateTo = __WEBPACK_IMPORTED_MODULE_0_moment___default()().endOf('month').format(this.format).toString();
          break;
      }
      this.params.mode = mode;
      window.localStorage.setItem('displayMode', mode);
      this.$store.dispatch('getOrders', this.params);
    },
    prevInterval: function prevInterval() {
      var oldDateFrom = __WEBPACK_IMPORTED_MODULE_0_moment___default()(this.params.dateFrom, this.format);
      var oldDateTo = __WEBPACK_IMPORTED_MODULE_0_moment___default()(this.params.dateTo, this.format);
      if (this.mode !== 'month') {
        var interval = oldDateTo.diff(oldDateFrom, 'days') + 1;
        this.params = {};
        this.params.dateFrom = oldDateFrom.subtract(interval, 'days').format(this.format).toString();
        this.params.dateTo = oldDateTo.subtract(interval, 'days').format(this.format).toString();
      } else {
        this.params = {};
        this.params.dateFrom = oldDateFrom.subtract(1, 'month').format(this.format).toString();
        this.params.dateTo = __WEBPACK_IMPORTED_MODULE_0_moment___default()(oldDateTo.subtract(1, 'month').format('YYYY-MM-DD')).endOf('month').format(this.format).toString();
      }
      this.$store.dispatch('getOrders', this.params);
    },
    nextInterval: function nextInterval() {
      var oldDateFrom = __WEBPACK_IMPORTED_MODULE_0_moment___default()(this.params.dateFrom, this.format);
      var oldDateTo = __WEBPACK_IMPORTED_MODULE_0_moment___default()(this.params.dateTo, this.format);
      if (this.mode !== 'month') {
        var interval = oldDateTo.diff(oldDateFrom, 'days') + 1;
        this.params = {};
        this.params.dateFrom = oldDateFrom.add(interval, 'days').format(this.format).toString();
        this.params.dateTo = oldDateTo.add(interval, 'days').format(this.format).toString();
      } else {
        this.params = {};
        this.params.dateFrom = oldDateFrom.add(1, 'month').format(this.format).toString();
        this.params.dateTo = __WEBPACK_IMPORTED_MODULE_0_moment___default()(oldDateTo.add(1, 'month').format('YYYY-MM-DD')).endOf('month').format(this.format).toString();
      }
      this.$store.dispatch('getOrders', this.params);
    },
    showSearchModal: function showSearchModal() {
      this.$root.$emit('focusOnHeaderSearchInput');
    },
    exportToExcel: function exportToExcel() {
      var _this = this;

      if (this.exportLoading) {
        return;
      }
      this.exportLoading = true;
      this.$http.post(__WEBPACK_IMPORTED_MODULE_2__config__["g" /* exportUrl */], {
        params: this.viewParams
      }, {
        headers: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__config__["d" /* getHeader */])(),
        responseType: 'blob'
      }).then(function (response) {
        var filename = 'Orders-' + _this.viewParams.dateTo + '-' + _this.viewParams.dateTo + '.xlsx';
        __WEBPACK_IMPORTED_MODULE_3_react_file_download___default()(response.data, filename, 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet');
        _this.exportLoading = false;
        _this.addToast({
          text: 'Отчет успешно сформирован',
          type: 'success',
          dismissAfter: 3000
        });
      }, function (error) {
        console.log(error);
        _this.exportLoading = false;
        _this.addToast({
          text: 'Ошибка формирования отчета. Если ошибка повторяется обратитесь к администратору:' + error,
          type: 'danger',
          dismissAfter: 3000
        });
      });
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["mapActions"])({
    addToast: __WEBPACK_IMPORTED_MODULE_4_vuex_toast__["ADD_TOAST_MESSAGE"]
  })),
  created: function created() {
    if (window.localStorage.getItem('displayMode')) {
      var mode = window.localStorage.getItem('displayMode');
      this.switchDisplayMode(mode);
    } else {
      this.switchDisplayMode('today');
    }
  }
});

/***/ }),
/* 411 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex_toast__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex_toast___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuex_toast__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__OrderStatus__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__OrderStatus___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__OrderStatus__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Comments__ = __webpack_require__(273);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Comments___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_Comments__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__OrderHistory__ = __webpack_require__(278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__OrderHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__OrderHistory__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  computed: _extends({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["mapState"])({
    order: function order(state) {
      return state.orderStore.order;
    },
    currentUser: function currentUser(state) {
      return state.globalStore.user;
    }
  })),
  watch: {
    '$route': 'loadOrderData'
  },
  components: {
    OrderHistory: __WEBPACK_IMPORTED_MODULE_4__OrderHistory___default.a,
    Comments: __WEBPACK_IMPORTED_MODULE_3__components_Comments___default.a,
    OrderStatus: __WEBPACK_IMPORTED_MODULE_2__OrderStatus___default.a
  },
  data: function data() {
    return {
      loading: false,
      id: null
    };
  },

  methods: _extends({
    loadOrderData: function loadOrderData() {
      var _this = this;

      this.loading = true;
      this.id = this.$route.params.id;
      this.$store.dispatch('getOrderById', { id: this.id }).then(function () {
        _this.loading = false;
      }).catch(function () {
        _this.loading = false;
      });
    },
    getCommission: function getCommission(sum, profit) {
      if (sum !== null && profit !== null && this.currentUser.isAdmin) {
        return parseInt(profit / sum * 100);
      }
      return false;
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["mapActions"])({
    addToast: __WEBPACK_IMPORTED_MODULE_1_vuex_toast__["ADD_TOAST_MESSAGE"]
  })),
  created: function created() {
    this.loadOrderData();
  }
});

/***/ }),
/* 412 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex_toast__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex_toast___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuex_toast__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_image_crop_upload_upload_2_vue__ = __webpack_require__(987);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_image_crop_upload_upload_2_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_image_crop_upload_upload_2_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Profile_Timeline_vue__ = __webpack_require__(969);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Profile_Timeline_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__Profile_Timeline_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Profile_ProfileSettings_vue__ = __webpack_require__(967);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Profile_ProfileSettings_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__Profile_ProfileSettings_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Profile_ProfileNotificationSettings_vue__ = __webpack_require__(966);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Profile_ProfileNotificationSettings_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__Profile_ProfileNotificationSettings_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Profile_Security_vue__ = __webpack_require__(968);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Profile_Security_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__Profile_Security_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Profile_Permissions_vue__ = __webpack_require__(965);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Profile_Permissions_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__Profile_Permissions_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__gql_mutations_BlockUser_graphql__ = __webpack_require__(249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__gql_mutations_BlockUser_graphql___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__gql_mutations_BlockUser_graphql__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//











/* harmony default export */ __webpack_exports__["default"] = ({
  computed: _extends({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["mapState"])({
    user: function user(state) {
      return state.userStore.user;
    },
    currentUser: function currentUser(state) {
      return state.globalStore.user;
    }
  })),
  watch: {
    '$route': 'loadUserData'
  },
  data: function data() {
    return {
      showAvatarModal: false,
      params: {
        name: 'avatar'
      },
      imgDataUrl: '', // the datebase64 url of created image,
      tabIndex: null,
      tabs: [],
      tabCounter: 0,
      loading: false,
      blockUserLoading: false
    };
  },

  name: 'profile',
  components: {
    AvatarUpload: __WEBPACK_IMPORTED_MODULE_3_vue_image_crop_upload_upload_2_vue___default.a,
    Timeline: __WEBPACK_IMPORTED_MODULE_4__Profile_Timeline_vue___default.a,
    ProfileSettings: __WEBPACK_IMPORTED_MODULE_5__Profile_ProfileSettings_vue___default.a,
    ProfileNotificationSettings: __WEBPACK_IMPORTED_MODULE_6__Profile_ProfileNotificationSettings_vue___default.a,
    Security: __WEBPACK_IMPORTED_MODULE_7__Profile_Security_vue___default.a,
    Permissions: __WEBPACK_IMPORTED_MODULE_8__Profile_Permissions_vue___default.a
  },
  methods: _extends({
    /**
     * Блокировка/разблокировка пользователя
     * @param user
     * @param enabled
     */
    blockUser: function blockUser(user, enabled) {
      var _this = this;

      this.blockUserLoading = user.id;
      this.$apollo.mutate({
        mutation: __WEBPACK_IMPORTED_MODULE_9__gql_mutations_BlockUser_graphql___default.a,
        variables: {
          id: user.id,
          enabled: enabled
        }
      }).then(function (result) {
        _this.$store.commit('UPDATE_VIEWED_USER', result.data.blockUser);
        _this.addToast({
          text: 'Изменения сохранены',
          type: 'success',
          dismissAfter: 3000
        });
        _this.blockUserLoading = false;
      }).catch(function (error) {
        console.error(error);
        _this.addToast({
          text: 'Произошла ошибка:' + error,
          type: 'danger',
          dismissAfter: 10000
        });
        _this.blockUserLoading = false;
      });
    },
    toggleShowAvatarModal: function toggleShowAvatarModal() {
      this.showAvatarModal = !this.showAvatarModal;
    },
    getUploadUrl: function getUploadUrl() {
      return __WEBPACK_IMPORTED_MODULE_2__config__["e" /* storageUrl */] + '/api/user/' + this.user.id + '/upload-avatar';
    },
    getHeaders: function getHeaders() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__config__["d" /* getHeader */])();
    },
    loadUserData: function loadUserData() {
      var _this2 = this;

      this.loading = true;
      var id = null;
      if (this.$route.name === 'ViewProfile') {
        id = this.$route.params.id;
      }
      this.$store.dispatch('getUserById', id).then(function () {
        _this2.loading = false;
      });
    },

    /**
     * Метод возвращает полный путь к аватарке пользователя
     * @param path
     * @return {string}
     */
    getAvatarPath: function getAvatarPath(path) {
      return __WEBPACK_IMPORTED_MODULE_2__config__["e" /* storageUrl */] + path;
    },

    /**
     * crop success
     *
     * [param] imgDataUrl
     * [param] field
     */
    cropSuccess: function cropSuccess(imgDataUrl, field) {
      this.imgDataUrl = imgDataUrl;
    },

    /**
     * upload success
     *
     * [param] jsonData   server api return data, already json encode
     * [param] field
     */
    cropUploadSuccess: function cropUploadSuccess(result) {
      if (result.result) {
        this.$store.commit('UPDATE_VIEWED_AVATAR', result.filePath);
        if (this.currentUser.id === this.user.id) {
          this.$store.commit('UPDATE_AVATAR', result.filePath);
        }
        this.addToast({
          text: 'Автар успешно обновлен',
          type: 'success',
          dismissAfter: 3000
        });
      } else {
        this.addToast({
          text: 'Ошибка при загрузке аватара: ' + result,
          type: 'danger',
          dismissAfter: 3000
        });
      }
    },

    /**
     * upload fail
     *
     * [param] status    server api return error status, like 500
     * [param] field
     */
    cropUploadFail: function cropUploadFail(status, field) {
      this.addToast({
        text: 'Ошибка при загрузке аватара: ' + status,
        type: 'danger',
        dismissAfter: 3000
      });
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["mapActions"])({
    addToast: __WEBPACK_IMPORTED_MODULE_1_vuex_toast__["ADD_TOAST_MESSAGE"]
  })),
  created: function created() {
    this.loadUserData();
  }
});

/***/ }),
/* 413 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex_toast__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex_toast___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuex_toast__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__gql_queries_Acl_getRoles_graphql__ = __webpack_require__(252);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__gql_queries_Acl_getRoles_graphql___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__gql_queries_Acl_getRoles_graphql__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__gql_queries_Acl_getPermissions_graphql__ = __webpack_require__(251);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__gql_queries_Acl_getPermissions_graphql___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__gql_queries_Acl_getPermissions_graphql__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__gql_mutations_Acl_UpdateUserRole_graphql__ = __webpack_require__(826);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__gql_mutations_Acl_UpdateUserRole_graphql___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__gql_mutations_Acl_UpdateUserRole_graphql__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__gql_mutations_Acl_ClearUserRoles_graphql__ = __webpack_require__(823);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__gql_mutations_Acl_ClearUserRoles_graphql___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__gql_mutations_Acl_ClearUserRoles_graphql__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__gql_mutations_Acl_UpdateUserPermission_graphql__ = __webpack_require__(825);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__gql_mutations_Acl_UpdateUserPermission_graphql___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__gql_mutations_Acl_UpdateUserPermission_graphql__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['userId'],
  computed: _extends({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["mapState"])({
    user: function user(state) {
      return state.userStore.user;
    },
    currentUser: function currentUser(state) {
      return state.globalStore.user;
    }
  })),
  data: function data() {
    return {
      roles: [],
      permissions: [],
      loadingRoles: false,
      loadingPermissions: false,
      rolesChanges: [],
      permissionChanges: []
    };
  },

  methods: _extends({
    getPermissionsGroups: function getPermissionsGroups() {
      var groups = this.permissions.map(function (item) {
        var arr = item.name.split('.');
        return arr[0];
      }).filter(function (value, index, self) {
        return self.indexOf(value) === index;
      });
      return groups;
    },
    getPermissionsGroupName: function getPermissionsGroupName(code) {
      switch (code) {
        case 'order':
          return 'Заказы';
        case 'comments':
          return 'Комментарии';
        case 'role':
          return 'Роли пользователей';
        case 'permission':
          return 'Разрешения';
        case 'user':
          return 'Пользователи';
        case 'company':
          return 'Компании';
        case 'city':
          return 'Города';
        case 'pbx':
          return 'Телефония';
        case 'techcenter':
          return 'Техцентры';
        default:
          return code;
      }
    },
    getPermissionsByGroupName: function getPermissionsByGroupName(group) {
      var permissions = this.permissions.filter(function (item) {
        var arr = item.name.split('.');
        return arr[0] === group;
      });
      return permissions;
    },
    updateUserRole: function updateUserRole(oldValue, roleId) {
      var _this = this;

      this.rolesChanges.push(roleId);
      this.$apollo.mutate({
        mutation: __WEBPACK_IMPORTED_MODULE_4__gql_mutations_Acl_UpdateUserRole_graphql___default.a,
        variables: {
          userId: this.userId,
          roleId: roleId,
          value: !oldValue
        }
      }).then(function (result) {
        _this.$store.commit('UPDATE_VIEWED_USER', result.data.updateUserRole);
        _this.addToast({
          text: 'Настройки успешно обновлены',
          type: 'success',
          dismissAfter: 3000
        });
        _this.rolesChanges.splice(_this.rolesChanges.indexOf(roleId), 1);
      }).catch(function (error) {
        _this.rolesChanges.splice(_this.rolesChanges.indexOf(roleId), 1);
        console.error(error);
        _this.addToast({
          text: 'Произошла ошибка при сохраннеии настроек: ' + error,
          type: 'danger',
          dismissAfter: 10000
        });
      });
    },
    updateUserPermission: function updateUserPermission(oldValue, permissionId) {
      var _this2 = this;

      this.permissionChanges.push(permissionId);
      this.$apollo.mutate({
        mutation: __WEBPACK_IMPORTED_MODULE_6__gql_mutations_Acl_UpdateUserPermission_graphql___default.a,
        variables: {
          userId: this.userId,
          permissionId: permissionId,
          value: !oldValue
        }
      }).then(function (result) {
        _this2.$store.commit('UPDATE_VIEWED_USER', result.data.updateUserPermission);
        _this2.addToast({
          text: 'Настройки успешно обновлены',
          type: 'success',
          dismissAfter: 3000
        });
        _this2.permissionChanges.splice(_this2.permissionChanges.indexOf(permissionId), 1);
      }).catch(function (error) {
        console.error(error);
        _this2.addToast({
          text: 'Произошла ошибка при сохраннеии настроек: ' + error,
          type: 'danger',
          dismissAfter: 10000
        });
        _this2.permissionChanges.splice(_this2.permissionChanges.indexOf(permissionId), 1);
      });
    },
    clearUserRole: function clearUserRole(index) {
      var _this3 = this;

      this.rolesChanges.push('personal');
      this.$apollo.mutate({
        mutation: __WEBPACK_IMPORTED_MODULE_5__gql_mutations_Acl_ClearUserRoles_graphql___default.a,
        variables: {
          userId: this.userId
        }
      }).then(function (result) {
        _this3.$store.commit('UPDATE_VIEWED_USER', result.data.clearUserRoles);
        _this3.addToast({
          text: 'Настройки успешно обновлены',
          type: 'success',
          dismissAfter: 3000
        });
        _this3.rolesChanges.splice(_this3.rolesChanges.indexOf('personal'), 1);
      }).catch(function (error) {
        _this3.addToast({
          text: 'Произошла ошибка при сохраннеии настроек: ' + error,
          type: 'danger',
          dismissAfter: 10000
        });
        _this3.rolesChanges.splice(_this3.rolesChanges.indexOf('personal'), 1);
      });
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["mapActions"])({
    addToast: __WEBPACK_IMPORTED_MODULE_1_vuex_toast__["ADD_TOAST_MESSAGE"]
  })),
  apollo: {
    roles: {
      query: __WEBPACK_IMPORTED_MODULE_2__gql_queries_Acl_getRoles_graphql___default.a,
      variables: {
        all: true
      },
      update: function update(data) {
        return data.roles;
      },
      watchLoading: function watchLoading(isLoading, countModifier) {
        this.loadingRoles = isLoading;
      }
    },
    permissions: {
      query: __WEBPACK_IMPORTED_MODULE_3__gql_queries_Acl_getPermissions_graphql___default.a,
      update: function update(data) {
        return data.permissions;
      },
      watchLoading: function watchLoading(isLoading, countModifier) {
        this.loadingPermissions = isLoading;
      }
    }
  }
});

/***/ }),
/* 414 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__gql_queries_getUserNotificationSettings_graphql__ = __webpack_require__(869);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__gql_queries_getUserNotificationSettings_graphql___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__gql_queries_getUserNotificationSettings_graphql__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__gql_mutations_UpdateUserNotificationSetting_graphql__ = __webpack_require__(851);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__gql_mutations_UpdateUserNotificationSetting_graphql___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__gql_mutations_UpdateUserNotificationSetting_graphql__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_indexOfProperty__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex_toast__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex_toast___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vuex_toast__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['userId'],
  computed: {
    settingsActions: function settingsActions() {
      return this.settings.map(function (item) {
        return { id: item.action.id, name: item.action.name };
      }).filter(function (value, index, self) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__helpers_indexOfProperty__["a" /* default */])(self, 'id', value.id) === index;
      });
    },
    settingsChannels: function settingsChannels() {
      return this.settings.map(function (item) {
        return { id: item.channel.id, name: item.channel.name };
      }).filter(function (value, index, self) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__helpers_indexOfProperty__["a" /* default */])(self, 'id', value.id) === index;
      });
    }
  },
  data: function data() {
    return {
      settings: [],
      loading: false,
      loadingTab: false
    };
  },

  methods: _extends({
    getSettingsByAction: function getSettingsByAction(action) {
      return this.settings.filter(function (setting) {
        return setting.action.id === action.id;
      });
    },
    changeSetting: function changeSetting(setting) {
      var _this = this;

      this.loading = true;
      this.$apollo.mutate({
        mutation: __WEBPACK_IMPORTED_MODULE_1__gql_mutations_UpdateUserNotificationSetting_graphql___default.a,
        variables: {
          userId: this.userId,
          channel: setting.channel.id,
          action: setting.action.id,
          value: setting.value
        }
      }).then(function () {
        _this.loading = false;
        _this.addToast({
          text: 'Настройки успешно обновлены',
          type: 'success',
          dismissAfter: 3000
        });
      }).catch(function (error) {
        _this.loading = false;
        setting.value = !setting.value;
        console.error(error);
        _this.addToast({
          text: 'Произошла ошибка при сохраннеии настроек: ' + error,
          type: 'danger',
          dismissAfter: 10000
        });
      });
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["mapActions"])({
    addToast: __WEBPACK_IMPORTED_MODULE_4_vuex_toast__["ADD_TOAST_MESSAGE"]
  })),
  apollo: {
    settingsData: {
      query: __WEBPACK_IMPORTED_MODULE_0__gql_queries_getUserNotificationSettings_graphql___default.a,
      variables: function variables() {
        return {
          userId: this.userId
        };
      },

      fetchPolicy: 'network-only',
      watchLoading: function watchLoading(isLoading) {
        this.loadingTab = isLoading;
      },

      update: function update(data) {
        return data.userNotificationsSetting;
      },
      result: function result(_ref) {
        var data = _ref.data,
            loader = _ref.loader,
            networkStatus = _ref.networkStatus;

        this.settings = JSON.parse(JSON.stringify(data.userNotificationsSetting));
      }
    }
  }
});

/***/ }),
/* 415 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex_toast__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex_toast___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuex_toast__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  computed: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["mapState"])({
    user: function user(state) {
      return state.userStore.user;
    },
    currentUser: function currentUser(state) {
      return state.globalStore.user;
    }
  }),
  data: function data() {
    return {
      newUserData: {},
      loading: false
    };
  },

  methods: _extends({
    /**
     * Валидация
     */
    beforeSubmit: function beforeSubmit() {
      this.$v.newUserData.$touch();
      if (!this.$v.newUserData.$error) {
        this.updateProfile();
      }
    },

    /**
     * Обновление профиля пользователя
     */
    updateProfile: function updateProfile() {
      var _this = this;

      this.loading = true;
      this.$store.dispatch('updateUserProfile', this.newUserData).then(function (newUserData) {
        if (_this.currentUser.id === _this.user.id) {
          _this.$store.commit('UPDATE_USER', newUserData);
        }
        _this.loading = false;
        _this.addToast({
          text: 'Профиль успешно обновлен',
          type: 'success',
          dismissAfter: 3000
        });
      }).catch(function (error) {
        _this.loading = false;
        _this.addToast({
          text: 'Произошла ошибка при обновлении профиля: ' + error,
          type: 'danger',
          dismissAfter: 3000
        });
      });
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["mapActions"])({
    addToast: __WEBPACK_IMPORTED_MODULE_1_vuex_toast__["ADD_TOAST_MESSAGE"]
  })),
  created: function created() {
    this.newUserData = Object.assign({}, this.user);
  },

  components: {
    //      datepicker
  },
  validations: {
    newUserData: {
      lastname: {
        required: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"],
        minLength: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["minLength"])(2)
      },
      firstname: {
        required: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"],
        minLength: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["minLength"])(2)
      },
      email: {
        required: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"],
        email: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["email"]
      },
      phone: {
        required: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"],
        numeric: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["numeric"],
        maxLength: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["maxLength"])(10),
        minLength: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["minLength"])(10)
      }
    }
  }
});

/***/ }),
/* 416 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__gql_mutations_ChangePassword_graphql__ = __webpack_require__(835);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__gql_mutations_ChangePassword_graphql___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__gql_mutations_ChangePassword_graphql__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex_toast__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex_toast___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vuex_toast__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  computed: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["mapState"])({
    user: function user(state) {
      return state.userStore.user;
    },
    currentUser: function currentUser(state) {
      return state.globalStore.user;
    }
  }),
  data: function data() {
    return {
      loading: false,
      oldPassword: null,
      newPassword: null,
      remindNewPassword: null
    };
  },

  methods: _extends({
    /**
     * todo добавить валидацию
     */
    beforeSubmit: function beforeSubmit() {
      this.changePassword();
    },
    changePassword: function changePassword() {
      var _this = this;

      this.loading = true;
      this.$apollo.mutate({
        mutation: __WEBPACK_IMPORTED_MODULE_0__gql_mutations_ChangePassword_graphql___default.a,
        variables: {
          userId: this.user.id,
          oldPassword: this.oldPassword,
          newPassword: this.newPassword,
          remindNewPassword: this.remindNewPassword
        }
      }).then(function (data) {
        _this.loading = false;
        _this.oldPassword = null;
        _this.newPassword = null;
        _this.remindNewPassword = null;
        _this.$v.newPassword.$reset();
        _this.$v.remindNewPassword.$reset();
        _this.addToast({
          text: 'Пароль успешно обновлен',
          type: 'success',
          dismissAfter: 3000
        });
      }).catch(function (error) {
        _this.loading = false;
        console.error(error);
        _this.addToast({
          text: 'Произошла ошибка при обновлении пароля: ' + error,
          type: 'danger',
          dismissAfter: 10000
        });
      });
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["mapActions"])({
    addToast: __WEBPACK_IMPORTED_MODULE_2_vuex_toast__["ADD_TOAST_MESSAGE"]
  })),
  validations: {
    newPassword: {
      required: __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["required"],
      minLength: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["minLength"])(6)
    },
    remindNewPassword: {
      sameAsPassword: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["sameAs"])('newPassword')
    }
  }
});

/***/ }),
/* 417 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__gql_queries_getUserLogs_graphql__ = __webpack_require__(868);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__gql_queries_getUserLogs_graphql___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__gql_queries_getUserLogs_graphql__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['userId'],
  data: function data() {
    return {
      page: 1,
      logsPage: {
        paginator: {
          total_count: 10,
          limit: 10
        }
      },
      loading: false
    };
  },

  methods: {
    showOrderDetail: function showOrderDetail(id) {
      this.$store.dispatch('showOrderDetail', id);
    }
  },
  apollo: {
    logsPage: {
      query: __WEBPACK_IMPORTED_MODULE_0__gql_queries_getUserLogs_graphql___default.a,
      variables: function variables() {
        return {
          userId: this.userId,
          page: this.page
        };
      },

      fetchPolicy: 'network-only',
      watchLoading: function watchLoading(isLoading) {
        this.loading = isLoading;
      },

      update: function update(data) {
        return data;
      }
    }
  }
});

/***/ }),
/* 418 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_marked__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_marked___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_marked__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__gql_mutations_AddTechcenter_graphql__ = __webpack_require__(247);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__gql_mutations_AddTechcenter_graphql___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__gql_mutations_AddTechcenter_graphql__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__gql_mutations_UpdateTechcenter_graphql__ = __webpack_require__(250);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__gql_mutations_UpdateTechcenter_graphql___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__gql_mutations_UpdateTechcenter_graphql__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex_toast__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex_toast___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vuex_toast__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_TcInput__ = __webpack_require__(279);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_TcInput___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_TcInput__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_TcSelectCity__ = __webpack_require__(981);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_TcSelectCity___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_TcSelectCity__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_TcSelectTimeZone__ = __webpack_require__(983);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_TcSelectTimeZone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_TcSelectTimeZone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_TcSelectWorkTime__ = __webpack_require__(985);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_TcSelectWorkTime___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_TcSelectWorkTime__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_TcInputPhone__ = __webpack_require__(977);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_TcInputPhone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_TcInputPhone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_TcAddImages__ = __webpack_require__(973);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_TcAddImages___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_TcAddImages__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_TcTextArea__ = __webpack_require__(986);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_TcTextArea___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__components_TcTextArea__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_TcMap__ = __webpack_require__(978);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_TcMap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__components_TcMap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_TcCheckBox__ = __webpack_require__(974);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_TcCheckBox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__components_TcCheckBox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_TcSelectCompany__ = __webpack_require__(982);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_TcSelectCompany___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__components_TcSelectCompany__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_TcSelectUsers__ = __webpack_require__(984);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_TcSelectUsers___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__components_TcSelectUsers__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_TcInputAdvantages__ = __webpack_require__(976);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_TcInputAdvantages___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__components_TcInputAdvantages__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_TcPartnership__ = __webpack_require__(980);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_TcPartnership___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__components_TcPartnership__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_TcColorPicker__ = __webpack_require__(975);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_TcColorPicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__components_TcColorPicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__helpers_workDates__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__helpers_workTimes__ = __webpack_require__(115);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






















// TODO потом удалить



/* harmony default export */ __webpack_exports__["default"] = ({
  computed: _extends({
    compiledMarkdown: function compiledMarkdown() {
      if (this.techcenter.description) {
        return __WEBPACK_IMPORTED_MODULE_0_marked___default()(this.techcenter.description, { sanitize: true });
      }
      return '<div class="alert alert-danger">Описание не заполнено</div>';
    },
    partnership: {
      get: function get() {
        return {
          commissionInstall: this.newDataItem.commissionInstall,
          commissionReclamation: this.newDataItem.commissionReclamation,
          commissionRetail: this.newDataItem.commissionRetail
        };
      },
      set: function set(obj) {
        this.changePartnership(obj);
      }
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["mapState"])({
    techcenter: function techcenter(state) {
      return state.techcenterStore.techcenter;
    },
    cities: function cities(state) {
      return state.globalStore.cities;
    }
  })),
  watch: {
    '$route': 'loadTechcenterData'
  },
  components: {
    TcColorPicker: __WEBPACK_IMPORTED_MODULE_20__components_TcColorPicker___default.a,
    TcPartnership: __WEBPACK_IMPORTED_MODULE_19__components_TcPartnership___default.a,
    TcInputAdvantages: __WEBPACK_IMPORTED_MODULE_18__components_TcInputAdvantages___default.a,
    TcSelectUsers: __WEBPACK_IMPORTED_MODULE_17__components_TcSelectUsers___default.a,
    TcSelectCompany: __WEBPACK_IMPORTED_MODULE_16__components_TcSelectCompany___default.a,
    TcCheckBox: __WEBPACK_IMPORTED_MODULE_15__components_TcCheckBox___default.a,
    TcMap: __WEBPACK_IMPORTED_MODULE_14__components_TcMap___default.a,
    TcTextArea: __WEBPACK_IMPORTED_MODULE_13__components_TcTextArea___default.a,
    TcAddImages: __WEBPACK_IMPORTED_MODULE_12__components_TcAddImages___default.a,
    TcInputPhone: __WEBPACK_IMPORTED_MODULE_11__components_TcInputPhone___default.a,
    TcSelectWorkTime: __WEBPACK_IMPORTED_MODULE_10__components_TcSelectWorkTime___default.a,
    TcSelectCity: __WEBPACK_IMPORTED_MODULE_8__components_TcSelectCity___default.a,
    TcInput: __WEBPACK_IMPORTED_MODULE_7__components_TcInput___default.a,
    TcSelectTimeZone: __WEBPACK_IMPORTED_MODULE_9__components_TcSelectTimeZone___default.a
  },
  data: function data() {
    return {
      loading: false,
      saving: false,
      newDataItem: {},
      // TODO schedule должен быть в таком виде в newDataItem
      schedule: [{
        id: 0,
        dayIds: [2, 3, 4],
        timeStart: '07:00:00',
        timeEnd: '22:00:00'
      }, {
        id: 1,
        dayIds: [5, 6],
        timeStart: '00:00:00',
        timeEnd: '00:00:00'
      }, {
        id: 2,
        dayIds: [1, 7],
        timeStart: '16:00:00',
        timeEnd: '22:00:00'
      }],
      usersObjects: [],
      // TODO потом удалить
      workDates: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_21__helpers_workDates__["a" /* workDates */])(),
      workTimes: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_22__helpers_workTimes__["a" /* default */])()
    };
  },

  methods: _extends({
    loadTechcenterData: function loadTechcenterData() {
      var _this = this;

      this.loading = true;
      this.id = this.$route.params.id;
      this.$store.dispatch('getTechcenterById', { id: this.id, imgWidth: 240, imgHeight: 120 }).then(function () {
        _this.setNewDataItem();
        _this.loading = false;
      }).catch(function (error) {
        _this.addToast({
          text: 'Произошла ошибка:' + error,
          type: 'danger',
          dismissAfter: 10000
        });
      });
    },
    setNewDataItem: function setNewDataItem() {
      var item = this.techcenter;
      this.newDataItem = Object.assign({}, item);
      delete this.newDataItem.city;
      delete this.newDataItem.company;
      this.newDataItem.cityId = item.city.id;
      this.newDataItem.companyId = item.company.id;
      this.newDataItem.users = item.users.map(function (user) {
        return user.id;
      });
      this.usersObjects = item.users;
      this.newDataItem.workTimeEnd = __WEBPACK_IMPORTED_MODULE_6_moment___default()(item.workTimeEnd, 'HH:mm').format('HH:mm:ss').toString();
      this.newDataItem.workTimeStart = __WEBPACK_IMPORTED_MODULE_6_moment___default()(item.workTimeStart, 'HH:mm').format('HH:mm:ss').toString();
    },
    beforeUpdateForm: function beforeUpdateForm() {
      this.$v.newDataItem.$touch();
      if (this.$v.newDataItem.$error) {
        return;
      }
      if (this.$route.params.id) {
        this.updateItem();
      } else {
        this.addItem();
      }
    },
    addItem: function addItem() {
      var _this2 = this;

      this.saving = true;
      this.$apollo.mutate({
        mutation: __WEBPACK_IMPORTED_MODULE_2__gql_mutations_AddTechcenter_graphql___default.a,
        variables: this.newDataItem
      }).then(function (result) {
        _this2.saving = false;
        _this2.addToast({
          text: 'Техцентр успешно добавлен',
          type: 'success',
          dismissAfter: 3000
        });
        _this2.$router.push({ name: 'Techcenter', params: { id: result.data.addTechcenter.id } });
      }).catch(function (error) {
        console.error(error);
        _this2.addToast({
          text: 'Произошла ошибка:' + error,
          type: 'danger',
          dismissAfter: 10000
        });
        _this2.saving = false;
      });
    },
    updateItem: function updateItem() {
      var _this3 = this;

      this.saving = true;
      this.$apollo.mutate({
        mutation: __WEBPACK_IMPORTED_MODULE_3__gql_mutations_UpdateTechcenter_graphql___default.a,
        variables: this.newDataItem
      }).then(function (result) {
        _this3.saving = false;
        _this3.addToast({
          text: 'Техцентр успешно обновлен',
          type: 'success',
          dismissAfter: 3000
        });
        _this3.$store.commit('SET_TECHCENTER', result.data.updateTechcenter);
        _this3.setNewDataItem();
      }).catch(function (error) {
        _this3.addToast({
          text: 'Произошла ошибка:' + error,
          type: 'danger',
          dismissAfter: 10000
        });
        _this3.saving = false;
      });
    },
    changePartnership: function changePartnership(obj) {
      this.newDataItem.commissionInstall = obj.commissionInstall;
      this.newDataItem.commissionReclamation = obj.commissionReclamation;
      this.newDataItem.commissionRetail = obj.commissionRetail;
    },
    clearData: function clearData() {
      this.newDataItem = {
        id: null,
        name: '',
        enabled: true,
        cityId: 1,
        companyId: null,
        address: '',
        link: '',
        color: '#BF4040',
        users: [],
        workDateStart: 1,
        workDateEnd: 7,
        workTimeStart: '10:00:00',
        workTimeEnd: '20:00:00',
        commissionReclamation: 40,
        commissionInstall: 40,
        commissionRetail: 50,
        maxOrders: 2,
        tzOffset: 'Europe/Moscow',
        description: '',
        coords: ''
      };
      this.$v.newDataItem.$reset();
      this.$store.commit('CLEAR_TECHCENTER_DATA');
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["mapActions"])({
    addToast: __WEBPACK_IMPORTED_MODULE_5_vuex_toast__["ADD_TOAST_MESSAGE"]
  })),

  validations: {
    newDataItem: {
      name: {
        required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"],
        minLength: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["minLength"])(2)
      },
      cityId: {
        numeric: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["numeric"],
        required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"]
      },
      companyId: {
        required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"]
      },
      address: {
        required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"],
        minLength: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["minLength"])(2)
      },
      phone: {
        required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"],
        numeric: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["numeric"],
        maxLength: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["maxLength"])(10),
        minLength: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["minLength"])(10)
      },
      link: {
        required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"],
        url: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["url"]
      },
      maxOrders: {
        required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"],
        numeric: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["numeric"]
      },
      commissionReclamation: {
        required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"],
        numeric: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["numeric"]
      },
      commissionInstall: {
        required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"],
        numeric: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["numeric"]
      },
      commissionRetail: {
        required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"],
        numeric: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["numeric"]
      }
    }
  },
  created: function created() {
    if (this.$route.params.id) {
      this.loadTechcenterData();
    } else {
      this.clearData();
    }
  }
});

/***/ }),
/* 419 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__gql_queries_getAllTechcenters_graphql__ = __webpack_require__(856);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__gql_queries_getAllTechcenters_graphql___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__gql_queries_getAllTechcenters_graphql__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__gql_mutations_BlockTechcenter_graphql__ = __webpack_require__(248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__gql_mutations_BlockTechcenter_graphql___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__gql_mutations_BlockTechcenter_graphql__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__gql_queries_getCompanies_graphql__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__gql_queries_getCompanies_graphql___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__gql_queries_getCompanies_graphql__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex_toast__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex_toast___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vuex_toast__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Admin_Components_AdminCard__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Admin_Components_AdminCard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__Admin_Components_AdminCard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Admin_Components_AdminFilter__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Admin_Components_AdminFilter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__Admin_Components_AdminFilter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Admin_Components_AdminList__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Admin_Components_AdminList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__Admin_Components_AdminList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Admin_Components_AdminPagination__ = __webpack_require__(277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Admin_Components_AdminPagination___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__Admin_Components_AdminPagination__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ __webpack_exports__["default"] = ({
  computed: _extends({
    items: function items() {
      return this.itemsPage.techcenters !== undefined ? this.itemsPage.techcenters : [];
    },
    citiesOptions: function citiesOptions() {
      return this.cities ? this.cities.map(function (item) {
        return { name: item.name, value: item.id };
      }) : [];
    },
    companiesOptions: function companiesOptions() {
      return this.companiesList && this.companiesList.companies ? this.companiesList.companies.map(function (item) {
        return { name: item.name, value: item.id };
      }) : [];
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["mapState"])({
    cities: function cities(state) {
      return state.globalStore.cities;
    },
    currentUser: function currentUser(state) {
      return state.globalStore.user;
    }
  })),
  name: 'Techcenters',
  components: {
    AdminPagination: __WEBPACK_IMPORTED_MODULE_8__Admin_Components_AdminPagination___default.a,
    AdminList: __WEBPACK_IMPORTED_MODULE_7__Admin_Components_AdminList___default.a,
    AdminFilter: __WEBPACK_IMPORTED_MODULE_6__Admin_Components_AdminFilter___default.a,
    AdminCard: __WEBPACK_IMPORTED_MODULE_5__Admin_Components_AdminCard___default.a
  },
  data: function data() {
    return {
      page: 1,
      itemsPage: {
        paginator: {
          total_count: 1000,
          limit: 10
        }
      },
      blockLoading: false,
      showFilter: true,
      loading: false,
      filterParams: [{
        name: 'Название',
        code: 'query',
        type: 'text',
        value: null
      }, {
        name: 'Город',
        code: 'cityId',
        type: 'select',
        value: null,
        multiple: false,
        options: []
      }, {
        name: 'Компания',
        code: 'companyId',
        type: 'select',
        value: null,
        multiple: false,
        options: []
      }]
    };
  },

  methods: _extends({
    /**
     * Блокировка/разблокировка техцентра
     * @param item
     * @param enabled
     */
    block: function block(item, enabled) {
      var _this = this;

      this.blockLoading = item.id;
      this.$apollo.mutate({
        mutation: __WEBPACK_IMPORTED_MODULE_1__gql_mutations_BlockTechcenter_graphql___default.a,
        variables: {
          id: item.id,
          enabled: enabled
        }
      }).then(function (data) {
        _this.addToast({
          text: 'Изменения сохранены',
          type: 'success',
          dismissAfter: 3000
        });
        _this.blockLoading = false;
      }).catch(function (error) {
        console.error(error);
        _this.addToast({
          text: 'Произошла ошибка:' + error,
          type: 'danger',
          dismissAfter: 10000
        });
        _this.blockLoading = false;
      });
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["mapActions"])({
    addToast: __WEBPACK_IMPORTED_MODULE_4_vuex_toast__["ADD_TOAST_MESSAGE"]
  })),
  apollo: {
    itemsPage: {
      query: __WEBPACK_IMPORTED_MODULE_0__gql_queries_getAllTechcenters_graphql___default.a,
      variables: function variables() {
        return {
          page: this.page,
          query: this.filterParams[0].value,
          cityId: this.filterParams[1].value,
          companyId: this.filterParams[2].value
        };
      },

      fetchPolicy: 'network-only',
      watchLoading: function watchLoading(isLoading, countModifier) {
        this.loading = isLoading;
      },

      update: function update(data) {
        return data;
      }
    },
    companiesList: {
      query: __WEBPACK_IMPORTED_MODULE_2__gql_queries_getCompanies_graphql___default.a,
      variables: {
        all: true
      },
      update: function update(data) {
        return data;
      }
    }
  },
  created: function created() {
    this.filterParams[1].options = this.citiesOptions;
    this.filterParams[2].options = this.companiesOptions;
  }
});

/***/ }),
/* 420 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex_toast__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex_toast___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuex_toast__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_marked__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_marked___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_marked__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_ApParts_ApGallery__ = __webpack_require__(915);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_ApParts_ApGallery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_ApParts_ApGallery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_TcOrdersList__ = __webpack_require__(979);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_TcOrdersList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_TcOrdersList__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
  computed: _extends({
    compiledMarkdown: function compiledMarkdown() {
      if (this.techcenter.description) {
        return __WEBPACK_IMPORTED_MODULE_2_marked___default()(this.techcenter.description, { sanitize: true });
      }
      return '<div class="alert alert-danger">Описание не заполнено</div>';
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["mapState"])({
    techcenter: function techcenter(state) {
      return state.techcenterStore.techcenter;
    },
    currentUser: function currentUser(state) {
      return state.globalStore.user;
    }
  })),
  watch: {
    '$route': 'loadTechcenterData'
  },
  components: {
    TcOrdersList: __WEBPACK_IMPORTED_MODULE_4__components_TcOrdersList___default.a,
    ApGallery: __WEBPACK_IMPORTED_MODULE_3__components_ApParts_ApGallery___default.a
  },
  data: function data() {
    return {
      loading: false,
      loadingBlock: false,
      loadingMap: false,
      editDescription: false,
      description: '',
      id: null
    };
  },

  methods: _extends({
    loadTechcenterData: function loadTechcenterData() {
      var _this = this;

      this.loading = true;
      this.id = this.$route.params.id;
      this.$store.dispatch('getTechcenterById', { id: this.id, imgWidth: 60, imgHeight: 50 }).then(function () {
        _this.loading = false;
      }).catch(function () {
        _this.loading = false;
      });
    },
    block: function block(enabled) {
      var _this2 = this;

      this.loadingBlock = true;
      this.$store.dispatch('blockTechcenter', { id: this.id, enabled: enabled }).then(function () {
        _this2.loadingBlock = false;
        _this2.addToast({
          text: 'Настройки успешно сохранены',
          type: 'success',
          dismissAfter: 3000
        });
      }).catch(function (error) {
        _this2.loadingBlock = false;
        _this2.addToast({
          text: 'Ошибка при сохранении данных: ' + error,
          type: 'danger',
          dismissAfter: 3000
        });
      });
    },
    getCoords: function getCoords(coords) {
      return coords.split(', ');
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["mapActions"])({
    addToast: __WEBPACK_IMPORTED_MODULE_1_vuex_toast__["ADD_TOAST_MESSAGE"]
  })),
  created: function created() {
    this.loadTechcenterData();
  }
});

/***/ }),
/* 421 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex_toast__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex_toast___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vuex_toast__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_easy_lightbox__ = __webpack_require__(272);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_easy_lightbox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_easy_lightbox__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'TcAddImages',
  props: {
    value: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  components: {
    Lightbox: __WEBPACK_IMPORTED_MODULE_3_vue_easy_lightbox___default.a
  },
  data: function data() {
    return {
      files: this.value.slice(), // Копия, иначе read-only
      loading: false,
      visible: false,
      index: 0,
      acceptTypes: ['image/jpeg', 'image/pjpeg', 'image/png']
    };
  },

  computed: {
    maxFiles: function maxFiles() {
      var maxFiles = 30;
      if (maxFiles - this.files.length === maxFiles) {
        return 'Добавить фото';
      }
      if (maxFiles - this.files.length > 0) {
        return 'Осталось ' + (maxFiles - this.files.length) + ' фото';
      }
      if (maxFiles - this.files.length <= 0) {
        return false;
      }
    },
    imgUrls: function imgUrls() {
      var urls = [];
      this.files.forEach(function (item) {
        urls.push(item.originPath);
      });
      return urls;
    }
  },
  methods: _extends({
    handleImage: function handleImage(url) {
      var _this = this;

      if (url === '') {
        this.visible = false;
        return true;
      }
      this.files.forEach(function (item, index) {
        if (item.fullPath === url) {
          _this.index = index;
        }
      });
      this.visible = !this.visible;
    },
    beforeOnFileChange: function beforeOnFileChange() {
      this.loading = true;
      var fileTypeCheck = false;
      var files = this.$refs.fileInput.files;
      for (var i = 0; i < files.length; i++) {
        var file = files[i];
        if (this.acceptTypes.includes(file.type)) {
          fileTypeCheck = true;
        }
      }
      if (fileTypeCheck) {
        this.onFileChange();
      } else {
        this.loading = false;
        this.addToast({
          text: 'Произошла ошибка: Неверный тип изображения',
          type: 'danger',
          dismissAfter: 10000
        });
      }
    },
    onFileChange: function onFileChange() {
      var _this2 = this;

      this.loading = true;
      var files = this.$refs.fileInput.files;
      var formData = new FormData();
      for (var i = 0; i < files.length; i++) {
        var file = files[i];
        formData.append('files[' + i + ']', file);
      }
      formData.append('width', '240');
      formData.append('height', '120');
      var headers = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__config__["d" /* getHeader */])();
      this.$http.post(this.getUploadUrl() + '/upload-photos', formData, {
        headers: {
          'Accept': headers['Accept'],
          'X-Api-Token': headers['X-Api-Token'],
          'Content-Type': 'multipart/form-data'
        }
      }).then(function (response) {
        response.data.files.forEach(function (file) {
          _this2.files.push({
            originPath: file.fullPath,
            fullPath: file.fullPath,
            id: file.id,
            savePath: file.savePath
          });
        });
        _this2.loading = false;
      }).catch(function (error) {
        console.log(error);
        _this2.loading = false;
        _this2.addToast({
          text: 'Произошла ошибка:' + error,
          type: 'danger',
          dismissAfter: 10000
        });
      });
    },
    getUploadUrl: function getUploadUrl() {
      return __WEBPACK_IMPORTED_MODULE_0__config__["f" /* apiDomain */] + 'api/techcenter/' + this.$route.params.id;
    },
    inputInit: function inputInit() {
      if (!this.loading) {
        this.$refs.fileInput.click();
      }
    },
    removeFile: function removeFile(id) {
      var _this3 = this;

      var oldFiles = this.files;
      this.files = this.files.filter(function (val) {
        return val.id !== id;
      });
      this.$http.post(this.getUploadUrl() + '/remove-photo', { id: id }, { headers: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__config__["d" /* getHeader */])() }).catch(function (error) {
        _this3.files = oldFiles;
        _this3.addToast({
          text: 'Произошла ошибка:' + error,
          type: 'danger',
          dismissAfter: 10000
        });
      });
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["mapActions"])({
    addToast: __WEBPACK_IMPORTED_MODULE_2_vuex_toast__["ADD_TOAST_MESSAGE"]
  }))
});

/***/ }),
/* 422 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'TcCheckBox',
  props: {
    value: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      enabled: this.value
    };
  }
});

/***/ }),
/* 423 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_color__ = __webpack_require__(271);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_color___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_color__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'TcColorPicker',
  props: {
    value: {
      type: String,
      default: '#BF4040'
    }
  },
  components: {
    'color-picker': __WEBPACK_IMPORTED_MODULE_0_vue_color__["Slider"]
  },
  data: function data() {
    return {
      color: {
        hex: this.value
      }
    };
  }
});

/***/ }),
/* 424 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ACFInput',
  props: {
    value: {
      type: [String, Number],
      default: null
    },
    error: {
      type: Boolean,
      default: false
    },
    inputRequire: {
      type: Boolean,
      default: false
    },
    errorText: {
      type: String,
      default: 'Неправильно заполнено поле'
    },
    labelText: {
      type: String,
      default: ''
    },
    labelId: {
      type: String,
      default: ''
    },
    inputType: {
      type: String,
      default: 'text'
    }
  },
  methods: {
    changeValue: function changeValue(val) {
      this.$emit('input', this.inputType === 'text' ? val : parseInt(val));
    }
  }
});

/***/ }),
/* 425 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'TcInputAdvantages',
  props: {
    value: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {
      newAdvantage: '',
      // TODO просто пример, потом подставить "this.value"
      advantages: [{
        id: 0,
        name: 'Комната ожидания'
      }, {
        id: 1,
        name: 'Wi-fi'
      }, {
        id: 2,
        name: 'Безналичный расчет'
      }],
      error: ''
    };
  },

  methods: {
    addAdvantage: function addAdvantage() {
      this.error = '';
      if (this.newAdvantage.length < 2) {
        this.error = 'Введите преимущество';
        return false;
      }
      this.advantages.push({
        id: this.getNewId(),
        name: this.newAdvantage
      });
      this.newAdvantage = '';
    },
    removeAdvantage: function removeAdvantage(id) {
      this.advantages = this.advantages.filter(function (el) {
        return el.id !== id;
      });
    },
    getNewId: function getNewId() {
      if (this.advantages.length > 0) {
        return this.advantages[this.advantages.length - 1].id + 1;
      } else {
        return 1;
      }
    }
  },
  created: function created() {
    // TODO потом задать значение в data()
    this.advantages = this.value;
  }
});

/***/ }),
/* 426 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_ApForm_ApInputPhone__ = __webpack_require__(914);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_ApForm_ApInputPhone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_ApForm_ApInputPhone__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'TcInputPhone',
  props: {
    value: {
      type: String,
      default: ''
    },
    error: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      phone: this.value
    };
  },

  components: {
    ApInputPhone: __WEBPACK_IMPORTED_MODULE_0__components_ApForm_ApInputPhone___default.a
  }
});

/***/ }),
/* 427 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex_toast__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex_toast___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuex_toast__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__TcInput__ = __webpack_require__(279);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__TcInput___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__TcInput__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config__ = __webpack_require__(23);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'TcMap',
  props: {
    value: {
      type: String,
      default: '55.751242, 37.620686'
    },
    cityId: {
      type: Number,
      default: 1
    },
    address: {
      type: String,
      default: ''
    }
  },
  components: {
    TcInput: __WEBPACK_IMPORTED_MODULE_2__TcInput___default.a
  },
  watch: {
    cityId: function cityId() {
      var _this = this;

      this.stopTimeout();
      setTimeout(function () {
        // Ограничение кол-ва запросов
        _this.setMapCoordsByAddress();
      }, 800);
    },
    address: function address() {
      var _this2 = this;

      this.stopTimeout();
      setTimeout(function () {
        // Ограничение кол-ва запросов
        _this2.setMapCoordsByAddress();
      }, 2000);
    },
    coordsString: function coordsString() {
      this.setMapCoordsString();
    }
  },
  computed: _extends({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["mapState"])({
    cities: function cities(state) {
      return state.globalStore.cities;
    }
  })),
  data: function data() {
    return {
      placemarks: [{
        coords: [55.751242, 37.620686],
        options: { draggable: true },
        callbacks: { dragend: this.setNewCoord }
      }],
      mapObj: {},
      mapCoord: [55.751242, 37.620686],
      open: false,
      coordsString: '55.751242, 37.620686'
    };
  },

  methods: _extends({
    initHandler: function initHandler(obj) {
      this.mapObj = obj;
      this.getCameraCoords(this.mapObj);
    },
    setNewCoord: function setNewCoord(e) {
      var thisPlacemark = e.get('target');
      var coords = thisPlacemark.geometry.getCoordinates();
      this.coordsString = coords[0] + ', ' + coords[1];
      this.$emit('input', +coords[0] + ', ' + coords[1]);
      this.placemarks[0].coords = coords;
    },
    setMapCoordsString: function setMapCoordsString() {
      this.mapCoord = this.coordsString.split(', ');
      this.placemarks.splice(0, 1, {
        coords: [parseFloat(this.coordsString.split(', ')[0]), parseFloat(this.coordsString.split(', ')[1])],
        options: { draggable: true },
        callbacks: { dragend: this.setNewCoord }
      });
      this.$emit('input', '' + this.coordsString);
    },
    getCameraCoords: function getCameraCoords(map) {
      if (this.placemarks.length === 1) {
        map.setCenter(this.placemarks[0].coords, 14, {
          checkZoomRange: true
        });
      }
    },
    setMapCoordsByAddress: function setMapCoordsByAddress() {
      var _this3 = this;

      var city = void 0;
      this.cities.forEach(function (e) {
        if (e.id === _this3.cityId) {
          city = e.name;
        }
      });
      var address = this.address;
      var url = 'https://geocode-maps.yandex.ru/1.x/?format=json&apikey=' + __WEBPACK_IMPORTED_MODULE_3__config__["a" /* yandexGeoCodeApiKey */] + '&sco=latlong&geocode=' + city + ' ' + address;
      this.$http.get(url).then(function (response) {
        var coords = response.data.response.GeoObjectCollection.featureMember[0].GeoObject.Point.pos.split(' ');
        coords = coords.map(function (coord) {
          return parseFloat(coord);
        });
        _this3.placemarks.splice(0, 1, {
          coords: [coords[1], coords[0]],
          options: { draggable: true },
          callbacks: { dragend: _this3.setNewCoord }
        });
        _this3.getCameraCoords(_this3.mapObj);
        _this3.coordsString = coords[1] + ', ' + coords[0];
        _this3.$emit('input', +coords[1] + ', ' + coords[0]);
      }).catch(function (error) {
        console.log(error);
        _this3.addToast({
          text: 'Ошибка при загрузке карты: ' + error,
          type: 'danger',
          dismissAfter: 3000
        });
      });
    },
    stopTimeout: function stopTimeout() {
      var id = window.setTimeout(null, 0);
      while (id--) {
        window.clearTimeout(id);
      }
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["mapActions"])({
    addToast: __WEBPACK_IMPORTED_MODULE_1_vuex_toast__["ADD_TOAST_MESSAGE"]
  })),
  created: function created() {
    this.placemarks[0].coords[0] = parseFloat(this.value.split(', ')[0]);
    this.placemarks[0].coords[1] = parseFloat(this.value.split(', ')[1]);
    this.coordsString = this.value;
  }
});

/***/ }),
/* 428 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(3);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  params: {
    techcenterId: {
      type: Number,
      required: true
    }
  },
  name: 'TcOrdersList',
  data: function data() {
    return {
      params: {
        dateFrom: null,
        dateTo: null
      },
      format: 'DD.MM.YYYY',
      days: []
    };
  },
  created: function created() {
    var day = __WEBPACK_IMPORTED_MODULE_0_moment___default()().startOf('day');
    this.params.dateFrom = day.format(this.format).toString();
    var endDay = __WEBPACK_IMPORTED_MODULE_0_moment___default()().endOf('day').add(13, 'days');
    this.params.dateTo = endDay.format(this.format).toString();
    while (day <= endDay) {
      this.days.push(day.format('DD.MM.YYYY'));
      day = day.clone().add(1, 'd');
    }
    this.params.techcenterId = [this.techcenter.id];
    this.$store.dispatch('getOrders', this.params);
  },

  methods: {
    chunk: function chunk(arr, len) {
      var chunks = [];
      var i = 0;
      var n = arr.length;

      while (i < n) {
        chunks.push(arr.slice(i, i += len));
      }

      return chunks;
    },
    convertDataToString: function convertDataToString(date) {
      __WEBPACK_IMPORTED_MODULE_0_moment___default.a.locale('ru');
      var dateString = __WEBPACK_IMPORTED_MODULE_0_moment___default()(date, 'DD.MM.YYYY').format('dddd D MMMM Y').toString();
      dateString = dateString.charAt(0).toUpperCase() + dateString.substr(1);
      return dateString;
    },
    getOrdersByDate: function getOrdersByDate(date) {
      var orders = this.orders.filter(function (order) {
        return order.date === date && !order.canceled;
      });
      if (orders.length === 0) {
        return [];
      }

      var times = this.getFreeTimesAll(date);
      var newTimes = times.map(function (dateTime, index, arr) {
        var timeOrders = [];
        if (index === 0) {
          timeOrders = orders.filter(function (order) {
            var orderDateTime = __WEBPACK_IMPORTED_MODULE_0_moment___default()(order.date + '_' + order.time, 'DD.MM.YYYY_HH:mm');
            if (orderDateTime <= dateTime) {
              return true;
            }
          });
        } else if (index + 1 === arr.length) {
          timeOrders = orders.filter(function (order) {
            var orderDateTime = __WEBPACK_IMPORTED_MODULE_0_moment___default()(order.date + '_' + order.time, 'DD.MM.YYYY_HH:mm');
            if (orderDateTime >= dateTime) {
              return true;
            }
          });
        } else {
          timeOrders = orders.filter(function (order) {
            var orderDateTime = __WEBPACK_IMPORTED_MODULE_0_moment___default()(order.date + '_' + order.time, 'DD.MM.YYYY_HH:mm');
            if (orderDateTime >= dateTime && orderDateTime < arr[index + 1]) {
              return true;
            }
            return false;
          });
        }

        return {
          dateTime: dateTime,
          orders: timeOrders.sort(function (a, b) {
            if (a.time > b.time) {
              return 1;
            } else if (a.time < b.time) {
              return -1;
            } else if (a.id > b.id) {
              return 1;
            } else if (a.id < b.id) {
              return -1;
            } else {
              console.error('error');
              return 0;
            }
          })
        };
      });
      return newTimes;
    },
    getFreeTimesAll: function getFreeTimesAll(date) {
      var times = [];
      var startHour = this.techcenter.workTimeStart.split(':');
      var endHour = this.techcenter.workTimeEnd.split(':');
      var startTime = __WEBPACK_IMPORTED_MODULE_0_moment___default()(date, 'DD.MM.YYYY').set('hour', startHour[0]).startOf('hour');
      var endTime = __WEBPACK_IMPORTED_MODULE_0_moment___default()(date, 'DD.MM.YYYY').set('hour', endHour[0]).endOf('hour');
      while (startTime <= endTime) {
        times.push(startTime);
        startTime = startTime.clone().add(30, 'm');
      }
      return times;
    },
    selectDate: function selectDate(date, time) {
      console.log('selectDate ' + date);
      var win = window.parent;
      win.postMessage({ date: date, time: time }, 'https://alarmru.amocrm.ru');
    },
    isClosed: function isClosed(date) {
      var weekday = __WEBPACK_IMPORTED_MODULE_0_moment___default()(date, 'DD.MM.YYYY').weekday() + 1;
      if (weekday >= this.techcenter.workDateStart && weekday <= this.techcenter.workDateEnd) {
        return false;
      }

      return true;
    }
  },
  computed: _extends({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["mapState"])({
    orders: function orders(state) {
      return state.orderStore.orders;
    },
    loading: function loading(state) {
      return state.orderStore.loading;
    },
    techcenter: function techcenter(state) {
      return state.techcenterStore.techcenter;
    }
  }), {
    ordersDays: function ordersDays() {
      return this.orders.map(function (item) {
        return item.date;
      }).filter(function (value, index, self) {
        return self.indexOf(value) === index;
      }).sort(function (a, b) {
        var dateA = __WEBPACK_IMPORTED_MODULE_0_moment___default()(a, 'DD.MM.YYYY');
        var dateB = __WEBPACK_IMPORTED_MODULE_0_moment___default()(b, 'DD.MM.YYYY');
        return dateB.isBefore(dateA) ? 1 : -1;
      });
    }
  })
});

/***/ }),
/* 429 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'TcPartnership',
  props: {
    value: {
      type: Object,
      default: function _default() {}
    }
  },
  data: function data() {
    return {
      partnership: this.value
    };
  },

  methods: {
    changePartnership: function changePartnership() {
      this.partnership.commissionInstall = parseInt(this.partnership.commissionInstall);
      this.partnership.commissionReclamation = parseInt(this.partnership.commissionReclamation);
      this.partnership.commissionRetail = parseInt(this.partnership.commissionRetail);
      this.$emit('input', this.partnership);
    }
  }
});

/***/ }),
/* 430 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_multiselect__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_multiselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_multiselect__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'TcSelectCity',
  components: { Multiselect: __WEBPACK_IMPORTED_MODULE_1_vue_multiselect___default.a },
  computed: _extends({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["mapState"])({
    cities: function cities(state) {
      return state.globalStore.cities;
    }
  })),
  props: {
    city: {
      type: Object,
      default: null
    },
    value: {
      default: null
    },
    error: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    changeCity: function changeCity($city) {
      this.$emit('input', $city ? $city.id : null);
    }
  }
});

/***/ }),
/* 431 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_multiselect__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_multiselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_multiselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__gql_queries_getCompanies_graphql__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__gql_queries_getCompanies_graphql___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__gql_queries_getCompanies_graphql__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'TcSelectCompany',
  components: { Multiselect: __WEBPACK_IMPORTED_MODULE_0_vue_multiselect___default.a },
  props: {
    value: {
      type: Number,
      default: null
    },
    company: {
      type: Object,
      default: function _default() {}
    },
    error: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      companies: [],
      loading: false
    };
  },

  methods: {
    /**
     * Подргрузка Компаний
     * активируется при открытии селекта
     */
    loadCompanies: function loadCompanies() {
      var _this = this;

      this.loadingCompanies = true;
      this.$apollo.query({
        query: __WEBPACK_IMPORTED_MODULE_1__gql_queries_getCompanies_graphql___default.a,
        variables: {
          all: true
        }
      }).then(function (result) {
        _this.companies = result.data.companies;
        _this.loadingCompanies = false;
      }).catch(function (error) {
        console.log(error);
        _this.loadingCompanies = false;
      });
    },
    changeCompany: function changeCompany(company) {
      this.$emit('input', company ? company.id : null);
    }
  }
});

/***/ }),
/* 432 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_multiselect__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_multiselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_multiselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_tzOffsets__ = __webpack_require__(180);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'TcSelectTimeZone',
  props: {
    value: {
      type: String,
      default: ''
    }
  },
  components: {
    Multiselect: __WEBPACK_IMPORTED_MODULE_0_vue_multiselect___default.a
  },
  data: function data() {
    return {
      timeZones: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers_tzOffsets__["a" /* default */])(),
      timeZone: {}
    };
  },

  methods: {
    changeTimeZone: function changeTimeZone($timeZone) {
      this.$emit('input', $timeZone ? $timeZone.id : null);
    }
  },
  created: function created() {
    var _this = this;

    this.timeZone = this.timeZones.filter(function (zone) {
      return zone.id === _this.value;
    })[0];
  }
});

/***/ }),
/* 433 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_multiselect__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_multiselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_multiselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__gql_queries_getUsersForMultiselect_graphql__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__gql_queries_getUsersForMultiselect_graphql___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__gql_queries_getUsersForMultiselect_graphql__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'TcSelectUsers',
  components: { Multiselect: __WEBPACK_IMPORTED_MODULE_0_vue_multiselect___default.a },
  props: {
    value: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    usersObjects: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  computed: {
    placeholder: function placeholder() {
      if (this.loading) {
        return 'Загрузка пользователей...';
      } else if (this.selectedUsers.length > 0) {
        return 'Добавить пользователя';
      } else {
        return 'Пользователи не заданы';
      }
    }
  },
  data: function data() {
    return {
      users: [],
      selectedUsers: this.usersObjects,
      loading: false
    };
  },

  methods: {
    loadUsers: function loadUsers() {
      var _this = this;

      this.loading = true;
      this.$apollo.query({
        query: __WEBPACK_IMPORTED_MODULE_1__gql_queries_getUsersForMultiselect_graphql___default.a
      }).then(function (result) {
        _this.users = result.data.users;
        _this.loading = false;
      }).catch(function (error) {
        console.log(error);
        _this.loading = false;
      });
    },
    changeUsers: function changeUsers() {
      var usersIds = this.selectedUsers.map(function (user) {
        return user.id;
      });
      this.$emit('input', usersIds);
    }
  }
});

/***/ }),
/* 434 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_workDates__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_workTimes__ = __webpack_require__(115);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'TcSelectWorkTime',
  props: {
    /**
     * value = Array(
     *  Object(
     *      id: Number,
     *      dayIds: Array (String),
     *      timeStart: String
     *      timeEnd: String
     *    )
     * )
     */
    value: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  filters: {
    parseSchedule: function parseSchedule(value) {
      var parsedText = '';
      var checkDay = false;
      if (value.dayIds.length > 1) {
        for (var i = 0; i < value.dayIds.length; i++) {
          if (value.dayIds[i + 1] && value.dayIds[i] + 1 !== value.dayIds[i + 1]) {
            checkDay = true;
            break;
          }
        }
        if (checkDay) {
          for (var _i = 0; _i < value.dayIds.length; _i++) {
            parsedText += __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_workDates__["b" /* getDayName */])(value.dayIds[_i]) + ', ';
          }
        } else {
          parsedText += __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_workDates__["b" /* getDayName */])(value.dayIds[0], true) + ' - ' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_workDates__["b" /* getDayName */])(value.dayIds[value.dayIds.length - 1], true) + ', ';
        }
      } else {
        parsedText += __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_workDates__["b" /* getDayName */])(value.dayIds[0], true) + ' ';
      }
      if (value.timeStart === '00:00:00' && value.timeEnd === '00:00:00') {
        parsedText += 'круглосуточно';
      } else {
        parsedText += 'c ' + value.timeStart.slice(0, 5) + ' до ' + value.timeEnd.slice(0, 5);
      }
      return parsedText;
    }
  },
  computed: {
    buttonDisabled: function buttonDisabled() {
      var countDays = 0;
      for (var i = 0; i < this.workDates.length; i++) {
        if (this.workDates[i].selected === true) {
          countDays++;
        }
      }
      return countDays === 0;
    }
  },
  data: function data() {
    return {
      workDates: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_workDates__["a" /* workDates */])(),
      workTimes: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers_workTimes__["a" /* default */])(),
      schedule: this.value,
      timeStart: '08:00:00',
      timeEnd: '22:00:00',
      allDay: false,
      error: ''
    };
  },

  methods: {
    deleteSchedule: function deleteSchedule(id) {
      this.schedule = this.schedule.filter(function (el) {
        return el.id !== id;
      });
      this.$emit('input', this.schedule);
    },
    addSchedule: function addSchedule() {
      this.error = '';
      if (this.timeStart > this.timeEnd) {
        this.error = 'Время начала рабочего дня должно быть меньше окончания рабочего дня';
        return false;
      }
      if (this.allDay) {
        this.timeStart = '00:00:00';
        this.timeEnd = '00:00:00';
      }
      var newSchedule = {
        id: this.getNewId(),
        dayIds: [],
        timeStart: this.timeStart,
        timeEnd: this.timeEnd
      };
      for (var i = 0; i < this.workDates.length; i++) {
        if (this.workDates[i].selected === true) {
          newSchedule.dayIds.push(this.workDates[i].id);
          this.workDates[i].selected = false;
        }
      }
      this.schedule.push(newSchedule);
      this.timeStart = '08:00:00';
      this.timeEnd = '22:00:00';
      this.$emit('input', this.schedule);
    },
    getNewId: function getNewId() {
      if (this.schedule.length > 0) {
        return this.schedule[this.schedule.length - 1].id + 1;
      } else {
        return 0;
      }
    }
  }
});

/***/ }),
/* 435 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'TcTextArea',
  props: {
    value: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      text: this.value === null ? '' : this.value,
      // TODO если pull-request примут то можно будет поменять на русский @see https://github.com/hinesboy/mavonEditor/pull/274
      toolbars: {
        bold: true,
        italic: true,
        header: true,
        underline: true,
        strikethrough: true,
        mark: true,
        superscript: true,
        subscript: true,
        quote: true,
        ul: true,
        link: true,
        undo: true,
        redo: true,
        alignleft: true,
        aligncenter: true,
        alignright: true,
        subfield: true,
        preview: true
      }
    };
  }
});

/***/ }),
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */,
/* 440 */,
/* 441 */,
/* 442 */,
/* 443 */,
/* 444 */,
/* 445 */,
/* 446 */,
/* 447 */,
/* 448 */,
/* 449 */,
/* 450 */,
/* 451 */,
/* 452 */,
/* 453 */,
/* 454 */,
/* 455 */,
/* 456 */,
/* 457 */,
/* 458 */,
/* 459 */,
/* 460 */,
/* 461 */,
/* 462 */,
/* 463 */,
/* 464 */,
/* 465 */,
/* 466 */,
/* 467 */,
/* 468 */,
/* 469 */,
/* 470 */,
/* 471 */,
/* 472 */,
/* 473 */,
/* 474 */,
/* 475 */,
/* 476 */,
/* 477 */,
/* 478 */,
/* 479 */,
/* 480 */,
/* 481 */,
/* 482 */,
/* 483 */,
/* 484 */,
/* 485 */,
/* 486 */,
/* 487 */,
/* 488 */,
/* 489 */,
/* 490 */,
/* 491 */,
/* 492 */,
/* 493 */,
/* 494 */,
/* 495 */,
/* 496 */,
/* 497 */,
/* 498 */,
/* 499 */,
/* 500 */,
/* 501 */,
/* 502 */,
/* 503 */,
/* 504 */,
/* 505 */,
/* 506 */,
/* 507 */,
/* 508 */,
/* 509 */,
/* 510 */,
/* 511 */,
/* 512 */,
/* 513 */,
/* 514 */,
/* 515 */,
/* 516 */,
/* 517 */,
/* 518 */,
/* 519 */,
/* 520 */,
/* 521 */,
/* 522 */,
/* 523 */,
/* 524 */,
/* 525 */,
/* 526 */,
/* 527 */,
/* 528 */,
/* 529 */,
/* 530 */,
/* 531 */,
/* 532 */,
/* 533 */,
/* 534 */,
/* 535 */,
/* 536 */,
/* 537 */,
/* 538 */,
/* 539 */,
/* 540 */,
/* 541 */,
/* 542 */,
/* 543 */,
/* 544 */,
/* 545 */,
/* 546 */,
/* 547 */,
/* 548 */,
/* 549 */,
/* 550 */,
/* 551 */,
/* 552 */,
/* 553 */,
/* 554 */,
/* 555 */,
/* 556 */,
/* 557 */,
/* 558 */,
/* 559 */,
/* 560 */,
/* 561 */,
/* 562 */,
/* 563 */,
/* 564 */,
/* 565 */,
/* 566 */,
/* 567 */,
/* 568 */,
/* 569 */,
/* 570 */,
/* 571 */,
/* 572 */,
/* 573 */,
/* 574 */,
/* 575 */,
/* 576 */,
/* 577 */,
/* 578 */,
/* 579 */,
/* 580 */,
/* 581 */,
/* 582 */,
/* 583 */,
/* 584 */,
/* 585 */,
/* 586 */,
/* 587 */,
/* 588 */,
/* 589 */,
/* 590 */,
/* 591 */,
/* 592 */,
/* 593 */,
/* 594 */,
/* 595 */,
/* 596 */,
/* 597 */,
/* 598 */,
/* 599 */,
/* 600 */,
/* 601 */,
/* 602 */,
/* 603 */,
/* 604 */,
/* 605 */,
/* 606 */,
/* 607 */,
/* 608 */,
/* 609 */,
/* 610 */,
/* 611 */,
/* 612 */,
/* 613 */,
/* 614 */,
/* 615 */,
/* 616 */,
/* 617 */,
/* 618 */,
/* 619 */,
/* 620 */,
/* 621 */,
/* 622 */,
/* 623 */,
/* 624 */,
/* 625 */,
/* 626 */,
/* 627 */,
/* 628 */,
/* 629 */,
/* 630 */,
/* 631 */,
/* 632 */,
/* 633 */,
/* 634 */,
/* 635 */,
/* 636 */,
/* 637 */,
/* 638 */,
/* 639 */,
/* 640 */,
/* 641 */,
/* 642 */,
/* 643 */,
/* 644 */,
/* 645 */,
/* 646 */,
/* 647 */,
/* 648 */,
/* 649 */,
/* 650 */,
/* 651 */,
/* 652 */,
/* 653 */,
/* 654 */,
/* 655 */,
/* 656 */,
/* 657 */,
/* 658 */,
/* 659 */,
/* 660 */,
/* 661 */,
/* 662 */,
/* 663 */,
/* 664 */,
/* 665 */,
/* 666 */,
/* 667 */,
/* 668 */,
/* 669 */,
/* 670 */,
/* 671 */,
/* 672 */,
/* 673 */,
/* 674 */,
/* 675 */,
/* 676 */,
/* 677 */,
/* 678 */,
/* 679 */,
/* 680 */,
/* 681 */,
/* 682 */,
/* 683 */,
/* 684 */,
/* 685 */,
/* 686 */,
/* 687 */,
/* 688 */,
/* 689 */,
/* 690 */,
/* 691 */,
/* 692 */,
/* 693 */,
/* 694 */,
/* 695 */,
/* 696 */,
/* 697 */,
/* 698 */,
/* 699 */,
/* 700 */,
/* 701 */,
/* 702 */,
/* 703 */,
/* 704 */,
/* 705 */,
/* 706 */,
/* 707 */,
/* 708 */,
/* 709 */,
/* 710 */,
/* 711 */,
/* 712 */,
/* 713 */,
/* 714 */,
/* 715 */,
/* 716 */,
/* 717 */,
/* 718 */,
/* 719 */,
/* 720 */,
/* 721 */,
/* 722 */,
/* 723 */,
/* 724 */,
/* 725 */,
/* 726 */,
/* 727 */,
/* 728 */,
/* 729 */,
/* 730 */,
/* 731 */,
/* 732 */,
/* 733 */,
/* 734 */,
/* 735 */,
/* 736 */,
/* 737 */,
/* 738 */,
/* 739 */,
/* 740 */,
/* 741 */,
/* 742 */,
/* 743 */,
/* 744 */,
/* 745 */,
/* 746 */,
/* 747 */,
/* 748 */,
/* 749 */,
/* 750 */,
/* 751 */,
/* 752 */,
/* 753 */,
/* 754 */,
/* 755 */,
/* 756 */,
/* 757 */,
/* 758 */,
/* 759 */,
/* 760 */,
/* 761 */,
/* 762 */,
/* 763 */,
/* 764 */,
/* 765 */,
/* 766 */,
/* 767 */,
/* 768 */,
/* 769 */,
/* 770 */,
/* 771 */,
/* 772 */,
/* 773 */,
/* 774 */,
/* 775 */,
/* 776 */,
/* 777 */,
/* 778 */,
/* 779 */,
/* 780 */,
/* 781 */,
/* 782 */,
/* 783 */,
/* 784 */,
/* 785 */,
/* 786 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 787 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 788 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 789 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 790 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 791 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 792 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 793 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 794 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 795 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 796 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 797 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 798 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 799 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 800 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 801 */,
/* 802 */,
/* 803 */,
/* 804 */,
/* 805 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 806 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 807 */,
/* 808 */,
/* 809 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 810 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 811 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 812 */,
/* 813 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 814 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 815 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 816 */,
/* 817 */,
/* 818 */,
/* 819 */,
/* 820 */,
/* 821 */
/***/ (function(module, exports) {


    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"IncomingCallFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"IncomingCall"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"pbxCallId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"date"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"time"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"number"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"records"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":130}};
    doc.loc.source = {"body":"fragment IncomingCallFragment on IncomingCall {\n    id\n    pbxCallId\n    date\n    time\n    number\n    records{\n        url\n    }\n}","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

      module.exports = doc;
    


/***/ }),
/* 822 */
/***/ (function(module, exports, __webpack_require__) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"description"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"users"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"permissions"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addRole"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}},{"kind":"Argument","name":{"kind":"Name","value":"description"},"value":{"kind":"Variable","name":{"kind":"Name","value":"description"}}},{"kind":"Argument","name":{"kind":"Name","value":"users"},"value":{"kind":"Variable","name":{"kind":"Name","value":"users"}}},{"kind":"Argument","name":{"kind":"Name","value":"permissions"},"value":{"kind":"Variable","name":{"kind":"Name","value":"permissions"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RoleFragment"},"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"permissions"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PermissionFragment"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"users"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserFragment"},"directives":[]}]}}]}}]}}],"loc":{"start":0,"end":542}};
    doc.loc.source = {"body":"#import \"./../../fragments/Acl/RoleFragment.graphql\"\n#import \"./../../fragments/Acl/PermissionFragment.graphql\"\n#import \"./../../fragments/UserFragment.graphql\"\n\nmutation (\n    $name: String!\n    $description: String\n    $users: [ID]\n    $permissions: [ID]\n) {\n    addRole(\n        name: $name\n        description: $description\n        users: $users\n        permissions: $permissions\n    ) {\n        ...RoleFragment\n        permissions{\n            ...PermissionFragment\n        }\n        users{\n            ...UserFragment\n        }\n    }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  doc.definitions = doc.definitions.concat(unique(__webpack_require__(154).definitions));
doc.definitions = doc.definitions.concat(unique(__webpack_require__(101).definitions));
doc.definitions = doc.definitions.concat(unique(__webpack_require__(18).definitions));


    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set(opRefs);
      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    


/***/ }),
/* 823 */
/***/ (function(module, exports, __webpack_require__) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"clearUserRoles"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserFragment"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserAdminFragment"},"directives":[]}]}}]}}],"loc":{"start":0,"end":245}};
    doc.loc.source = {"body":"#import \"./../../fragments/UserFragment.graphql\"\n#import \"./../../fragments/UserAdminFragment.graphql\"\n\nmutation (\n$userId: ID!\n) {\n    clearUserRoles(\n        userId: $userId\n    ) {\n        ...UserFragment\n        ...UserAdminFragment\n    }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  doc.definitions = doc.definitions.concat(unique(__webpack_require__(18).definitions));
doc.definitions = doc.definitions.concat(unique(__webpack_require__(52).definitions));


    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set(opRefs);
      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    


/***/ }),
/* 824 */
/***/ (function(module, exports, __webpack_require__) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"description"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"users"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"permissions"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateRole"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}},{"kind":"Argument","name":{"kind":"Name","value":"description"},"value":{"kind":"Variable","name":{"kind":"Name","value":"description"}}},{"kind":"Argument","name":{"kind":"Name","value":"users"},"value":{"kind":"Variable","name":{"kind":"Name","value":"users"}}},{"kind":"Argument","name":{"kind":"Name","value":"permissions"},"value":{"kind":"Variable","name":{"kind":"Name","value":"permissions"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RoleFragment"},"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"permissions"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PermissionFragment"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"users"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserFragment"},"directives":[]}]}}]}}]}}],"loc":{"start":0,"end":574}};
    doc.loc.source = {"body":"#import \"./../../fragments/Acl/RoleFragment.graphql\"\n#import \"./../../fragments/Acl/PermissionFragment.graphql\"\n#import \"./../../fragments/UserFragment.graphql\"\n\nmutation (\n    $id: ID!\n    $name: String!\n    $description: String\n    $users: [ID]\n    $permissions: [ID]\n) {\n    updateRole(\n        id: $id\n        name: $name\n        description: $description\n        users: $users\n        permissions: $permissions\n    ) {\n        ...RoleFragment\n        permissions{\n            ...PermissionFragment\n        }\n        users{\n            ...UserFragment\n        }\n    }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  doc.definitions = doc.definitions.concat(unique(__webpack_require__(154).definitions));
doc.definitions = doc.definitions.concat(unique(__webpack_require__(101).definitions));
doc.definitions = doc.definitions.concat(unique(__webpack_require__(18).definitions));


    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set(opRefs);
      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    


/***/ }),
/* 825 */
/***/ (function(module, exports, __webpack_require__) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"permissionId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"value"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateUserPermission"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}},{"kind":"Argument","name":{"kind":"Name","value":"permissionId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"permissionId"}}},{"kind":"Argument","name":{"kind":"Name","value":"value"},"value":{"kind":"Variable","name":{"kind":"Name","value":"value"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserFragment"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserAdminFragment"},"directives":[]}]}}]}}],"loc":{"start":0,"end":359}};
    doc.loc.source = {"body":"#import \"./../../fragments/UserFragment.graphql\"\n#import \"./../../fragments/UserAdminFragment.graphql\"\n\nmutation (\n    $userId: ID!,\n    $permissionId: ID!,\n    $value: Boolean!\n) {\n    updateUserPermission(\n        userId: $userId\n        permissionId: $permissionId\n        value: $value\n    ) {\n        ...UserFragment\n        ...UserAdminFragment\n    }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  doc.definitions = doc.definitions.concat(unique(__webpack_require__(18).definitions));
doc.definitions = doc.definitions.concat(unique(__webpack_require__(52).definitions));


    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set(opRefs);
      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    


/***/ }),
/* 826 */
/***/ (function(module, exports, __webpack_require__) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"roleId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"value"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateUserRole"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}},{"kind":"Argument","name":{"kind":"Name","value":"roleId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"roleId"}}},{"kind":"Argument","name":{"kind":"Name","value":"value"},"value":{"kind":"Variable","name":{"kind":"Name","value":"value"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserFragment"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserAdminFragment"},"directives":[]}]}}]}}],"loc":{"start":0,"end":335}};
    doc.loc.source = {"body":"#import \"./../../fragments/UserFragment.graphql\"\n#import \"./../../fragments/UserAdminFragment.graphql\"\n\nmutation (\n    $userId: ID!,\n    $roleId: ID!,\n    $value: Boolean!\n) {\n    updateUserRole(\n        userId: $userId\n        roleId: $roleId\n        value: $value\n    ) {\n        ...UserFragment\n        ...UserAdminFragment\n    }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  doc.definitions = doc.definitions.concat(unique(__webpack_require__(18).definitions));
doc.definitions = doc.definitions.concat(unique(__webpack_require__(52).definitions));


    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set(opRefs);
      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    


/***/ }),
/* 827 */
/***/ (function(module, exports, __webpack_require__) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sort"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"enabled"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addCity"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}},{"kind":"Argument","name":{"kind":"Name","value":"sort"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sort"}}},{"kind":"Argument","name":{"kind":"Name","value":"enabled"},"value":{"kind":"Variable","name":{"kind":"Name","value":"enabled"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CityFragment"},"directives":[]}]}}]}}],"loc":{"start":0,"end":239}};
    doc.loc.source = {"body":"#import \"./../fragments/CityFragment.graphql\"\n\nmutation (\n    $name: String!\n    $sort: Int!\n    $enabled: Boolean!\n) {\n    addCity(\n        name: $name\n        sort: $sort\n        enabled: $enabled\n    ) {\n        ...CityFragment\n    }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  doc.definitions = doc.definitions.concat(unique(__webpack_require__(66).definitions));


    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set(opRefs);
      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    


/***/ }),
/* 828 */
/***/ (function(module, exports, __webpack_require__) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"text"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addComment"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"text"},"value":{"kind":"Variable","name":{"kind":"Name","value":"text"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderId"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CommentFragment"},"directives":[]}]}}]}}],"loc":{"start":0,"end":178}};
    doc.loc.source = {"body":"#import \"./../fragments/CommentFragment.graphql\"\n\nmutation ($text: String!, $orderId: Int!) {\n    addComment(text: $text, orderId: $orderId) {\n        ...CommentFragment\n    }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  doc.definitions = doc.definitions.concat(unique(__webpack_require__(246).definitions));


    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set(opRefs);
      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    


/***/ }),
/* 829 */
/***/ (function(module, exports, __webpack_require__) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sort"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"enabled"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"users"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addCompany"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}},{"kind":"Argument","name":{"kind":"Name","value":"sort"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sort"}}},{"kind":"Argument","name":{"kind":"Name","value":"enabled"},"value":{"kind":"Variable","name":{"kind":"Name","value":"enabled"}}},{"kind":"Argument","name":{"kind":"Name","value":"users"},"value":{"kind":"Variable","name":{"kind":"Name","value":"users"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CompanyFragment"},"directives":[]}]}}]}}],"loc":{"start":0,"end":288}};
    doc.loc.source = {"body":"#import \"./../fragments/CompanyFragment.graphql\"\n\nmutation (\n    $name: String!\n    $sort: Int!\n    $enabled: Boolean!\n    $users: [ID]\n) {\n    addCompany(\n        name: $name\n        sort: $sort\n        enabled: $enabled,\n        users: $users\n    ) {\n        ...CompanyFragment\n    }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  doc.definitions = doc.definitions.concat(unique(__webpack_require__(155).definitions));


    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set(opRefs);
      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    


/***/ }),
/* 830 */
/***/ (function(module, exports, __webpack_require__) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"amoId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"code"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"type"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sort"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"required"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"viewed"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"editable"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"entityType"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addCustomField"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"amoId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"amoId"}}},{"kind":"Argument","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}},{"kind":"Argument","name":{"kind":"Name","value":"code"},"value":{"kind":"Variable","name":{"kind":"Name","value":"code"}}},{"kind":"Argument","name":{"kind":"Name","value":"type"},"value":{"kind":"Variable","name":{"kind":"Name","value":"type"}}},{"kind":"Argument","name":{"kind":"Name","value":"sort"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sort"}}},{"kind":"Argument","name":{"kind":"Name","value":"required"},"value":{"kind":"Variable","name":{"kind":"Name","value":"required"}}},{"kind":"Argument","name":{"kind":"Name","value":"viewed"},"value":{"kind":"Variable","name":{"kind":"Name","value":"viewed"}}},{"kind":"Argument","name":{"kind":"Name","value":"editable"},"value":{"kind":"Variable","name":{"kind":"Name","value":"editable"}}},{"kind":"Argument","name":{"kind":"Name","value":"entityType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"entityType"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CustomFieldFragment"},"directives":[]}]}}]}}],"loc":{"start":0,"end":533}};
    doc.loc.source = {"body":"#import \"./../fragments/CustomFieldFragment.graphql\"\n\nmutation (\n    $amoId: Int\n    $name: String!\n    $code: String!\n    $type: String!\n    $sort: Int\n    $required: Boolean!\n    $viewed: Boolean!\n    $editable: Boolean!\n    $entityType: String!\n) {\n    addCustomField(\n        amoId: $amoId\n        name: $name\n        code: $code\n        type: $type\n        sort: $sort\n        required: $required\n        viewed: $viewed\n        editable: $editable\n        entityType: $entityType\n    ) {\n        ...CustomFieldFragment\n    }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  doc.definitions = doc.definitions.concat(unique(__webpack_require__(102).definitions));


    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set(opRefs);
      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    


/***/ }),
/* 831 */
/***/ (function(module, exports, __webpack_require__) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderDate"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderTime"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"techcenterId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"description"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"clientName"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"clientPhone"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sum"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addOrder"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderDate"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderTime"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderTime"}}},{"kind":"Argument","name":{"kind":"Name","value":"techcenterId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"techcenterId"}}},{"kind":"Argument","name":{"kind":"Name","value":"description"},"value":{"kind":"Variable","name":{"kind":"Name","value":"description"}}},{"kind":"Argument","name":{"kind":"Name","value":"clientName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"clientName"}}},{"kind":"Argument","name":{"kind":"Name","value":"clientPhone"},"value":{"kind":"Variable","name":{"kind":"Name","value":"clientPhone"}}},{"kind":"Argument","name":{"kind":"Name","value":"sum"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sum"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrderFragment"},"directives":[]}]}}]}}],"loc":{"start":0,"end":508}};
    doc.loc.source = {"body":"#import \"./../fragments/OrderFragment.graphql\"\n\nmutation (\n    $orderDate: String!,\n    $orderTime: String!,\n    $techcenterId: Int!,\n    $description: String!,\n    $clientName: String,\n    $clientPhone: String,\n    $sum: Float!\n) {\n    addOrder(\n        orderDate: $orderDate,\n        orderTime: $orderTime,\n        techcenterId: $techcenterId,\n        description: $description,\n        clientName: $clientName,\n        clientPhone: $clientPhone,\n        sum: $sum\n    ) {\n        ...OrderFragment\n    }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  doc.definitions = doc.definitions.concat(unique(__webpack_require__(50).definitions));


    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set(opRefs);
      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    


/***/ }),
/* 832 */
/***/ (function(module, exports, __webpack_require__) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"code"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"class"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sort"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"enabled"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"amoStatuses"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AmoStatusInput"}}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addStatus"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}},{"kind":"Argument","name":{"kind":"Name","value":"code"},"value":{"kind":"Variable","name":{"kind":"Name","value":"code"}}},{"kind":"Argument","name":{"kind":"Name","value":"class"},"value":{"kind":"Variable","name":{"kind":"Name","value":"class"}}},{"kind":"Argument","name":{"kind":"Name","value":"sort"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sort"}}},{"kind":"Argument","name":{"kind":"Name","value":"enabled"},"value":{"kind":"Variable","name":{"kind":"Name","value":"enabled"}}},{"kind":"Argument","name":{"kind":"Name","value":"amoStatuses"},"value":{"kind":"Variable","name":{"kind":"Name","value":"amoStatuses"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"StatusFragment"},"directives":[]}]}}]}}],"loc":{"start":0,"end":395}};
    doc.loc.source = {"body":"#import \"./../fragments/StatusFragment.graphql\"\n\nmutation (\n    $name: String!\n    $code: String!\n    $class: String!\n    $sort: Int!\n    $enabled: Boolean!\n    $amoStatuses: [AmoStatusInput]\n) {\n    addStatus(\n        name: $name\n        code: $code\n        class: $class\n        sort: $sort\n        enabled: $enabled\n        amoStatuses: $amoStatuses\n    ) {\n        ...StatusFragment\n    }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  doc.definitions = doc.definitions.concat(unique(__webpack_require__(105).definitions));


    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set(opRefs);
      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    


/***/ }),
/* 833 */
/***/ (function(module, exports, __webpack_require__) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"firstname"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lastname"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"email"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"phone"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"password"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"techcenters"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"roles"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companies"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"notifyEmail"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addUser"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"firstname"},"value":{"kind":"Variable","name":{"kind":"Name","value":"firstname"}}},{"kind":"Argument","name":{"kind":"Name","value":"lastname"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lastname"}}},{"kind":"Argument","name":{"kind":"Name","value":"email"},"value":{"kind":"Variable","name":{"kind":"Name","value":"email"}}},{"kind":"Argument","name":{"kind":"Name","value":"phone"},"value":{"kind":"Variable","name":{"kind":"Name","value":"phone"}}},{"kind":"Argument","name":{"kind":"Name","value":"password"},"value":{"kind":"Variable","name":{"kind":"Name","value":"password"}}},{"kind":"Argument","name":{"kind":"Name","value":"techcenters"},"value":{"kind":"Variable","name":{"kind":"Name","value":"techcenters"}}},{"kind":"Argument","name":{"kind":"Name","value":"roles"},"value":{"kind":"Variable","name":{"kind":"Name","value":"roles"}}},{"kind":"Argument","name":{"kind":"Name","value":"companies"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companies"}}},{"kind":"Argument","name":{"kind":"Name","value":"notifyEmail"},"value":{"kind":"Variable","name":{"kind":"Name","value":"notifyEmail"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserFragment"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserAdminFragment"},"directives":[]}]}}]}}],"loc":{"start":0,"end":643}};
    doc.loc.source = {"body":"#import \"./../fragments/UserFragment.graphql\"\n#import \"./../fragments/UserAdminFragment.graphql\"\n\nmutation (\n    $firstname: String!\n    $lastname: String!\n    $email: String!\n    $phone: String!\n    $password: String!\n    $techcenters: [ID]\n    $roles: [ID]\n    $companies: [ID]\n    $notifyEmail: Boolean!\n) {\n    addUser(\n        firstname: $firstname\n        lastname: $lastname\n        email: $email\n        phone: $phone\n        password: $password\n        techcenters: $techcenters\n        roles: $roles\n        companies: $companies\n        notifyEmail: $notifyEmail\n    ) {\n        ...UserFragment\n        ...UserAdminFragment\n    }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  doc.definitions = doc.definitions.concat(unique(__webpack_require__(18).definitions));
doc.definitions = doc.definitions.concat(unique(__webpack_require__(52).definitions));


    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set(opRefs);
      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    


/***/ }),
/* 834 */
/***/ (function(module, exports, __webpack_require__) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"value"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cause"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cancelOrder"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderId"}}},{"kind":"Argument","name":{"kind":"Name","value":"value"},"value":{"kind":"Variable","name":{"kind":"Name","value":"value"}}},{"kind":"Argument","name":{"kind":"Name","value":"cause"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cause"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrderFragment"},"directives":[]}]}}]}}],"loc":{"start":0,"end":210}};
    doc.loc.source = {"body":"#import \"./../fragments/OrderFragment.graphql\"\n\nmutation ($orderId: Int!, $value: Boolean!, $cause: String) {\n    cancelOrder(orderId: $orderId, value: $value, cause: $cause) {\n        ...OrderFragment\n    }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  doc.definitions = doc.definitions.concat(unique(__webpack_require__(50).definitions));


    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set(opRefs);
      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    


/***/ }),
/* 835 */
/***/ (function(module, exports) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"oldPassword"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"newPassword"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"remindNewPassword"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"changePassword"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}},{"kind":"Argument","name":{"kind":"Name","value":"oldPassword"},"value":{"kind":"Variable","name":{"kind":"Name","value":"oldPassword"}}},{"kind":"Argument","name":{"kind":"Name","value":"newPassword"},"value":{"kind":"Variable","name":{"kind":"Name","value":"newPassword"}}},{"kind":"Argument","name":{"kind":"Name","value":"remindNewPassword"},"value":{"kind":"Variable","name":{"kind":"Name","value":"remindNewPassword"}}}],"directives":[]}]}}],"loc":{"start":0,"end":283}};
    doc.loc.source = {"body":"mutation (\n    $userId: ID!,\n    $oldPassword: String,\n    $newPassword: String!,\n    $remindNewPassword: String!\n) {\n    changePassword(\n        userId: $userId\n        oldPassword: $oldPassword\n        newPassword: $newPassword\n        remindNewPassword: $remindNewPassword\n    )\n}","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set(opRefs);
      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    


/***/ }),
/* 836 */
/***/ (function(module, exports, __webpack_require__) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sum"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"profit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"closeOrder"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderId"}}},{"kind":"Argument","name":{"kind":"Name","value":"sum"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sum"}}},{"kind":"Argument","name":{"kind":"Name","value":"profit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"profit"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrderFragment"},"directives":[]}]}}]}}],"loc":{"start":0,"end":201}};
    doc.loc.source = {"body":"#import \"./../fragments/OrderFragment.graphql\"\n\nmutation ($orderId: Int!, $sum: Float, $profit: Float) {\n    closeOrder(orderId: $orderId, sum: $sum, profit: $profit) {\n        ...OrderFragment\n    }\n}","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  doc.definitions = doc.definitions.concat(unique(__webpack_require__(50).definitions));


    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set(opRefs);
      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    


/***/ }),
/* 837 */
/***/ (function(module, exports) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteOrder"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"directives":[]}]}}],"loc":{"start":0,"end":50}};
    doc.loc.source = {"body":"mutation ($id: Int!) {\n    deleteOrder(id: $id)\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set(opRefs);
      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    


/***/ }),
/* 838 */
/***/ (function(module, exports) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","variableDefinitions":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"markAsViewed"},"arguments":[],"directives":[]}]}}],"loc":{"start":0,"end":28}};
    doc.loc.source = {"body":"mutation{\n    markAsViewed\n}","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set(opRefs);
      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    


/***/ }),
/* 839 */
/***/ (function(module, exports) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"markAsViewedComments"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderId"}}}],"directives":[]}]}}],"loc":{"start":0,"end":71}};
    doc.loc.source = {"body":"mutation($orderId: Int!){\n    markAsViewedComments(orderId: $orderId)\n}","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set(opRefs);
      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    


/***/ }),
/* 840 */
/***/ (function(module, exports, __webpack_require__) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"code"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sum"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"profit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"comment"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"orderTransition"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"code"},"value":{"kind":"Variable","name":{"kind":"Name","value":"code"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderId"}}},{"kind":"Argument","name":{"kind":"Name","value":"sum"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sum"}}},{"kind":"Argument","name":{"kind":"Name","value":"profit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"profit"}}},{"kind":"Argument","name":{"kind":"Name","value":"comment"},"value":{"kind":"Variable","name":{"kind":"Name","value":"comment"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrderFragment"},"directives":[]}]}}]}}],"loc":{"start":0,"end":274}};
    doc.loc.source = {"body":"#import \"./../fragments/OrderFragment.graphql\"\n\nmutation ($code: String!, $orderId: Int!, $sum: Float, $profit: Float,  $comment: String) {\n    orderTransition(code: $code, orderId: $orderId, sum: $sum, profit: $profit, comment: $comment) {\n        ...OrderFragment\n    }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  doc.definitions = doc.definitions.concat(unique(__webpack_require__(50).definitions));


    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set(opRefs);
      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    


/***/ }),
/* 841 */
/***/ (function(module, exports, __webpack_require__) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"number"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"users"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addInternalNumber"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"number"},"value":{"kind":"Variable","name":{"kind":"Name","value":"number"}}},{"kind":"Argument","name":{"kind":"Name","value":"users"},"value":{"kind":"Variable","name":{"kind":"Name","value":"users"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalNumberFragment"},"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"users"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserFragment"},"directives":[]}]}}]}}]}}],"loc":{"start":0,"end":338}};
    doc.loc.source = {"body":"#import \"./../../fragments/PBX/InternalNumberFragment.graphql\"\n#import \"./../../fragments/UserFragment.graphql\"\n\nmutation (\n    $number: String!\n    $users: [ID]\n) {\n    addInternalNumber(\n        number: $number\n        users: $users\n    ) {\n        ...InternalNumberFragment\n        users{\n            ...UserFragment\n        }\n    }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  doc.definitions = doc.definitions.concat(unique(__webpack_require__(103).definitions));
doc.definitions = doc.definitions.concat(unique(__webpack_require__(18).definitions));


    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set(opRefs);
      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    


/***/ }),
/* 842 */
/***/ (function(module, exports, __webpack_require__) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"number"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cityId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"country"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"site"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addVirtualNumber"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"number"},"value":{"kind":"Variable","name":{"kind":"Name","value":"number"}}},{"kind":"Argument","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}},{"kind":"Argument","name":{"kind":"Name","value":"cityId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cityId"}}},{"kind":"Argument","name":{"kind":"Name","value":"country"},"value":{"kind":"Variable","name":{"kind":"Name","value":"country"}}},{"kind":"Argument","name":{"kind":"Name","value":"site"},"value":{"kind":"Variable","name":{"kind":"Name","value":"site"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VirtualNumberFragment"},"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"city"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CityFragment"},"directives":[]}]}}]}}]}}],"loc":{"start":0,"end":460}};
    doc.loc.source = {"body":"#import \"./../../fragments/PBX/VirtualNumberFragment.graphql\"\n#import \"./../../fragments/CityFragment.graphql\"\n\nmutation (\n    $name: String!\n    $number: String!\n    $cityId: Int\n    $country: String\n    $site: String\n) {\n    addVirtualNumber(\n        number: $number\n        name: $name\n        cityId: $cityId\n        country: $country\n        site: $site\n    ) {\n        ...VirtualNumberFragment\n        city{\n            ...CityFragment\n        }\n    }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  doc.definitions = doc.definitions.concat(unique(__webpack_require__(104).definitions));
doc.definitions = doc.definitions.concat(unique(__webpack_require__(66).definitions));


    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set(opRefs);
      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    


/***/ }),
/* 843 */
/***/ (function(module, exports, __webpack_require__) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"number"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"users"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateInternalNumber"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"number"},"value":{"kind":"Variable","name":{"kind":"Name","value":"number"}}},{"kind":"Argument","name":{"kind":"Name","value":"users"},"value":{"kind":"Variable","name":{"kind":"Name","value":"users"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalNumberFragment"},"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"users"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserFragment"},"directives":[]}]}}]}}]}}],"loc":{"start":0,"end":370}};
    doc.loc.source = {"body":"#import \"./../../fragments/PBX/InternalNumberFragment.graphql\"\n#import \"./../../fragments/UserFragment.graphql\"\n\nmutation (\n    $id: ID!\n    $number: String!\n    $users: [ID]\n) {\n    updateInternalNumber(\n        id: $id\n        number: $number\n        users: $users\n    ) {\n        ...InternalNumberFragment\n        users{\n            ...UserFragment\n        }\n    }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  doc.definitions = doc.definitions.concat(unique(__webpack_require__(103).definitions));
doc.definitions = doc.definitions.concat(unique(__webpack_require__(18).definitions));


    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set(opRefs);
      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    


/***/ }),
/* 844 */
/***/ (function(module, exports, __webpack_require__) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"number"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cityId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"country"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"site"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateVirtualNumber"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"number"},"value":{"kind":"Variable","name":{"kind":"Name","value":"number"}}},{"kind":"Argument","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}},{"kind":"Argument","name":{"kind":"Name","value":"cityId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cityId"}}},{"kind":"Argument","name":{"kind":"Name","value":"country"},"value":{"kind":"Variable","name":{"kind":"Name","value":"country"}}},{"kind":"Argument","name":{"kind":"Name","value":"site"},"value":{"kind":"Variable","name":{"kind":"Name","value":"site"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VirtualNumberFragment"},"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"city"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CityFragment"},"directives":[]}]}}]}}]}}],"loc":{"start":0,"end":492}};
    doc.loc.source = {"body":"#import \"./../../fragments/PBX/VirtualNumberFragment.graphql\"\n#import \"./../../fragments/CityFragment.graphql\"\n\nmutation (\n    $id: ID!\n    $name: String!\n    $number: String!\n    $cityId: Int\n    $country: String\n    $site: String\n) {\n    updateVirtualNumber(\n        id: $id\n        number: $number\n        name: $name\n        cityId: $cityId\n        country: $country\n        site: $site\n    ) {\n        ...VirtualNumberFragment\n        city{\n            ...CityFragment\n        }\n    }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  doc.definitions = doc.definitions.concat(unique(__webpack_require__(104).definitions));
doc.definitions = doc.definitions.concat(unique(__webpack_require__(66).definitions));


    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set(opRefs);
      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    


/***/ }),
/* 845 */
/***/ (function(module, exports, __webpack_require__) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"value"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cause"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"problemOrder"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderId"}}},{"kind":"Argument","name":{"kind":"Name","value":"value"},"value":{"kind":"Variable","name":{"kind":"Name","value":"value"}}},{"kind":"Argument","name":{"kind":"Name","value":"cause"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cause"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrderFragment"},"directives":[]}]}}]}}],"loc":{"start":0,"end":211}};
    doc.loc.source = {"body":"#import \"./../fragments/OrderFragment.graphql\"\n\nmutation ($orderId: Int!, $value: Boolean!, $cause: String) {\n    problemOrder(orderId: $orderId, value: $value, cause: $cause) {\n        ...OrderFragment\n    }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  doc.definitions = doc.definitions.concat(unique(__webpack_require__(50).definitions));


    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set(opRefs);
      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    


/***/ }),
/* 846 */
/***/ (function(module, exports, __webpack_require__) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sort"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"enabled"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateCity"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}},{"kind":"Argument","name":{"kind":"Name","value":"sort"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sort"}}},{"kind":"Argument","name":{"kind":"Name","value":"enabled"},"value":{"kind":"Variable","name":{"kind":"Name","value":"enabled"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CityFragment"},"directives":[]}]}}]}}],"loc":{"start":0,"end":271}};
    doc.loc.source = {"body":"#import \"./../fragments/CityFragment.graphql\"\n\nmutation (\n    $id: ID!\n    $name: String!\n    $sort: Int!\n    $enabled: Boolean!\n) {\n    updateCity(\n        id: $id\n        name: $name\n        sort: $sort\n        enabled: $enabled\n    ) {\n        ...CityFragment\n    }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  doc.definitions = doc.definitions.concat(unique(__webpack_require__(66).definitions));


    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set(opRefs);
      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    


/***/ }),
/* 847 */
/***/ (function(module, exports, __webpack_require__) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sort"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"enabled"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"users"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateCompany"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}},{"kind":"Argument","name":{"kind":"Name","value":"sort"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sort"}}},{"kind":"Argument","name":{"kind":"Name","value":"enabled"},"value":{"kind":"Variable","name":{"kind":"Name","value":"enabled"}}},{"kind":"Argument","name":{"kind":"Name","value":"users"},"value":{"kind":"Variable","name":{"kind":"Name","value":"users"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CompanyFragment"},"directives":[]}]}}]}}],"loc":{"start":0,"end":319}};
    doc.loc.source = {"body":"#import \"./../fragments/CompanyFragment.graphql\"\n\nmutation (\n    $id: ID!\n    $name: String!\n    $sort: Int!\n    $enabled: Boolean!\n    $users: [ID]\n) {\n    updateCompany(\n        id: $id\n        name: $name\n        sort: $sort\n        enabled: $enabled\n        users: $users\n    ) {\n        ...CompanyFragment\n    }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  doc.definitions = doc.definitions.concat(unique(__webpack_require__(155).definitions));


    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set(opRefs);
      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    


/***/ }),
/* 848 */
/***/ (function(module, exports, __webpack_require__) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"amoId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"code"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"type"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sort"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"required"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"viewed"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"editable"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"entityType"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateCustomField"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"amoId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"amoId"}}},{"kind":"Argument","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}},{"kind":"Argument","name":{"kind":"Name","value":"code"},"value":{"kind":"Variable","name":{"kind":"Name","value":"code"}}},{"kind":"Argument","name":{"kind":"Name","value":"type"},"value":{"kind":"Variable","name":{"kind":"Name","value":"type"}}},{"kind":"Argument","name":{"kind":"Name","value":"sort"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sort"}}},{"kind":"Argument","name":{"kind":"Name","value":"required"},"value":{"kind":"Variable","name":{"kind":"Name","value":"required"}}},{"kind":"Argument","name":{"kind":"Name","value":"viewed"},"value":{"kind":"Variable","name":{"kind":"Name","value":"viewed"}}},{"kind":"Argument","name":{"kind":"Name","value":"editable"},"value":{"kind":"Variable","name":{"kind":"Name","value":"editable"}}},{"kind":"Argument","name":{"kind":"Name","value":"entityType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"entityType"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CustomFieldFragment"},"directives":[]}]}}]}}],"loc":{"start":0,"end":565}};
    doc.loc.source = {"body":"#import \"./../fragments/CustomFieldFragment.graphql\"\n\nmutation (\n    $id: ID!\n    $amoId: Int\n    $name: String!\n    $code: String!\n    $type: String!\n    $sort: Int\n    $required: Boolean!\n    $viewed: Boolean!\n    $editable: Boolean!\n    $entityType: String!\n) {\n    updateCustomField(\n        id: $id\n        amoId: $amoId\n        name: $name\n        code: $code\n        type: $type\n        sort: $sort\n        required: $required\n        viewed: $viewed\n        editable: $editable\n        entityType: $entityType\n    ) {\n        ...CustomFieldFragment\n    }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  doc.definitions = doc.definitions.concat(unique(__webpack_require__(102).definitions));


    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set(opRefs);
      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    


/***/ }),
/* 849 */
/***/ (function(module, exports, __webpack_require__) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderDate"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderTime"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"techcenterId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"description"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"clientName"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"clientPhone"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sum"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateOrder"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderDate"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderTime"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderTime"}}},{"kind":"Argument","name":{"kind":"Name","value":"techcenterId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"techcenterId"}}},{"kind":"Argument","name":{"kind":"Name","value":"description"},"value":{"kind":"Variable","name":{"kind":"Name","value":"description"}}},{"kind":"Argument","name":{"kind":"Name","value":"clientName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"clientName"}}},{"kind":"Argument","name":{"kind":"Name","value":"clientPhone"},"value":{"kind":"Variable","name":{"kind":"Name","value":"clientPhone"}}},{"kind":"Argument","name":{"kind":"Name","value":"sum"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sum"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrderFragment"},"directives":[]}]}}]}}],"loc":{"start":0,"end":542}};
    doc.loc.source = {"body":"#import \"./../fragments/OrderFragment.graphql\"\n\nmutation (\n    $id: ID!,\n    $orderDate: String!,\n    $orderTime: String!,\n    $techcenterId: Int!,\n    $description: String!,\n    $clientName: String,\n    $clientPhone: String,\n    $sum: Float!\n) {\n    updateOrder(\n        id: $id,\n        orderDate: $orderDate,\n        orderTime: $orderTime,\n        techcenterId: $techcenterId,\n        description: $description,\n        clientName: $clientName,\n        clientPhone: $clientPhone,\n        sum: $sum\n    ) {\n        ...OrderFragment\n    }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  doc.definitions = doc.definitions.concat(unique(__webpack_require__(50).definitions));


    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set(opRefs);
      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    


/***/ }),
/* 850 */
/***/ (function(module, exports, __webpack_require__) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"code"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"class"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sort"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"enabled"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"amoStatuses"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AmoStatusInput"}}}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateStatus"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}},{"kind":"Argument","name":{"kind":"Name","value":"code"},"value":{"kind":"Variable","name":{"kind":"Name","value":"code"}}},{"kind":"Argument","name":{"kind":"Name","value":"class"},"value":{"kind":"Variable","name":{"kind":"Name","value":"class"}}},{"kind":"Argument","name":{"kind":"Name","value":"sort"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sort"}}},{"kind":"Argument","name":{"kind":"Name","value":"enabled"},"value":{"kind":"Variable","name":{"kind":"Name","value":"enabled"}}},{"kind":"Argument","name":{"kind":"Name","value":"amoStatuses"},"value":{"kind":"Variable","name":{"kind":"Name","value":"amoStatuses"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"StatusFragment"},"directives":[]}]}}]}}],"loc":{"start":0,"end":428}};
    doc.loc.source = {"body":"#import \"./../fragments/StatusFragment.graphql\"\n\nmutation (\n    $id: ID!\n    $name: String!\n    $code: String!\n    $class: String!\n    $sort: Int!\n    $enabled: Boolean!\n    $amoStatuses: [AmoStatusInput]!\n) {\n    updateStatus(\n        id: $id\n        name: $name\n        code: $code\n        class: $class\n        sort: $sort\n        enabled: $enabled\n        amoStatuses: $amoStatuses\n    ) {\n        ...StatusFragment\n    }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  doc.definitions = doc.definitions.concat(unique(__webpack_require__(105).definitions));


    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set(opRefs);
      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    


/***/ }),
/* 851 */
/***/ (function(module, exports) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"channel"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"action"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"value"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateUserNotificationSetting"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}},{"kind":"Argument","name":{"kind":"Name","value":"channel"},"value":{"kind":"Variable","name":{"kind":"Name","value":"channel"}}},{"kind":"Argument","name":{"kind":"Name","value":"action"},"value":{"kind":"Variable","name":{"kind":"Name","value":"action"}}},{"kind":"Argument","name":{"kind":"Name","value":"value"},"value":{"kind":"Variable","name":{"kind":"Name","value":"value"}}}],"directives":[]}]}}],"loc":{"start":0,"end":238}};
    doc.loc.source = {"body":"mutation (\n    $userId: ID!,\n    $channel: String!,\n    $action: String!,\n    $value: Boolean!\n) {\n    updateUserNotificationSetting(\n        userId: $userId\n        channel: $channel\n        action: $action\n        value: $value\n    )\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set(opRefs);
      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    


/***/ }),
/* 852 */
/***/ (function(module, exports, __webpack_require__) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"firstname"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lastname"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"email"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"phone"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skype"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"icq"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"birthday"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"telegramUserId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"amoId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateUserProfile"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"firstname"},"value":{"kind":"Variable","name":{"kind":"Name","value":"firstname"}}},{"kind":"Argument","name":{"kind":"Name","value":"lastname"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lastname"}}},{"kind":"Argument","name":{"kind":"Name","value":"email"},"value":{"kind":"Variable","name":{"kind":"Name","value":"email"}}},{"kind":"Argument","name":{"kind":"Name","value":"phone"},"value":{"kind":"Variable","name":{"kind":"Name","value":"phone"}}},{"kind":"Argument","name":{"kind":"Name","value":"skype"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skype"}}},{"kind":"Argument","name":{"kind":"Name","value":"icq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"icq"}}},{"kind":"Argument","name":{"kind":"Name","value":"birthday"},"value":{"kind":"Variable","name":{"kind":"Name","value":"birthday"}}},{"kind":"Argument","name":{"kind":"Name","value":"telegramUserId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"telegramUserId"}}},{"kind":"Argument","name":{"kind":"Name","value":"amoId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"amoId"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserFragment"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserAdminFragment"},"directives":[]}]}}]}}],"loc":{"start":0,"end":664}};
    doc.loc.source = {"body":"#import \"./../fragments/UserFragment.graphql\"\n#import \"./../fragments/UserAdminFragment.graphql\"\n\nmutation (\n    $id: ID!,\n    $firstname: String,\n    $lastname: String,\n    $email: String!,\n    $phone: String!,\n    $skype: String,\n    $icq: String,\n    $birthday: String,\n    $telegramUserId: String,\n    $amoId: Int\n) {\n    updateUserProfile(\n        id: $id\n        firstname: $firstname\n        lastname: $lastname\n        email: $email\n        phone: $phone\n        skype: $skype\n        icq: $icq\n        birthday: $birthday,\n        telegramUserId: $telegramUserId,\n        amoId: $amoId\n    ) {\n        ...UserFragment\n        ...UserAdminFragment\n    }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  doc.definitions = doc.definitions.concat(unique(__webpack_require__(18).definitions));
doc.definitions = doc.definitions.concat(unique(__webpack_require__(52).definitions));


    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set(opRefs);
      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    


/***/ }),
/* 853 */
/***/ (function(module, exports) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getAdditionalData"},"variableDefinitions":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"companies"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"_all"},"value":{"kind":"BooleanValue","value":true}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"techcenters"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"_all"},"value":{"kind":"BooleanValue","value":true}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"roles"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"_all"},"value":{"kind":"BooleanValue","value":true}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"description"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":218}};
    doc.loc.source = {"body":"query getAdditionalData {\n    companies(_all: true){\n        name\n        id\n    },\n    techcenters(_all: true){\n        name\n        id\n    },\n    roles(_all: true){\n        name\n        description\n        id\n    }\n}","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set(opRefs);
      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports["getAdditionalData"] = oneQuery(doc, "getAdditionalData");
        


/***/ }),
/* 854 */
/***/ (function(module, exports, __webpack_require__) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getCities"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"page"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"query"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cities"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"_limit"},"value":{"kind":"IntValue","value":"10"}},{"kind":"Argument","name":{"kind":"Name","value":"_page"},"value":{"kind":"Variable","name":{"kind":"Name","value":"page"}}},{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CityFragment"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"paginator"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"StringValue","value":"cities","block":false}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PaginatorFragment"},"directives":[]}]}}]}}],"loc":{"start":0,"end":297}};
    doc.loc.source = {"body":"#import \"./../fragments/CityFragment.graphql\"\n#import \"./../fragments/PaginatorFragment.graphql\"\n\nquery getCities ($page: Int, $query: String) {\n    cities(_limit:10, _page: $page, query: $query){\n        ...CityFragment\n    }\n    paginator (query: \"cities\") {\n        ...PaginatorFragment\n    }\n}","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  doc.definitions = doc.definitions.concat(unique(__webpack_require__(66).definitions));
doc.definitions = doc.definitions.concat(unique(__webpack_require__(51).definitions));


    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set(opRefs);
      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports["getCities"] = oneQuery(doc, "getCities");
        


/***/ }),
/* 855 */
/***/ (function(module, exports, __webpack_require__) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getCompanies"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"page"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"query"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"companies"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"_limit"},"value":{"kind":"IntValue","value":"10"}},{"kind":"Argument","name":{"kind":"Name","value":"_page"},"value":{"kind":"Variable","name":{"kind":"Name","value":"page"}}},{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"fullname"},"arguments":[],"directives":[]}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"CompanyFragment"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"paginator"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"StringValue","value":"companies","block":false}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PaginatorFragment"},"directives":[]}]}}]}}],"loc":{"start":0,"end":373}};
    doc.loc.source = {"body":"#import \"./../fragments/CompanyFragment.graphql\"\n#import \"./../fragments/PaginatorFragment.graphql\"\n\nquery getCompanies ($page: Int, $query: String) {\n    companies(_limit:10, _page: $page, query: $query){\n        users{\n            id\n            fullname\n        }\n        ...CompanyFragment\n    }\n    paginator (query: \"companies\") {\n        ...PaginatorFragment\n    }\n}","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  doc.definitions = doc.definitions.concat(unique(__webpack_require__(155).definitions));
doc.definitions = doc.definitions.concat(unique(__webpack_require__(51).definitions));


    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set(opRefs);
      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports["getCompanies"] = oneQuery(doc, "getCompanies");
        


/***/ }),
/* 856 */
/***/ (function(module, exports, __webpack_require__) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getTechcenters"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"page"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"query"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cityId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyIds"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cityIds"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"techcenters"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"_limit"},"value":{"kind":"IntValue","value":"10"}},{"kind":"Argument","name":{"kind":"Name","value":"_page"},"value":{"kind":"Variable","name":{"kind":"Name","value":"page"}}},{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}},{"kind":"Argument","name":{"kind":"Name","value":"companyId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyId"}}},{"kind":"Argument","name":{"kind":"Name","value":"cityId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cityId"}}},{"kind":"Argument","name":{"kind":"Name","value":"companyIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"cityIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cityIds"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TechcenterFragment"},"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"users"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserFragment"},"directives":[]}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"paginator"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"StringValue","value":"techcenters","block":false}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PaginatorFragment"},"directives":[]}]}}]}}],"loc":{"start":0,"end":573}};
    doc.loc.source = {"body":"#import \"./../fragments/TechcenterFragment.graphql\"\n#import \"./../fragments/UserFragment.graphql\"\n#import \"./../fragments/PaginatorFragment.graphql\"\n\nquery getTechcenters ($page: Int, $query: String, $companyId: Int, $cityId: Int, $companyIds: [ID], $cityIds: [ID]) {\n    techcenters(_limit:10, _page: $page, query: $query, companyId: $companyId, cityId: $cityId, companyIds: $companyIds, cityIds: $cityIds){\n        ...TechcenterFragment\n        users{\n            ...UserFragment\n        }\n    }\n    paginator (query: \"techcenters\") {\n        ...PaginatorFragment\n    }\n}","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  doc.definitions = doc.definitions.concat(unique(__webpack_require__(79).definitions));
doc.definitions = doc.definitions.concat(unique(__webpack_require__(18).definitions));
doc.definitions = doc.definitions.concat(unique(__webpack_require__(51).definitions));


    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set(opRefs);
      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports["getTechcenters"] = oneQuery(doc, "getTechcenters");
        


/***/ }),
/* 857 */
/***/ (function(module, exports) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getAmoStatuses"},"variableDefinitions":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amoStatuses"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"amoId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"pipelineId"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":94}};
    doc.loc.source = {"body":"query getAmoStatuses {\n    amoStatuses{\n        name\n        amoId\n        pipelineId\n    }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set(opRefs);
      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports["getAmoStatuses"] = oneQuery(doc, "getAmoStatuses");
        


/***/ }),
/* 858 */
/***/ (function(module, exports, __webpack_require__) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getComments"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"comments"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderId"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CommentFragment"},"directives":[]}]}}]}}],"loc":{"start":0,"end":154}};
    doc.loc.source = {"body":"#import \"./../fragments/CommentFragment.graphql\"\n\nquery getComments ($orderId: Int!) {\n    comments (orderId: $orderId){\n       ...CommentFragment\n    }\n}","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  doc.definitions = doc.definitions.concat(unique(__webpack_require__(246).definitions));


    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set(opRefs);
      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports["getComments"] = oneQuery(doc, "getComments");
        


/***/ }),
/* 859 */
/***/ (function(module, exports, __webpack_require__) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getCustomFieldById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"customFields"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"ListValue","values":[{"kind":"Variable","name":{"kind":"Name","value":"id"}}]}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CustomFieldFragment"},"directives":[]}]}}]}}],"loc":{"start":0,"end":158}};
    doc.loc.source = {"body":"#import \"./../fragments/CustomFieldFragment.graphql\"\n\nquery getCustomFieldById($id: ID!){\n    customFields(id: [$id]){\n        ...CustomFieldFragment\n    }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  doc.definitions = doc.definitions.concat(unique(__webpack_require__(102).definitions));


    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set(opRefs);
      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports["getCustomFieldById"] = oneQuery(doc, "getCustomFieldById");
        


/***/ }),
/* 860 */
/***/ (function(module, exports, __webpack_require__) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getCustomFields"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"page"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"query"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"entityType"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"type"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"customFields"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"_limit"},"value":{"kind":"IntValue","value":"10"}},{"kind":"Argument","name":{"kind":"Name","value":"_page"},"value":{"kind":"Variable","name":{"kind":"Name","value":"page"}}},{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}},{"kind":"Argument","name":{"kind":"Name","value":"entityType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"entityType"}}},{"kind":"Argument","name":{"kind":"Name","value":"type"},"value":{"kind":"Variable","name":{"kind":"Name","value":"type"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CustomFieldFragment"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"paginator"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"StringValue","value":"customFields","block":false}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PaginatorFragment"},"directives":[]}]}}]}}],"loc":{"start":0,"end":403}};
    doc.loc.source = {"body":"#import \"./../fragments/CustomFieldFragment.graphql\"\n#import \"./../fragments/PaginatorFragment.graphql\"\n\nquery getCustomFields($page: Int,  $query: String, $entityType: String, $type: String){\n    customFields(_limit:10, _page: $page, query: $query, entityType: $entityType, type: $type){\n        ...CustomFieldFragment\n    }\n    paginator (query: \"customFields\") {\n        ...PaginatorFragment\n    }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  doc.definitions = doc.definitions.concat(unique(__webpack_require__(102).definitions));
doc.definitions = doc.definitions.concat(unique(__webpack_require__(51).definitions));


    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set(opRefs);
      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports["getCustomFields"] = oneQuery(doc, "getCustomFields");
        


/***/ }),
/* 861 */
/***/ (function(module, exports) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getDocument"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"uri"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"document"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"uri"},"value":{"kind":"Variable","name":{"kind":"Name","value":"uri"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"title"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"content"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":109}};
    doc.loc.source = {"body":"query getDocument ($uri: String!) {\n    document(uri: $uri){\n        id\n        title\n        content\n    }\n}","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set(opRefs);
      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports["getDocument"] = oneQuery(doc, "getDocument");
        


/***/ }),
/* 862 */
/***/ (function(module, exports) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getNotifications"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"page"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"notifications"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"_limit"},"value":{"kind":"IntValue","value":"20"}},{"kind":"Argument","name":{"kind":"Name","value":"_page"},"value":{"kind":"Variable","name":{"kind":"Name","value":"page"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"objectId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"objectType"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"diffForHumans"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"iconClass"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"isViewed"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"paginator"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"StringValue","value":"notifications","block":false}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total_count"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"is_first_page"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"is_last_page"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"page"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"pages_count"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"limit"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":363}};
    doc.loc.source = {"body":"query getNotifications ($page: Int!){\n    notifications(_limit:20, _page: $page) {\n        text,\n        objectId,\n        objectType,\n        diffForHumans,\n        iconClass,\n        isViewed\n    },\n    paginator(query: \"notifications\"){\n        total_count,\n        is_first_page,\n        is_last_page,\n        page,\n        pages_count,\n        limit\n    }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set(opRefs);
      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports["getNotifications"] = oneQuery(doc, "getNotifications");
        


/***/ }),
/* 863 */
/***/ (function(module, exports, __webpack_require__) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getOrderById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"orders"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrderFragment"},"directives":[]}]}}]}}],"loc":{"start":0,"end":164}};
    doc.loc.source = {"body":"#import \"./../fragments/OrderFragment.graphql\"\r\n\r\nquery getOrderById (\r\n$id: [ID]\r\n) {\r\n    orders (\r\n        id: $id\r\n    ) {\r\n        ...OrderFragment\r\n    }\r\n}\r\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  doc.definitions = doc.definitions.concat(unique(__webpack_require__(50).definitions));


    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set(opRefs);
      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports["getOrderById"] = oneQuery(doc, "getOrderById");
        


/***/ }),
/* 864 */
/***/ (function(module, exports, __webpack_require__) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getStatusById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"statuses"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"ListValue","values":[{"kind":"Variable","name":{"kind":"Name","value":"id"}}]}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"StatusFragment"},"directives":[]}]}}]}}],"loc":{"start":0,"end":139}};
    doc.loc.source = {"body":"#import \"./../fragments/StatusFragment.graphql\"\n\nquery getStatusById($id: ID!){\n    statuses(id: [$id]){\n        ...StatusFragment\n    }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  doc.definitions = doc.definitions.concat(unique(__webpack_require__(105).definitions));


    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set(opRefs);
      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports["getStatusById"] = oneQuery(doc, "getStatusById");
        


/***/ }),
/* 865 */
/***/ (function(module, exports, __webpack_require__) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getCities"},"variableDefinitions":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"statuses"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"StatusFragment"},"directives":[]}]}}]}}],"loc":{"start":0,"end":114}};
    doc.loc.source = {"body":"#import \"./../fragments/StatusFragment.graphql\"\n\nquery getCities{\n    statuses{\n        ...StatusFragment\n    }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  doc.definitions = doc.definitions.concat(unique(__webpack_require__(105).definitions));


    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set(opRefs);
      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports["getCities"] = oneQuery(doc, "getCities");
        


/***/ }),
/* 866 */
/***/ (function(module, exports, __webpack_require__) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getTechcenterById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"imgWidth"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}},"defaultValue":{"kind":"IntValue","value":"50"}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"imgHeight"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}},"defaultValue":{"kind":"IntValue","value":"50"}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"techcenters"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TechcenterFragment"},"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"users"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserFragment"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"width"},"value":{"kind":"Variable","name":{"kind":"Name","value":"imgWidth"}}},{"kind":"Argument","name":{"kind":"Name","value":"height"},"value":{"kind":"Variable","name":{"kind":"Name","value":"imgHeight"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"savePath"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"fullPath"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"originPath"},"arguments":[],"directives":[]}]}}]}}]}}],"loc":{"start":0,"end":391}};
    doc.loc.source = {"body":"#import \"./../fragments/TechcenterFragment.graphql\"\n#import \"./../fragments/UserFragment.graphql\"\n\nquery getTechcenterById ($id: [ID]!, $imgWidth: Int = 50, $imgHeight: Int = 50) {\n  techcenters (id: $id) {\n    ...TechcenterFragment\n    users{\n      ...UserFragment\n    }\n    images(width: $imgWidth, height: $imgHeight) {\n      id\n      savePath\n      fullPath\n      originPath\n    }\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  doc.definitions = doc.definitions.concat(unique(__webpack_require__(79).definitions));
doc.definitions = doc.definitions.concat(unique(__webpack_require__(18).definitions));


    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set(opRefs);
      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports["getTechcenterById"] = oneQuery(doc, "getTechcenterById");
        


/***/ }),
/* 867 */
/***/ (function(module, exports, __webpack_require__) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getUserById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserFragment"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserAdminFragment"},"directives":[]}]}}]}}],"loc":{"start":0,"end":210}};
    doc.loc.source = {"body":"#import \"./../fragments/UserFragment.graphql\"\n#import \"./../fragments/UserAdminFragment.graphql\"\n\nquery getUserById ($id: ID) {\n    user (id: $id) {\n        ...UserFragment\n        ...UserAdminFragment\n    }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  doc.definitions = doc.definitions.concat(unique(__webpack_require__(18).definitions));
doc.definitions = doc.definitions.concat(unique(__webpack_require__(52).definitions));


    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set(opRefs);
      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports["getUserById"] = oneQuery(doc, "getUserById");
        


/***/ }),
/* 868 */
/***/ (function(module, exports) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"logsPage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"page"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"logs"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}},{"kind":"Argument","name":{"kind":"Name","value":"_limit"},"value":{"kind":"IntValue","value":"10"}},{"kind":"Argument","name":{"kind":"Name","value":"_page"},"value":{"kind":"Variable","name":{"kind":"Name","value":"page"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"date"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"diffForHumans"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"text"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"time"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"objectId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"objectType"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"paginator"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"StringValue","value":"logs","block":false}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total_count"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"is_first_page"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"is_last_page"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"page"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"pages_count"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"limit"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":368}};
    doc.loc.source = {"body":"query logsPage ($userId: Int!, $page: Int) {\n    logs (userId: $userId, _limit:10, _page: $page) {\n        id\n        date\n        diffForHumans\n        text\n        time\n        objectId\n        objectType\n    }\n    paginator (query: \"logs\") {\n        total_count,\n        is_first_page,\n        is_last_page,\n        page,\n        pages_count,\n        limit\n    }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set(opRefs);
      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports["logsPage"] = oneQuery(doc, "logsPage");
        


/***/ }),
/* 869 */
/***/ (function(module, exports) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getUserNotificationSettings"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userNotificationsSetting"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"channel"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"action"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"value"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":241}};
    doc.loc.source = {"body":"query getUserNotificationSettings($userId: Int!) {\n    userNotificationsSetting (userId: $userId) {\n        channel {\n            id\n            name\n        }\n        action {\n            id\n            name\n        }\n        value\n    }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set(opRefs);
      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports["getUserNotificationSettings"] = oneQuery(doc, "getUserNotificationSettings");
        


/***/ }),
/* 870 */
/***/ (function(module, exports, __webpack_require__) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getUsers"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"page"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"query"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"_limit"},"value":{"kind":"IntValue","value":"10"}},{"kind":"Argument","name":{"kind":"Name","value":"_page"},"value":{"kind":"Variable","name":{"kind":"Name","value":"page"}}},{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserFragment"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserAdminFragment"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"paginator"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"StringValue","value":"users","block":false}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total_count"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"is_first_page"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"is_last_page"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"page"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"pages_count"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"limit"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":412}};
    doc.loc.source = {"body":"#import \"./../fragments/UserFragment.graphql\"\n#import \"./../fragments/UserAdminFragment.graphql\"\n\nquery getUsers ($page: Int, $query: String) {\n    users (_limit:10, _page: $page, query: $query) {\n        ...UserFragment\n        ...UserAdminFragment\n    }\n    paginator (query: \"users\") {\n        total_count,\n        is_first_page,\n        is_last_page,\n        page,\n        pages_count,\n        limit\n    }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  doc.definitions = doc.definitions.concat(unique(__webpack_require__(18).definitions));
doc.definitions = doc.definitions.concat(unique(__webpack_require__(52).definitions));


    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set(opRefs);
      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports["getUsers"] = oneQuery(doc, "getUsers");
        


/***/ }),
/* 871 */
/***/ (function(module, exports, __webpack_require__) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","variableDefinitions":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserFragment"},"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"permissions"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"roles"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"statuses"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"enabled"},"value":{"kind":"BooleanValue","value":true}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"class"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"code"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"cities"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"_all"},"value":{"kind":"BooleanValue","value":true}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"sort"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"enabled"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"notifications"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"_limit"},"value":{"kind":"IntValue","value":"20"}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"objectId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"objectType"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"diffForHumans"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"iconClass"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"isViewed"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"paginator"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"StringValue","value":"notifications","block":false}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total_count"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"is_first_page"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"is_last_page"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"page"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"pages_count"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"limit"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":658}};
    doc.loc.source = {"body":"#import \"./../fragments/UserFragment.graphql\"\n\nquery {\n    user{\n        ...UserFragment\n        permissions{\n            id\n            name\n        },\n        roles {\n            id\n            name\n        }\n    },\n    statuses(enabled: true){\n        name, class, code, id\n    },\n    cities(_all: true){\n        name, id, sort, enabled\n    },\n    notifications(_limit:20) {\n        text,\n        objectId,\n        objectType,\n        diffForHumans,\n        iconClass,\n        isViewed\n    },\n    paginator(query: \"notifications\"){\n        total_count,\n        is_first_page,\n        is_last_page,\n        page,\n        pages_count,\n        limit\n    }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  doc.definitions = doc.definitions.concat(unique(__webpack_require__(18).definitions));


    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set(opRefs);
      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    


/***/ }),
/* 872 */
/***/ (function(module, exports) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","variableDefinitions":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"notifications"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"_limit"},"value":{"kind":"IntValue","value":"20"}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"objectId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"objectType"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"diffForHumans"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"iconClass"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"isViewed"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"paginator"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"StringValue","value":"notifications","block":false}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total_count"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"is_first_page"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"is_last_page"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"page"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"pages_count"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"limit"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":318}};
    doc.loc.source = {"body":"query {\n    notifications(_limit:20) {\n        text,\n        objectId,\n        objectType,\n        diffForHumans,\n        iconClass,\n        isViewed\n    },\n    paginator(query: \"notifications\"){\n        total_count,\n        is_first_page,\n        is_last_page,\n        page,\n        pages_count,\n        limit\n    }\n}","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set(opRefs);
      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    


/***/ }),
/* 873 */,
/* 874 */,
/* 875 */,
/* 876 */,
/* 877 */,
/* 878 */,
/* 879 */,
/* 880 */,
/* 881 */,
/* 882 */,
/* 883 */,
/* 884 */,
/* 885 */,
/* 886 */,
/* 887 */,
/* 888 */,
/* 889 */,
/* 890 */,
/* 891 */,
/* 892 */,
/* 893 */,
/* 894 */,
/* 895 */,
/* 896 */,
/* 897 */,
/* 898 */,
/* 899 */,
/* 900 */,
/* 901 */,
/* 902 */,
/* 903 */,
/* 904 */,
/* 905 */,
/* 906 */,
/* 907 */,
/* 908 */,
/* 909 */,
/* 910 */,
/* 911 */,
/* 912 */,
/* 913 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(793)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(352),
  /* template */
  __webpack_require__(1012),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 914 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(788)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(353),
  /* template */
  __webpack_require__(996),
  /* scopeId */
  "data-v-0f58d760",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 915 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(798)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(354),
  /* template */
  __webpack_require__(1021),
  /* scopeId */
  "data-v-3082dcd4",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 916 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(355),
  /* template */
  __webpack_require__(1060),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 917 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(357),
  /* template */
  __webpack_require__(991),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 918 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(792)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(358),
  /* template */
  __webpack_require__(1010),
  /* scopeId */
  "data-v-2328522c",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 919 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(359),
  /* template */
  __webpack_require__(1053),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 920 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(360),
  /* template */
  __webpack_require__(1007),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 921 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(361),
  /* template */
  __webpack_require__(1072),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 922 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(362),
  /* template */
  __webpack_require__(1038),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 923 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(363),
  /* template */
  __webpack_require__(1040),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 924 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(364),
  /* template */
  __webpack_require__(1035),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 925 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(365),
  /* template */
  __webpack_require__(1047),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 926 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(366),
  /* template */
  __webpack_require__(1049),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 927 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(367),
  /* template */
  __webpack_require__(1055),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 928 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(368),
  /* template */
  __webpack_require__(1030),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 929 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(369),
  /* template */
  __webpack_require__(1028),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 930 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(370),
  /* template */
  __webpack_require__(1011),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 931 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(371),
  /* template */
  __webpack_require__(998),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 932 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(372),
  /* template */
  __webpack_require__(1004),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 933 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(373),
  /* template */
  __webpack_require__(1061),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 934 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(374),
  /* template */
  __webpack_require__(1029),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 935 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(375),
  /* template */
  __webpack_require__(1066),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 936 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(800)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(376),
  /* template */
  __webpack_require__(1024),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 937 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(377),
  /* template */
  __webpack_require__(1036),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 938 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(378),
  /* template */
  __webpack_require__(1041),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 939 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(379),
  /* template */
  __webpack_require__(1068),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 940 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(380),
  /* template */
  __webpack_require__(1070),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 941 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(381),
  /* template */
  __webpack_require__(1077),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 942 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(389),
  /* template */
  __webpack_require__(1048),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 943 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(390),
  /* template */
  __webpack_require__(1059),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 944 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(799)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(391),
  /* template */
  __webpack_require__(1022),
  /* scopeId */
  "data-v-31069ed2",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 945 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(392),
  /* template */
  __webpack_require__(1052),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 946 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(393),
  /* template */
  __webpack_require__(1027),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 947 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(394),
  /* template */
  __webpack_require__(992),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 948 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(395),
  /* template */
  __webpack_require__(1016),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 949 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(396),
  /* template */
  __webpack_require__(1031),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 950 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(397),
  /* template */
  __webpack_require__(1025),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 951 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(398),
  /* template */
  __webpack_require__(1017),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 952 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  null,
  /* template */
  __webpack_require__(1005),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 953 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(399),
  /* template */
  __webpack_require__(1006),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 954 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(400),
  /* template */
  __webpack_require__(1039),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 955 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(401),
  /* template */
  __webpack_require__(1056),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 956 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(402),
  /* template */
  __webpack_require__(1071),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 957 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(794)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(403),
  /* template */
  __webpack_require__(1013),
  /* scopeId */
  "data-v-269ff54d",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 958 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(404),
  /* template */
  __webpack_require__(1042),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 959 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(405),
  /* template */
  __webpack_require__(1065),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 960 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(406),
  /* template */
  __webpack_require__(997),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 961 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(409),
  /* template */
  __webpack_require__(1076),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 962 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(410),
  /* template */
  __webpack_require__(1051),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 963 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(791)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(411),
  /* template */
  __webpack_require__(1003),
  /* scopeId */
  "data-v-1db223d4",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 964 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(787)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(412),
  /* template */
  __webpack_require__(994),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 965 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(413),
  /* template */
  __webpack_require__(1069),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 966 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(414),
  /* template */
  __webpack_require__(1062),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 967 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(415),
  /* template */
  __webpack_require__(1014),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 968 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(416),
  /* template */
  __webpack_require__(1054),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 969 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(797)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(417),
  /* template */
  __webpack_require__(1019),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 970 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(418),
  /* template */
  __webpack_require__(1020),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 971 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(419),
  /* template */
  __webpack_require__(1009),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 972 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(420),
  /* template */
  __webpack_require__(999),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 973 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(809)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(421),
  /* template */
  __webpack_require__(1043),
  /* scopeId */
  "data-v-68328e8c",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 974 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(815)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(422),
  /* template */
  __webpack_require__(1075),
  /* scopeId */
  "data-v-e3ec391c",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 975 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(795)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(423),
  /* template */
  __webpack_require__(1015),
  /* scopeId */
  "data-v-2c7e89d2",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 976 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(810)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(425),
  /* template */
  __webpack_require__(1058),
  /* scopeId */
  "data-v-8ad757da",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 977 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(805)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(426),
  /* template */
  __webpack_require__(1034),
  /* scopeId */
  "data-v-4d53b953",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 978 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(814)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(427),
  /* template */
  __webpack_require__(1074),
  /* scopeId */
  "data-v-e17cc646",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 979 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(428),
  /* template */
  __webpack_require__(1050),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 980 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(789)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(429),
  /* template */
  __webpack_require__(1000),
  /* scopeId */
  "data-v-1a0204f6",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 981 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(430),
  /* template */
  __webpack_require__(1057),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 982 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(431),
  /* template */
  __webpack_require__(1046),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 983 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(796)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(432),
  /* template */
  __webpack_require__(1018),
  /* scopeId */
  "data-v-2ed59ac4",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 984 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(433),
  /* template */
  __webpack_require__(995),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 985 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(806)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(434),
  /* template */
  __webpack_require__(1037),
  /* scopeId */
  "data-v-53ef41a9",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 986 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(790)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(435),
  /* template */
  __webpack_require__(1001),
  /* scopeId */
  "data-v-1a0bb7a9",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 987 */,
/* 988 */,
/* 989 */,
/* 990 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "status-box"
  }, [_c('div', [(_vm.order.canceled) ? [_c('div', {
    staticClass: "small"
  }, [_vm._v("Заказ отменен")]), _vm._v(" "), _vm._m(0)] : [_c('div', {
    staticClass: "small",
    class: 'text-' + _vm.order.status.class
  }, [_vm._v(_vm._s(_vm.order.status.name))]), _vm._v(" "), _c('div', {
    staticClass: "progress progress-md mt-h mb-1"
  }, [_c('div', {
    staticClass: "progress-bar",
    class: 'bg-' + (_vm.order.problem ? 'danger' : _vm.order.status.class),
    style: ({
      width: _vm.progressBarWidth + '%'
    }),
    attrs: {
      "role": "progressbar",
      "aria-valuenow": "25",
      "aria-valuemin": "0",
      "aria-valuemax": "100"
    }
  })])], _vm._v(" "), _c('div', [(_vm.loading) ? _c('loading', {
    attrs: {
      "size": 2,
      "message": false
    }
  }) : _c('div', {
    staticClass: "btn-group",
    attrs: {
      "role": "group"
    }
  }, _vm._l((_vm.order.transitions), function(transition) {
    return _c('b-btn', {
      key: transition.code,
      attrs: {
        "size": "md",
        "variant": _vm.getTransitionClass(transition),
        "disabled": (transition.code === 'accept' || transition.code === 'acceptFromConfirmed') && !_vm.todayCheck
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          $event.preventDefault();
          _vm.beforeSetOrderTransition(transition)
        }
      }
    }, [_c('span', {
      directives: [{
        name: "b-tooltip",
        rawName: "v-b-tooltip.hover",
        modifiers: {
          "hover": true
        }
      }],
      attrs: {
        "title": (transition.code === 'accept' || transition.code === 'acceptFromConfirmed') && !_vm.todayCheck ? 'В работу можно перевести только заказы на сегодня или просроченные' : ''
      }
    }, [_vm._v("\n                    " + _vm._s(transition.name) + "\n                  ")])])
  }))], 1)], 2), _vm._v(" "), (_vm.showSum) ? _c('div', [(_vm.order.sum) ? _c('div', [_vm._v("Выручка: "), _c('b', {
    staticClass: "text-success"
  }, [_vm._v(_vm._s(_vm.order.sum))]), _vm._v(" "), _c('i', {
    staticClass: "fa fa-rub"
  })]) : _vm._e(), _vm._v(" "), (_vm.order.profit) ? _c('div', [_vm._v("Прибыль: "), _c('b', {
    staticClass: "text-success"
  }, [_vm._v(_vm._s(_vm.order.profit))]), _vm._v(" "), _c('i', {
    staticClass: "fa fa-rub"
  }), _vm._v(" "), (_vm.commission !== -1) ? _c('span', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover",
      modifiers: {
        "hover": true
      }
    }],
    class: {
      'commission-warn': _vm.commission < 10
    },
    attrs: {
      "title": "Рентабельность заказа"
    }
  }, [_vm._v("(" + _vm._s(_vm.commissionShow) + "%)")]) : _vm._e()]) : _vm._e()]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "progress progress-md mt-h mb-1"
  }, [_c('div', {
    staticClass: "progress-bar bg-canceled",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "role": "progressbar",
      "aria-valuenow": "25",
      "aria-valuemin": "0",
      "aria-valuemax": "100"
    }
  })])
}]}

/***/ }),
/* 991 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "app-footer"
  }, [_c('div', {
    staticClass: "float-left"
  }, [_vm._v("\n        © " + _vm._s(new Date().getFullYear()) + " Alarm.ru\n        "), _c('a', {
    staticClass: "btn btn-facebook icon btn-sm",
    attrs: {
      "href": "http://www.facebook.com/alarmcenterru",
      "target": "_blank",
      "type": "button"
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "btn btn-vk icon btn-sm",
    attrs: {
      "href": "http://vk.com/alarmru",
      "type": "button",
      "target": "_blank"
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "btn btn-youtube icon btn-sm",
    attrs: {
      "href": "https://www.youtube.com/c/AlarmcenterRu?sub_confirmation=1",
      "type": "button",
      "target": "_blank"
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "btn btn-instagram icon btn-sm",
    attrs: {
      "href": "https://www.instagram.com/alarm_ru/",
      "type": "button",
      "target": "_blank"
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "btn btn-telegram icon btn-sm",
    attrs: {
      "href": "https://t.me/alarmru",
      "type": "button",
      "target": "_blank"
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://form.asana.com?k=7V8BvVXyrVWqsLOv1fjmhA&d=954381603374797",
      "target": "_blank"
    }
  }, [_vm._v("Замечания и предложения")])]), _vm._v(" "), _vm._m(0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "float-right"
  }, [_c('span', {}, [_vm._v("Отдел продаж   "), _c('i', {
    staticClass: "fa fa-phone"
  }), _vm._v(" +7 903 724-81-17")]), _c('br'), _vm._v(" "), _c('span', {}, [_vm._v("Техподдержка  "), _c('i', {
    staticClass: "fa fa-envelope"
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "mailto:anton@alarm.ru"
    }
  }, [_vm._v("anton@alarm.ru")])])])
}]}

/***/ }),
/* 992 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated fadeIn"
  }, [_c('div', {
    staticClass: "card admin"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_vm._v("\n            Список виртуальных номеров\n            "), _c('div', {
    staticClass: "pull-right",
    staticStyle: {
      "margin-top": "7px"
    }
  }, [_c('button', {
    staticClass: "btn btn-secondary",
    class: {
      active: _vm.showFilter
    },
    attrs: {
      "data-toggle": "dropdown",
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.showFilter = !_vm.showFilter
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-filter"
  }), _vm._v(" Фильтр\n                ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.showModal($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" Добавить виртуальный номер\n                ")])]), _vm._v(" "), (_vm.showFilter) ? _c('div', {
    staticClass: "mt-1"
  }, [_c('div', {
    staticClass: "row col-12"
  }, [_c('form', {
    attrs: {
      "сlass": "form-horizontal"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.search($event)
      }
    }
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-3 form-control-label"
  }, [_vm._v("Номер телефона")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.params.query),
      expression: "params.query"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.params.query)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.params, "query", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-3 form-control-label"
  }, [_vm._v("Город")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.cities,
      "searchable": true,
      "close-on-select": true,
      "show-labels": false,
      "placeholder": "Город не выбран",
      "track-by": "id",
      "label": "name"
    },
    on: {
      "input": _vm.changeCity
    }
  })], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "col-6"
  })]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "card-block admin__list"
  }, [_vm._m(0), _vm._v(" "), (_vm.loading) ? _c('loading', {
    attrs: {
      "message": "Загружаем номера..."
    }
  }) : _vm._l((_vm.items), function(item) {
    return _c('div', {
      staticClass: "row mb-1 admin__list__item admin__list__item_hover-bg-gray"
    }, [_c('div', {
      staticClass: "col-1 d-none d-lg-block"
    }, [_vm._v(_vm._s(item.id))]), _vm._v(" "), _c('div', {
      staticClass: "col-6 col-md-3 col-lg-2"
    }, [_vm._v(_vm._s(item.number))]), _vm._v(" "), _c('div', {
      staticClass: "col-6 col-md-2"
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('div', {
      staticClass: "col-6 col-md-1"
    }, [(item.city) ? _c('span', [_vm._v(_vm._s(item.city.name))]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "col-6 col-md-2"
    }, [_vm._v(_vm._s(item.country))]), _vm._v(" "), _c('div', {
      staticClass: "col-6 col-md-2"
    }, [_vm._v(_vm._s(item.site))]), _vm._v(" "), _c('div', {
      staticClass: "col-6 col-md-2"
    }, [(_vm.blockLoading === item.id) ? _c('loading', {
      attrs: {
        "size": 2,
        "message": false
      }
    }) : [_c('button', {
      staticClass: "btn btn-primary btn-sm",
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.editItem(item)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-edit"
    }), _vm._v(" Изменить\n                        ")])]], 2)])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "card-header"
  }, [_c('b-pagination', {
    staticClass: "mb-0",
    attrs: {
      "size": "md",
      "total-rows": _vm.itemsPage.paginator.total_count,
      "per-page": _vm.itemsPage.paginator.limit
    },
    model: {
      value: (_vm.params.page),
      callback: function($$v) {
        _vm.$set(_vm.params, "page", $$v)
      },
      expression: "params.page"
    }
  })], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row mb-1 text-muted small"
  }, [_c('div', {
    staticClass: "col-1 d-none d-lg-block"
  }, [_vm._v("Id")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-md-3 col-lg-2"
  }, [_vm._v("Номер")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-md-2"
  }, [_vm._v("Название")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-md-1"
  }, [_vm._v("Город")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-md-2"
  }, [_vm._v("Страна")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-md-2"
  }, [_vm._v("Сайт")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-md-2"
  }, [_vm._v("Действие")])])
}]}

/***/ }),
/* 993 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group row",
    class: {
      'has-danger': _vm.error
    }
  }, [_c('label', {
    staticClass: "col-4 col-form-label",
    attrs: {
      "for": _vm.labelId
    }
  }, [_vm._v(_vm._s(_vm.labelText) + "\n    "), (_vm.allowEmpty) ? _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-8"
  }, [_c('vue-multiselect', {
    attrs: {
      "options": _vm.options,
      "multiple": _vm.multiple,
      "searchable": _vm.searchable,
      "allow-empty": _vm.allowEmpty,
      "value": _vm.getSelectedMultiselectByValue(_vm.value, _vm.options, 'value'),
      "placeholder": "Выбрать",
      "selectedLabel": "Выбрано",
      "deselectLabel": "Нажимите для удаления",
      "selectLabel": "Нажимите для выбора",
      "tag-placeholder": "Нажмите Enter для добавления",
      "track-by": _vm.trackBy,
      "label": _vm.label,
      "taggable": _vm.taggable,
      "autocomplete": "off"
    },
    on: {
      "tag": _vm.addTag,
      "remove": _vm.remove,
      "input": _vm.changeValue
    }
  }), _vm._v(" "), (_vm.error) ? _c('span', {
    staticClass: "small help-block text-danger"
  }, [_vm._v(_vm._s(_vm.errorText))]) : _vm._e()], 1)])
},staticRenderFns: []}

/***/ }),
/* 994 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated fadeIn"
  }, [(_vm.loading) ? _c('loading', {
    attrs: {
      "message": "Загружаем информацию о пользователе..."
    }
  }) : _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 col-lg-3"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "row ml-0 mr-0"
  }, [_c('div', {
    staticClass: "card-block text-center col-md-5 col-lg-12"
  }, [_c('div', {
    staticClass: " avatar-box"
  }, [_c('img', {
    staticClass: "img-avatar",
    attrs: {
      "src": _vm.getAvatarPath(_vm.user.avatar)
    },
    on: {
      "click": _vm.toggleShowAvatarModal
    }
  }), _vm._v(" "), _c('avatar-upload', {
    attrs: {
      "field": "avatar",
      "langType": "ru",
      "width": 300,
      "height": 300,
      "url": _vm.getUploadUrl(),
      "headers": _vm.getHeaders(),
      "params": _vm.params,
      "img-format": "png"
    },
    on: {
      "crop-success": _vm.cropSuccess,
      "crop-upload-success": _vm.cropUploadSuccess,
      "crop-upload-fail": _vm.cropUploadFail
    },
    model: {
      value: (_vm.showAvatarModal),
      callback: function($$v) {
        _vm.showAvatarModal = $$v
      },
      expression: "showAvatarModal"
    }
  })], 1), _vm._v(" "), (_vm.user.enabled) ? _c('span', {
    staticClass: "badge badge-success"
  }, [_vm._v("Активен")]) : _c('span', {
    staticClass: "badge badge-danger"
  }, [_vm._v("Заблокирован")]), _vm._v(" "), _c('h4', {
    staticClass: "card-title mb-0"
  }, [_vm._v(_vm._s(_vm.user.fullname))]), _vm._v(" "), _vm._l((_vm.user.roles), function(role) {
    return _c('span', {
      staticClass: "badge badge-warning"
    }, [_vm._v(_vm._s(role.description))])
  }), _vm._v(" "), (_vm.currentUser.isAdmin && _vm.currentUser.id !== _vm.user.id) ? _c('div', {
    staticClass: "mt-1"
  }, [(_vm.blockUserLoading === _vm.user.id) ? _c('loading', {
    attrs: {
      "size": 2,
      "message": false
    }
  }) : [(_vm.user.enabled) ? _c('button', {
    staticClass: "btn btn-danger btn-sm",
    on: {
      "click": function($event) {
        _vm.blockUser(_vm.user, false)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-lock"
  }), _vm._v(" Заблокировать\n                                ")]) : _c('button', {
    staticClass: "btn btn-secondary btn-sm",
    on: {
      "click": function($event) {
        _vm.blockUser(_vm.user, true)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-unlock"
  }), _vm._v(" Разблокировать\n                                ")])]], 2) : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticClass: "card-footer col-md-7 col-lg-12"
  }, [_c('div', {
    staticClass: "mb-1"
  }, [_c('span', {
    staticClass: "text-muted"
  }, [_c('i', {
    staticClass: "fa fa-envelope-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Электронная почта")]), _vm._v(" "), _c('h6', [_vm._v(_vm._s(_vm.user.email))])]), _vm._v(" "), (_vm.user.phone) ? _c('div', {
    staticClass: "mb-1"
  }, [_c('span', {
    staticClass: "text-muted"
  }, [_c('i', {
    staticClass: "fa fa-phone",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Телефон")]), _vm._v(" "), _c('h6', [_vm._v("+7" + _vm._s(_vm.user.phone))])]) : _vm._e(), _vm._v(" "), (_vm.user.skype) ? _c('div', {
    staticClass: "mb-1"
  }, [_c('span', {
    staticClass: "text-muted"
  }, [_c('i', {
    staticClass: "fa fa-skype",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Skype")]), _vm._v(" "), _c('h6', [_vm._v(_vm._s(_vm.user.skype))])]) : _vm._e(), _vm._v(" "), (_vm.user.birthday) ? _c('div', {
    staticClass: "mb-1"
  }, [_c('span', {
    staticClass: "text-muted"
  }, [_c('i', {
    staticClass: "icon-calendar",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" День рождения")]), _vm._v(" "), _c('h6', [_vm._v(_vm._s(_vm.user.birthday))])]) : _vm._e(), _vm._v(" "), (_vm.user.companies.length) ? _c('div', {
    staticClass: "mb-1"
  }, [_c('span', {
    staticClass: "text-muted"
  }, [_c('i', {
    staticClass: "fa fa-building",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Руководитель в компании")]), _vm._v(" "), _vm._l((_vm.user.companies), function(company) {
    return _c('h6', [_vm._v(_vm._s(company.name))])
  })], 2) : _vm._e(), _vm._v(" "), (_vm.user.techcenters.length) ? _c('div', {
    staticClass: "mb-1"
  }, [_c('span', {
    staticClass: "text-muted"
  }, [_c('i', {
    staticClass: "fa fa-building",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Техцентры")]), _vm._v(" "), _vm._l((_vm.user.techcenters), function(techcenter) {
    return _c('h6', [_vm._v(_vm._s(techcenter.city.name) + ", " + _vm._s(techcenter.address))])
  })], 2) : _vm._e()])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-12 col-lg-9"
  }, [_c('b-card', {
    attrs: {
      "no-block": ""
    }
  }, [_c('b-tabs', {
    ref: "tabs",
    attrs: {
      "card": ""
    },
    model: {
      value: (_vm.tabIndex),
      callback: function($$v) {
        _vm.tabIndex = $$v
      },
      expression: "tabIndex"
    }
  }, [_c('b-tab', {
    attrs: {
      "title": "<i class='fa fa-universal-access'></i> <span class='hidden-xs-down'>Активность</span>"
    }
  }, [(_vm.tabIndex === 0) ? _c('timeline', {
    attrs: {
      "user-id": _vm.user.id
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('b-tab', {
    attrs: {
      "title": "<i class='fa fa-user'></i> <span class='hidden-md-down'>Настройки профиля</span>\n                                    <span class='hidden-lg-up hidden-sm-down'>Профиль</span>"
    }
  }, [(_vm.tabIndex === 1) ? _c('profile-settings') : _vm._e()], 1), _vm._v(" "), _c('b-tab', {
    attrs: {
      "title": "<i class='fa fa-bell'></i> <span class='hidden-md-down'>Настройки уведомлений</span>\n                                    <span class='hidden-lg-up hidden-sm-down'>Уведомление</span>"
    }
  }, [(_vm.tabIndex === 2) ? _c('profile-notification-settings', {
    attrs: {
      "user-id": _vm.user.id
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('b-tab', {
    attrs: {
      "title": "<i class='fa fa-lock'></i> <span class='hidden-xs-down'>Безопасность</span>"
    }
  }, [(_vm.tabIndex === 3) ? _c('security') : _vm._e()], 1), _vm._v(" "), _c('b-tab', {
    attrs: {
      "title": "<i class='fa fa-shield'></i> <span class='hidden-xs-down'>Права доступа</span>"
    }
  }, [(_vm.tabIndex === 4) ? _c('permissions', {
    attrs: {
      "user-id": _vm.user.id
    }
  }) : _vm._e()], 1)], 1)], 1)], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 995 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-4 col-form-label"
  }, [_vm._v("Пользователи")]), _vm._v(" "), _c('div', {
    staticClass: "col-8"
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.users,
      "searchable": true,
      "multiple": true,
      "close-on-select": true,
      "show-labels": false,
      "placeholder": _vm.placeholder,
      "track-by": "id",
      "label": "fullname",
      "loading": _vm.loading
    },
    on: {
      "input": _vm.changeUsers,
      "open": _vm.loadUsers
    },
    model: {
      value: (_vm.selectedUsers),
      callback: function($$v) {
        _vm.selectedUsers = $$v
      },
      expression: "selectedUsers"
    }
  }, [_c('span', {
    attrs: {
      "slot": "noResult"
    },
    slot: "noResult"
  }, [_vm._v("Пользователь не найден.")])])], 1)])
},staticRenderFns: []}

/***/ }),
/* 996 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n      +7\n    ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "mask",
      rawName: "v-mask",
      value: ('(###) ###-##-##'),
      expression: "'(###) ###-##-##'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.phone),
      expression: "phone"
    }],
    staticClass: "form-control",
    attrs: {
      "id": _vm.inputId,
      "autocomplete": "off"
    },
    domProps: {
      "value": (_vm.phone)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.phone = $event.target.value
      }, function($event) {
        _vm.$emit('input', _vm.formattedPhone)
      }]
    }
  })]), _vm._v(" "), (_vm.error) ? _c('span', {
    staticClass: "small text-danger",
    class: _vm.advancedErrorClass
  }, [_vm._v("\n    " + _vm._s(_vm.errorText) + "\n  ")]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 997 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.order.clientPhone === '**********') ? _c('div', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover",
      modifiers: {
        "hover": true
      }
    }],
    attrs: {
      "title": "Номер телефона клиента доступен только для заказов в статусе 'В работе'. Если вам необходимо связаться с клиентом, то свяжитесь с ответственным мереджером в отделе продаж"
    }
  }, [(_vm.order.clientPhone) ? _c('span', [_vm._v("+7")]) : _vm._e(), _vm._v(_vm._s(_vm.order.clientPhone) + " " + _vm._s(_vm.order.clientName) + "\n    "), _c('div', {
    staticClass: "small"
  }, [_vm._v("Ответственный " + _vm._s(_vm.order.user.firstname) + " " + _vm._s(_vm.order.user.lastname))])]) : _c('div', [(_vm.order.clientPhone) ? _c('span', [_vm._v("+7")]) : _vm._e(), _vm._v(_vm._s(_vm.order.clientPhone) + " " + _vm._s(_vm.order.clientName) + "\n    "), _c('div', {
    staticClass: "small"
  }, [_vm._v("Ответственный " + _vm._s(_vm.order.user.firstname) + " " + _vm._s(_vm.order.user.lastname))])])
},staticRenderFns: []}

/***/ }),
/* 998 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-modal', {
    attrs: {
      "visible": _vm.showModal === 'problemOrder',
      "lazy": true
    },
    on: {
      "hidden": _vm.hideProblemModal
    }
  }, [_c('div', {
    attrs: {
      "slot": "modal-title"
    },
    slot: "modal-title"
  }, [(_vm.order) ? _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Сообщить о проблеме с заказом № " + _vm._s(_vm.order.id))]) : _vm._e()]), _vm._v(" "), (_vm.loading) ? _c('loading', {
    attrs: {
      "size": 3,
      "message": "Сообщаем о проблеме..."
    }
  }) : _c('form', {
    attrs: {
      "сlass": "form-horizontal"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.problem($event)
      }
    }
  }, [_c('div', {
    staticClass: "form-group",
    class: {
      'has-danger': _vm.$v.text.$error
    }
  }, [_c('label', {
    staticClass: "form-control-label",
    attrs: {
      "for": "cancel-input"
    }
  }, [_vm._v("Описание проблемы")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.text),
      expression: "text"
    }],
    ref: "focusThis",
    staticClass: "form-control",
    attrs: {
      "id": "cancel-input",
      "rows": "4",
      "placeholder": "Подробно опишите почему этот заказ проблемный, например: 'Клиент не приехал в назначенное время', 'Нет оборудования', 'Все занято не можем принять' и т.д."
    },
    domProps: {
      "value": (_vm.text)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.text = $event.target.value
      }, function($event) {
        _vm.$v.text.$touch()
      }]
    }
  }), _vm._v(" "), (_vm.$v.text.$error) ? _c('span', {
    staticClass: "small help-block text-danger"
  }, [_vm._v("Пожалуйста опишите проблему")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "modal-footer"
    },
    slot: "modal-footer"
  }, [(!_vm.loading) ? _c('b-btn', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.hideProblemModal($event)
      }
    }
  }, [_vm._v("Ничего не делать")]) : _vm._e(), _vm._v(" "), (!_vm.loading) ? _c('b-btn', {
    class: {
      'disabled': _vm.$v.text.$invalid
    },
    attrs: {
      "variant": "warning",
      "disabled": _vm.$v.text.$invalid
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.problem($event)
      }
    }
  }, [_vm._v("Сообщить о проблеме")]) : _vm._e()], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 999 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.$route.name === 'Techcenter' || _vm.$route.name === 'TechcenterIframe') ? _c('div', {
    staticClass: "animated fadeIn"
  }, [(_vm.loading) ? _c('loading', {
    attrs: {
      "message": "Загружаем информацию о техцентре..."
    }
  }) : _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('h4', {
    staticClass: "col-8"
  }, [_vm._v(_vm._s(_vm.techcenter.name))]), _vm._v(" "), (_vm.currentUser.isAdmin) ? _c('div', {
    staticClass: "col-4 text-right"
  }, [(_vm.$route.meta.isIframe) ? _c('a', {
    staticClass: "btn btn-primary btn-sm",
    attrs: {
      "href": '/techcenters/edit/' + _vm.techcenter.id
    }
  }, [_c('i', {
    staticClass: "fa fa-edit"
  }), _vm._v(" Изменить\n              ")]) : _c('router-link', {
    staticClass: "btn btn-primary btn-sm",
    attrs: {
      "to": {
        name: 'TechcenterEdit',
        params: {
          id: _vm.techcenter.id
        }
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-edit"
  }), _vm._v(" Изменить\n              ")]), _vm._v(" "), (_vm.loadingBlock) ? _c('div', {
    staticClass: "float-right px-2 pt-q"
  }, [_c('loading', {
    attrs: {
      "message": false,
      "size": 2
    }
  })], 1) : (_vm.techcenter.enabled) ? _c('button', {
    staticClass: "btn btn-danger btn-sm",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.block(!_vm.techcenter.enabled)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-lock"
  }), _vm._v(" Заблокировать\n              ")]) : _c('button', {
    staticClass: "btn btn-success btn-sm",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.block(!_vm.techcenter.enabled)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-unlock"
  }), _vm._v(" Разблокировать\n              ")])], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('span', {
    staticClass: "col-1"
  }, [_vm._v(_vm._s(_vm.techcenter.company.name))]), _vm._v(" "), _c('span', {
    staticClass: "col-10"
  }, [_c('i', {
    staticClass: "fa fa-map-marker"
  }), _vm._v(" Адрес техцентра: " + _vm._s(_vm.techcenter.city.name) + ", " + _vm._s(_vm.techcenter.address) + "\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "col-1 text-right"
  }, [(_vm.techcenter.enabled) ? _c('span', {
    staticClass: "badge badge-success"
  }, [_vm._v("Активен")]) : _c('span', {
    staticClass: "badge badge-danger"
  }, [_vm._v("Заблокирован")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-5 pr-0"
  }, [_c('div', {
    staticClass: "card-block text-left"
  }, [_c('h4', {
    staticClass: "mb-1"
  }, [_c('i', {
    staticClass: "fa fa-phone"
  }), _vm._v(" Номер телефона:\n            "), (_vm.techcenter.phone) ? _c('span', [_vm._v(_vm._s(_vm._f("phoneRuFormatting")(_vm.techcenter.phone)))]) : _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("не указан!")])]), _vm._v(" "), _c('p', {
    staticClass: "card-text mb-1 text-muted"
  }, [_c('i', {
    staticClass: "fa fa-clock-o"
  }), _vm._v("\n            График работы: " + _vm._s(_vm.techcenter.schedule) + "\n          ")]), _vm._v(" "), _c('p', {
    staticClass: "card-text mb-0 text-muted"
  }, [_c('i', {
    staticClass: "fa fa-user"
  }), _vm._v(" Менеджеры:")]), _vm._v(" "), _c('div', {
    staticClass: "mb-1"
  }, _vm._l((_vm.techcenter.users), function(user) {
    return _c('span', {
      staticClass: "badge badge-info"
    }, [(_vm.$route.meta.isIframe) ? _c('span', [_vm._v("\n                 " + _vm._s(user.fullname) + "\n              ")]) : _c('router-link', {
      attrs: {
        "to": {
          name: 'ViewProfile',
          params: {
            id: user.id
          }
        }
      }
    }, [_vm._v("\n                " + _vm._s(user.fullname) + "\n              ")])], 1)
  })), _vm._v(" "), _c('div', [_c('ap-gallery', {
    attrs: {
      "images": _vm.techcenter.images
    }
  })], 1), _vm._v(" "), _c('h5', [_c('i', {
    staticClass: "fa fa-compass"
  }), _vm._v(" Описание проезда")]), _vm._v(" "), _c('a', {
    staticClass: "card-text",
    attrs: {
      "href": _vm.techcenter.link,
      "target": "_blank"
    }
  }, [_vm._v("Схема проезда")]), _vm._v(" "), _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.compiledMarkdown)
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-7 pt-1"
  }, [(_vm.loadingMap) ? _c('loading', {
    attrs: {
      "message": "Загрузка карты"
    }
  }) : _c('div', {
    staticClass: "card-block col-12"
  }, [_c('yandex-map', {
    staticStyle: {
      "width": "100%",
      "height": "400px"
    },
    attrs: {
      "coords": _vm.getCoords(_vm.techcenter.coords),
      "cluster-options": {
        1: {
          clusterDisableClickZoom: true
        }
      },
      "zoom": "15",
      "map-type": "map"
    },
    on: {
      "map-was-initialized": function($event) {}
    }
  }, [_c('ymap-marker', {
    attrs: {
      "marker-id": _vm.techcenter.id,
      "coords": _vm.getCoords(_vm.techcenter.coords),
      "marker-type": "placemark",
      "cluster-name": "1"
    }
  })], 1)], 1)], 1)])]), _vm._v(" "), (!_vm.loading) ? _c('TcOrdersList', {
    attrs: {
      "techcenter-id": _vm.$route.params.id
    }
  }) : _vm._e()], 1) : _c('router-view')
},staticRenderFns: []}

/***/ }),
/* 1000 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row pt-1 pb-1 pr-1 partnership-block"
  }, [_c('div', {
    staticClass: "col-4"
  }, [_vm._v("Условия сотрудничеста")]), _vm._v(" "), _c('div', {
    staticClass: "col-8 form-group"
  }, [_c('div', {
    staticClass: "row pb-1"
  }, [_c('div', {
    staticClass: "col-8"
  }, [_vm._v("От установки")]), _vm._v(" "), _c('div', {
    staticClass: "input-group col-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.partnership.commissionInstall),
      expression: "partnership.commissionInstall"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.partnership.commissionInstall)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.partnership, "commissionInstall", $event.target.value)
      }, function($event) {
        _vm.changePartnership()
      }]
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n          %\n        ")])])]), _vm._v(" "), _c('div', {
    staticClass: "row pb-1"
  }, [_c('div', {
    staticClass: "col-8"
  }, [_vm._v("От рекламации")]), _vm._v(" "), _c('div', {
    staticClass: "input-group col-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.partnership.commissionReclamation),
      expression: "partnership.commissionReclamation"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.partnership.commissionReclamation)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.partnership, "commissionReclamation", $event.target.value)
      }, function($event) {
        _vm.changePartnership()
      }]
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n          %\n        ")])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-8"
  }, [_vm._v("От продажи в розницу")]), _vm._v(" "), _c('div', {
    staticClass: "input-group col-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.partnership.commissionRetail),
      expression: "partnership.commissionRetail"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.partnership.commissionRetail)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.partnership, "commissionRetail", $event.target.value)
      }, function($event) {
        _vm.changePartnership()
      }]
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n          %\n        ")])])])])])
},staticRenderFns: []}

/***/ }),
/* 1001 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-12 col-form-label",
    attrs: {
      "for": "inputTransitDescription"
    }
  }, [_vm._v("Описание техцентра")]), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_c('mavon-editor', {
    attrs: {
      "id": "inputTransitDescription",
      "toolbars": _vm.toolbars,
      "language": "ru"
    },
    on: {
      "input": function($event) {
        _vm.$emit('input', _vm.text)
      }
    },
    model: {
      value: (_vm.text),
      callback: function($$v) {
        _vm.text = $$v
      },
      expression: "text"
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),
/* 1002 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('h6', {
    staticClass: "card-title mb-0"
  }, [_vm._v("Комментарии к заказу")]), _vm._v(" "), (_vm.order.canOrderViewComments) ? [(_vm.loading) ? _c('loading', {
    attrs: {
      "message": "Загружаем комментари..."
    }
  }) : _c('div', {
    staticClass: "chat-box"
  }, [(_vm.comments && _vm.comments.length > 0) ? _c('ul', {
    staticClass: "chat-list"
  }, [_vm._l((_vm.comments), function(comment, index) {
    return [(comment.user.id === _vm.user.id) ? _c('li', {
      staticClass: "chat-item odd"
    }, [_c('div', {
      staticClass: "chat-content"
    }, [(_vm.firstCommentUser(comment.user, index)) ? [_c('h5', [_vm._v("Вы")]), _vm._v(" "), _c('div', {
      staticClass: "small chat-diff-for-hummans"
    }, [_vm._v(_vm._s(comment.diffForHumans) + " - " + _vm._s(comment.date))])] : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "box bg-light-inverse"
    }, [_vm._v(_vm._s(comment.text))])], 2), _vm._v(" "), _c('div', {
      staticClass: "chat-time"
    }, [_vm._v(_vm._s(comment.time))])]) : _c('li', {
      staticClass: "chat-item",
      class: {
        'chat-new': !comment.isViewed
      }
    }, [_c('div', {
      staticClass: "chat-img"
    }, [_c('img', {
      attrs: {
        "src": _vm.getAvatarPath(comment.user.avatar),
        "alt": "user"
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "chat-content"
    }, [_c('h5', [_vm._v(_vm._s(comment.user.fullname))]), _vm._v(" "), _c('div', {
      staticClass: "small chat-diff-for-hummans"
    }, [_vm._v(_vm._s(comment.diffForHumans) + " - " + _vm._s(comment.date) + " ")]), _vm._v(" "), _c('div', {
      staticClass: "box bg-light-info"
    }, [_vm._v(_vm._s(comment.text))])]), _vm._v(" "), _c('div', {
      staticClass: "chat-time"
    }, [_vm._v(_vm._s(comment.time))])])]
  })], 2) : _c('div', {
    staticClass: "alert alert-warning mt-2"
  }, [_vm._v("\n                Пока никто не оставлял комментарии.\n            ")])])] : _c('div', {
    staticClass: "alert alert-warning mt-1"
  }, [_vm._v("\n            У вас недостаточно прав доступа для просмотра комментариев к этому заказу.\n        ")])], 2), _vm._v(" "), (_vm.order.canOrderAddComments) ? _c('div', {
    staticClass: "card-footer"
  }, [(_vm.sendLoading) ? _c('loading', {
    attrs: {
      "size": 2,
      "message": false
    }
  }) : _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.beforeSend($event)
      }
    }
  }, [_c('div', {
    staticClass: "input-group",
    class: {
      'has-danger': _vm.$v.commentText.$error
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.commentText),
      expression: "commentText",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Введите текст комментария",
      "autofocus": ""
    },
    domProps: {
      "value": (_vm.commentText)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.commentText = $event.target.value.trim()
      }, function($event) {
        _vm.$v.commentText.$touch()
      }],
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn btn-success",
    class: {
      'disabled': _vm.$v.commentText.$invalid
    },
    attrs: {
      "disabled": _vm.$v.commentText.$invalid,
      "type": "submit"
    }
  }, [_vm._v("Опубликовать")])])]), _vm._v(" "), (_vm.$v.commentText.$error) ? _c('span', {
    staticClass: "small help-block text-danger"
  }, [_vm._v("Минимальна длинна комментария " + _vm._s(_vm.$v.commentText.$params.minLength.min) + " символа")]) : _vm._e()])], 1) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 1003 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.$route.name === 'Order' || _vm.$route.name === 'OrderIframe') ? _c('div', {
    staticClass: "animated fadeIn"
  }, [(_vm.loading) ? _c('loading', {
    attrs: {
      "message": "Загружаем информацию о заказе..."
    }
  }) : _c('div', {
    staticClass: "order-view"
  }, [_c('h3', {
    staticClass: "mb-2 h3"
  }, [_vm._v("Заказ №" + _vm._s(_vm.order.id) + " - " + _vm._s(_vm.order.description))]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-block order-view__block order-view__block--bordered"
  }, [_c('order-status', {
    attrs: {
      "order": _vm.order,
      "showSum": false
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "card-block order-view__block order-view__block--bordered"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-5 text-muted"
  }, [_vm._v("Дата")]), _vm._v(" "), _c('div', {
    staticClass: "col-7"
  }, [_vm._v(_vm._s(_vm.order.date))])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-5 text-muted"
  }, [_vm._v("Время")]), _vm._v(" "), _c('div', {
    staticClass: "col-7"
  }, [_vm._v(_vm._s(_vm.order.time))])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-5 text-muted"
  }, [_vm._v("Город")]), _vm._v(" "), _c('div', {
    staticClass: "col-7"
  }, [_vm._v(_vm._s(_vm.order.techcenter.city.name))])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-5 text-muted"
  }, [_vm._v("Адрес")]), _vm._v(" "), _c('div', {
    staticClass: "col-7"
  }, [_vm._v(_vm._s(_vm.order.techcenter.address))])])]), _vm._v(" "), _c('div', {
    staticClass: "card-block order-view__block order-view__block--bordered"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-5 text-muted"
  }, [_vm._v("Клиент")]), _vm._v(" "), _c('div', {
    staticClass: "col-7"
  }, [_vm._v(_vm._s(_vm.order.clientName))])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-5 text-muted"
  }, [_vm._v("\n                Телефон\n                "), (_vm.order.clientPhone === '**********') ? _c('span', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover",
      modifiers: {
        "hover": true
      }
    }],
    staticClass: "text-danger",
    attrs: {
      "title": "Номер телефона клиента открывается за 1 час до приезде клиента, а также доступен при статусе 'В работе'. Если вам необходимо связаться с клиентом, то свяжитесь с ответственным мереджером в отделе продаж"
    }
  }, [_c('i', {
    staticClass: "fa fa-exclamation-triangle"
  })]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-7"
  }, [_vm._v("+7" + _vm._s(_vm.order.clientPhone))])])]), _vm._v(" "), _c('div', {
    staticClass: "card-block order-view__block"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-5 text-muted"
  }, [_vm._v("Ответственный")]), _vm._v(" "), _c('div', {
    staticClass: "col-7"
  }, [_vm._v(_vm._s(_vm.order.user.firstname) + "\n                " + _vm._s(_vm.order.user.lastname) + "\n              ")])]), _vm._v(" "), (_vm.order.sum) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-5 text-muted"
  }, [_vm._v("Сумма по заказ-наряду")]), _vm._v(" "), _c('div', {
    staticClass: "col-7"
  }, [_vm._v(_vm._s(_vm.order.sum) + " "), _c('i', {
    staticClass: "fa fa-rub"
  })])]) : _vm._e(), _vm._v(" "), (_vm.order.profit) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-5 text-muted"
  }, [_vm._v("Комиссия")]), _vm._v(" "), _c('div', {
    staticClass: "col-7"
  }, [_vm._v(_vm._s(_vm.order.profit) + " "), _c('i', {
    staticClass: "fa fa-rub"
  })])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-5 text-muted"
  }, [_vm._v("Создан")]), _vm._v(" "), _c('div', {
    staticClass: "col-7"
  }, [_vm._v(_vm._s(_vm.order.created))])]), _vm._v(" "), (_vm.order.amoId && !_vm.$route.meta.isIframe) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-5 text-muted"
  }, [_vm._v("Id в amoCRM")]), _vm._v(" "), _c('div', {
    staticClass: "col-7"
  }, [_c('a', {
    attrs: {
      "href": 'https://alarmru.amocrm.ru/leads/detail/' + _vm.order.amoId,
      "target": "_blank"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.order.amoId) + "\n                ")])])]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('comments', {
    attrs: {
      "order": _vm.order
    }
  }), _vm._v(" "), _c('order-history', {
    attrs: {
      "order": _vm.order
    }
  })], 1)])])], 1) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 1004 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.transition) ? _c('b-modal', {
    attrs: {
      "visible": _vm.showModal === 'transitionOrderConfirm',
      "lazy": true
    },
    on: {
      "show": _vm.initModal,
      "hidden": _vm.hideModal
    }
  }, [_c('div', {
    attrs: {
      "slot": "modal-title"
    },
    slot: "modal-title"
  }, [(_vm.order) ? _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Подтвердите действие для заказа №" + _vm._s(_vm.order.id))]) : _vm._e()]), _vm._v(" "), (_vm.loading) ? _c('loading', {
    attrs: {
      "size": 3,
      "message": "Подождите..."
    }
  }) : _c('div', [_c('div', {
    staticClass: "alert alert-warning"
  }, [_c('h3', [_vm._v(_vm._s(_vm.transition.name) + "?")]), _vm._v(" "), (_vm.transition.code == 'accept') ? _c('span', [_vm._v("\n                Укажите предполагаемую сумму заказ-наряда.\n            ")]) : _vm._e(), _vm._v(" "), (_vm.transition.code == 'complete') ? _c('span', [_vm._v("\n                Подтвердите сумму заказ-наряда которую заплатил клиент.\n            ")]) : _vm._e(), _vm._v(" "), (_vm.transition.code == 'calculate') ? _c('span', [_vm._v("\n                Заполните данные. Они необходимы для расчетов.\n            ")]) : _vm._e()]), _vm._v(" "), (_vm.transition.code === 'accept' || _vm.transition.code === 'complete' || _vm.transition.code == 'calculate') ? _c('form', {
    attrs: {
      "сlass": "form-horizontal"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.setTransition($event)
      }
    }
  }, [_c('div', {
    staticClass: "form-group row",
    class: {
      'has-danger': _vm.$v.sum.$error
    }
  }, [_c('label', {
    staticClass: "col-6 form-control-label",
    attrs: {
      "for": "sum-input"
    }
  }, [_vm._v("Общая сумма заказ-наряда")]), _vm._v(" "), _c('div', {
    staticClass: "col-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sum),
      expression: "sum"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "rel": "focusThis",
      "id": "sum-input",
      "placeholder": "Сумма по заказ-наряду"
    },
    domProps: {
      "value": (_vm.sum)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.sum = $event.target.value
      }, function($event) {
        _vm.$v.sum.$touch()
      }]
    }
  }), _vm._v(" "), (_vm.$v.sum.$error) ? _c('span', {
    staticClass: "small help-block text-danger"
  }, [_vm._v("Сумма заказ-наряда дожна быть больше 0")]) : _vm._e()])]), _vm._v(" "), (_vm.transition.code === 'calculate') ? _c('div', {
    staticClass: "form-group row",
    class: {
      'has-danger': _vm.$v.profit.$error
    }
  }, [_c('label', {
    staticClass: "col-6 form-control-label",
    attrs: {
      "for": "profit-input"
    }
  }, [_vm._v("Комиссия с заказа")]), _vm._v(" "), _c('div', {
    staticClass: "col-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profit),
      expression: "profit"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "id": "profit-input",
      "placeholder": "Комиссия по заказ-наряду"
    },
    domProps: {
      "value": (_vm.profit)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.profit = $event.target.value
      }, function($event) {
        _vm.$v.profit.$touch()
      }]
    }
  }), _vm._v(" "), (_vm.$v.profit.$error) ? _c('span', {
    staticClass: "small help-block text-danger"
  }, [_vm._v("Комиссия должна быть больше 0")]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.transition.code === 'calculate') ? _c('div', {
    staticClass: "form-group row",
    class: {
      'has-danger': _vm.$v.comment.$error
    }
  }, [_c('label', {
    staticClass: "col-12 form-control-label",
    attrs: {
      "for": "comment-input"
    }
  }, [_vm._v("Как был сделан расчет (прикрепится комментарий к заказу)")]), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.comment),
      expression: "comment"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "comment-input",
      "placeholder": "Пожалуйста распишите как можно подробнее как был произведен расчет, стоимость закупки оборудования, работы установщика и т.д.",
      "rows": "4"
    },
    domProps: {
      "value": (_vm.comment)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.comment = $event.target.value
      }, function($event) {
        _vm.$v.comment.$touch()
      }]
    }
  }), _vm._v(" "), (_vm.$v.comment.$error) ? _c('span', {
    staticClass: "small help-block text-danger"
  }, [_vm._v("Описание обязательно должно быть заполнено")]) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('button', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "submit"
    }
  })]) : _vm._e()]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "modal-footer"
    },
    slot: "modal-footer"
  }, [(!_vm.loading) ? _c('b-btn', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.hideModal($event)
      }
    }
  }, [_vm._v("Ничего не делать")]) : _vm._e(), _vm._v(" "), (!_vm.loading) ? _c('b-btn', {
    class: _vm.transition.class,
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.setTransition($event)
      }
    }
  }, [_vm._v("Подтвердить")]) : _vm._e()], 1)], 1) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 1005 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row justify-content-center animated fadeInRight"
  }, [_c('div', {
    staticClass: "col-lg-6 col-md-8 col-sm-12"
  }, [_c('div', {
    staticClass: "card-group mb-0"
  }, [_c('div', {
    staticClass: "card p-4"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('h1', [_vm._v("Проверьте почту")]), _vm._v(" "), _c('div', {
    staticClass: "alert alert-success"
  }, [_vm._v("\n                        На ваш адрес электронной почты был выслана ссылка для сброса пароля. Пожалуйста откройте письмо и перейдите по ней.\n                        Если письма нет, проверьте папку \"спам\". В ином случае обратитесь к администратору.\n                    ")]), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-primary",
    attrs: {
      "to": {
        name: 'Auth'
      }
    }
  }, [_vm._v("Вернуться к странице авторизации")])], 1)])])])])
},staticRenderFns: []}

/***/ }),
/* 1006 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row justify-content-center animated fadeInDown"
  }, [(_vm.loading) ? _c('loading', {
    attrs: {
      "message": "Авторизирую..."
    }
  }) : _c('form', {
    staticClass: "col-lg-5 col-md-8 col-sm-12",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.handleLoginFormSubmit()
      }
    }
  }, [_c('div', {
    staticClass: "card-group mb-0"
  }, [_c('div', {
    staticClass: "card p-4"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('h1', [_vm._v("Войти в Аларм План")]), _vm._v(" "), _c('p', {
    staticClass: "text-muted"
  }, [_vm._v("Войдите в свой аккаунт")]), _vm._v(" "), _c('div', {
    staticClass: "mb-1"
  }, [_c('div', {
    staticClass: "input-group",
    class: {
      'has-danger': _vm.error || _vm.$v.login.email.$error
    }
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "fa fa-envelope"
  })]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.login.email),
      expression: "login.email"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "email",
      "type": "email",
      "required": "",
      "autofocus": "",
      "placeholder": "Электронная почта"
    },
    domProps: {
      "value": (_vm.login.email)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.login, "email", $event.target.value)
      }, function($event) {
        _vm.$v.login.email.$touch()
      }]
    }
  })]), _vm._v(" "), (_vm.error) ? _c('small', {
    staticClass: "help-block text-danger"
  }, [_vm._v("Ошибка авторизации")]) : _vm._e(), _vm._v(" "), (_vm.$v.login.email.$error) ? _c('small', {
    staticClass: "help-block text-danger"
  }, [_vm._v("Укажите валидный адрес электронной почты")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "mb-1"
  }, [_c('div', {
    staticClass: "input-group",
    class: {
      'has-danger': _vm.error || _vm.$v.login.password.$error
    }
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "icon-lock"
  })]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.login.password),
      expression: "login.password"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "password",
      "type": "password",
      "required": "",
      "placeholder": "Пароль"
    },
    domProps: {
      "value": (_vm.login.password)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.login, "password", $event.target.value)
      }, function($event) {
        _vm.$v.login.password.$touch()
      }]
    }
  })]), _vm._v(" "), (_vm.error) ? _c('small', {
    staticClass: "help-block text-danger"
  }, [_vm._v("Неправильный email или пароль")]) : _vm._e(), _vm._v(" "), (_vm.$v.login.password.$error) ? _c('small', {
    staticClass: "help-block text-danger"
  }, [_vm._v("Пароль должен быть не менее 6 символов")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "input-group mb-1"
  }, [_c('label', {
    staticClass: "switch switch-text switch-primary-outline-alt mr-1"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.login.remember),
      expression: "login.remember"
    }],
    staticClass: "switch-input",
    attrs: {
      "type": "checkbox",
      "checked": ""
    },
    domProps: {
      "checked": Array.isArray(_vm.login.remember) ? _vm._i(_vm.login.remember, null) > -1 : (_vm.login.remember)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.login.remember,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.login.remember = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.login.remember = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.login, "remember", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-label",
    attrs: {
      "data-on": "On",
      "data-off": "Off"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-handle"
  })]), _vm._v("\n                        Запомнить меня\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "row mb-2"
  }, [_c('div', {
    staticClass: "col-6"
  }, [_c('button', {
    staticClass: "btn btn-primary px-4",
    class: {
      'disabled': _vm.$v.login.$invalid
    },
    attrs: {
      "disabled": _vm.$v.login.$invalid,
      "type": "submit"
    }
  }, [_vm._v("Войти")])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 text-right"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'RemindPassword'
      }
    }
  }, [_vm._v("Забыли пароль?")])], 1)])])])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 1007 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-center loader"
  }, [_c('div', {
    staticClass: "loader__icon"
  }), _vm._v(" "), (_vm.message) ? _c('div', {
    staticClass: "loader__message",
    staticStyle: {
      "width": "100%",
      "font-size": "1rem!important"
    }
  }, [_vm._v("\n        " + _vm._s(_vm.message) + "\n    ")]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 1008 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "admin__list"
  }, [_c('div', {
    staticClass: "row mb-1 small text-muted"
  }, [_c('div', {
    staticClass: "col-1 d-none d-md-block"
  }, [_vm._v("Id")]), _vm._v(" "), _vm._t("headerList")], 2), _vm._v(" "), (_vm.loading) ? _c('loading', {
    attrs: {
      "message": "Загружаем ..."
    }
  }) : _vm._l((_vm.items), function(item) {
    return _c('div', {
      key: item.id,
      staticClass: "row mb-1 admin__list__item admin__list__item_hover-bg-gray"
    }, [_c('div', {
      staticClass: "col-1 d-none d-md-block"
    }, [_vm._v("\n      " + _vm._s(item.id) + "\n    ")]), _vm._v(" "), _vm._t("default", null, {
      item: item
    })], 2)
  })], 2)
},staticRenderFns: []}

/***/ }),
/* 1009 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.$route.name === 'Techcenters') ? _c('div', [_c('admin-filter', {
    model: {
      value: (_vm.filterParams),
      callback: function($$v) {
        _vm.filterParams = $$v
      },
      expression: "filterParams"
    }
  }), _vm._v(" "), _c('admin-card', [_c('template', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v("\n      Список техцентров\n      "), (_vm.currentUser.hasPermission('techcenter.add')) ? _c('router-link', {
    staticClass: "pull-right btn btn-primary btn-sm",
    attrs: {
      "to": {
        name: 'TechcenterCreate'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" Добавить\n      ")]) : _vm._e()], 1), _vm._v(" "), _c('admin-list', {
    attrs: {
      "items": _vm.items,
      "loading": _vm.loading
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var item = ref.item;

        return [_c('div', {
          staticClass: "col-12 col-md-6 col-lg-2"
        }, [_c('router-link', {
          attrs: {
            "to": {
              name: 'Techcenter',
              params: {
                id: item.id
              }
            }
          }
        }, [_vm._v(_vm._s(item.name))])], 1), _vm._v(" "), _c('div', {
          staticClass: "col-12 col-md-6 col-lg-1"
        }, [_vm._v(_vm._s(item.company.name))]), _vm._v(" "), _c('div', {
          staticClass: "col-12 col-md-6 col-lg-1"
        }, [_vm._v(_vm._s(item.city.name))]), _vm._v(" "), _c('div', {
          staticClass: "col-12 col-md-6 col-lg-1"
        }, [_vm._v("\n          " + _vm._s(item.address)), _c('br'), _vm._v(" "), _c('small', [_c('a', {
          attrs: {
            "href": item.link,
            "target": "_blank"
          }
        }, [_vm._v("Схема проезда")])]), _vm._v(" "), _c('small', {
          staticClass: "text-muted"
        }, [_vm._v("Часовой пояс +" + _vm._s(item.tzOffset))])]), _vm._v(" "), _c('div', {
          staticClass: "col-2 col-md-6 col-lg-1"
        }, _vm._l((item.users), function(user, index) {
          return _c('span', {
            staticClass: "badge badge-info"
          }, [_c('router-link', {
            attrs: {
              "to": {
                name: 'ViewProfile',
                params: {
                  id: user.id
                }
              }
            }
          }, [_vm._v(_vm._s(user.fullname))])], 1)
        })), _vm._v(" "), _c('div', {
          staticClass: "col-12 col-md-6 col-lg-1"
        }, [_vm._v(_vm._s(item.schedule))]), _vm._v(" "), _c('div', {
          staticClass: "col-12 col-md-6 col-lg-1"
        }, [_c('small', [_vm._v(_vm._s(_vm._f("phoneRuFormatting")(item.phone)))])]), _vm._v(" "), _c('div', {
          staticClass: "col-12 col-md-6 col-lg-1"
        }, [(item.enabled) ? _c('span', {
          staticClass: "badge badge-success"
        }, [_vm._v("Активен")]) : _c('span', {
          staticClass: "badge badge-danger"
        }, [_vm._v("Заблокирован")])]), _vm._v(" "), _c('div', {
          staticClass: "col-12 col-md-6 col-lg-2"
        }, [(_vm.blockLoading === item.id) ? _c('loading', {
          attrs: {
            "size": 2,
            "message": false
          }
        }) : [(_vm.currentUser.hasPermission('techcenter.update')) ? _c('router-link', {
          staticClass: "btn btn-primary btn-sm",
          attrs: {
            "to": {
              name: 'TechcenterEdit',
              params: {
                id: item.id
              }
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-edit"
        }), _vm._v(" Изменить\n            ")]) : _vm._e(), _vm._v(" "), (_vm.currentUser.isAdmin) ? [(item.enabled) ? _c('button', {
          staticClass: "btn btn-danger btn-sm",
          on: {
            "click": function($event) {
              _vm.block(item, false)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-lock"
        }), _vm._v(" Заблокировать\n              ")]) : _c('button', {
          staticClass: "btn btn-secondary btn-sm",
          on: {
            "click": function($event) {
              _vm.block(item, true)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-unlock"
        }), _vm._v(" Разблокировать\n              ")])] : _vm._e()]], 2)]
      }
    }])
  }, [_c('template', {
    attrs: {
      "slot": "headerList"
    },
    slot: "headerList"
  }, [_c('div', {
    staticClass: "col-6 col-lg-2 d-none d-md-block"
  }, [_vm._v("Название")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-lg-1 d-none d-md-block"
  }, [_vm._v("Компания")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-lg-1 d-none d-md-block"
  }, [_vm._v("Город")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-lg-1 d-none d-md-block"
  }, [_vm._v("Адрес")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-lg-1 d-none d-md-block"
  }, [_vm._v("Пользователи")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-lg-1 d-none d-md-block"
  }, [_vm._v("График работы")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-lg-1 d-none d-md-block"
  }, [_vm._v("Номер телефона")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-lg-1 d-none d-md-block"
  }, [_vm._v("Активность")]), _vm._v(" "), _c('div', {
    staticClass: "col-2 d-none d-lg-block"
  }, [_vm._v("Действие")]), _vm._v(" "), _c('div', {
    staticClass: "col-12 d-md-none"
  }, [_vm._v("Общая информация")])])], 2), _vm._v(" "), _c('template', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('admin-pagination', {
    attrs: {
      "paginator": _vm.itemsPage.paginator
    },
    model: {
      value: (_vm.page),
      callback: function($$v) {
        _vm.page = $$v
      },
      expression: "page"
    }
  })], 1)], 2)], 1) : _c('router-view')
},staticRenderFns: []}

/***/ }),
/* 1010 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('navbar', [_c('button', {
    staticClass: "navbar-toggler mobile-sidebar-toggler hidden-lg-up",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.mobileSidebarToggle
    }
  }, [_vm._v("☰")]), _vm._v(" "), _c('a', {
    staticClass: "navbar-brand hidden-md-down",
    attrs: {
      "href": "#"
    }
  }), _vm._v(" "), _c('ul', {
    staticClass: "nav navbar-nav hidden-md-down"
  }, [_c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link navbar-toggler sidebar-toggler",
    attrs: {
      "href": "#"
    },
    on: {
      "click": _vm.sidebarToggle
    }
  }, [_vm._v("☰")])])]), _vm._v(" "), _c('header-search-input'), _vm._v(" "), _c('ul', {
    staticClass: "nav navbar-nav ml-auto"
  }, [(_vm.user.hasPermission('order.add')) ? _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.ModalEditOrder",
      modifiers: {
        "ModalEditOrder": true
      }
    }],
    staticClass: "nav-link add-order-link",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus px-1"
  }), _vm._v(" "), _c('span', {
    staticClass: "hidden-sm-down"
  }, [_vm._v("Добавить заказ")])])]) : _vm._e(), _vm._v(" "), _c('li', {
    staticClass: "nav-item dropdown d-md-down-none show"
  }, [_c('a', {
    staticClass: "nav-link nav-link",
    attrs: {
      "data-toggle": "dropdown",
      "href": "#",
      "role": "button",
      "aria-haspopup": "true",
      "aria-expanded": "true"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.showNotifications = !_vm.showNotifications
      }
    }
  }, [_c('i', {
    staticClass: "icon-bell"
  }), _vm._v(" "), (_vm.paginator.totalCount) ? _c('span', {
    staticClass: "badge badge-pill badge-warning"
  }, [_vm._v(_vm._s(_vm.paginator.totalCount))]) : _vm._e()]), _vm._v(" "), (_vm.showNotifications) ? _c('div', {
    staticClass: "dropdown-menu dropdown-menu-right dropdown-menu-lg"
  }, [_c('div', {
    staticClass: "dropdown-header text-center"
  }, [(_vm.paginator.totalCount) ? _c('strong', [_vm._v("У вас " + _vm._s(_vm.paginator.totalCount) + " непрочитанных уведомлений")]) : _c('strong', [_vm._v("У вас нет непрочитанных уведомлений")])]), _vm._v(" "), _c('div', {
    staticClass: "infinity-loading"
  }, [_vm._l((_vm.notifications), function(notification) {
    return _c('a', {
      key: notification.id,
      staticClass: "dropdown-item",
      class: {
        'bg-light-warning': !notification.isViewed
      },
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.showOrderDetail(notification.objectId)
        }
      }
    }, [_c('i', {
      class: notification.iconClass
    }), _vm._v(" "), _c('span', {
      staticClass: "small"
    }, [_vm._v(_vm._s(notification.diffForHumans))]), _vm._v("\n                    " + _vm._s(notification.text) + "\n                ")])
  }), _vm._v(" "), _c('infinite-loading', {
    ref: "notificationsLoading",
    on: {
      "infinite": _vm.infiniteHandler
    }
  }, [_c('span', {
    attrs: {
      "slot": "spinner"
    },
    slot: "spinner"
  }, [_c('div', {
    staticClass: "mt-1 mb-1"
  }, [_c('loading', {
    attrs: {
      "size": 2,
      "message": "Загружаем уведомления..."
    }
  })], 1)]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "no-more"
    },
    slot: "no-more"
  }, [_vm._v("Уведомлений больше нет :)")])])], 2), _vm._v(" "), (_vm.paginator.totalCount) ? _c('div', {
    staticClass: "dropdown-header text-center cursor-pointer",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.markAllAsViewed($event)
      }
    }
  }, [(_vm.loadingMarkAsRead) ? _c('loading', {
    attrs: {
      "size": 2,
      "message": false
    }
  }) : _c('strong', [_vm._v("Отметить все как прочитанные")])], 1) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('b-dropdown', {
    attrs: {
      "id": "profile-dropdown",
      "variant": "link"
    }
  }, [_c('span', {
    attrs: {
      "slot": "button-content"
    },
    slot: "button-content"
  }, [_c('img', {
    staticClass: "img-avatar",
    attrs: {
      "src": _vm.getAvatarPath(_vm.user.avatar)
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "hidden-md-down"
  }, [_vm._v(_vm._s(_vm._f("truncate")(_vm.user.firstname, 12)))])]), _vm._v(" "), _c('b-dropdown-item', {
    attrs: {
      "aria-describedby": "profile"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.goToProfile($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-user"
  }), _vm._v(" Профиль\n            ")]), _vm._v(" "), _c('b-dropdown-item', {
    attrs: {
      "aria-describedby": "header1"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.logout($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-lock"
  }), _vm._v(" Выйти")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1011 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-modal', {
    ref: "ModalEditOrder",
    attrs: {
      "id": "ModalEditOrder",
      "size": "lg",
      "centered": ""
    },
    on: {
      "hidden": _vm.modalHasBeenHidden,
      "shown": _vm.initEditOrder
    }
  }, [_c('div', {
    attrs: {
      "slot": "modal-title"
    },
    slot: "modal-title"
  }, [(_vm.order) ? _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Изменить заказ № " + _vm._s(_vm.order.id))]) : _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Новый заказ")])]), _vm._v(" "), (_vm.loading) ? _c('loading', {
    attrs: {
      "size": 3,
      "message": "Сохраняем..."
    }
  }) : _c('form', {
    attrs: {
      "сlass": "form-horizontal"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group col-6 col-md-2",
    class: {
      'has-danger': _vm.$v.newOrderData.orderDate.$error
    }
  }, [_c('datepicker', {
    attrs: {
      "format": "dd/MM/yyyy",
      "lang": "ru",
      "tabindex": 1
    },
    on: {
      "input": function($event) {
        _vm.$v.newOrderData.orderDate.$touch()
      }
    },
    model: {
      value: (_vm.newOrderData.orderDate),
      callback: function($$v) {
        _vm.$set(_vm.newOrderData, "orderDate", $$v)
      },
      expression: "newOrderData.orderDate"
    }
  }), _vm._v(" "), (_vm.$v.newOrderData.orderDate.$error) ? _c('span', {
    staticClass: "small help-block text-danger"
  }, [_vm._v("Дата обязательна")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group col-6 col-md-2",
    class: {
      'has-danger': _vm.$v.newOrderData.orderTime.$error
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newOrderData.orderTime),
      expression: "newOrderData.orderTime"
    }],
    staticClass: "form-control",
    attrs: {
      "tabindex": "2"
    },
    on: {
      "input": function($event) {
        _vm.$v.newOrderData.orderTime.$touch()
      },
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.newOrderData, "orderTime", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.timeOptions), function(item) {
    return _c('option', {
      domProps: {
        "value": item
      }
    }, [_vm._v(_vm._s(item))])
  })), _vm._v(" "), (_vm.$v.newOrderData.orderTime.$error) ? _c('span', {
    staticClass: "small help-block text-danger"
  }, [_vm._v("Время обязательно")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-12 col-md-3"
  }, [_c('multiselect', {
    attrs: {
      "tabindex": 3,
      "options": _vm.cities,
      "searchable": true,
      "close-on-select": true,
      "show-labels": false,
      "placeholder": "Город не выбран",
      "allow-empty": false,
      "track-by": "id",
      "label": "name"
    },
    on: {
      "input": _vm.loadTechcenters
    },
    model: {
      value: (_vm.citySelected),
      callback: function($$v) {
        _vm.citySelected = $$v
      },
      expression: "citySelected"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group col-12 col-md-5",
    class: {
      'has-danger': _vm.$v.newOrderData.techcenterId.$error
    }
  }, [_c('multiselect', {
    attrs: {
      "tabindex": 4,
      "options": _vm.techcenters,
      "searchable": true,
      "close-on-select": true,
      "show-labels": false,
      "allow-empty": true,
      "placeholder": "Техцентр не выбран",
      "track-by": "id",
      "label": "name",
      "loading": _vm.loadingTechcenters,
      "value": null
    },
    on: {
      "input": _vm.setTechcneter
    },
    model: {
      value: (_vm.techcenterSelected),
      callback: function($$v) {
        _vm.techcenterSelected = $$v
      },
      expression: "techcenterSelected"
    }
  }), _vm._v(" "), (_vm.$v.newOrderData.techcenterId.$error) ? _c('span', {
    staticClass: "small help-block text-danger"
  }, [_vm._v("Обязательно укажите техцентр")]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group col-12",
    class: {
      'has-danger': _vm.$v.newOrderData.description.$error
    }
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newOrderData.description),
      expression: "newOrderData.description"
    }],
    staticClass: "form-control",
    attrs: {
      "cols": "30",
      "rows": "10",
      "tabindex": 5
    },
    domProps: {
      "value": (_vm.newOrderData.description)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newOrderData, "description", $event.target.value)
      }, function($event) {
        _vm.$v.newOrderData.description.$touch()
      }]
    }
  }), _vm._v(" "), (_vm.$v.newOrderData.description.$error) ? _c('span', {
    staticClass: "small help-block text-danger"
  }, [_vm._v("Описание должно состоять как минимум из " + _vm._s(_vm.$v.newOrderData.description.$params.minLength.min) + " символов")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group col-12 col-md-6",
    class: {
      'has-danger': _vm.$v.newOrderData.clientPhone.$error
    }
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("+7")]), _vm._v(" "), (_vm.newOrderData.clientPhone !== '**********') ? _c('input', {
    directives: [{
      name: "mask",
      rawName: "v-mask",
      value: ('(###) ###-##-##'),
      expression: "'(###) ###-##-##'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.newOrderData.clientPhone),
      expression: "newOrderData.clientPhone"
    }],
    staticClass: "input-mask-phone form-control",
    attrs: {
      "type": "text",
      "tabindex": 6
    },
    domProps: {
      "value": (_vm.newOrderData.clientPhone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newOrderData, "clientPhone", $event.target.value)
      }
    }
  }) : _c('input', {
    staticClass: "form-control disabled",
    attrs: {
      "type": "text",
      "disabled": "",
      "value": "(***) ***-**-**"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-12 col-md-6",
    class: {
      'has-danger': _vm.$v.newOrderData.clientName.$error
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newOrderData.clientName),
      expression: "newOrderData.clientName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Имя клиента",
      "tabindex": 7
    },
    domProps: {
      "value": (_vm.newOrderData.clientName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newOrderData, "clientName", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group col-12 col-md-6 flex-md-first",
    class: {
      'has-danger': _vm.$v.newOrderData.sum.$error
    }
  }, [_c('span', [_vm._v("Первоначальная cумма заказ-наряда")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newOrderData.sum),
      expression: "newOrderData.sum"
    }],
    staticClass: "input-mask-phone form-control text-right",
    attrs: {
      "type": "number",
      "tabindex": 8
    },
    domProps: {
      "value": (_vm.newOrderData.sum)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newOrderData, "sum", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "fa fa-rub"
  })])])])])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "modal-footer"
    },
    slot: "modal-footer"
  }, [_c('div', {
    attrs: {
      "id": "buttonAddOrEditOrder"
    }
  }, [(!_vm.loading) ? _c('button', {
    staticClass: "btn btn-success",
    class: {
      'disabled': _vm.$v.newOrderData.$invalid
    },
    attrs: {
      "disabled": _vm.$v.newOrderData.$invalid,
      "type": "button",
      "tabindex": 8
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.beforeUpdateForm($event)
      }
    }
  }, [(_vm.order) ? [_vm._v("Сохранить изменение")] : [_vm._v("Добавить заказ")]], 2) : _vm._e()]), _vm._v(" "), (_vm.$v.newOrderData.$invalid) ? _c('b-tooltip', {
    attrs: {
      "target": "buttonAddOrEditOrder",
      "title": "Обязательно заполните все поля"
    }
  }) : _vm._e()], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1012 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.errors) ? _c('div', {
    staticClass: "app-body app flex-row align-items-center"
  }, [_c('main', {
    staticClass: "main"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row justify-content-center"
  }, [_c('div', {
    staticClass: "alert alert-danger"
  }, [_c('p', [_vm._v("\n              Произошла непредвиденная ошибка, попробуйте обновить страницу.\n            ")]), _vm._v(" "), _c('p', [_vm._v("\n              " + _vm._s(_vm.errors) + "\n            ")])])])])])]) : [_c('router-view'), _vm._v(" "), _c('toast', {
    attrs: {
      "html": true,
      "position": "se"
    }
  })]], 2)
},staticRenderFns: []}

/***/ }),
/* 1013 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.$route.name === 'Orders') ? _c('div', {
    staticClass: "animated fadeIn"
  }, [_c('order-top-panel'), _vm._v(" "), (_vm.loading) ? _c('loading', {
    attrs: {
      "message": "Загружаем заказы..."
    }
  }) : _vm._l((_vm.ordersDays), function(date) {
    return _c('div', {
      staticClass: "card"
    }, [_c('div', {
      staticClass: "card-header"
    }, [_vm._v("\n      " + _vm._s(_vm.convertDataToString(date)) + "\n      "), _c('div', {
      staticClass: "pull-right"
    }, [_vm._v("\n        Заказов отмено: " + _vm._s(_vm.getOrdersCanceledByDate(date).length) + "\n        "), (_vm.showCanceled) ? _c('button', {
      staticClass: "ml-2 btn btn-sm btn-secondary",
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.showCanceled = false
        }
      }
    }, [_vm._v("Скрыть отмененые")]) : _c('button', {
      staticClass: "ml-2 btn btn-sm btn-danger",
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.showCanceled = true
        }
      }
    }, [_vm._v("Показать отмененые")])])]), _vm._v(" "), _c('div', {
      staticClass: "card-block orders-items"
    }, [_c('div', {
      staticClass: "row",
      staticStyle: {
        "margin-left": "-20px",
        "margin-right": "-20px"
      }
    }, [_c('div', {
      staticClass: "col-12 mt-1 mb-1 small  hidden-md-down"
    }, [_c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-1"
    }, [_c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-12 col-lg-7"
    }, [_vm._v("№")]), _vm._v(" "), _c('div', {
      staticClass: "col-12 col-lg-5"
    }, [_vm._v("Время")])])]), _vm._v(" "), _c('div', {
      staticClass: "col-3 col-lg-2"
    }, [_vm._v("Статус")]), _vm._v(" "), _c('div', {
      staticClass: "col-2 col-lg-3"
    }, [_vm._v("Описание")]), _vm._v(" "), _c('div', {
      staticClass: "col-2"
    }, [_vm._v("Клиент")]), _vm._v(" "), _c('div', {
      staticClass: "col-2"
    }, [_vm._v("Город, компания, техцентр")]), _vm._v(" "), _c('div', {
      staticClass: "col-1",
      staticStyle: {
        "word-wrap": "break-word"
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "col-1"
    }, [_vm._v("Действие")])])]), _vm._v(" "), _vm._l((_vm.getOrdersByDate(date)), function(order, index) {
      return _c('div', {
        key: order.id,
        staticClass: "col-12 order-item",
        class: {
          active: _vm.activeOrderId === order.id, 'text-danger': order.problem && !order.canceled, 'text-muted': order.canceled
        },
        attrs: {
          "id": _vm.getIdElement(order.id)
        }
      }, [_c('div', {
        staticClass: "row order-item-row",
        class: {
          active: _vm.activeOrderId === order.id,
            'order-item-row--commission-problem': _vm.getCommission(order.sum, order.profit) !== false && _vm.getCommission(order.sum, order.profit) < 10
        },
        on: {
          "click": function($event) {
            $event.preventDefault();
            _vm.showOrderDetail(order.id)
          }
        }
      }, [_c('div', {
        staticClass: "col-6 col-md-1"
      }, [_c('div', {
        staticClass: "row"
      }, [_c('div', {
        staticClass: "col-12 col-lg-7"
      }, [_c('small', {
        staticClass: "hidden-md-up text-muted"
      }, [_vm._v("№ "), _c('br')]), _vm._v("\n                  " + _vm._s(order.id) + "\n                  "), _c('br'), _c('span', {
        staticClass: "text-muted small"
      }, [_vm._v(_vm._s(order.amoId))]), _vm._v(" "), (order.amoId) ? _c('a', {
        staticClass: "btn btn-secondary btn-sm",
        attrs: {
          "href": _vm.getAmoLeadUrl(order.amoId),
          "target": "_blank"
        },
        on: {
          "click": function($event) {
            $event.stopPropagation();
          }
        }
      }, [_vm._v("Открыть"), _c('br'), _vm._v(" в AmoCRM")]) : _vm._e()]), _vm._v(" "), _c('div', {
        staticClass: "col-12 col-lg-5"
      }, [_c('small', {
        staticClass: "hidden-md-up text-muted"
      }, [_vm._v("Время "), _c('br')]), _vm._v("\n                  " + _vm._s(order.time) + "\n                ")])])]), _vm._v(" "), _c('div', {
        staticClass: "col-6 col-md-3 col-lg-2"
      }, [_c('order-status', {
        attrs: {
          "order": order,
          "commission": _vm.getCommission(order.sum, order.profit)
        }
      })], 1), _vm._v(" "), _c('div', {
        staticClass: "col-6 col-md-5 col-lg-3"
      }, [_vm._v("\n              " + _vm._s(order.description) + "\n              "), (order.canceled) ? _c('div', {
        staticClass: "text-danger small"
      }, [_vm._v("\n                Причина отмены: " + _vm._s(order.cancelCause) + ".\n                "), (order.movedOrder) ? _c('span', [_c('a', {
        attrs: {
          "href": "#"
        },
        on: {
          "click": function($event) {
            $event.stopPropagation();
            $event.preventDefault();
            _vm.showMovedOrderDetail(order.movedOrder.id)
          }
        }
      }, [_vm._v("Заказ №" + _vm._s(order.movedOrder.id))]), _vm._v(" в "), _c('span', {
        staticClass: "badge",
        style: ({
          backgroundColor: order.movedOrder.techcenter.color
        })
      }, [_vm._v(_vm._s(order.movedOrder.techcenter.address))])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (order.problem) ? _c('div', {
        staticClass: "text-danger small"
      }, [_c('i', {
        staticClass: "fa fa-exclamation-triangle",
        attrs: {
          "aria-hidden": "true"
        }
      }), _vm._v(" Проблема с заказом: " + _vm._s(order.problemCause))]) : _vm._e()]), _vm._v(" "), _c('div', {
        staticClass: "col-6 col-md-3 col-lg-2"
      }, [_c('order-client-info', {
        attrs: {
          "order": order
        }
      })], 1), _vm._v(" "), _c('div', {
        staticClass: "col-6 col-md-9 col-lg-2"
      }, [_c('order-techcenter-info', {
        attrs: {
          "order": order
        }
      })], 1), _vm._v(" "), _c('div', {
        staticClass: "col-1"
      }, [_c('span', {
        directives: [{
          name: "b-tooltip",
          rawName: "v-b-tooltip"
        }],
        attrs: {
          "placement": "bottom",
          "title": _vm.getCreatedDescr(order)
        }
      }, [_c('i', {
        staticClass: "fa fa-clock-o"
      })]), _vm._v(" "), _c('span', {
        directives: [{
          name: "b-tooltip",
          rawName: "v-b-tooltip"
        }],
        attrs: {
          "placement": "bottom",
          "title": _vm.getCommentsDescr(order.commentsCountUnviewed)
        }
      }, [_c('span', {
        staticClass: "text-muted",
        class: {
          'text-warning': order.commentsCountUnviewed
        }
      }, [_c('i', {
        staticClass: "fa fa-comment-o"
      })]), _vm._v("\n                " + _vm._s(order.commentsCount) + "\n              ")])]), _vm._v(" "), _c('div', {
        staticClass: "col-1"
      }, [_c('order-actions', {
        attrs: {
          "order": order
        }
      })], 1)]), _vm._v(" "), (_vm.activeOrderId === order.id) ? _c('div', {
        staticClass: "row mt-2"
      }, [_c('hr'), _vm._v(" "), _c('div', {
        staticClass: "col-12 col-lg-6"
      }, [_c('comments', {
        attrs: {
          "order": order
        }
      })], 1), _vm._v(" "), _c('div', {
        staticClass: "col-12 col-lg-6"
      }, [_c('b-card', [_c('b-tabs', {
        ref: "tabs",
        refInFor: true,
        attrs: {
          "card": "",
          "lazy": true
        }
      }, [_c('b-tab', {
        attrs: {
          "title": "<i class='fa fa-history'></i> История изменений заказа",
          "active": ""
        }
      }, [_c('order-history', {
        attrs: {
          "order": order
        }
      })], 1), _vm._v(" "), (order.canViewCallHistory) ? _c('b-tab', {
        attrs: {
          "title": "<i class='fa fa-phone'></i> История звонков"
        }
      }, [_c('order-call-history', {
        attrs: {
          "order": order
        }
      })], 1) : _vm._e()], 1)], 1)], 1)]) : _vm._e()])
    })], 2)])])
  }), _vm._v(" "), (_vm.showAlertNoOrders) ? _c('div', {
    staticClass: "alert alert-warning"
  }, [_c('h6', [_vm._v("К сожалению заказы по заданным параметрам не найдены. Попробуйте изменить параметры поиска или режим отображения заказов.")])]) : _vm._e()], 2) : _c('router-view')
},staticRenderFns: []}

/***/ }),
/* 1014 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.loading) ? _c('loading', {
    attrs: {
      "size": 2,
      "message": "Обновляем профиль..."
    }
  }) : _c('form', {
    staticClass: "form-horizontal",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.beforeSubmit($event)
      }
    }
  }, [_c('div', {
    staticClass: "form-group row",
    class: {
      'has-danger': _vm.$v.newUserData.firstname.$error
    }
  }, [_c('label', {
    staticClass: "col-4 col-md-2 col-form-label",
    attrs: {
      "for": "user-firstname"
    }
  }, [_vm._v("Имя")]), _vm._v(" "), _c('div', {
    staticClass: "col-8 col-md-4"
  }, [(_vm.currentUser.isAdmin) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newUserData.firstname),
      expression: "newUserData.firstname"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "firstname",
      "type": "text",
      "id": "user-firstname"
    },
    domProps: {
      "value": (_vm.newUserData.firstname)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newUserData, "firstname", $event.target.value)
      }, function($event) {
        _vm.$v.newUserData.firstname.$touch()
      }]
    }
  }) : _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newUserData.firstname),
      expression: "newUserData.firstname"
    }],
    staticClass: "form-control disabled",
    attrs: {
      "disabled": "",
      "name": "firstname",
      "type": "text",
      "id": "user-firstname"
    },
    domProps: {
      "value": (_vm.newUserData.firstname)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newUserData, "firstname", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.$v.newUserData.firstname.$error) ? _c('span', {
    staticClass: "small help-block text-danger"
  }, [_vm._v("Имя обязательно должно быть указано")]) : _vm._e()]), _vm._v(" "), (!_vm.currentUser.isAdmin) ? _c('div', {
    staticClass: "help-inline col-12 col-md-6"
  }, [_c('small', {
    staticClass: "text-muted"
  }, [_vm._v("Имя может изменить только администратор")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group row",
    class: {
      'has-danger': _vm.$v.newUserData.lastname.$error
    }
  }, [_c('label', {
    staticClass: "col-4 col-md-2 col-form-label",
    attrs: {
      "for": "user-lastname"
    }
  }, [_vm._v("Фамилия")]), _vm._v(" "), _c('div', {
    staticClass: "col-8 col-md-4"
  }, [(_vm.currentUser.isAdmin) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newUserData.lastname),
      expression: "newUserData.lastname"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "user-lastname"
    },
    domProps: {
      "value": (_vm.newUserData.lastname)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newUserData, "lastname", $event.target.value)
      }, function($event) {
        _vm.$v.newUserData.lastname.$touch()
      }]
    }
  }) : _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newUserData.lastname),
      expression: "newUserData.lastname"
    }],
    staticClass: "form-control disabled",
    attrs: {
      "disabled": "",
      "type": "text",
      "id": "user-lastname"
    },
    domProps: {
      "value": (_vm.newUserData.lastname)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newUserData, "lastname", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.$v.newUserData.lastname.$error) ? _c('span', {
    staticClass: "small help-block text-danger"
  }, [_vm._v("Фамилия обязательно должна быть указана")]) : _vm._e()]), _vm._v(" "), (!_vm.currentUser.isAdmin) ? _c('div', {
    staticClass: "help-inline col-12 col-md-6"
  }, [_c('small', {
    staticClass: "text-muted"
  }, [_vm._v("Фамилию может изменить только администратор")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group row",
    class: {
      'has-danger': _vm.$v.newUserData.email.$error
    }
  }, [_c('label', {
    staticClass: "col-4 col-md-2 col-form-label",
    attrs: {
      "for": "user-email"
    }
  }, [_vm._v("Электронная почта")]), _vm._v(" "), _c('div', {
    staticClass: "col-8 col-md-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newUserData.email),
      expression: "newUserData.email"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "user-email"
    },
    domProps: {
      "value": (_vm.newUserData.email)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newUserData, "email", $event.target.value)
      }, function($event) {
        _vm.$v.newUserData.email.$touch()
      }]
    }
  }), _vm._v(" "), (_vm.$v.newUserData.email.$error) ? _c('span', {
    staticClass: "small help-block text-danger"
  }, [_vm._v("Адрес электронной почты обязателен и должен быть валидным")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "help-inline col-12 col-md-6"
  }, [_c('small', {
    staticClass: "text-muted"
  }, [_vm._v("На данный адрес будут приходить оповещения, также этот адрес используется для авторизации в Аларм Плане")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row",
    class: {
      'has-danger': _vm.$v.newUserData.phone.$error
    }
  }, [_c('label', {
    staticClass: "col-4 col-sm-2 col-form-label",
    attrs: {
      "for": "user-phone"
    }
  }, [_vm._v("Номер телефона")]), _vm._v(" "), _c('div', {
    staticClass: "col-8 col-sm-4"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("+7")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newUserData.phone),
      expression: "newUserData.phone"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "user-phone"
    },
    domProps: {
      "value": (_vm.newUserData.phone)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newUserData, "phone", $event.target.value)
      }, function($event) {
        _vm.$v.newUserData.phone.$touch()
      }]
    }
  })]), _vm._v(" "), (_vm.$v.newUserData.phone.$error) ? _c('span', {
    staticClass: "small help-block text-danger"
  }, [_vm._v("Телефон обязателен и должен состоять из 10 цифр")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "help-inline col-12 col-md-6"
  }, [_c('small', {
    staticClass: "text-muted"
  }, [_vm._v("На данный номер будут приходить оповещения. Настроить оповещения можно в следующей вкладке")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-4 col-md-2 col-form-label"
  }, [_vm._v("Дата рождения")]), _vm._v(" "), _c('div', {
    staticClass: "col-8 col-md-4"
  }, [_c('datepicker', {
    attrs: {
      "format": "dd/MM/yyyy"
    },
    model: {
      value: (_vm.newUserData.birthday),
      callback: function($$v) {
        _vm.$set(_vm.newUserData, "birthday", $$v)
      },
      expression: "newUserData.birthday"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "help-inline col-12 col-6"
  }, [_c('small', {
    staticClass: "text-muted"
  }, [_vm._v("Мы поздравим Вас, когда прийдёт время")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-4 col-md-2 col-form-label",
    attrs: {
      "for": "user-skype"
    }
  }, [_vm._v("Skype")]), _vm._v(" "), _c('div', {
    staticClass: "col-8 col-md-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newUserData.skype),
      expression: "newUserData.skype"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "user-skype"
    },
    domProps: {
      "value": (_vm.newUserData.skype)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newUserData, "skype", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-4 col-md-2 col-form-label",
    attrs: {
      "for": "user-icq"
    }
  }, [_vm._v("Id пользователя в Телеграм")]), _vm._v(" "), _c('div', {
    staticClass: "col-8 col-md-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newUserData.telegramUserId),
      expression: "newUserData.telegramUserId"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "user-telegram"
    },
    domProps: {
      "value": (_vm.newUserData.telegramUserId)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newUserData, "telegramUserId", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "help-inline col-12 col-md-6"
  }, [_c('small', {
    staticClass: "text-muted"
  }, [_vm._v("Для того, чтобы получать уведомления в Телеграм необходимо указать id пользователя. Для этого подключитьсеь к боту "), _c('a', {
    attrs: {
      "href": "https://t.me/AlarmPlanBot?start ",
      "target": "_blank"
    }
  }, [_vm._v("@AlarmPlanBot")]), _vm._v(", нажав "), _c('b', [_vm._v("Start")]), _vm._v(", в ответ бот пришлет вам id, который необходимо тут указать")])])]), _vm._v(" "), (_vm.currentUser.isAdmin) ? _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-4 col-md-2 col-form-label",
    attrs: {
      "for": "user-icq"
    }
  }, [_vm._v("Id пользователя в AmoCrm")]), _vm._v(" "), _c('div', {
    staticClass: "col-8 col-md-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newUserData.amoId),
      expression: "newUserData.amoId"
    }],
    staticClass: "form-control",
    class: {
      'disabled': !_vm.currentUser.isAdmin
    },
    attrs: {
      "type": "text",
      "id": "user-amo-id",
      "disabled": !_vm.currentUser.isAdmin
    },
    domProps: {
      "value": (_vm.newUserData.amoId)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newUserData, "amoId", $event.target.value)
      }
    }
  })])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "offset-sm-2 col-sm-10"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    class: {
      'disabled': _vm.$v.newUserData.$invalid
    },
    attrs: {
      "disabled": _vm.$v.newUserData.$invalid,
      "type": "submit"
    }
  }, [_vm._v("Сохранить")])])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 1015 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('label', {
    staticClass: "col-4 col-form-label"
  }, [_vm._v("\n    Цвет\n    "), _c('span', {
    staticClass: "badge",
    style: ({
      'background-color': _vm.color.hex
    })
  }, [_vm._v("\n      " + _vm._s(_vm.color.hex) + "\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-8"
  }, [_c('color-picker', {
    on: {
      "input": function($event) {
        _vm.$emit('input', _vm.color.hex)
      }
    },
    model: {
      value: (_vm.color),
      callback: function($$v) {
        _vm.color = $$v
      },
      expression: "color"
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),
/* 1016 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated fadeIn"
  }, [_c('div', {
    staticClass: "card admin"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_vm._v("\n            Список ролей\n            "), _c('div', {
    staticClass: "pull-right",
    staticStyle: {
      "margin-top": "7px"
    }
  }, [_c('button', {
    staticClass: "btn btn-secondary",
    class: {
      active: _vm.showFilter
    },
    attrs: {
      "data-toggle": "dropdown",
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.showFilter = !_vm.showFilter
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-filter"
  }), _vm._v(" Фильтр\n                ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.showModal($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" Добавить роль\n                ")])]), _vm._v(" "), (_vm.showFilter) ? _c('div', {
    staticClass: "mt-3 mt-lg-1"
  }, [_c('div', {
    staticClass: "row col-12 col-md-6"
  }, [_c('form', {
    attrs: {
      "сlass": "form-horizontal"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.search($event)
      }
    }
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-3 form-control-label"
  }, [_vm._v("Название")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9 col-lg-5"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.params.query),
      expression: "params.query"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.params.query)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.params, "query", $event.target.value)
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-6"
  })]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "card-block admin__list"
  }, [_vm._m(0), _vm._v(" "), (_vm.loading) ? _c('loading', {
    attrs: {
      "message": "Загружаем роли..."
    }
  }) : _vm._l((_vm.items), function(item) {
    return _c('div', {
      staticClass: "row mb-1 admin__list__item admin__list__item_hover-bg-gray"
    }, [_c('div', {
      staticClass: "col-1 d-none d-md-block"
    }, [_vm._v("\n                    " + _vm._s(item.id) + "\n                ")]), _vm._v(" "), _c('div', {
      staticClass: "col-6 col-md-4"
    }, [_vm._v("\n                   " + _vm._s(item.name) + "\n                ")]), _vm._v(" "), _c('div', {
      staticClass: "col-6 col-md-2"
    }, [_vm._v("\n                    " + _vm._s(item.description) + "\n                ")]), _vm._v(" "), _c('div', {
      staticClass: "col-6 col-md-2"
    }), _vm._v(" "), _c('div', {
      staticClass: "col-6 col-md-3"
    }, [_c('button', {
      staticClass: "btn btn-primary btn-sm",
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.editItem(item)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-edit"
    }), _vm._v(" Изменить\n                    ")])])])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "card-header"
  }, [_c('b-pagination', {
    staticClass: "mb-0",
    attrs: {
      "size": "md",
      "total-rows": _vm.itemsPage.paginator.total_count,
      "per-page": _vm.itemsPage.paginator.limit
    },
    model: {
      value: (_vm.params.page),
      callback: function($$v) {
        _vm.$set(_vm.params, "page", $$v)
      },
      expression: "params.page"
    }
  })], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row mb-1 small text-muted"
  }, [_c('div', {
    staticClass: "col-1 d-none d-md-block"
  }, [_vm._v("Id")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-md-4"
  }, [_vm._v("Код")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-md-2"
  }, [_vm._v("Назвние")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-md-2"
  }, [_vm._v("Разрешения")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-md-3"
  }, [_vm._v("Управление")])])
}]}

/***/ }),
/* 1017 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated fadeIn"
  }, [_c('div', {
    staticClass: "card admin"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_vm._v("\n            Список пользователей\n            "), _c('div', {
    staticClass: "pull-right",
    staticStyle: {
      "margin-top": "7px"
    }
  }, [_c('button', {
    staticClass: "btn btn-secondary",
    class: {
      active: _vm.showFilter
    },
    attrs: {
      "data-toggle": "dropdown",
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.showFilter = !_vm.showFilter
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-filter"
  }), _vm._v(" Фильтр\n                ")]), _vm._v(" "), (_vm.currentUser.hasPermission('user.add')) ? _c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.showModalAddUser($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" Добавить пользователя\n                ")]) : _vm._e()]), _vm._v(" "), (_vm.showFilter) ? _c('div', {
    staticClass: "mt-3 mt-lg-1"
  }, [_c('div', {
    staticClass: "row col-12 col-lg-6"
  }, [_c('form', {
    attrs: {
      "сlass": "form-horizontal"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.search($event)
      }
    }
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-6 form-control-label"
  }, [_vm._v("Имя или фамилия")]), _vm._v(" "), _c('div', {
    staticClass: "col-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.params.query),
      expression: "params.query"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.params.query)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.params, "query", $event.target.value)
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-6"
  })]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "card-block admin__list"
  }, [_vm._m(0), _vm._v(" "), (_vm.loadingUsers) ? _c('loading', {
    attrs: {
      "message": "Загружаем пользователей..."
    }
  }) : _vm._l((_vm.users), function(user) {
    return _c('div', {
      staticClass: "row mb-1 admin__list__item admin__list__item_hover-bg-gray"
    }, [_c('div', {
      staticClass: "col-12 col-lg-1 text-lg-center"
    }, [_c('div', {
      staticClass: "avatar d-none d-lg-inline"
    }, [_c('img', {
      staticClass: "img-avatar",
      attrs: {
        "src": _vm.getAvatarPath(user.avatar)
      }
    })]), _vm._v(" "), _c('div', [(user.enabled) ? _c('span', {
      staticClass: "badge badge-success"
    }, [_vm._v("Активен")]) : _c('span', {
      staticClass: "badge badge-danger"
    }, [_vm._v("Заблокирован")])])]), _vm._v(" "), _c('div', {
      staticClass: "col-6 col-md-8 col-lg-2"
    }, [(_vm.currentUser.hasPermission('user.view.all')) ? _c('router-link', {
      attrs: {
        "to": {
          name: 'ViewProfile',
          params: {
            id: user.id
          }
        }
      }
    }, [_vm._v(_vm._s(user.fullname))]) : _c('span', [_vm._v(_vm._s(user.fullname))]), _vm._v(" "), _c('div', {
      staticClass: "small text-muted"
    }, [_vm._v(_vm._s(user.email))])], 1), _vm._v(" "), _c('div', {
      staticClass: "col-6 col-md-4 col-lg-2"
    }, _vm._l((user.companies), function(company) {
      return _c('span', {
        staticClass: "badge badge-success"
      }, [_vm._v(_vm._s(company.name))])
    })), _vm._v(" "), _c('div', {
      staticClass: "col-6 col-md-8 col-lg-2"
    }, _vm._l((user.techcenters), function(techcenter, index) {
      return _c('span', {
        staticClass: "badge badge-info"
      }, [_vm._v("\n                      " + _vm._s(techcenter.address) + "\n                    ")])
    })), _vm._v(" "), _c('div', {
      staticClass: "col-6 col-md-4 col-lg-1"
    }, [_vm._v("\n                    +7" + _vm._s(user.phone) + "\n                ")]), _vm._v(" "), _c('div', {
      staticClass: "col-6 col-md-8 col-lg-1"
    }, [(user.isAdmin) ? _c('span', {
      staticClass: "badge badge-danger"
    }, [_vm._v("Администратор")]) : _vm._e(), _vm._v(" "), (user.role === 'supermanager') ? _c('span', {
      staticClass: "badge badge-warning"
    }, [_vm._v("Менеджер")]) : _vm._e(), _vm._v(" "), (user.role === 'user') ? _c('span', {
      staticClass: "badge badge-success"
    }, [_vm._v("Пользователь")]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "col-6 col-md-4 col-lg-3"
    }, [(_vm.currentUser.hasPermission('user.block')) ? [(_vm.blockUserLoading === user.id) ? _c('loading', {
      attrs: {
        "size": 2,
        "message": false
      }
    }) : [(user.enabled) ? _c('button', {
      staticClass: "btn btn-danger btn-sm",
      on: {
        "click": function($event) {
          _vm.blockUser(user, false)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-lock"
    }), _vm._v(" Заблокировать\n                            ")]) : _c('button', {
      staticClass: "btn btn-secondary btn-sm",
      on: {
        "click": function($event) {
          _vm.blockUser(user, true)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-unlock"
    }), _vm._v(" Разблокировать\n                            ")])]] : _vm._e()], 2)])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "card-header"
  }, [_c('b-pagination', {
    staticClass: "mb-0",
    attrs: {
      "size": "md",
      "total-rows": _vm.usersPage.paginator.total_count,
      "per-page": _vm.usersPage.paginator.limit
    },
    model: {
      value: (_vm.params.page),
      callback: function($$v) {
        _vm.$set(_vm.params, "page", $$v)
      },
      expression: "params.page"
    }
  })], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row mb-1 small text-muted"
  }, [_c('div', {
    staticClass: "col-1 col-lg-1 d-none d-lg-block"
  }, [_vm._v("Id")]), _vm._v(" "), _c('div', {
    staticClass: "col-12 col-md-8 col-lg-2"
  }, [_vm._v("Основаная информация")]), _vm._v(" "), _c('div', {
    staticClass: "col-2 d-none d-lg-block"
  }, [_vm._v("Компании")]), _vm._v(" "), _c('div', {
    staticClass: "col-2 d-none d-lg-block"
  }, [_vm._v("Техцентры")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 col-lg-1 d-none d-md-block"
  }, [_vm._v("Телефон")]), _vm._v(" "), _c('div', {
    staticClass: "col-1 d-none d-lg-block"
  }, [_vm._v("Роль")]), _vm._v(" "), _c('div', {
    staticClass: "col-3 d-none d-lg-block"
  }, [_vm._v("Управление")])])
}]}

/***/ }),
/* 1018 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-4 form-control-label"
  }, [_vm._v("Часовой пояс")]), _vm._v(" "), _c('div', {
    staticClass: "col-8"
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.timeZones,
      "close-on-select": true,
      "show-labels": false,
      "value": _vm.value,
      "placeholder": "Часовой пояс не выбран",
      "track-by": "id",
      "label": "name",
      "autocomplete": "off"
    },
    on: {
      "input": _vm.changeTimeZone
    },
    model: {
      value: (_vm.timeZone),
      callback: function($$v) {
        _vm.timeZone = $$v
      },
      expression: "timeZone"
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),
/* 1019 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.loading) ? _c('loading', {
    attrs: {
      "size": 2,
      "message": "Загружаем активность пользователя..."
    }
  }) : _c('div', {
    staticClass: "steamline"
  }, _vm._l((_vm.logsPage.logs), function(log) {
    return _c('div', {
      staticClass: "sl-item"
    }, [_c('div', {
      staticClass: "sl-left"
    }, [_c('i', {
      staticClass: "fa fa-code-fork"
    })]), _vm._v(" "), _c('div', {
      staticClass: "text-muted"
    }, [_vm._v(_vm._s(log.diffForHumans) + " (" + _vm._s(log.date) + " в " + _vm._s(log.time) + ")")]), _vm._v(" "), _c('div', {
      staticClass: "desc"
    }, [_vm._v(_vm._s(log.text) + " "), _c('a', {
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.showOrderDetail(log.objectId)
        }
      }
    }, [_vm._v("№" + _vm._s(log.objectId))])])])
  })), _vm._v(" "), _c('b-pagination', {
    staticClass: "mb-0",
    attrs: {
      "size": "md",
      "total-rows": _vm.logsPage.paginator.total_count,
      "per-page": _vm.logsPage.paginator.limit
    },
    model: {
      value: (_vm.page),
      callback: function($$v) {
        _vm.page = $$v
      },
      expression: "page"
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1020 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated fadeIn"
  }, [(_vm.loading) ? _c('loading', {
    attrs: {
      "message": "Загружаем информацию о техцентре..."
    }
  }) : (_vm.saving) ? _c('loading', {
    attrs: {
      "message": "Сохраняем информацию о техцентре..."
    }
  }) : _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 col-xl-6"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('form', {
    attrs: {
      "сlass": "form-horizontal"
    }
  }, [_c('div', {
    staticClass: "card-header"
  }, [_vm._v("Основная информация")]), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('tc-check-box', {
    model: {
      value: (_vm.newDataItem.enabled),
      callback: function($$v) {
        _vm.$set(_vm.newDataItem, "enabled", $$v)
      },
      expression: "newDataItem.enabled"
    }
  }), _vm._v(" "), _c('tc-input', {
    attrs: {
      "label-text": 'Название',
      "label-id": 'inputName',
      "input-require": true,
      "error": _vm.$v.newDataItem.name.$error,
      "error-text": 'Название обязательно должно быть указано, минимум 2 символа'
    },
    on: {
      "input": function($event) {
        _vm.$v.newDataItem.name.$touch()
      }
    },
    model: {
      value: (_vm.newDataItem.name),
      callback: function($$v) {
        _vm.$set(_vm.newDataItem, "name", $$v)
      },
      expression: "newDataItem.name"
    }
  }), _vm._v(" "), _c('tc-select-company', {
    attrs: {
      "company": _vm.techcenter.company,
      "error": _vm.$v.newDataItem.companyId.$error
    },
    on: {
      "input": function($event) {
        _vm.$v.newDataItem.cityId.$touch()
      }
    },
    model: {
      value: (_vm.newDataItem.companyId),
      callback: function($$v) {
        _vm.$set(_vm.newDataItem, "companyId", $$v)
      },
      expression: "newDataItem.companyId"
    }
  }), _vm._v(" "), _c('tc-select-users', {
    attrs: {
      "users-objects": _vm.usersObjects
    },
    model: {
      value: (_vm.newDataItem.users),
      callback: function($$v) {
        _vm.$set(_vm.newDataItem, "users", $$v)
      },
      expression: "newDataItem.users"
    }
  }), _vm._v(" "), _c('tc-select-city', {
    attrs: {
      "city": _vm.techcenter.city,
      "error": _vm.$v.newDataItem.cityId.$error
    },
    on: {
      "input": function($event) {
        _vm.$v.newDataItem.cityId.$touch()
      }
    },
    model: {
      value: (_vm.newDataItem.cityId),
      callback: function($$v) {
        _vm.$set(_vm.newDataItem, "cityId", $$v)
      },
      expression: "newDataItem.cityId"
    }
  }), _vm._v(" "), _c('tc-input', {
    staticClass: "mb-0",
    attrs: {
      "label-text": 'Адрес',
      "label-id": 'inputAddress',
      "input-require": true,
      "error": _vm.$v.newDataItem.address.$error,
      "error-text": 'Адрес обязательно должен быть указан, минимум 2 символа'
    },
    on: {
      "input": function($event) {
        _vm.$v.newDataItem.address.$touch()
      }
    },
    model: {
      value: (_vm.newDataItem.address),
      callback: function($$v) {
        _vm.$set(_vm.newDataItem, "address", $$v)
      },
      expression: "newDataItem.address"
    }
  }), _vm._v(" "), _c('tc-map', {
    staticClass: "mb-1",
    staticStyle: {
      "margin-top": "4px"
    },
    attrs: {
      "address": _vm.newDataItem.address,
      "city-id": _vm.newDataItem.cityId
    },
    model: {
      value: (_vm.newDataItem.coords),
      callback: function($$v) {
        _vm.$set(_vm.newDataItem, "coords", $$v)
      },
      expression: "newDataItem.coords"
    }
  }), _vm._v(" "), _c('tc-input-phone', {
    attrs: {
      "error": _vm.$v.newDataItem.phone.$error
    },
    on: {
      "input": function($event) {
        _vm.$v.newDataItem.phone.$touch()
      }
    },
    model: {
      value: (_vm.newDataItem.phone),
      callback: function($$v) {
        _vm.$set(_vm.newDataItem, "phone", $$v)
      },
      expression: "newDataItem.phone"
    }
  }), _vm._v(" "), _c('tc-input', {
    attrs: {
      "label-text": 'Максимальное число заказов',
      "label-id": 'inputMaxOrders',
      "input-require": true,
      "error": _vm.$v.newDataItem.maxOrders.$error,
      "error-text": 'Введите максимальное число заказов',
      "input-type": "number"
    },
    model: {
      value: (_vm.newDataItem.maxOrders),
      callback: function($$v) {
        _vm.$set(_vm.newDataItem, "maxOrders", $$v)
      },
      expression: "newDataItem.maxOrders"
    }
  }), _vm._v(" "), _c('tc-partnership', {
    staticClass: "mb-1",
    model: {
      value: (_vm.partnership),
      callback: function($$v) {
        _vm.partnership = $$v
      },
      expression: "partnership"
    }
  }), _vm._v(" "), _c('tc-color-picker', {
    staticClass: "mb-1",
    model: {
      value: (_vm.newDataItem.color),
      callback: function($$v) {
        _vm.$set(_vm.newDataItem, "color", $$v)
      },
      expression: "newDataItem.color"
    }
  }), _vm._v(" "), _c('tc-select-time-zone', {
    model: {
      value: (_vm.newDataItem.tzOffset),
      callback: function($$v) {
        _vm.$set(_vm.newDataItem, "tzOffset", $$v)
      },
      expression: "newDataItem.tzOffset"
    }
  }), _vm._v(" "), (false) ? _c('tc-select-work-time', {
    model: {
      value: (_vm.schedule),
      callback: function($$v) {
        _vm.schedule = $$v
      },
      expression: "schedule"
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-4 form-control-label"
  }, [_vm._v("График работы")]), _vm._v(" "), _c('div', {
    staticClass: "col-8"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group col-6"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newDataItem.workDateStart),
      expression: "newDataItem.workDateStart"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.newDataItem, "workDateStart", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.workDates), function(item) {
    return _c('option', {
      domProps: {
        "value": item.id
      }
    }, [_vm._v(_vm._s(item.name))])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-6"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newDataItem.workDateEnd),
      expression: "newDataItem.workDateEnd"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.newDataItem, "workDateEnd", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.workDates), function(item) {
    return _c('option', {
      domProps: {
        "value": item.id
      }
    }, [_vm._v(_vm._s(item.name))])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-6"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newDataItem.workTimeStart),
      expression: "newDataItem.workTimeStart"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.newDataItem, "workTimeStart", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.workTimes), function(item) {
    return _c('option', {
      domProps: {
        "value": item.id
      }
    }, [_vm._v(_vm._s(item.name))])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-6"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newDataItem.workTimeEnd),
      expression: "newDataItem.workTimeEnd"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.newDataItem, "workTimeEnd", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.workTimes), function(item) {
    return _c('option', {
      domProps: {
        "value": item.id
      }
    }, [_vm._v(_vm._s(item.name))])
  }))])])])]), _vm._v(" "), _c('tc-add-images', {
    staticClass: "mt-1 mb-1",
    model: {
      value: (_vm.newDataItem.images),
      callback: function($$v) {
        _vm.$set(_vm.newDataItem, "images", $$v)
      },
      expression: "newDataItem.images"
    }
  }), _vm._v(" "), _c('tc-input', {
    attrs: {
      "label-text": 'Ссылка на схему проезда',
      "label-id": 'inputTransitLink',
      "error": _vm.$v.newDataItem.link.$error,
      "error-text": 'Ссылка должна быть указана'
    },
    on: {
      "input": function($event) {
        _vm.$v.newDataItem.link.$touch()
      }
    },
    model: {
      value: (_vm.newDataItem.link),
      callback: function($$v) {
        _vm.$set(_vm.newDataItem, "link", $$v)
      },
      expression: "newDataItem.link"
    }
  }), _vm._v(" "), _c('tc-text-area', {
    model: {
      value: (_vm.newDataItem.description),
      callback: function($$v) {
        _vm.$set(_vm.newDataItem, "description", $$v)
      },
      expression: "newDataItem.description"
    }
  }), _vm._v(" "), (false) ? _c('tc-input-advantages') : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "card-footer"
  }, [(!_vm.loading) ? _c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.beforeUpdateForm($event)
      }
    }
  }, [(_vm.techcenter) ? [_vm._v("Сохранить изменения")] : [_vm._v("Добавить техцентр")]], 2) : _vm._e()])])])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 1021 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "ap-gallery"
  }, _vm._l((_vm.images), function(image) {
    return _c('div', {
      key: image.id,
      staticClass: "position-relative ap-gallery__item",
      on: {
        "click": function($event) {
          _vm.handleImage(image.fullPath)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": image.fullPath
      }
    })])
  })), _vm._v(" "), _c('Lightbox', {
    attrs: {
      "visible": _vm.visible,
      "imgs": _vm.imgUrls,
      "index": _vm.index
    },
    on: {
      "hide": function($event) {
        _vm.handleImage('')
      }
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1022 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated fadeIn"
  }, [_c('router-view')], 1)
},staticRenderFns: []}

/***/ }),
/* 1023 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group row",
    class: {
      'has-danger': _vm.error
    }
  }, [_c('label', {
    staticClass: "col-4 col-form-label",
    attrs: {
      "for": _vm.labelId
    }
  }, [_vm._v(_vm._s(_vm.labelText) + "\n    "), (_vm.inputRequire) ? _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-8"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "id": _vm.labelId,
      "type": _vm.inputType,
      "autocomplete": "off"
    },
    domProps: {
      "value": _vm.value
    },
    on: {
      "input": function($event) {
        _vm.changeValue($event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.error) ? _c('span', {
    staticClass: "small help-block text-danger"
  }, [_vm._v(_vm._s(_vm.errorText))]) : _vm._e()])])
},staticRenderFns: []}

/***/ }),
/* 1024 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sidebar"
  }, [_c('nav', {
    staticClass: "sidebar-nav"
  }, [_c('ul', {
    staticClass: "nav"
  }, [(_vm.user.hasPermission('order.view.*')) ? _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": '/orders'
    }
  }, [_c('i', {
    staticClass: "fa fa-list"
  }), _vm._v(" Заказы")])], 1) : _vm._e(), _vm._v(" "), (_vm.user.isAdmin) ? _c('li', {
    staticClass: "nav-title"
  }, [_vm._v("\n        Админ центр\n      ")]) : _vm._e(), _vm._v(" "), (_vm.user.hasPermission('user.view.*')) ? _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": '/admin/users'
    }
  }, [_c('i', {
    staticClass: "fa fa-users"
  }), _vm._v(" Пользователи")])], 1) : _vm._e(), _vm._v(" "), (_vm.user.hasPermission('techcenter.view.*')) ? _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": '/techcenters'
    }
  }, [_c('i', {
    staticClass: "fa fa-car"
  }), _vm._v(" Техцентры")])], 1) : _vm._e(), _vm._v(" "), (_vm.user.hasPermission('city.view')) ? _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": '/admin/cities'
    }
  }, [_c('i', {
    staticClass: "fa fa-map-marker"
  }), _vm._v(" Города")])], 1) : _vm._e(), _vm._v(" "), (_vm.user.hasPermission('company.view.*')) ? _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": '/admin/companies'
    }
  }, [_c('i', {
    staticClass: "fa fa-building"
  }), _vm._v(" Компании")])], 1) : _vm._e(), _vm._v(" "), (_vm.user.hasPermission('role.view')) ? _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": '/admin/roles'
    }
  }, [_c('i', {
    staticClass: "fa fa-lock"
  }), _vm._v(" Роли")])], 1) : _vm._e(), _vm._v(" "), (_vm.user.hasPermission('pbx.listen.all')) ? _c('li', {
    staticClass: "nav-title"
  }, [_vm._v("\n        Телефония\n      ")]) : _vm._e(), _vm._v(" "), (_vm.user.hasPermission('pbx.virtualNumbers.control')) ? _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": '/admin/pbx/virtual-numbers'
    }
  }, [_c('i', {
    staticClass: "icon-call-out icons"
  }), _vm._v(" Виртуальные номера")])], 1) : _vm._e(), _vm._v(" "), (_vm.user.isAdmin) ? _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": '/admin/custom-fields'
    }
  }, [_c('i', {
    staticClass: "fa fa-list-alt"
  }), _vm._v(" Кастомные поля")])], 1) : _vm._e(), _vm._v(" "), (_vm.user.isAdmin) ? _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": '/admin/statuses'
    }
  }, [_c('i', {
    staticClass: "fa fa-list-alt"
  }), _vm._v(" Статусы")])], 1) : _vm._e(), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": '/help'
    }
  }, [_c('i', {
    staticClass: "fa fa-question"
  }), _vm._v(" Помощь")])], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.scrolled) ? _c('li', {
    staticClass: "nav-item scroll-to-top-btn"
  }, [_c('a', {
    staticClass: "nav-link",
    staticStyle: {
      "width": "220px"
    },
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.scrollToTopAction($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-up"
  }), _vm._v(" Наверх")])]) : _vm._e(), _vm._v(" "), (_vm.scrollToPrev && !_vm.scrolled) ? _c('li', {
    staticClass: "nav-item scroll-to-top-btn"
  }, [_c('a', {
    staticClass: "nav-link",
    staticStyle: {
      "width": "220px"
    },
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.scrollToPrevAction($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-down"
  }), _vm._v(" Вернуться")])]) : _vm._e()])], 1)])])
},staticRenderFns: []}

/***/ }),
/* 1025 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.$route.name === 'Statuses') ? _c('div', [_c('admin-filter', {
    model: {
      value: (_vm.filterParams),
      callback: function($$v) {
        _vm.filterParams = $$v
      },
      expression: "filterParams"
    }
  }), _vm._v(" "), _c('admin-card', [_c('template', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v("\n      Список статусов\n      "), _c('router-link', {
    staticClass: "pull-right btn btn-primary btn-sm",
    attrs: {
      "to": {
        name: 'StatusCreate'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" Добавить\n      ")])], 1), _vm._v(" "), _c('admin-list', {
    attrs: {
      "items": _vm.items,
      "loading": _vm.loading
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var item = ref.item;

        return [_c('div', {
          staticClass: "col-6 col-md-4"
        }, [_vm._v("\n            " + _vm._s(item.name) + "\n          ")]), _vm._v(" "), _c('div', {
          staticClass: "col-6 col-md-1"
        }, [_vm._v("\n            " + _vm._s(item.code) + "\n          ")]), _vm._v(" "), _c('div', {
          staticClass: "col-6 col-md-1"
        }, [_vm._v("\n            " + _vm._s(item.class) + "\n          ")]), _vm._v(" "), _c('div', {
          staticClass: "col-6 col-md-1"
        }, [_vm._v("\n            " + _vm._s(item.sort) + "\n          ")]), _vm._v(" "), _c('div', {
          staticClass: "col-6 col-md-1"
        }, _vm._l((item.amoStatuses), function(amoStatus) {
          return _c('span', {
            staticClass: "badge badge-info text-muted small"
          }, [_vm._v(_vm._s(amoStatus.name))])
        })), _vm._v(" "), _c('div', {
          staticClass: "col-6 col-md-2"
        }, [_c('router-link', {
          staticClass: "btn btn-primary btn-sm",
          attrs: {
            "to": {
              name: 'StatusEdit',
              params: {
                id: item.id
              }
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-edit"
        }), _vm._v(" Изменить\n            ")])], 1)]
      }
    }])
  }, [_c('template', {
    attrs: {
      "slot": "headerList"
    },
    slot: "headerList"
  }, [_c('div', {
    staticClass: "col-6 col-md-4"
  }, [_vm._v("Название")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-md-1"
  }, [_vm._v("Код")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-md-1"
  }, [_vm._v("Класс")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-md-1"
  }, [_vm._v("Сортировка")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-md-1"
  }, [_vm._v("Id статусов в AmoCrm")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-md-2"
  }, [_vm._v("Управление")])])], 2)], 2)], 1) : _c('router-view')
},staticRenderFns: []}

/***/ }),
/* 1026 */,
/* 1027 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated fadeIn"
  }, [_c('div', {
    staticClass: "card admin"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_vm._v("\n            Список внутренних номеров\n            "), _c('div', {
    staticClass: "pull-right",
    staticStyle: {
      "margin-top": "7px"
    }
  }, [_c('button', {
    staticClass: "btn btn-secondary",
    class: {
      active: _vm.showFilter
    },
    attrs: {
      "data-toggle": "dropdown",
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.showFilter = !_vm.showFilter
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-filter"
  }), _vm._v(" Фильтр\n                ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.showModal($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" Добавить внутренний номер\n                ")])]), _vm._v(" "), (_vm.showFilter) ? _c('div', {
    staticClass: "mt-1"
  }, [_c('div', {
    staticClass: "row col-12"
  }, [_c('form', {
    attrs: {
      "сlass": "form-horizontal"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.search($event)
      }
    }
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-3 form-control-label"
  }, [_vm._v("Номер телефона")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.params.query),
      expression: "params.query"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.params.query)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.params, "query", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-3 form-control-label"
  }, [_vm._v("Пользователь")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.users,
      "searchable": true,
      "close-on-select": true,
      "show-labels": false,
      "placeholder": "Пользователь не выбран",
      "track-by": "id",
      "label": "fullname",
      "loading": _vm.loadingUsers
    },
    on: {
      "open": _vm.loadUsers,
      "input": _vm.changeUser
    }
  })], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "col-6"
  })]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "card-block admin__list"
  }, [_vm._m(0), _vm._v(" "), (_vm.loading) ? _c('loading', {
    attrs: {
      "message": "Загружаем номера..."
    }
  }) : _vm._l((_vm.items), function(item) {
    return _c('div', {
      staticClass: "row mb-1 admin__list__item admin__list__item_hover-bg-gray"
    }, [_c('div', {
      staticClass: "col-1 d-none d-md-block"
    }, [_vm._v(_vm._s(item.id))]), _vm._v(" "), _c('div', {
      staticClass: "col-2"
    }, [_vm._v(_vm._s(item.number))]), _vm._v(" "), _c('div', {
      staticClass: "col-5 col-md-7"
    }, _vm._l((item.users), function(user, index) {
      return _c('span', {
        staticClass: "badge badge-info"
      }, [_c('router-link', {
        attrs: {
          "to": {
            name: 'ViewProfile',
            params: {
              id: user.id
            }
          }
        }
      }, [_vm._v(_vm._s(user.fullname))])], 1)
    })), _vm._v(" "), _c('div', {
      staticClass: "col-2"
    }, [(_vm.blockLoading === item.id) ? _c('loading', {
      attrs: {
        "size": 2,
        "message": false
      }
    }) : [_c('button', {
      staticClass: "btn btn-primary btn-sm",
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.editItem(item)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-edit"
    }), _vm._v(" Изменить\n                        ")])]], 2)])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "card-header"
  }, [_c('b-pagination', {
    staticClass: "mb-0",
    attrs: {
      "size": "md",
      "total-rows": _vm.itemsPage.paginator.total_count,
      "per-page": _vm.itemsPage.paginator.limit
    },
    model: {
      value: (_vm.params.page),
      callback: function($$v) {
        _vm.$set(_vm.params, "page", $$v)
      },
      expression: "params.page"
    }
  })], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row mb-1 text-muted small"
  }, [_c('div', {
    staticClass: "col-1 d-none d-md-block"
  }, [_vm._v("Id")]), _vm._v(" "), _c('div', {
    staticClass: "col-2"
  }, [_vm._v("Номер")]), _vm._v(" "), _c('div', {
    staticClass: "col-5 col-md-7"
  }, [_vm._v("Пользователи")]), _vm._v(" "), _c('div', {
    staticClass: "col-3 col-md-2"
  }, [_vm._v("Действие")])])
}]}

/***/ }),
/* 1028 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-modal', {
    attrs: {
      "visible": _vm.showModal === 'closeOrder',
      "lazy": true
    },
    on: {
      "show": _vm.initModal,
      "hidden": _vm.hideCloseModal
    }
  }, [_c('div', {
    attrs: {
      "slot": "modal-title"
    },
    slot: "modal-title"
  }, [(_vm.order) ? _c('h4', [_vm._v("Закрыть заказ № " + _vm._s(_vm.order.id))]) : _vm._e()]), _vm._v(" "), (_vm.loading) ? _c('loading', {
    attrs: {
      "size": 3,
      "message": "Заказ закрывается..."
    }
  }) : _c('form', {
    attrs: {
      "сlass": "form-horizontal"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.close($event)
      }
    }
  }, [_c('div', {
    staticClass: "form-group row",
    class: {
      'has-danger': _vm.$v.sum.$error
    }
  }, [_c('label', {
    staticClass: "col-6 form-control-label",
    attrs: {
      "for": "sum-input"
    }
  }, [_vm._v("Общая сумма заказ-наряда")]), _vm._v(" "), _c('div', {
    staticClass: "col-6"
  }, [_c('input', {
    directives: [{
      name: "focus",
      rawName: "v-focus"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.sum),
      expression: "sum"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "rel": "focusThis",
      "id": "sum-input",
      "placeholder": "Сумма по заказ-наряду"
    },
    domProps: {
      "value": (_vm.sum)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.sum = $event.target.value
      }, function($event) {
        _vm.$v.sum.$touch()
      }],
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key)) { return null; }
        _vm.close($event)
      }
    }
  }), _vm._v(" "), (_vm.$v.sum.$error) ? _c('span', {
    staticClass: "small help-block text-danger"
  }, [_vm._v("Сумма заказ-наряда дожна быть больше 0")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row",
    class: {
      'has-danger': _vm.$v.profit.$error
    }
  }, [_c('label', {
    staticClass: "col-6 form-control-label",
    attrs: {
      "for": "profit-input"
    }
  }, [_vm._v("Комиссия с заказа")]), _vm._v(" "), _c('div', {
    staticClass: "col-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profit),
      expression: "profit"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "id": "profit-input",
      "placeholder": "Комиссия по заказ-наряду"
    },
    domProps: {
      "value": (_vm.profit)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.profit = $event.target.value
      }, function($event) {
        _vm.$v.profit.$touch()
      }],
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key)) { return null; }
        _vm.close($event)
      }
    }
  }), _vm._v(" "), (_vm.$v.profit.$error) ? _c('span', {
    staticClass: "small help-block text-danger"
  }, [_vm._v("Комиссия должна быть больше 0")]) : _vm._e()])]), _vm._v(" "), _c('button', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "submit"
    }
  })]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "modal-footer"
    },
    slot: "modal-footer"
  }, [(!_vm.loading) ? _c('b-btn', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.hideCloseModal($event)
      }
    }
  }, [_vm._v("Отменить")]) : _vm._e(), _vm._v(" "), (!_vm.loading) ? _c('b-btn', {
    class: {
      'disabled': _vm.$v.sum.$invalid || _vm.$v.profit.$invalid
    },
    attrs: {
      "variant": "success",
      "disabled": _vm.$v.sum.$invalid || _vm.$v.profit.$invalid
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.close($event)
      }
    }
  }, [_vm._v("Закрыть заказ")]) : _vm._e()], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1029 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-modal', {
    attrs: {
      "visible": _vm.showModal === 'OrderStatisticParams',
      "lazy": true
    },
    on: {
      "hidden": _vm.hideSearchModal
    }
  }, [_c('div', {
    attrs: {
      "slot": "modal-title"
    },
    slot: "modal-title"
  }, [_c('h4', [_vm._v("Статистика по параметрам")])]), _vm._v(" "), _c('form', {
    attrs: {
      "action": "",
      "method": "post",
      "сlass": "form-horizontal"
    }
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-3 form-control-label"
  }, [_vm._v("Дата c")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('datepicker', {
    attrs: {
      "format": "dd/MM/yyyy"
    },
    model: {
      value: (_vm.params.dateFrom),
      callback: function($$v) {
        _vm.$set(_vm.params, "dateFrom", $$v)
      },
      expression: "params.dateFrom"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-3 form-control-label"
  }, [_vm._v("Дата по")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('datepicker', {
    attrs: {
      "format": "dd/MM/yyyy"
    },
    model: {
      value: (_vm.params.dateTo),
      callback: function($$v) {
        _vm.$set(_vm.params, "dateTo", $$v)
      },
      expression: "params.dateTo"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-3 form-control-label"
  }, [_vm._v("Город")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.cities,
      "searchable": true,
      "close-on-select": true,
      "show-labels": false,
      "placeholder": "Город не выбран",
      "track-by": "id",
      "label": "name"
    },
    on: {
      "input": _vm.changeCity
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-3 form-control-label"
  }, [_vm._v("Компания")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.companies,
      "searchable": true,
      "close-on-select": true,
      "show-labels": false,
      "placeholder": "Компания не выбрана",
      "track-by": "id",
      "label": "name",
      "loading": _vm.loadingCompanies
    },
    on: {
      "input": _vm.changeCompany
    },
    model: {
      value: (_vm.companySelected),
      callback: function($$v) {
        _vm.companySelected = $$v
      },
      expression: "companySelected"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-3 form-control-label"
  }, [_vm._v("Техцентр")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.techcenters,
      "searchable": true,
      "close-on-select": true,
      "show-labels": false,
      "placeholder": "Техцентр не выбран",
      "track-by": "id",
      "label": "name",
      "loading": _vm.loadingTechcenters
    },
    model: {
      value: (_vm.techcenterSelected),
      callback: function($$v) {
        _vm.techcenterSelected = $$v
      },
      expression: "techcenterSelected"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-3 form-control-label"
  }, [_vm._v("Статус")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('multiselect', {
    attrs: {
      "value": _vm.status,
      "options": _vm.statuses,
      "searchable": true,
      "close-on-select": true,
      "show-labels": false,
      "placeholder": "Статус не выбран",
      "track-by": "code",
      "label": "name"
    },
    on: {
      "update:value": function($event) {
        _vm.status = $event
      },
      "input": _vm.setStatus
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-3 form-control-label"
  }, [_vm._v("Менеджер")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.users,
      "searchable": true,
      "close-on-select": true,
      "show-labels": false,
      "placeholder": "Менеджер не выбран",
      "track-by": "id",
      "label": "fullname",
      "loading": _vm.loadingUsers
    },
    on: {
      "input": _vm.setUserId,
      "open": _vm.loadUsers
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "modal-footer"
    },
    slot: "modal-footer"
  }, [_c('b-btn', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.hideSearchModal($event)
      }
    }
  }, [_vm._v("Отменить")]), _vm._v(" "), _c('b-btn', {
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.search($event)
      }
    }
  }, [_vm._v("Показать статистику заказов")])], 1)])
},staticRenderFns: []}

/***/ }),
/* 1030 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-modal', {
    attrs: {
      "visible": _vm.showModal === 'cancelOrder',
      "lazy": true
    },
    on: {
      "hidden": _vm.hideCancelModal
    }
  }, [_c('div', {
    attrs: {
      "slot": "modal-title"
    },
    slot: "modal-title"
  }, [(_vm.order) ? _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Отменить заказ № " + _vm._s(_vm.order.id))]) : _vm._e()]), _vm._v(" "), (_vm.loading) ? _c('loading', {
    attrs: {
      "size": 3,
      "message": "Заказ отменяется..."
    }
  }) : _c('form', {
    attrs: {
      "сlass": "form-horizontal"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.cancel($event)
      }
    }
  }, [_c('div', {
    staticClass: "form-group",
    class: {
      'has-danger': _vm.$v.text.$error
    }
  }, [_c('label', {
    staticClass: "form-control-label",
    attrs: {
      "for": "cancel-input"
    }
  }, [_vm._v("Причина отмены заказа")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.text),
      expression: "text"
    }],
    ref: "focusThis",
    staticClass: "form-control",
    attrs: {
      "id": "cancel-input",
      "rows": "4",
      "placeholder": "Укажите по какой причине заказ отменяется?"
    },
    domProps: {
      "value": (_vm.text)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.text = $event.target.value
      }, function($event) {
        _vm.$v.text.$touch()
      }]
    }
  }), _vm._v(" "), (_vm.$v.text.$error) ? _c('span', {
    staticClass: "small help-block text-danger"
  }, [_vm._v("Для отмены заказа необходимо обязательно указать причину")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "modal-footer"
    },
    slot: "modal-footer"
  }, [(!_vm.loading) ? _c('b-btn', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.hideCancelModal($event)
      }
    }
  }, [_vm._v("Не отменять")]) : _vm._e(), _vm._v(" "), (!_vm.loading) ? _c('b-btn', {
    class: {
      'disabled': _vm.$v.text.$invalid
    },
    attrs: {
      "variant": "danger",
      "disabled": _vm.$v.text.$invalid
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.cancel($event)
      }
    }
  }, [_vm._v("Отменить заказ")]) : _vm._e()], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1031 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.loading) ? _c('loading', {
    attrs: {
      "message": "Загружаем информацию..."
    }
  }) : (_vm.saving) ? _c('loading', {
    attrs: {
      "message": "Сохраняем информацию..."
    }
  }) : _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 col-sm-12 col-md-10 col-lg-8"
  }, [_c('admin-card', [_c('admin-form-input', {
    attrs: {
      "label-text": 'Название',
      "label-id": 'inputName',
      "input-require": true,
      "error": _vm.$v.newDataItem.name.$error,
      "error-text": 'Название обязательно должно быть указано, минимум 2 символа'
    },
    on: {
      "input": function($event) {
        _vm.$v.newDataItem.name.$touch()
      }
    },
    model: {
      value: (_vm.newDataItem.name),
      callback: function($$v) {
        _vm.$set(_vm.newDataItem, "name", $$v)
      },
      expression: "newDataItem.name"
    }
  }), _vm._v(" "), _c('admin-form-input', {
    attrs: {
      "label-text": 'Код',
      "label-id": 'inputCode',
      "input-require": true,
      "error": _vm.$v.newDataItem.code.$error,
      "error-text": 'Код обязательно должн быть указан, минимум 2 символа'
    },
    on: {
      "input": function($event) {
        _vm.$v.newDataItem.code.$touch()
      }
    },
    model: {
      value: (_vm.newDataItem.code),
      callback: function($$v) {
        _vm.$set(_vm.newDataItem, "code", $$v)
      },
      expression: "newDataItem.code"
    }
  }), _vm._v(" "), _c('admin-form-input', {
    attrs: {
      "label-text": 'Класс',
      "label-id": 'inputClass',
      "input-require": true,
      "error": _vm.$v.newDataItem.class.$error,
      "error-text": 'Класс обязательно должн быть указан, минимум 2 символа'
    },
    on: {
      "input": function($event) {
        _vm.$v.newDataItem.class.$touch()
      }
    },
    model: {
      value: (_vm.newDataItem.class),
      callback: function($$v) {
        _vm.$set(_vm.newDataItem, "class", $$v)
      },
      expression: "newDataItem.class"
    }
  }), _vm._v(" "), _c('admin-form-input', {
    attrs: {
      "label-text": 'Сортировка статуса',
      "label-id": 'inputSort',
      "input-require": true,
      "error": _vm.$v.newDataItem.sort.$error,
      "error-text": 'Допустимо только число'
    },
    on: {
      "input": function($event) {
        _vm.$v.newDataItem.sort.$touch()
      }
    },
    model: {
      value: (_vm.newDataItem.sort),
      callback: function($$v) {
        _vm.$set(_vm.newDataItem, "sort", $$v)
      },
      expression: "newDataItem.sort"
    }
  }), _vm._v(" "), _c('admin-form-check-box', {
    attrs: {
      "label-text": 'Активен'
    },
    model: {
      value: (_vm.newDataItem.enabled),
      callback: function($$v) {
        _vm.$set(_vm.newDataItem, "enabled", $$v)
      },
      expression: "newDataItem.enabled"
    }
  }), _vm._v(" "), _c('admin-form-multi-select', {
    attrs: {
      "options": _vm.amoStatuses,
      "label-text": 'Id соответсвующих статутсов в Amo Crm',
      "label": "name",
      "trackBy": "name",
      "multiple": true
    },
    model: {
      value: (_vm.newDataItem.amoStatuses),
      callback: function($$v) {
        _vm.$set(_vm.newDataItem, "amoStatuses", $$v)
      },
      expression: "newDataItem.amoStatuses"
    }
  }), _vm._v(" "), _c('template', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [(!_vm.loading) ? _c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.beforeUpdateForm($event)
      }
    }
  }, [(_vm.newDataItem.id) ? [_vm._v("Сохранить изменения")] : [_vm._v("Добавить статус")]], 2) : _vm._e()])], 2)], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 1032 */,
/* 1033 */,
/* 1034 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group row",
    class: {
      'has-danger': _vm.error
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-8"
  }, [_c('ap-input-phone', {
    attrs: {
      "input-id": 'inputPhone',
      "error": _vm.error
    },
    on: {
      "input": function($event) {
        _vm.$emit('input', _vm.phone)
      }
    },
    model: {
      value: (_vm.phone),
      callback: function($$v) {
        _vm.phone = $$v
      },
      expression: "phone"
    }
  })], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "col-4 col-form-label",
    attrs: {
      "for": "inputPhone"
    }
  }, [_vm._v("Номер телефона "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])])
}]}

/***/ }),
/* 1035 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-modal', {
    attrs: {
      "visible": _vm.showAdminModal === 'addEditRole',
      "size": "lg",
      "lazy": true
    },
    on: {
      "hidden": _vm.hideModal
    }
  }, [_c('div', {
    attrs: {
      "slot": "modal-title"
    },
    slot: "modal-title"
  }, [(_vm.item) ? _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Изменить роль " + _vm._s(_vm.item.name))]) : _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Добавить роль")])]), _vm._v(" "), (_vm.loading) ? _c('loading', {
    attrs: {
      "size": 3,
      "message": "Сохраняем..."
    }
  }) : _c('form', {
    attrs: {
      "сlass": "form-horizontal"
    }
  }, [_c('div', {
    staticClass: "form-group row",
    class: {
      'has-danger': _vm.$v.newDataItem.name.$error
    }
  }, [_c('label', {
    staticClass: "col-4 col-md-2 col-form-label",
    attrs: {
      "for": "item-name"
    }
  }, [_vm._v("Название (код)")]), _vm._v(" "), _c('div', {
    staticClass: "col-8 col-md-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.newDataItem.name),
      expression: "newDataItem.name",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "item-name"
    },
    domProps: {
      "value": (_vm.newDataItem.name)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newDataItem, "name", $event.target.value.trim())
      }, function($event) {
        _vm.$v.newDataItem.name.$touch()
      }],
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), (_vm.$v.newDataItem.name.$error) ? _c('span', {
    staticClass: "small help-block text-danger"
  }, [_vm._v("Название обязательно должно быть указано латиницей, минимум " + _vm._s(_vm.$v.newDataItem.name.$params.minLength.min) + " символа")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-4 col-md-2 col-form-label",
    attrs: {
      "for": "item-sort"
    }
  }, [_vm._v("Описание")]), _vm._v(" "), _c('div', {
    staticClass: "col-8 col-md-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.newDataItem.description),
      expression: "newDataItem.description",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "item-sort"
    },
    domProps: {
      "value": (_vm.newDataItem.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newDataItem, "description", $event.target.value.trim())
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-4 col-md-2 col-form-label"
  }, [_vm._v("Пользователи")]), _vm._v(" "), _c('div', {
    staticClass: "col-8 col-md-10"
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.users,
      "searchable": true,
      "multiple": true,
      "close-on-select": true,
      "show-labels": false,
      "placeholder": "Пользователи не заданы",
      "track-by": "id",
      "label": "fullname",
      "loading": _vm.loadingUsers
    },
    on: {
      "select": _vm.attachUser,
      "remove": _vm.detachUser,
      "open": _vm.loadUsers
    },
    model: {
      value: (_vm.selectedUsers),
      callback: function($$v) {
        _vm.selectedUsers = $$v
      },
      expression: "selectedUsers"
    }
  })], 1)]), _vm._v(" "), (_vm.loadingPermissions) ? _c('loading', {
    attrs: {
      "size": 3,
      "message": "Загружаем права доступа..."
    }
  }) : _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_vm._v("Права доступа")]), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, _vm._l((_vm.permissions), function(permission) {
    return _c('div', [_c('label', {
      staticClass: "switch switch-lg switch-3d switch-primary mb-2 mr-1"
    }, [_c('input', {
      staticClass: "switch-input",
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "value": _vm.newDataItem.permissions.indexOf(permission.id) !== -1,
        "checked": _vm.newDataItem.permissions.indexOf(permission.id) !== -1
      },
      on: {
        "change": function($event) {
          _vm.changePermission(_vm.newDataItem.permissions.indexOf(permission.id), permission.id)
        }
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "switch-label"
    }), _vm._v(" "), _c('span', {
      staticClass: "switch-handle"
    })]), _vm._v("\n                    " + _vm._s(permission.description) + "\n                ")])
  }))])], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "modal-footer"
    },
    slot: "modal-footer"
  }, [(!_vm.loading && !_vm.loadingPermissions) ? _c('button', {
    staticClass: "btn btn-success",
    class: {
      'disabled': _vm.$v.newDataItem.$invalid
    },
    attrs: {
      "disabled": _vm.$v.newDataItem.$invalid,
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.beforeUpdateForm($event)
      }
    }
  }, [(_vm.item) ? [_vm._v("Сохранить изменения")] : [_vm._v("Добавить роль")]], 2) : _vm._e()])], 1)
},staticRenderFns: []}

/***/ }),
/* 1036 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app"
  }, [_c('div', {
    staticClass: "app-body app flex-row align-items-center"
  }, [_c('main', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('router-view')], 1)])])])
},staticRenderFns: []}

/***/ }),
/* 1037 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('label', {
    staticClass: "col-12 form-control-label"
  }, [_vm._v("График работы")]), _vm._v(" "), _c('small', {
    staticClass: "col-12 text-muted"
  }, [_vm._v("Укажите дни и время работы техцентра")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "d-flex justify-content-between"
  }, _vm._l((_vm.workDates), function(day) {
    return _c('div', {
      key: day.id,
      staticClass: "select-day"
    }, [_c('div', {
      staticClass: "select-day__item",
      class: {
        'select-day__item--active': day.selected
      },
      on: {
        "click": function($event) {
          day.selected = !day.selected
        }
      }
    }, [_vm._v("\n          " + _vm._s(day.name) + "\n        ")])])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "col-12 mt-2"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "input-group col-5"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.timeStart),
      expression: "timeStart"
    }],
    staticClass: "form-control",
    class: {
      'disabled': _vm.allDay
    },
    attrs: {
      "disabled": _vm.allDay
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.timeStart = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.workTimes), function(item) {
    return _c('option', {
      domProps: {
        "value": item.id
      }
    }, [_vm._v("\n            " + _vm._s(item.name) + "\n          ")])
  })), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.timeEnd),
      expression: "timeEnd"
    }],
    staticClass: "form-control",
    class: {
      'disabled': _vm.allDay
    },
    attrs: {
      "disabled": _vm.allDay
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.timeEnd = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.workTimes), function(item) {
    return _c('option', {
      domProps: {
        "value": item.id
      }
    }, [_vm._v("\n            " + _vm._s(item.name) + "\n          ")])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "form-check col-3"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.allDay),
      expression: "allDay"
    }],
    staticClass: "form-check-input",
    attrs: {
      "type": "checkbox",
      "id": "infinityCheck"
    },
    domProps: {
      "checked": Array.isArray(_vm.allDay) ? _vm._i(_vm.allDay, null) > -1 : (_vm.allDay)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.allDay,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.allDay = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.allDay = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.allDay = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "form-check-label",
    attrs: {
      "for": "infinityCheck"
    }
  }, [_vm._v("Круглосуточно")])]), _vm._v(" "), _c('div', {
    staticClass: "col-4"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    class: {
      'disabled': _vm.buttonDisabled
    },
    attrs: {
      "type": "button",
      "disabled": _vm.buttonDisabled
    },
    on: {
      "click": _vm.addSchedule
    }
  }, [_vm._v("\n            Добавить\n        ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [(_vm.error) ? _c('span', {
    staticClass: "small text-danger"
  }, [_vm._v("\n        " + _vm._s(_vm.error) + "\n    ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-12 mt-2"
  }, _vm._l((_vm.schedule), function(item) {
    return _c('div', {
      key: item.id,
      staticClass: "alert alert-info"
    }, [_vm._v("\n      " + _vm._s(_vm._f("parseSchedule")(item)) + "\n      "), _c('button', {
      staticClass: "close",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.deleteSchedule(item.id)
        }
      }
    }, [_c('span', {
      staticClass: "text-primary",
      attrs: {
        "aria-hidden": "true"
      }
    }, [_vm._v("×")])])])
  }))])
},staticRenderFns: []}

/***/ }),
/* 1038 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-modal', {
    attrs: {
      "visible": _vm.showAdminModal === 'addEditCompany',
      "size": "lg",
      "lazy": true
    },
    on: {
      "hidden": _vm.hideModal
    }
  }, [_c('div', {
    attrs: {
      "slot": "modal-title"
    },
    slot: "modal-title"
  }, [(_vm.item) ? _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Изменить компанию " + _vm._s(_vm.item.name))]) : _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Добавить компанию")])]), _vm._v(" "), (_vm.loading) ? _c('loading', {
    attrs: {
      "size": 3,
      "message": "Подождите..."
    }
  }) : _c('form', {
    attrs: {
      "сlass": "form-horizontal"
    }
  }, [_c('div', {
    staticClass: "form-group row",
    class: {
      'has-danger': _vm.$v.newDataItem.name.$error
    }
  }, [_c('label', {
    staticClass: "col-4 col-md-2 col-form-label",
    attrs: {
      "for": "item-name"
    }
  }, [_vm._v("Название")]), _vm._v(" "), _c('div', {
    staticClass: "col-8 col-md-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.newDataItem.name),
      expression: "newDataItem.name",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "item-name"
    },
    domProps: {
      "value": (_vm.newDataItem.name)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newDataItem, "name", $event.target.value.trim())
      }, function($event) {
        _vm.$v.newDataItem.name.$touch()
      }],
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), (_vm.$v.newDataItem.name.$error) ? _c('span', {
    staticClass: "small help-block text-danger"
  }, [_vm._v("Название обязательно должно быть указано, минимум " + _vm._s(_vm.$v.newDataItem.name.$params.minLength.min) + " символа")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row",
    class: {
      'has-danger': _vm.$v.newDataItem.sort.$error
    }
  }, [_c('label', {
    staticClass: "col-4 col-md-2 col-form-label",
    attrs: {
      "for": "item-sort"
    }
  }, [_vm._v("Сортировка")]), _vm._v(" "), _c('div', {
    staticClass: "col-8 col-md-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.newDataItem.sort),
      expression: "newDataItem.sort",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "item-sort"
    },
    domProps: {
      "value": (_vm.newDataItem.sort)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newDataItem, "sort", $event.target.value.trim())
      }, function($event) {
        _vm.$v.newDataItem.sort.$touch()
      }],
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), (_vm.$v.newDataItem.sort.$error) ? _c('span', {
    staticClass: "small help-block text-danger"
  }, [_vm._v("Укажите число")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-4 col-md-2 col-form-label"
  }, [_vm._v("Активность компании")]), _vm._v(" "), _c('div', {
    staticClass: "col-8 col-md-4"
  }, [_c('label', {
    staticClass: "switch switch-lg switch-3d switch-primary ml-1"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newDataItem.enabled),
      expression: "newDataItem.enabled"
    }],
    staticClass: "switch-input",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.newDataItem.enabled) ? _vm._i(_vm.newDataItem.enabled, null) > -1 : (_vm.newDataItem.enabled)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.newDataItem.enabled,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.newDataItem.enabled = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.newDataItem.enabled = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.newDataItem, "enabled", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-label"
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-handle"
  }), _vm._v(" "), (_vm.newDataItem.enabled) ? _c('small', [_vm._v("включена")]) : _c('small', [_vm._v("выключена")])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2 form-control-label"
  }, [_vm._v("Руководители")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.additionalData.users,
      "searchable": true,
      "close-on-select": false,
      "show-labels": false,
      "multiple": true,
      "placeholder": "Руководители не выбран",
      "track-by": "id",
      "label": "fullname"
    },
    model: {
      value: (_vm.newDataItem.users),
      callback: function($$v) {
        _vm.$set(_vm.newDataItem, "users", $$v)
      },
      expression: "newDataItem.users"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "modal-footer"
    },
    slot: "modal-footer"
  }, [(!_vm.loading) ? _c('button', {
    staticClass: "btn btn-success",
    class: {
      'disabled': _vm.$v.newDataItem.$invalid
    },
    attrs: {
      "disabled": _vm.$v.newDataItem.$invalid,
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.beforeUpdateForm($event)
      }
    }
  }, [(_vm.item) ? [_vm._v("Сохранить изменения")] : [_vm._v("Добавить компанию")]], 2) : _vm._e()])], 1)
},staticRenderFns: []}

/***/ }),
/* 1039 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row justify-content-center animated fadeInRight"
  }, [(_vm.loading) ? _c('loading', {
    attrs: {
      "message": "Подождите..."
    }
  }) : _c('form', {
    staticClass: "col-lg-6 col-md-8 col-sm-12",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.remindEmail()
      }
    }
  }, [_c('div', {
    staticClass: "card-group mb-0"
  }, [_c('div', {
    staticClass: "card p-4"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('h1', [_vm._v("Забыли пароль?")]), _vm._v(" "), _c('p', {
    staticClass: "text-muted mt-2 mb-2"
  }, [_vm._v("\n                        Сбросить пароль используя электронну почту\n                        ")]), _vm._v(" "), (_vm.type === 'email') ? _c('div', {
    staticClass: "mb-1"
  }, [_c('div', {
    staticClass: "input-group",
    class: {
      'has-danger': _vm.error || _vm.$v.remind.email.$error
    }
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "fa fa-envelope"
  })]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.remind.email),
      expression: "remind.email"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "email",
      "type": "email",
      "placeholder": "Электронная почта"
    },
    domProps: {
      "value": (_vm.remind.email)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.remind, "email", $event.target.value)
      }, function($event) {
        _vm.$v.remind.email.$touch()
      }]
    }
  })]), _vm._v(" "), (_vm.$v.remind.email.$error) ? _c('small', {
    staticClass: "help-block text-danger"
  }, [_vm._v("Адрес электронной почты должен быть валидным")]) : _vm._e(), _vm._v(" "), (_vm.error) ? _c('small', {
    staticClass: "help-block text-danger"
  }, [_vm._v("Данный адрес электронной почты не найден")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.type === 'phone') ? _c('div', {
    staticClass: "mb-1"
  }, [_c('div', {
    staticClass: "input-group",
    class: {
      'has-danger': _vm.error
    }
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("+7")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.remind.phone),
      expression: "remind.phone"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "required": "",
      "placeholder": "Номер телефона"
    },
    domProps: {
      "value": (_vm.remind.phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.remind, "phone", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.error) ? _c('small', {
    staticClass: "help-block text-danger"
  }, [_vm._v("Данный номер телефона не найден")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 col-md-5 mb-2"
  }, [_c('button', {
    staticClass: "btn btn-primary px-4",
    class: {
      'disabled': _vm.$v.remind.$invalid
    },
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Сбросить пароль")])]), _vm._v(" "), _c('div', {
    staticClass: "col-12 col-md-7 mb-2 text-right"
  }, [_c('router-link', {
    staticClass: "btn btn-secondary",
    attrs: {
      "to": {
        name: 'Auth'
      }
    }
  }, [_vm._v("Вернуться к странице авторизации")])], 1)])])])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 1040 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-modal', {
    attrs: {
      "visible": _vm.showAdminModal === 'addEditInternalNumber',
      "size": "lg",
      "lazy": true
    },
    on: {
      "hidden": _vm.hideModal
    }
  }, [_c('div', {
    attrs: {
      "slot": "modal-title"
    },
    slot: "modal-title"
  }, [(_vm.item) ? _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Изменить внутренний номер " + _vm._s(_vm.item.number))]) : _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Добавить внутренний номер")])]), _vm._v(" "), (_vm.loading) ? _c('loading', {
    attrs: {
      "size": 3,
      "message": "Сохраняем..."
    }
  }) : _c('form', [_c('div', {
    staticClass: "form-group row",
    class: {
      'has-danger': _vm.$v.newDataItem.number.$error
    }
  }, [_c('label', {
    staticClass: "col-4 col-form-label",
    attrs: {
      "for": "item-number"
    }
  }, [_vm._v("Номер телефона")]), _vm._v(" "), _c('div', {
    staticClass: "col-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.newDataItem.number),
      expression: "newDataItem.number",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "item-number"
    },
    domProps: {
      "value": (_vm.newDataItem.number)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newDataItem, "number", $event.target.value.trim())
      }, function($event) {
        _vm.$v.newDataItem.number.$touch()
      }],
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), (_vm.$v.newDataItem.number.$error) ? _c('span', {
    staticClass: "small help-block text-danger"
  }, [_vm._v("Внутренний номер должн быть указан и состоять из " + _vm._s(_vm.$v.newDataItem.number.$params.minLength.min) + " цифр")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-4 form-control-label"
  }, [_vm._v("Пользователи")]), _vm._v(" "), _c('div', {
    staticClass: "col-8"
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.users,
      "searchable": true,
      "multiple": true,
      "close-on-select": true,
      "show-labels": false,
      "placeholder": "Пользователи не заданы",
      "track-by": "id",
      "label": "fullname",
      "loading": _vm.loadingUsers
    },
    on: {
      "select": _vm.attachUser,
      "remove": _vm.detachUser,
      "open": _vm.loadUsers
    },
    model: {
      value: (_vm.selectedUsers),
      callback: function($$v) {
        _vm.selectedUsers = $$v
      },
      expression: "selectedUsers"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "modal-footer"
    },
    slot: "modal-footer"
  }, [(!_vm.loading) ? _c('button', {
    staticClass: "btn btn-success",
    class: {
      'disabled': _vm.$v.newDataItem.$invalid
    },
    attrs: {
      "disabled": _vm.$v.newDataItem.$invalid,
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.beforeUpdateForm($event)
      }
    }
  }, [(_vm.item) ? [_vm._v("Сохранить изменения")] : [_vm._v("Добавить внутренний номер")]], 2) : _vm._e()])], 1)
},staticRenderFns: []}

/***/ }),
/* 1041 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.loading) ? _c('div', {
    staticClass: "app"
  }, [_c('div', {
    staticClass: "app-body app flex-row align-items-center"
  }, [_c('main', {
    staticClass: "main"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row justify-content-center"
  }, [_c('loading', {
    attrs: {
      "message": "Аларм План запускается..."
    }
  })], 1)])])])]) : _c('div', {
    staticClass: "app"
  }, [(_vm.$route.meta.isIframe) ? [_c('div', {
    staticClass: "app-body m-0 mt-2"
  }, [_c('main', {
    staticClass: "main m-0"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('router-view')], 1)])])] : [_c('AppHeader'), _vm._v(" "), _c('div', {
    staticClass: "app-body"
  }, [_c('Sidebar'), _vm._v(" "), _c('main', {
    staticClass: "main"
  }, [_c('breadcrumb', {
    attrs: {
      "list": _vm.list
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "container-fluid"
  }, [_c('router-view')], 1)], 1)], 1), _vm._v(" "), _c('AppFooter')], _vm._v(" "), _c('ModalCloseOrder'), _vm._v(" "), _c('ModalCancelOrder'), _vm._v(" "), _c('ModalProblemOrder'), _vm._v(" "), _c('ModalTransitionOrderConfirm'), _vm._v(" "), _c('ModalEditOrder'), _vm._v(" "), _c('ModalAdminAddUser'), _vm._v(" "), _c('ModalAdminAddEditCity'), _vm._v(" "), _c('ModalAdminAddEditCompany'), _vm._v(" "), _c('ModalAdminAddEditRole'), _vm._v(" "), _c('ModalAdminAddEditVirtualNumber'), _vm._v(" "), _c('ModalsOrdersStatisticParams'), _vm._v(" "), _c('ModalAdminAddEditInternalNumber'), _vm._v(" "), _c('ModalUpdatePage')], 2)])
},staticRenderFns: []}

/***/ }),
/* 1042 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.loading) ? _c('loading', {
    attrs: {
      "size": 2,
      "message": false
    }
  }) : _c('div', [(_vm.order.canOrderUpdate && !_vm.order.canceled) ? _c('button', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.ModalEditOrder",
      modifiers: {
        "ModalEditOrder": true
      }
    }, {
      name: "b-tooltip",
      rawName: "v-b-tooltip"
    }],
    staticClass: "btn btn-sm btn-primary",
    attrs: {
      "title": "Изменить заказ"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.initEditOrder($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-pencil"
  })]) : _vm._e(), _vm._v(" "), (_vm.order.canOrderDelete) ? _c('button', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip"
    }],
    staticClass: "btn btn-sm btn-danger",
    attrs: {
      "title": "Удалить заказ"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.removeOrder()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-trash"
  })]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 1043 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "add-image col-12"
  }, [_c('div', {
    staticClass: "add-image__title"
  }, [_vm._v("Фотографии")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_vm._l((_vm.files), function(image) {
    return _c('div', {
      key: image.id,
      staticClass: "position-relative col-3"
    }, [_c('div', {
      staticClass: "add-image__image",
      on: {
        "click": function($event) {
          _vm.handleImage(image.fullPath)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": image.fullPath
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "add-image__delete",
      on: {
        "click": function($event) {
          _vm.removeFile(image.id)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-times fa-2x"
    })])])
  }), _vm._v(" "), (_vm.maxFiles !== false) ? _c('div', {
    staticClass: "add-image__image col-3"
  }, [_c('div', {
    staticClass: "add-image__add-button",
    class: {
      'add-image__add-button--loading': _vm.loading
    },
    on: {
      "click": function($event) {
        _vm.inputInit()
      }
    }
  }, [_c('div', {
    staticClass: "text-center pt-2"
  }, [_c('i', {
    staticClass: "fa fa-plus-circle fa-3x",
    class: {
      'fa-spin': _vm.loading
    }
  }), _vm._v(" "), (_vm.loading) ? _c('p', [_vm._v("Сохранение...")]) : _c('p', [_vm._v(_vm._s(_vm.maxFiles))])])])]) : _vm._e()], 2), _vm._v(" "), _c('input', {
    ref: "fileInput",
    attrs: {
      "type": "file",
      "name": "img",
      "multiple": "",
      "accept": _vm.acceptTypes
    },
    on: {
      "change": _vm.beforeOnFileChange
    }
  }), _vm._v(" "), _c('Lightbox', {
    attrs: {
      "visible": _vm.visible,
      "imgs": _vm.imgUrls,
      "index": _vm.index
    },
    on: {
      "hide": function($event) {
        _vm.handleImage('')
      }
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1044 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group row",
    class: {
      'has-danger': _vm.error
    }
  }, [_c('label', {
    staticClass: "col-4 col-form-label",
    attrs: {
      "for": _vm.labelId
    }
  }, [_vm._v(_vm._s(_vm.labelText) + "\n    "), (_vm.inputRequire) ? _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-8"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "id": _vm.labelId,
      "type": _vm.inputType,
      "autocomplete": "off"
    },
    domProps: {
      "value": _vm.value
    },
    on: {
      "input": function($event) {
        _vm.changeValue($event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.error) ? _c('span', {
    staticClass: "small help-block text-danger"
  }, [_vm._v(_vm._s(_vm.errorText))]) : _vm._e()])])
},staticRenderFns: []}

/***/ }),
/* 1045 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-pagination', {
    staticClass: "mb-0",
    attrs: {
      "size": "md",
      "total-rows": _vm.paginator.total_count,
      "per-page": _vm.paginator.limit
    },
    model: {
      value: (_vm.page),
      callback: function($$v) {
        _vm.page = $$v
      },
      expression: "page"
    }
  })
},staticRenderFns: []}

/***/ }),
/* 1046 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group row",
    class: {
      'has-danger': _vm.error
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-8"
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.companies,
      "searchable": true,
      "close-on-select": true,
      "show-labels": false,
      "value": _vm.company,
      "loading": _vm.loading,
      "placeholder": "Компания не выбрана",
      "track-by": "id",
      "label": "name",
      "autocomplete": "off"
    },
    on: {
      "open": _vm.loadCompanies,
      "input": _vm.changeCompany
    }
  }, [_c('span', {
    attrs: {
      "slot": "noResult"
    },
    slot: "noResult"
  }, [_vm._v("Компания не найдена.")])]), _vm._v(" "), (_vm.error) ? _c('span', {
    staticClass: "small help-block text-danger"
  }, [_vm._v("Компания обязательно должена быть указана")]) : _vm._e()], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "col-4 col-form-label"
  }, [_vm._v("Компания "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])])
}]}

/***/ }),
/* 1047 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-modal', {
    attrs: {
      "visible": _vm.showAdminModal === 'addEditTechcenter',
      "size": "lg",
      "lazy": true
    },
    on: {
      "hidden": _vm.hideModal
    }
  }, [_c('div', {
    attrs: {
      "slot": "modal-title"
    },
    slot: "modal-title"
  }, [(_vm.item) ? _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Изменить техцентр " + _vm._s(_vm.item.name))]) : _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Добавить техцентр")])]), _vm._v(" "), (_vm.loading) ? _c('loading', {
    attrs: {
      "size": 3,
      "message": "Сохраняем..."
    }
  }) : _c('form', {
    attrs: {
      "сlass": "form-horizontal"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 col-md-6"
  }, [_c('div', {
    staticClass: "form-group row",
    class: {
      'has-danger': _vm.$v.newDataItem.name.$error
    }
  }, [_c('label', {
    staticClass: "col-4 col-form-label",
    attrs: {
      "for": "item-name"
    }
  }, [_vm._v("Название")]), _vm._v(" "), _c('div', {
    staticClass: "col-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.newDataItem.name),
      expression: "newDataItem.name",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "item-name"
    },
    domProps: {
      "value": (_vm.newDataItem.name)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newDataItem, "name", $event.target.value.trim())
      }, function($event) {
        _vm.$v.newDataItem.name.$touch()
      }],
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), (_vm.$v.newDataItem.name.$error) ? _c('span', {
    staticClass: "small help-block text-danger"
  }, [_vm._v("Название обязательно должно быть указано, минимум " + _vm._s(_vm.$v.newDataItem.name.$params.minLength.min) + " символа")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row",
    class: {
      'has-danger': _vm.$v.newDataItem.cityId.$error
    }
  }, [_c('label', {
    staticClass: "col-4 form-control-label"
  }, [_vm._v("Город")]), _vm._v(" "), _c('div', {
    staticClass: "col-8"
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.cities,
      "searchable": true,
      "close-on-select": true,
      "show-labels": false,
      "placeholder": "Город не выбран",
      "track-by": "id",
      "label": "name"
    },
    on: {
      "input": _vm.changeCity
    },
    model: {
      value: (_vm.selected.city),
      callback: function($$v) {
        _vm.$set(_vm.selected, "city", $$v)
      },
      expression: "selected.city"
    }
  }), _vm._v(" "), (_vm.$v.newDataItem.cityId.$error) ? _c('span', {
    staticClass: "small help-block text-danger"
  }, [_vm._v("Город обязательно должен быть указан")]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row",
    class: {
      'has-danger': _vm.$v.newDataItem.address.$error
    }
  }, [_c('label', {
    staticClass: "col-4 col-form-label",
    attrs: {
      "for": "item-address"
    }
  }, [_vm._v("Адрес")]), _vm._v(" "), _c('div', {
    staticClass: "col-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.newDataItem.address),
      expression: "newDataItem.address",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "item-address"
    },
    domProps: {
      "value": (_vm.newDataItem.address)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newDataItem, "address", $event.target.value.trim())
      }, function($event) {
        _vm.changeAddress()
      }],
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), (_vm.$v.newDataItem.address.$error) ? _c('span', {
    staticClass: "small help-block text-danger"
  }, [_vm._v("Адрес обязательно должн быть указан, минимум " + _vm._s(_vm.$v.newDataItem.address.$params.minLength.min) + " символа")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row",
    class: {
      'has-danger': _vm.$v.newDataItem.phone.$error
    }
  }, [_c('label', {
    staticClass: "col-4 col-form-label",
    attrs: {
      "for": "user-phone"
    }
  }, [_vm._v("Номер телефона")]), _vm._v(" "), _c('div', {
    staticClass: "col-8"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("+7")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.newDataItem.phone),
      expression: "newDataItem.phone",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "user-phone"
    },
    domProps: {
      "value": (_vm.newDataItem.phone)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newDataItem, "phone", $event.target.value.trim())
      }, function($event) {
        _vm.$v.newDataItem.phone.$touch()
      }],
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), (_vm.$v.newDataItem.phone.$error) ? _c('span', {
    staticClass: "small help-block text-danger"
  }, [_vm._v("Телефон обязателен и должен состоять из 10 цифр")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-4 form-control-label"
  }, [_vm._v("График работы")]), _vm._v(" "), _c('div', {
    staticClass: "col-8"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group col-6"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newDataItem.workDateStart),
      expression: "newDataItem.workDateStart"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.newDataItem, "workDateStart", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.workDates), function(item) {
    return _c('option', {
      domProps: {
        "value": item.id
      }
    }, [_vm._v(_vm._s(item.name))])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-6"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newDataItem.workDateEnd),
      expression: "newDataItem.workDateEnd"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.newDataItem, "workDateEnd", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.workDates), function(item) {
    return _c('option', {
      domProps: {
        "value": item.id
      }
    }, [_vm._v(_vm._s(item.name))])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-6"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newDataItem.workTimeStart),
      expression: "newDataItem.workTimeStart"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.newDataItem, "workTimeStart", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.workTimes), function(item) {
    return _c('option', {
      domProps: {
        "value": item.id
      }
    }, [_vm._v(_vm._s(item.name))])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-6"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newDataItem.workTimeEnd),
      expression: "newDataItem.workTimeEnd"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.newDataItem, "workTimeEnd", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.workTimes), function(item) {
    return _c('option', {
      domProps: {
        "value": item.id
      }
    }, [_vm._v(_vm._s(item.name))])
  }))])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-4 form-control-label"
  }, [_vm._v("Часовой пояс")]), _vm._v(" "), _c('div', {
    staticClass: "col-8"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newDataItem.tzOffset),
      expression: "newDataItem.tzOffset"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.newDataItem, "tzOffset", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.tzOffsets), function(item) {
    return _c('option', {
      domProps: {
        "value": item.id
      }
    }, [_vm._v(_vm._s(item.name))])
  }))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-4 form-control-label"
  }, [_vm._v("Цвет")]), _vm._v(" "), _c('div', {
    staticClass: "col-8"
  }, [_c('color-picker', {
    attrs: {
      "value": _vm.color
    },
    on: {
      "input": _vm.updateColorValue
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-12 col-md-6"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-6 col-form-label"
  }, [_vm._v("Активность техцентра")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 text-right"
  }, [_c('label', {
    staticClass: "switch switch-lg switch-3d switch-primary mr-1"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newDataItem.enabled),
      expression: "newDataItem.enabled"
    }],
    staticClass: "switch-input",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.newDataItem.enabled) ? _vm._i(_vm.newDataItem.enabled, null) > -1 : (_vm.newDataItem.enabled)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.newDataItem.enabled,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.newDataItem.enabled = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.newDataItem.enabled = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.newDataItem, "enabled", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-label"
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-handle"
  }), _vm._v(" "), (_vm.newDataItem.enabled) ? _c('small', [_vm._v("включен")]) : _c('small', [_vm._v("выключен")])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row",
    class: {
      'has-danger': _vm.$v.newDataItem.companyId.$error
    }
  }, [_c('label', {
    staticClass: "col-4 form-control-label"
  }, [_vm._v("Компания")]), _vm._v(" "), _c('div', {
    staticClass: "col-8"
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.companies,
      "searchable": true,
      "close-on-select": true,
      "show-labels": false,
      "placeholder": "Компания не выбран",
      "track-by": "id",
      "label": "name",
      "loading": _vm.loadingCompanies
    },
    on: {
      "input": _vm.changeCompany,
      "open": _vm.loadCompanies
    },
    model: {
      value: (_vm.selected.company),
      callback: function($$v) {
        _vm.$set(_vm.selected, "company", $$v)
      },
      expression: "selected.company"
    }
  }), _vm._v(" "), (_vm.$v.newDataItem.companyId.$error) ? _c('span', {
    staticClass: "small help-block text-danger"
  }, [_vm._v("Компания обязательно должна быть указана")]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-4 form-control-label"
  }, [_vm._v("Пользователи")]), _vm._v(" "), _c('div', {
    staticClass: "col-8"
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.users,
      "searchable": true,
      "multiple": true,
      "close-on-select": true,
      "show-labels": false,
      "placeholder": "Пользователи не заданы",
      "track-by": "id",
      "label": "fullname",
      "loading": _vm.loadingUsers
    },
    on: {
      "select": _vm.attachUser,
      "remove": _vm.detachUser,
      "open": _vm.loadUsers
    },
    model: {
      value: (_vm.selected.users),
      callback: function($$v) {
        _vm.$set(_vm.selected, "users", $$v)
      },
      expression: "selected.users"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row",
    class: {
      'has-danger': _vm.$v.newDataItem.maxOrders.$error
    }
  }, [_c('label', {
    staticClass: "col-4 col-form-label",
    attrs: {
      "for": "item-maxOrders"
    }
  }, [_vm._v("Максимальное число заказов")]), _vm._v(" "), _c('div', {
    staticClass: "col-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.newDataItem.maxOrders),
      expression: "newDataItem.maxOrders",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "id": "item-maxOrders"
    },
    domProps: {
      "value": (_vm.newDataItem.maxOrders)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newDataItem, "maxOrders", $event.target.value.trim())
      }, function($event) {
        _vm.$v.newDataItem.maxOrders.$touch()
      }],
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), (_vm.$v.newDataItem.maxOrders.$error) ? _c('span', {
    staticClass: "small help-block text-danger"
  }, [_vm._v("Число заказов должно быть больше 0")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_vm._v("Условия сотрудничеста (комиссия в процентах)")]), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "form-group row",
    class: {
      'has-danger': _vm.$v.newDataItem.commissionInstall.$error
    }
  }, [_c('label', {
    staticClass: "col-8 col-form-label",
    attrs: {
      "for": "item-commissionInstall"
    }
  }, [_vm._v("От установки")]), _vm._v(" "), _c('div', {
    staticClass: "col-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.newDataItem.commissionInstall),
      expression: "newDataItem.commissionInstall",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "id": "item-commissionInstall"
    },
    domProps: {
      "value": (_vm.newDataItem.commissionInstall)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newDataItem, "commissionInstall", $event.target.value.trim())
      }, function($event) {
        _vm.$v.newDataItem.commissionInstall.$touch()
      }],
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), (_vm.$v.newDataItem.commissionInstall.$error) ? _c('span', {
    staticClass: "small help-block text-danger"
  }, [_vm._v("Число должно быть больше 0")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row",
    class: {
      'has-danger': _vm.$v.newDataItem.commissionReclamation.$error
    }
  }, [_c('label', {
    staticClass: "col-8 col-form-label",
    attrs: {
      "for": "item-commissionReclamation"
    }
  }, [_vm._v("От рекламации")]), _vm._v(" "), _c('div', {
    staticClass: "col-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.newDataItem.commissionReclamation),
      expression: "newDataItem.commissionReclamation",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "id": "item-commissionReclamation"
    },
    domProps: {
      "value": (_vm.newDataItem.commissionReclamation)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newDataItem, "commissionReclamation", $event.target.value.trim())
      }, function($event) {
        _vm.$v.newDataItem.commissionReclamation.$touch()
      }],
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), (_vm.$v.newDataItem.commissionReclamation.$error) ? _c('span', {
    staticClass: "small help-block text-danger"
  }, [_vm._v("Число должно быть больше 0")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row",
    class: {
      'has-danger': _vm.$v.newDataItem.commissionRetail.$error
    }
  }, [_c('label', {
    staticClass: "col-8 col-form-label",
    attrs: {
      "for": "item-commissionRetail"
    }
  }, [_vm._v("От продажи в розницу")]), _vm._v(" "), _c('div', {
    staticClass: "col-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.newDataItem.commissionRetail),
      expression: "newDataItem.commissionRetail",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "id": "item-commissionRetail"
    },
    domProps: {
      "value": (_vm.newDataItem.commissionRetail)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newDataItem, "commissionRetail", $event.target.value.trim())
      }, function($event) {
        _vm.$v.newDataItem.commissionRetail.$touch()
      }],
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), (_vm.$v.newDataItem.commissionRetail.$error) ? _c('span', {
    staticClass: "small help-block text-danger"
  }, [_vm._v("Число должно быть больше 0")]) : _vm._e()])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "form-group row",
    class: {
      'has-danger': _vm.$v.newDataItem.link.$error
    }
  }, [_c('label', {
    staticClass: "col-4 col-form-label",
    attrs: {
      "for": "item-link"
    }
  }, [_vm._v("Ссылка на схему проезда")]), _vm._v(" "), _c('div', {
    staticClass: "col-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.newDataItem.link),
      expression: "newDataItem.link",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "item-link"
    },
    domProps: {
      "value": (_vm.newDataItem.link)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newDataItem, "link", $event.target.value.trim())
      }, function($event) {
        _vm.$v.newDataItem.link.$touch()
      }],
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), (_vm.$v.newDataItem.link.$error) ? _c('span', {
    staticClass: "small help-block text-danger"
  }, [_vm._v("Обязательно укажите ссылку на\n                    "), _c('a', {
    attrs: {
      "href": "https://maps.yandex.ru",
      "target": "_blank"
    }
  }, [_vm._v("Яндекс.Картах")]), _vm._v(",\n                    "), _c('a', {
    attrs: {
      "href": "https://www.google.ru/maps",
      "target": "_blank"
    }
  }, [_vm._v("Google Картах")]), _vm._v("\n                    или  "), _c('a', {
    attrs: {
      "href": "https://2gis.ru/",
      "target": "_blank"
    }
  }, [_vm._v("2 Gis")])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-4 col-form-label",
    attrs: {
      "for": "item-description"
    }
  }, [_vm._v("Описание проезда")]), _vm._v(" "), _c('div', {
    staticClass: "col-8"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.newDataItem.description),
      expression: "newDataItem.description",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "item-description",
      "placeholder": "Введите описание схемы проезда"
    },
    domProps: {
      "value": (_vm.newDataItem.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newDataItem, "description", $event.target.value.trim())
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })])])]), _vm._v(" "), _c('yandex-map', {
    staticStyle: {
      "width": "100%",
      "height": "400px"
    },
    attrs: {
      "coords": _vm.coords,
      "zoom": "11",
      "cluster-options": {
        1: {
          clusterDisableClickZoom: true
        }
      },
      "map-type": "map",
      "placemarks": _vm.placemarks
    },
    on: {
      "map-was-initialized": function($event) {}
    }
  })], 1)]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "modal-footer"
    },
    slot: "modal-footer"
  }, [(!_vm.loading) ? _c('button', {
    staticClass: "btn btn-success",
    class: {
      'disabled': _vm.$v.newDataItem.$invalid
    },
    attrs: {
      "disabled": _vm.$v.newDataItem.$invalid,
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.beforeUpdateForm($event)
      }
    }
  }, [(_vm.item) ? [_vm._v("Сохранить изменения")] : [_vm._v("Добавить техцентр")]], 2) : _vm._e()])], 1)
},staticRenderFns: []}

/***/ }),
/* 1048 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.loading) ? _c('loading', {
    attrs: {
      "message": "Загружаем информацию..."
    }
  }) : (_vm.saving) ? _c('loading', {
    attrs: {
      "message": "Сохраняем информацию..."
    }
  }) : _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 col-sm-12 col-md-10 col-lg-8"
  }, [_c('admin-card', [_c('admin-form-multi-select', {
    attrs: {
      "options": _vm.entityTypeOptions,
      "label-text": 'Тип сущности к которой относится',
      "error": _vm.$v.newDataItem.entityType.$error,
      "error-text": 'Тип обязательно должн быть указан'
    },
    on: {
      "input": function($event) {
        _vm.$v.newDataItem.entityType.$touch()
      }
    },
    model: {
      value: (_vm.newDataItem.entityType),
      callback: function($$v) {
        _vm.$set(_vm.newDataItem, "entityType", $$v)
      },
      expression: "newDataItem.entityType"
    }
  }), _vm._v(" "), _c('admin-form-input', {
    attrs: {
      "label-text": 'Название',
      "label-id": 'inputName',
      "input-require": true,
      "error": _vm.$v.newDataItem.name.$error,
      "error-text": 'Название обязательно должно быть указано, минимум 2 символа'
    },
    on: {
      "input": function($event) {
        _vm.$v.newDataItem.name.$touch()
      }
    },
    model: {
      value: (_vm.newDataItem.name),
      callback: function($$v) {
        _vm.$set(_vm.newDataItem, "name", $$v)
      },
      expression: "newDataItem.name"
    }
  }), _vm._v(" "), _c('admin-form-multi-select', {
    attrs: {
      "options": _vm.typeOptions,
      "label-text": 'Тип поля',
      "error": _vm.$v.newDataItem.type.$error,
      "error-text": 'Тип обязательно должн быть указан'
    },
    on: {
      "input": function($event) {
        _vm.$v.newDataItem.type.$touch()
      }
    },
    model: {
      value: (_vm.newDataItem.type),
      callback: function($$v) {
        _vm.$set(_vm.newDataItem, "type", $$v)
      },
      expression: "newDataItem.type"
    }
  }), _vm._v(" "), _c('admin-form-input', {
    attrs: {
      "label-text": 'Код (разделяя точкой группы)',
      "label-id": 'inputCode',
      "input-require": true,
      "error": _vm.$v.newDataItem.code.$error,
      "error-text": 'Код обязательно должн быть указан, минимум 2 символа'
    },
    on: {
      "input": function($event) {
        _vm.$v.newDataItem.code.$touch()
      }
    },
    model: {
      value: (_vm.newDataItem.code),
      callback: function($$v) {
        _vm.$set(_vm.newDataItem, "code", $$v)
      },
      expression: "newDataItem.code"
    }
  }), _vm._v(" "), _c('admin-form-input', {
    attrs: {
      "label-text": 'Идентификатор поля в AmoCrm',
      "label-id": 'inputAmoId',
      "input-require": false,
      "error": _vm.$v.newDataItem.amoId.$error,
      "error-text": 'Идентификатор должен состоять из цифр'
    },
    on: {
      "input": function($event) {
        _vm.$v.newDataItem.amoId.$touch()
      }
    },
    model: {
      value: (_vm.newDataItem.amoId),
      callback: function($$v) {
        _vm.$set(_vm.newDataItem, "amoId", $$v)
      },
      expression: "newDataItem.amoId"
    }
  }), _vm._v(" "), _c('admin-form-input', {
    attrs: {
      "label-text": 'Сортировка поля в карточке',
      "label-id": 'inputSort',
      "input-require": false,
      "error": _vm.$v.newDataItem.sort.$error,
      "error-text": 'Допустимо только число'
    },
    on: {
      "input": function($event) {
        _vm.$v.newDataItem.sort.$touch()
      }
    },
    model: {
      value: (_vm.newDataItem.sort),
      callback: function($$v) {
        _vm.$set(_vm.newDataItem, "sort", $$v)
      },
      expression: "newDataItem.sort"
    }
  }), _vm._v(" "), _c('admin-form-check-box', {
    attrs: {
      "label-text": 'Обязательно для заполнения при редактировании'
    },
    model: {
      value: (_vm.newDataItem.required),
      callback: function($$v) {
        _vm.$set(_vm.newDataItem, "required", $$v)
      },
      expression: "newDataItem.required"
    }
  }), _vm._v(" "), _c('admin-form-check-box', {
    attrs: {
      "label-text": 'Значение сможет видеть любой пользователь, который имеет доступ к просмотру сущности'
    },
    model: {
      value: (_vm.newDataItem.viewed),
      callback: function($$v) {
        _vm.$set(_vm.newDataItem, "viewed", $$v)
      },
      expression: "newDataItem.viewed"
    }
  }), _vm._v(" "), _c('admin-form-check-box', {
    attrs: {
      "label-text": 'Значение сможет редактировать любой пользователь, который имеет доступ к редактированию сущности'
    },
    model: {
      value: (_vm.newDataItem.editable),
      callback: function($$v) {
        _vm.$set(_vm.newDataItem, "editable", $$v)
      },
      expression: "newDataItem.editable"
    }
  }), _vm._v(" "), _c('template', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [(!_vm.loading) ? _c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.beforeUpdateForm($event)
      }
    }
  }, [(_vm.newDataItem.id) ? [_vm._v("Сохранить изменения")] : [_vm._v("Добавить кастомное поле")]], 2) : _vm._e()])], 2)], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 1049 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-modal', {
    attrs: {
      "visible": _vm.showAdminModal === 'addEditVirtualNumber',
      "size": "lg",
      "lazy": true
    },
    on: {
      "hidden": _vm.hideModal
    }
  }, [_c('div', {
    attrs: {
      "slot": "modal-title"
    },
    slot: "modal-title"
  }, [(_vm.item) ? _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Изменить виртуальный номер " + _vm._s(_vm.item.number))]) : _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Добавить виртуальный номер")])]), _vm._v(" "), (_vm.loading) ? _c('loading', {
    attrs: {
      "size": 3,
      "message": "Сохраняем..."
    }
  }) : _c('form', [_c('div', {
    staticClass: "form-group row",
    class: {
      'has-danger': _vm.$v.newDataItem.number.$error
    }
  }, [_c('label', {
    staticClass: "col-4 col-form-label",
    attrs: {
      "for": "item-number"
    }
  }, [_vm._v("Номер телефона")]), _vm._v(" "), _c('div', {
    staticClass: "col-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.newDataItem.number),
      expression: "newDataItem.number",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "item-number"
    },
    domProps: {
      "value": (_vm.newDataItem.number)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newDataItem, "number", $event.target.value.trim())
      }, function($event) {
        _vm.$v.newDataItem.number.$touch()
      }],
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), (_vm.$v.newDataItem.number.$error) ? _c('span', {
    staticClass: "small help-block text-danger"
  }, [_vm._v("Номер телефона обязательн должн быть указан, минимум " + _vm._s(_vm.$v.newDataItem.name.$params.minLength.min) + " символов, только цифры")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row",
    class: {
      'has-danger': _vm.$v.newDataItem.name.$error
    }
  }, [_c('label', {
    staticClass: "col-4 col-form-label",
    attrs: {
      "for": "item-name"
    }
  }, [_vm._v("Название")]), _vm._v(" "), _c('div', {
    staticClass: "col-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.newDataItem.name),
      expression: "newDataItem.name",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "item-name"
    },
    domProps: {
      "value": (_vm.newDataItem.name)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newDataItem, "name", $event.target.value.trim())
      }, function($event) {
        _vm.$v.newDataItem.name.$touch()
      }],
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), (_vm.$v.newDataItem.name.$error) ? _c('span', {
    staticClass: "small help-block text-danger"
  }, [_vm._v("Название обязательно должно быть указано, минимум " + _vm._s(_vm.$v.newDataItem.name.$params.minLength.min) + " символа")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-4 form-control-label"
  }, [_vm._v("Город")]), _vm._v(" "), _c('div', {
    staticClass: "col-8"
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.cities,
      "searchable": true,
      "close-on-select": true,
      "show-labels": false,
      "placeholder": "Город не выбран",
      "track-by": "id",
      "label": "name"
    },
    on: {
      "input": _vm.changeCity
    },
    model: {
      value: (_vm.selected.city),
      callback: function($$v) {
        _vm.$set(_vm.selected, "city", $$v)
      },
      expression: "selected.city"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-4 col-form-label",
    attrs: {
      "for": "item-country"
    }
  }, [_vm._v("Страна")]), _vm._v(" "), _c('div', {
    staticClass: "col-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.newDataItem.country),
      expression: "newDataItem.country",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "item-country"
    },
    domProps: {
      "value": (_vm.newDataItem.country)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newDataItem, "country", $event.target.value.trim())
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-4 col-form-label",
    attrs: {
      "for": "item-site"
    }
  }, [_vm._v("Сайт")]), _vm._v(" "), _c('div', {
    staticClass: "col-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.newDataItem.site),
      expression: "newDataItem.site",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "item-site"
    },
    domProps: {
      "value": (_vm.newDataItem.site)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newDataItem, "site", $event.target.value.trim())
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "modal-footer"
    },
    slot: "modal-footer"
  }, [(!_vm.loading) ? _c('button', {
    staticClass: "btn btn-success",
    class: {
      'disabled': _vm.$v.newDataItem.$invalid
    },
    attrs: {
      "disabled": _vm.$v.newDataItem.$invalid,
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.beforeUpdateForm($event)
      }
    }
  }, [(_vm.item) ? [_vm._v("Сохранить изменения")] : [_vm._v("Добавить виртуальный номер")]], 2) : _vm._e()])], 1)
},staticRenderFns: []}

/***/ }),
/* 1050 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.loading) ? _c('loading', {
    attrs: {
      "message": "Получаем информацию по свободным местам..."
    }
  }) : _c('div', [_c('h3', [_vm._v("Список заказов на ближайшие две недели")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, _vm._l((_vm.chunk(_vm.days, 14)), function(chunk) {
    return _c('div', {
      staticClass: "col"
    }, _vm._l((chunk), function(date) {
      return _c('div', {
        staticClass: "card"
      }, [(_vm.isClosed(date)) ? [_c('div', {
        staticClass: "card-header text-danger"
      }, [_vm._v("\n            " + _vm._s(_vm.convertDataToString(date)) + "\n          ")]), _vm._v(" "), _c('div', {
        staticClass: "card-block bg-danger"
      }, [_vm._v("\n            Закрыто\n          ")])] : (_vm.getOrdersByDate(date) && _vm.getOrdersByDate(date).length === 0) ? [_c('div', {
        staticClass: "card-header text-success"
      }, [_vm._v("\n            " + _vm._s(_vm.convertDataToString(date)) + " - все свободно\n          ")]), _vm._v(" "), _c('div', {
        staticClass: "card-block bg-success"
      }, _vm._l((_vm.getFreeTimesAll(date)), function(dateTime) {
        return _c('button', {
          staticClass: "btn btn-primary btn-sm",
          on: {
            "click": function($event) {
              _vm.selectDate(dateTime.format('DD.MM.YYYY'), dateTime.format('HH:mm'))
            }
          }
        }, [_vm._v(_vm._s(dateTime.format('HH:mm')))])
      }))] : [_c('div', {
        staticClass: "card-block"
      }, [_c('div', {
        staticClass: "card-header text-warning"
      }, [_vm._v("\n              " + _vm._s(_vm.convertDataToString(date)) + " - местами занято\n            ")]), _vm._v(" "), _vm._l((_vm.getOrdersByDate(date)), function(obj, index) {
        return [(obj.orders.length === 0) ? _c('div', {
          staticClass: "row"
        }, [_c('div', {
          staticClass: "col-1"
        }, [_c('button', {
          staticClass: "btn btn-primary btn-sm",
          on: {
            "click": function($event) {
              _vm.selectDate(obj.dateTime.format('DD.MM.YYYY'), obj.dateTime.format('HH:mm'))
            }
          }
        }, [_vm._v("\n                    " + _vm._s(obj.dateTime.format('HH:mm')))])]), _vm._v(" "), _c('div', {
          staticClass: "col"
        }, [_vm._v("Свободно")])]) : _vm._l((obj.orders), function(order) {
          return _c('div', {
            staticClass: "row"
          }, [_c('div', {
            staticClass: "col-1"
          }, [_c('button', {
            staticClass: "btn btn-danger btn-sm",
            on: {
              "click": function($event) {
                _vm.selectDate(obj.dateTime.format('DD.MM.YYYY'), order.time)
              }
            }
          }, [_vm._v(_vm._s(order.time))])]), _vm._v(" "), _c('div', {
            staticClass: "col-7"
          }, [_vm._v("\n                  " + _vm._s(order.description) + "\n                ")]), _vm._v(" "), _c('div', {
            staticClass: "col"
          }, [_vm._v("\n                  +7" + _vm._s(order.clientPhone) + " " + _vm._s(order.clientName) + "\n                ")]), _vm._v(" "), _c('div', {
            staticClass: "col"
          }, [_vm._v("\n                 " + _vm._s(order.sum) + " руб.\n                ")])])
        })]
      })], 2)]], 2)
    }))
  }))])
},staticRenderFns: []}

/***/ }),
/* 1051 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-9 col-lg-9"
  }, [_c('b-button-group', [_c('button', {
    staticClass: "btn btn-secondary btn-sm",
    class: {
      active: _vm.viewParams.mode == 'today'
    },
    attrs: {
      "id": "displayMode__today"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.switchDisplayMode('today')
      }
    }
  }, [_vm._v("\n                        Сегодня\n                    ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-secondary btn-sm",
    class: {
      active: _vm.viewParams.mode == 'week'
    },
    attrs: {
      "id": "displayMode__week"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.switchDisplayMode('week')
      }
    }
  }, [_vm._v("\n                        Неделя\n                    ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-secondary btn-sm",
    class: {
      active: _vm.viewParams.mode == 'two-week'
    },
    attrs: {
      "id": "displayMode__twoWeek"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.switchDisplayMode('two-week')
      }
    }
  }, [_vm._v("\n                        Две недели\n                    ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-secondary btn-sm",
    class: {
      active: _vm.viewParams.mode == 'month'
    },
    attrs: {
      "id": "displayMode__month"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.switchDisplayMode('month')
      }
    }
  }, [_vm._v("\n                        Месяц\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "mb-1 hidden-md-up"
  }), _vm._v(" "), _c('b-button-group', [_c('button', {
    staticClass: "btn btn-secondary btn-sm",
    attrs: {
      "id": "displayMode__prevInterval"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.prevInterval()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-left"
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-secondary btn-sm",
    attrs: {
      "id": "displayMode__nextInterval"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.nextInterval()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-right"
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-secondary btn-sm",
    class: {
      active: _vm.viewParams.mode == 'search'
    },
    attrs: {
      "id": "displayMode__search"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.showSearchModal()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-secondary btn-sm",
    attrs: {
      "disabled": _vm.exportLoading,
      "id": "displayMode__export"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.exportToExcel()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-file-excel-o"
  }), _vm._v("\n                        Экспорт в Excel\n                    ")])]), _vm._v(" "), _c('b-tooltip', {
    attrs: {
      "target": "displayMode__today",
      "title": "Показать заказы на сегодня",
      "placement": "bottom",
      "triggers": "hover"
    }
  }), _vm._v(" "), _c('b-tooltip', {
    attrs: {
      "target": "displayMode__week",
      "title": "Показать заказы на текущую неделю",
      "placement": "bottom",
      "triggers": "hover"
    }
  }), _vm._v(" "), _c('b-tooltip', {
    attrs: {
      "target": "displayMode__twoWeek",
      "title": "Показать заказы на текущую и следующую недели",
      "placement": "bottom",
      "triggers": "hover"
    }
  }), _vm._v(" "), _c('b-tooltip', {
    attrs: {
      "target": "displayMode__month",
      "title": "Показать заказы на текущий месяц",
      "placement": "bottom",
      "triggers": "hover"
    }
  }), _vm._v(" "), _c('b-tooltip', {
    attrs: {
      "target": "displayMode__prevInterval",
      "title": "Предыдущий интервал",
      "placement": "bottom",
      "triggers": "hover"
    }
  }), _vm._v(" "), _c('b-tooltip', {
    attrs: {
      "target": "displayMode__nextInterval",
      "title": "Следующий интервал",
      "placement": "bottom",
      "triggers": "hover"
    }
  }), _vm._v(" "), _c('b-tooltip', {
    attrs: {
      "target": "displayMode__search",
      "title": "Поиск и выбор заказов по параметрам",
      "placement": "bottom",
      "triggers": "hover"
    }
  }), _vm._v(" "), _c('b-tooltip', {
    attrs: {
      "target": "displayMode__export",
      "title": "Экспортировать текущие заказы в Excel",
      "placement": "bottom",
      "triggers": "hover"
    }
  })], 1), _vm._v(" "), (_vm.viewParams.dateFrom) ? _c('div', {
    staticClass: "col-sm-12 col-md-3 col-lg-3 text-right"
  }, [_vm._v("\n                Отображаются заказы с " + _vm._s(_vm.viewParams.dateFrom) + " по " + _vm._s(_vm.viewParams.dateTo) + "\n            ")]) : _vm._e()])])])
},staticRenderFns: []}

/***/ }),
/* 1052 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated fadeIn"
  }, [_c('div', {
    staticClass: "card admin"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_vm._v("\n            Статистика звонков\n            "), _c('div', {
    staticClass: "pull-right",
    staticStyle: {
      "margin-top": "7px"
    }
  }, [_c('button', {
    staticClass: "btn btn-secondary",
    class: {
      active: _vm.showFilter
    },
    attrs: {
      "data-toggle": "dropdown",
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.showFilter = !_vm.showFilter
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-filter"
  }), _vm._v(" Фильтр\n                ")])]), _vm._v(" "), (_vm.showFilter) ? _c('div', {
    staticClass: "row mt-1"
  }, [_c('div', {
    staticClass: "col-6"
  }, [_c('form', {
    attrs: {
      "сlass": "form-horizontal"
    }
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-3 form-control-label"
  }, [_vm._v("Номер телефона")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.params.query),
      expression: "params.query"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.params.query)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.params, "query", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-3 form-control-label"
  }, [_vm._v("Город")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.cities,
      "searchable": true,
      "close-on-select": true,
      "show-labels": false,
      "placeholder": "Город не выбран",
      "track-by": "id",
      "label": "name"
    },
    on: {
      "input": _vm.changeCity
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-3 form-control-label"
  }, [_vm._v("Номер на который позвонили")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.virtualNumbers,
      "searchable": true,
      "close-on-select": true,
      "show-labels": false,
      "placeholder": "Номер не выбран",
      "track-by": "id",
      "label": "name",
      "loading": _vm.loadingVirtualNumbers
    },
    on: {
      "input": _vm.changeVirtualNumber,
      "open": _vm.loadVirtualNumbers
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-3 form-control-label"
  }, [_vm._v("Внутренний номер, который ответил")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.internalNumbers,
      "searchable": true,
      "close-on-select": true,
      "show-labels": false,
      "placeholder": "Номер не выбран",
      "track-by": "id",
      "label": "number",
      "loading": _vm.loadingInternalNumbers
    },
    on: {
      "input": _vm.changeInternalNumber,
      "open": _vm.loadInternalNumbers
    }
  })], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "col-6"
  }, [_c('form', {
    attrs: {
      "сlass": "form-horizontal"
    }
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-3 form-control-label"
  }, [_vm._v("Интервал с")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.params.dateTimeFrom),
      expression: "params.dateTimeFrom"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "datetime-local"
    },
    domProps: {
      "value": (_vm.params.dateTimeFrom)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.params, "dateTimeFrom", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-3 form-control-label"
  }, [_vm._v("Интервал по")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.params.dateTimeTo),
      expression: "params.dateTimeTo"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "datetime-local"
    },
    domProps: {
      "value": (_vm.params.dateTimeTo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.params, "dateTimeTo", $event.target.value)
      }
    }
  })])])])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "card-block admin__list"
  }, [_vm._m(0), _vm._v(" "), (_vm.loading) ? _c('loading', {
    attrs: {
      "message": "Загружаем звонки..."
    }
  }) : _vm._l((_vm.items), function(item, index) {
    return _c('div', {
      staticClass: "row mb-1 admin__list__item admin__list__item_hover-bg-gray"
    }, [_c('div', {
      staticClass: "col-6 col-md-3 col-lg-2"
    }, [_vm._v(_vm._s(item.date) + " " + _vm._s(item.time))]), _vm._v(" "), _c('div', {
      staticClass: "col-6 col-md-3 col-lg-1"
    }, [_vm._v(_vm._s(item.number))]), _vm._v(" "), _c('div', {
      staticClass: "col-6 col-md-4 col-lg-1"
    }, [(item.virtualNumber) ? _c('span', [_vm._v(_vm._s(item.virtualNumber.number))]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "col-6 col-md-2 col-lg-1"
    }, [(item.virtualNumber && item.virtualNumber.city) ? _c('span', [_vm._v("\n                        " + _vm._s(item.virtualNumber.city.name) + "\n                    ")]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "col-6 col-md-3 col-lg-2"
    }, [(item.virtualNumber) ? _c('span', [_vm._v("\n                        " + _vm._s(item.virtualNumber.site) + "\n                    ")]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "col-6 col-md-7 col-lg-2"
    }, [(item.internalNumber) ? [_vm._v("\n                        Внутренний номер: " + _vm._s(item.internalNumber.number)), _c('br'), _vm._v(" "), _vm._l((item.internalNumber.users), function(user, index) {
      return _c('span', {
        staticClass: "badge badge-info"
      }, [_c('router-link', {
        attrs: {
          "to": {
            name: 'ViewProfile',
            params: {
              id: user.id
            }
          }
        }
      }, [_vm._v(_vm._s(user.fullname))])], 1)
    })] : _vm._e()], 2), _vm._v(" "), _c('div', {
      staticClass: "col-12 col-md-2 text-center text-md-left"
    }, [(item.records) ? _vm._l((item.records), function(record) {
      return _c('audio', {
        ref: "player",
        refInFor: true,
        attrs: {
          "controls": ""
        }
      }, [_c('source', {
        attrs: {
          "src": record.url
        }
      }), _vm._v("\n                            Ваш браузер не поддрживает воспроизведение аудио записей\n                        ")])
    }) : (_vm.loadingRecords === item.pbxCallId) ? _c('loading', {
      attrs: {
        "size": 2,
        "message": "Загружаем записи..."
      }
    }) : _c('b-button', {
      attrs: {
        "size": "sm",
        "variant": "secondary"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.loadRecords(item.pbxCallId, index)
        }
      }
    }, [_vm._v("Загрузить")])], 2)])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "card-header"
  }, [_c('b-pagination', {
    staticClass: "mb-0",
    attrs: {
      "size": "md",
      "total-rows": _vm.itemsPage.paginator.total_count,
      "per-page": _vm.itemsPage.paginator.limit
    },
    model: {
      value: (_vm.params.page),
      callback: function($$v) {
        _vm.$set(_vm.params, "page", $$v)
      },
      expression: "params.page"
    }
  })], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row mb-1 text-muted small"
  }, [_c('div', {
    staticClass: "col-6 col-md-3 col-lg-2"
  }, [_vm._v("Дата и время")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-md-3 col-lg-1"
  }, [_vm._v("Номер звонившего")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-md-4 col-lg-1"
  }, [_vm._v("Номер на который звонили")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-md-2 col-lg-1"
  }, [_vm._v("Город")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-md-3 col-lg-2"
  }, [_vm._v("Сайт")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-md-7 col-lg-2"
  }, [_vm._v("Кто ответил")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-md-2 col-lg-2"
  }, [_vm._v("Запись разговора")])])
}]}

/***/ }),
/* 1053 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header-search",
    class: {
      'header-search--open': _vm.show
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }],
    staticClass: "header-search__bg",
    on: {
      "click": [function($event) {
        $event.stopPropagation();
      }, function($event) {
        _vm.show = false
      }]
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "header-search__content"
  }, [_c('div', {
    staticClass: "header-search__form"
  }, [_c('i', {
    staticClass: "fa fa-search header-search__icon-search",
    on: {
      "click": _vm.focusSearchInput
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.query),
      expression: "query"
    }],
    ref: "focusThis",
    staticClass: "header-search__input",
    attrs: {
      "type": "text",
      "placeholder": "Поиск и фильтр, введите номер заказа, номер телефона или описание"
    },
    domProps: {
      "value": (_vm.query)
    },
    on: {
      "focus": function($event) {
        _vm.show = true
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.query = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.show) ? _c('i', {
    staticClass: "fa fa-times header-search__icon-times",
    on: {
      "click": function($event) {
        _vm.show = false
      }
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }],
    staticClass: "header-search__filter-wrapper",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [(_vm.query.length > 1) ? _c('div', [_c('div', {
    staticClass: "header-search__filter-wrapper-custom-scroll"
  }, [(_vm.loading.search) ? _c('div', [_c('loading', {
    attrs: {
      "size": 3,
      "message": "Ищем заказы..."
    }
  })], 1) : (_vm.result.length > 0) ? _vm._l((_vm.result), function(order) {
    return _c('div', {
      staticClass: "header-search__result"
    }, [_c('div', {
      staticClass: "row header-search__result-item",
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.showOrderDetail(order.id)
        }
      }
    }, [_c('div', {
      staticClass: "col-2 col-md-1"
    }, [_vm._v("\n                                №" + _vm._s(order.id) + "\n                            ")]), _vm._v(" "), _c('div', {
      staticClass: "col-5 col-md-2 col-lg-1 col-xl-2"
    }, [_vm._v("\n                                " + _vm._s(order.date) + " в " + _vm._s(order.time) + "\n                            ")]), _vm._v(" "), _c('div', {
      staticClass: "col-5 col-md-2 col-lg-1 col-xl-2"
    }, [_c('order-status', {
      attrs: {
        "order": order,
        "disabled": true
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "col-12 col-md-7 col-lg-4 col-xl-7 mt-1 mb-1 mb-xl-1 mt-md-0 mb-lg-0"
    }, [_vm._v("\n                                " + _vm._s(order.description) + "\n                                "), (order.status.code === 'canceled' && order.cancelCause) ? _c('div', {
      staticClass: "text-danger small"
    }, [_vm._v("Причина отмены: " + _vm._s(order.cancelCause))]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "col-6 col-md-5 col-lg-2 col-xl-5"
    }, [(order.clientPhone) ? _c('span', [_vm._v("+7")]) : _vm._e(), _vm._v(_vm._s(order.clientPhone) + " " + _vm._s(order.clientName) + "\n                                "), _c('div', {
      staticClass: "small"
    }, [_vm._v("Ответственный " + _vm._s(order.user.firstname) + " " + _vm._s(order.user.lastname))])]), _vm._v(" "), _c('div', {
      staticClass: "col-6 col-md-7 col-lg-3 col-xl-7"
    }, [_c('span', {
      staticClass: "text-muted"
    }, [_c('i', {
      staticClass: "fa fa-map-marker"
    }), _vm._v(" " + _vm._s(order.techcenter.city.name) + " - " + _vm._s(order.techcenter.company.name))]), _c('br'), _vm._v(" "), _c('span', {
      staticClass: "badge",
      style: ({
        backgroundColor: order.techcenter.color
      })
    }, [_vm._v(_vm._s(order.techcenter.address))]), _c('br')])])])
  }) : _c('div', {
    staticClass: "alert alert-warning"
  }, [_c('p', [_vm._v("К сожалению по указанным вами параметрам не найдено ни одного заказа. Попробуйте изменить параметры поиска или воспользуйтесь "), _c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.query = ''
      }
    }
  }, [_vm._v("подбром по фильтрам")])])])], 2), _vm._v(" "), _c('div', {
    staticClass: "header-search__filter-footer"
  }, [_c('button', {
    staticClass: "btn btn-secondary mr-1",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.query = ''
      }
    }
  }, [_vm._v("Показать фильтр")])])]) : [_c('div', {
    staticClass: "header-search__filter-wrapper-custom-scroll"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 col-md-4 col-lg-3"
  }, [_vm._m(0), _vm._v(" "), (_vm.filters.length > 0) ? _c('ul', {
    staticClass: "header-search__list-group"
  }, _vm._l((_vm.filters), function(filter, index) {
    return _c('li', {
      staticClass: "header-search__list-group-item d-flex justify-content-between align-items-center",
      class: {
        'header-search__list-group-item--active': _vm.activeFilterIndex === index
      },
      on: {
        "click": function($event) {
          _vm.activeFilter(filter, index)
        }
      }
    }, [_vm._v("\n                            " + _vm._s(filter.name) + "\n                            "), _c('span', {
      staticClass: "badge badge-secondary header-search__badge-times",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.removeFilter(index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-times"
    })])])
  })) : _c('div', {
    staticClass: "alert alert-warning"
  }, [_c('p', [_vm._v("У вас еще нет ни одного сохранненого фильтра.")]), _vm._v(" "), _c('p', {
    staticClass: "hidden-md-down"
  }, [_vm._v("Но вы можете создать требуемые для вас фильтры в правой колонке.")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-12 col-md-8 col-lg-9 header-search__filter-wrapper-left"
  }, [_c('form', {
    attrs: {
      "action": "",
      "method": "post",
      "сlass": "form-horizontal"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [(_vm.$v.formParams.$invalid) ? _c('div', {
    staticClass: "alert alert-danger"
  }, [_vm._v("\n                            Номер заказа или период должны быть обязательно указаны\n                        ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-3 form-control-label"
  }, [_vm._v("Номера заказов")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('multiselect', {
    attrs: {
      "tag-placeholder": "Нажмите Enter для добавления",
      "placeholder": "Введите номера заказов",
      "label": "id",
      "track-by": "name",
      "options": _vm.formParams.ordersIds,
      "multiple": true,
      "taggable": true
    },
    on: {
      "tag": _vm.addOrderId,
      "select": function($event) {
        _vm.$v.formParams.ordersIds.$touch()
      },
      "remove": function($event) {
        _vm.$v.formParams.ordersIds.$touch()
      }
    },
    model: {
      value: (_vm.formParams.ordersIds),
      callback: function($$v) {
        _vm.$set(_vm.formParams, "ordersIds", $$v)
      },
      expression: "formParams.ordersIds"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-3 form-control-label"
  }, [_vm._v("Период")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('DateRangePicker', {
    staticClass: "header-search__date-range-picker",
    attrs: {
      "range": true,
      "format": _vm.format,
      "lang": "ru",
      "width": "240",
      "first-day-of-week": 1,
      "shortcuts": false,
      "input-class": "form-control"
    },
    model: {
      value: (_vm.formParams.dates),
      callback: function($$v) {
        _vm.$set(_vm.formParams, "dates", $$v)
      },
      expression: "formParams.dates"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-3 form-control-label"
  }, [_vm._v("Город")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.cities,
      "searchable": true,
      "close-on-select": true,
      "placeholder": "Выберите город",
      "track-by": "id",
      "label": "name",
      "multiple": true,
      "select-label": "Нажмите enter чтобы добавить",
      "deselect-label": "Нажмите enter чтобы удалить",
      "selected-label": "Выбрано"
    },
    model: {
      value: (_vm.formParams.cities),
      callback: function($$v) {
        _vm.$set(_vm.formParams, "cities", $$v)
      },
      expression: "formParams.cities"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-3 form-control-label"
  }, [_vm._v("Компания")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.companies,
      "searchable": true,
      "close-on-select": true,
      "placeholder": "Выберите компанию",
      "track-by": "id",
      "label": "name",
      "multiple": true,
      "select-label": "Нажмите enter чтобы добавить",
      "deselect-label": "Нажмите enter чтобы удалить",
      "selected-label": "Выбрано",
      "loading": _vm.loading.companies
    },
    model: {
      value: (_vm.formParams.companies),
      callback: function($$v) {
        _vm.$set(_vm.formParams, "companies", $$v)
      },
      expression: "formParams.companies"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-3 form-control-label"
  }, [_vm._v("Техцентр")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.techcenters,
      "searchable": true,
      "close-on-select": true,
      "placeholder": "Выберите техцентр",
      "track-by": "id",
      "label": "name",
      "multiple": true,
      "select-label": "Нажмите enter чтобы добавить",
      "deselect-label": "Нажмите enter чтобы удалить",
      "selected-label": "Выбрано",
      "loading": _vm.loading.techcenters
    },
    model: {
      value: (_vm.formParams.techcenters),
      callback: function($$v) {
        _vm.$set(_vm.formParams, "techcenters", $$v)
      },
      expression: "formParams.techcenters"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-3 form-control-label"
  }, [_vm._v("Ответственный")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.users,
      "searchable": true,
      "close-on-select": true,
      "placeholder": "Выберите пользователей",
      "track-by": "id",
      "label": "fullname",
      "multiple": true,
      "select-label": "Нажмите enter чтобы добавить",
      "deselect-label": "Нажмите enter чтобы удалить",
      "selected-label": "Выбрано",
      "loading": _vm.loading.users
    },
    model: {
      value: (_vm.formParams.users),
      callback: function($$v) {
        _vm.$set(_vm.formParams, "users", $$v)
      },
      expression: "formParams.users"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-3 form-control-label"
  }, [_vm._v("Статус заказа")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.statuses,
      "searchable": true,
      "close-on-select": true,
      "placeholder": "Выберите статус",
      "track-by": "id",
      "label": "name",
      "multiple": true,
      "select-label": "Нажмите enter чтобы добавить",
      "deselect-label": "Нажмите enter чтобы удалить",
      "selected-label": "Выбрано"
    },
    model: {
      value: (_vm.formParams.statuses),
      callback: function($$v) {
        _vm.$set(_vm.formParams, "statuses", $$v)
      },
      expression: "formParams.statuses"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-3 form-control-label"
  }, [_vm._v("Только проблемные заказы")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('label', {
    staticClass: "switch switch-lg switch-3d switch-primary ml-1"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formParams.problem),
      expression: "formParams.problem"
    }],
    staticClass: "switch-input",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.formParams.problem) ? _vm._i(_vm.formParams.problem, null) > -1 : (_vm.formParams.problem)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.formParams.problem,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.formParams.problem = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.formParams.problem = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.formParams, "problem", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-label"
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-handle"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-3 form-control-label"
  }, [_vm._v("Только отменные заказы")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('label', {
    staticClass: "switch switch-lg switch-3d switch-primary ml-1"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formParams.canceled),
      expression: "formParams.canceled"
    }],
    staticClass: "switch-input",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.formParams.canceled) ? _vm._i(_vm.formParams.canceled, null) > -1 : (_vm.formParams.canceled)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.formParams.canceled,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.formParams.canceled = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.formParams.canceled = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.formParams, "canceled", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-label"
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-handle"
  })])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "header-search__filter-footer"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 col-md-9 offset-lg-3"
  }, [(_vm.$v.formParams.$invalid) ? [_c('button', {
    staticClass: "btn btn-primary disabled",
    attrs: {
      "disabled": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
      }
    }
  }, [_vm._v("Применить")]), _vm._v(" \n                        ")] : [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.search($event)
      }
    }
  }, [_vm._v("Применить")]), _vm._v(" \n                        ")], _vm._v(" "), _c('button', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.saveSearchFilter",
      modifiers: {
        "saveSearchFilter": true
      }
    }],
    staticClass: "btn btn-secondary",
    on: {
      "click": function($event) {
        $event.preventDefault();
      }
    }
  }, [_vm._v("Сохранить фильтр")]), _vm._v(" \n                        "), _c('button', {
    staticClass: "btn btn-link",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.clearFiltersParams($event)
      }
    }
  }, [_vm._v("Сбросить")]), _vm._v(" \n                        "), _c('button', {
    staticClass: "btn btn-link",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.show = false
      }
    }
  }, [_vm._v("Скрыть")]), _vm._v(" \n                    ")], 2)])])]], 2)]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "lazy": true,
      "id": "saveSearchFilter",
      "ok-title": "Сохранить",
      "cancel-title": "Отменить",
      "title": "Сохранить фильтр"
    },
    on: {
      "shown": _vm.focusFilterItemInput,
      "ok": _vm.saveFilter
    }
  }, [_vm._v("\n        Введите название фильтра\n        "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newFilterName),
      expression: "newFilterName"
    }],
    ref: "focusModalThis",
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.newFilterName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newFilterName = $event.target.value
      }
    }
  })])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h6', [_c('b', [_vm._v("Сохраненные фильтры")])])
}]}

/***/ }),
/* 1054 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.loading) ? _c('loading', {
    attrs: {
      "size": 2,
      "message": "Обновляем пароль..."
    }
  }) : _c('form', {
    staticClass: "form-horizontal",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.beforeSubmit($event)
      }
    }
  }, [(!_vm.currentUser.isAdmin) ? _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-4 col-md-2 col-form-label",
    attrs: {
      "for": "old-password"
    }
  }, [_vm._v("Старый пароль")]), _vm._v(" "), _c('div', {
    staticClass: "col-8 col-md-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.oldPassword),
      expression: "oldPassword"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "firstname",
      "type": "password",
      "id": "old-password"
    },
    domProps: {
      "value": (_vm.oldPassword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.oldPassword = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "help-inline col-12 col-md-6"
  }, [_c('small', {
    staticClass: "text-muted"
  }, [_vm._v("Если вы не помните старый пароль, то обратитесь к администратору, или сбросте пароль через email")])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group row",
    class: {
      'has-danger': _vm.$v.newPassword.$error
    }
  }, [_c('label', {
    staticClass: "col-4 col-lg-2 col-form-label",
    attrs: {
      "for": "new-password"
    }
  }, [_vm._v("Новый пароль")]), _vm._v(" "), _c('div', {
    staticClass: "col-8 col-md-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newPassword),
      expression: "newPassword"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "firstname",
      "type": "password",
      "id": "new-password"
    },
    domProps: {
      "value": (_vm.newPassword)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.newPassword = $event.target.value
      }, function($event) {
        _vm.$v.newPassword.$touch()
      }]
    }
  }), _vm._v(" "), (_vm.$v.newPassword.$error) ? _c('span', {
    staticClass: "small help-block text-danger"
  }, [_vm._v("Новый пароль должен быть не менее 6 символов")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row",
    class: {
      'has-danger': _vm.$v.remindNewPassword.$error
    }
  }, [_c('label', {
    staticClass: "col-4 col-lg-2 col-form-label",
    attrs: {
      "for": "remind-new-password"
    }
  }, [_vm._v("Повторите новый пароль")]), _vm._v(" "), _c('div', {
    staticClass: "col-8 col-md-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.remindNewPassword),
      expression: "remindNewPassword"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "firstname",
      "type": "password",
      "id": "remind-new-password"
    },
    domProps: {
      "value": (_vm.remindNewPassword)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.remindNewPassword = $event.target.value
      }, function($event) {
        _vm.$v.remindNewPassword.$touch()
      }]
    }
  }), _vm._v(" "), (_vm.$v.remindNewPassword.$error) ? _c('span', {
    staticClass: "small help-block text-danger"
  }, [_vm._v("Пароли должны совпадать")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "offset-sm-2 col-sm-10"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    class: {
      'disabled': _vm.$v.remindNewPassword.$invalid
    },
    attrs: {
      "type": "submit",
      "disabled": _vm.$v.remindNewPassword.$invalid
    }
  }, [_vm._v("Сохранить")])])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 1055 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-modal', {
    attrs: {
      "visible": _vm.showAdminModal === 'addUser',
      "size": "lg",
      "lazy": true
    },
    on: {
      "hidden": _vm.hideModal
    }
  }, [_c('div', {
    attrs: {
      "slot": "modal-title"
    },
    slot: "modal-title"
  }, [_c('h4', [_vm._v("Добавить пользователя")]), _vm._v(" "), _c('span', {
    staticClass: "small help-block"
  }, [_vm._v("Перед добавлением пользователя создайте техцентр если он не существует")])]), _vm._v(" "), (_vm.loading) ? _c('loading', {
    attrs: {
      "size": 3,
      "message": "Загружаем..."
    }
  }) : _c('form', {
    attrs: {
      "сlass": "form-horizontal"
    }
  }, [_c('div', {
    staticClass: "form-group row",
    class: {
      'has-danger': _vm.$v.userData.firstname.$error
    }
  }, [_c('label', {
    staticClass: "col-2 col-form-label",
    attrs: {
      "for": "user-firstname"
    }
  }, [_vm._v("Имя")]), _vm._v(" "), _c('div', {
    staticClass: "col-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.userData.firstname),
      expression: "userData.firstname",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "user-firstname",
      "autocomplete": "off"
    },
    domProps: {
      "value": (_vm.userData.firstname)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.userData, "firstname", $event.target.value.trim())
      }, function($event) {
        _vm.$v.userData.firstname.$touch()
      }],
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), (_vm.$v.userData.firstname.$error) ? _c('span', {
    staticClass: "small help-block text-danger"
  }, [_vm._v("Имя обязательно должно быть указано, минимум " + _vm._s(_vm.$v.userData.lastname.$params.minLength.min) + " символа")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row",
    class: {
      'has-danger': _vm.$v.userData.lastname.$error
    }
  }, [_c('label', {
    staticClass: "col-2 col-form-label",
    attrs: {
      "for": "user-lastname"
    }
  }, [_vm._v("Фамилия")]), _vm._v(" "), _c('div', {
    staticClass: "col-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.userData.lastname),
      expression: "userData.lastname",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "user-lastname",
      "autocomplete": "off"
    },
    domProps: {
      "value": (_vm.userData.lastname)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.userData, "lastname", $event.target.value.trim())
      }, function($event) {
        _vm.$v.userData.lastname.$touch()
      }],
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), (_vm.$v.userData.lastname.$error) ? _c('span', {
    staticClass: "small help-block text-danger"
  }, [_vm._v("Фамилия обязательно должна быть указана")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row",
    class: {
      'has-danger': _vm.$v.userData.email.$error
    }
  }, [_c('label', {
    staticClass: "col-2 col-form-label",
    attrs: {
      "for": "user-email"
    }
  }, [_vm._v("Электронная почта")]), _vm._v(" "), _c('div', {
    staticClass: "col-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.userData.email),
      expression: "userData.email",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "user-email",
      "autocomplete": "off"
    },
    domProps: {
      "value": (_vm.userData.email)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.userData, "email", $event.target.value.trim())
      }, function($event) {
        _vm.$v.userData.email.$touch()
      }],
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), (_vm.$v.userData.email.$error) ? _c('span', {
    staticClass: "small help-block text-danger"
  }, [_vm._v("Адрес электронной почты обязателен и должен быть валидным")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "help-inline col-6"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-3"
  }, [_c('label', {
    staticClass: "switch switch-lg switch-3d switch-primary ml-1"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.userData.notifyEmail),
      expression: "userData.notifyEmail"
    }],
    staticClass: "switch-input",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.userData.notifyEmail) ? _vm._i(_vm.userData.notifyEmail, null) > -1 : (_vm.userData.notifyEmail)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.userData.notifyEmail,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.userData.notifyEmail = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.userData.notifyEmail = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.userData, "notifyEmail", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-label"
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-handle"
  }), _vm._v(" "), (_vm.userData.notifyEmail) ? _c('small', [_vm._v("отправить")]) : _c('small', [_vm._v("не отправлять")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-9"
  }, [_c('small', {
    staticClass: "text-muted"
  }, [_vm._v("Отправить письмо с регистрационными данными")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row",
    class: {
      'has-danger': _vm.$v.userData.phone.$error
    }
  }, [_c('label', {
    staticClass: "col-2 col-form-label",
    attrs: {
      "for": "user-phone"
    }
  }, [_vm._v("Номер телефона")]), _vm._v(" "), _c('div', {
    staticClass: "col-4"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("+7")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.userData.phone),
      expression: "userData.phone",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "user-phone",
      "autocomplete": "off"
    },
    domProps: {
      "value": (_vm.userData.phone)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.userData, "phone", $event.target.value.trim())
      }, function($event) {
        _vm.$v.userData.phone.$touch()
      }],
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), (_vm.$v.userData.phone.$error) ? _c('span', {
    staticClass: "small help-block text-danger"
  }, [_vm._v("Телефон обязателен и должен состоять из 10 цифр")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row",
    class: {
      'has-danger': _vm.$v.userData.password.$error
    }
  }, [_c('label', {
    staticClass: "col-2 col-form-label",
    attrs: {
      "for": "new-password"
    }
  }, [_vm._v("Пароль")]), _vm._v(" "), _c('div', {
    staticClass: "col-4"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": _vm.passwordType,
      "id": "new-password",
      "autocomplete": "off"
    },
    domProps: {
      "value": _vm.userData.password
    },
    on: {
      "input": _vm.setPassword
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon"
  }, [(_vm.passwordType === 'password') ? _c('i', {
    staticClass: "fa fa-eye",
    attrs: {
      "aria-hidden": "true"
    },
    on: {
      "click": function($event) {
        _vm.passwordType = 'text'
      }
    }
  }) : _c('i', {
    staticClass: "fa fa-eye-slash",
    attrs: {
      "aria-hidden": "true"
    },
    on: {
      "click": function($event) {
        _vm.passwordType = 'password'
      }
    }
  })])]), _vm._v(" "), (_vm.$v.userData.password.$error) ? _c('span', {
    staticClass: "small help-block text-danger"
  }, [_vm._v("Пароль обязателен, минимум " + _vm._s(_vm.$v.userData.password.$params.minLength.min) + " символов")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "help-inline col-6"
  }, [_c('button', {
    staticClass: "btn btn-secondary",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.generatePassword($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-unlock-alt",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Сгенерировать")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2 form-control-label"
  }, [_vm._v("Компании")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.additionalData.companies,
      "searchable": true,
      "close-on-select": false,
      "show-labels": false,
      "multiple": true,
      "placeholder": "Компании не выбран",
      "track-by": "id",
      "label": "name"
    },
    model: {
      value: (_vm.userData.companies),
      callback: function($$v) {
        _vm.$set(_vm.userData, "companies", $$v)
      },
      expression: "userData.companies"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row",
    class: {
      'has-danger': _vm.$v.userData.techcenters.$error
    }
  }, [_c('label', {
    staticClass: "col-md-2 form-control-label"
  }, [_vm._v("Техцентры")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.additionalData.techcenters,
      "searchable": true,
      "close-on-select": false,
      "show-labels": false,
      "multiple": true,
      "placeholder": "Техцентры не выбран",
      "track-by": "id",
      "label": "name"
    },
    model: {
      value: (_vm.userData.techcenters),
      callback: function($$v) {
        _vm.$set(_vm.userData, "techcenters", $$v)
      },
      expression: "userData.techcenters"
    }
  }), _vm._v(" "), (_vm.$v.userData.techcenters.$error) ? _c('span', {
    staticClass: "small help-block text-danger"
  }, [_vm._v("Как минимум один техцентр должен быть выбран")]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row",
    class: {
      'has-danger': _vm.$v.userData.roles.$error
    }
  }, [_c('label', {
    staticClass: "col-md-2 form-control-label"
  }, [_vm._v("Роли пользователя")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.additionalData.roles,
      "searchable": true,
      "close-on-select": false,
      "show-labels": false,
      "multiple": true,
      "placeholder": "Роли не выбран",
      "track-by": "id",
      "label": "description"
    },
    model: {
      value: (_vm.userData.roles),
      callback: function($$v) {
        _vm.$set(_vm.userData, "roles", $$v)
      },
      expression: "userData.roles"
    }
  }), _vm._v(" "), (_vm.$v.userData.roles.$error) ? _c('span', {
    staticClass: "small help-block text-danger"
  }, [_vm._v("Роль должна быть указана")]) : _vm._e()], 1)])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "modal-footer"
    },
    slot: "modal-footer"
  }, [(!_vm.loading) ? _c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.beforeUpdateForm($event)
      }
    }
  }, [_vm._v("Добавить пользователя")]) : _vm._e()])], 1)
},staticRenderFns: []}

/***/ }),
/* 1056 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row justify-content-center animated fadeInRight"
  }, [(_vm.loading) ? _c('loading', {
    attrs: {
      "message": "Сбрасываем пароль..."
    }
  }) : (_vm.error) ? _c('div', {
    staticClass: "col-lg-6 col-md-8 col-sm-12"
  }, [_c('div', {
    staticClass: "card p-4"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('h1', [_vm._v("Ошибка сброса пароля")]), _vm._v(" "), _c('div', {
    staticClass: "alert alert-danger"
  }, [_vm._v("\n                    " + _vm._s(_vm.error) + "\n                ")]), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-primary",
    attrs: {
      "to": {
        name: 'RemindPassword'
      }
    }
  }, [_vm._v("Вернуться к странице сброса пароля")])], 1)])]) : _c('form', {
    staticClass: "col-lg-6 col-md-8 col-sm-12",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.resetPassword()
      }
    }
  }, [_c('div', {
    staticClass: "card-group mb-0"
  }, [_c('div', {
    staticClass: "card p-4"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('h1', [_vm._v("Задать новый пароль")]), _vm._v(" "), _c('p', {
    staticClass: "text-muted mt-2 mb-2"
  }, [_vm._v("\n                        Укажите уникальный новый пароль\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "form-group row",
    class: {
      'has-danger': _vm.$v.newPassword.$error
    }
  }, [_c('label', {
    staticClass: "col-12 col-md-6 col-form-label",
    attrs: {
      "for": "new-password"
    }
  }, [_vm._v("Новый пароль")]), _vm._v(" "), _c('div', {
    staticClass: "col-12 col-md-6 "
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newPassword),
      expression: "newPassword"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "firstname",
      "type": "password",
      "id": "new-password"
    },
    domProps: {
      "value": (_vm.newPassword)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.newPassword = $event.target.value
      }, function($event) {
        _vm.$v.newPassword.$touch()
      }]
    }
  }), _vm._v(" "), (_vm.$v.newPassword.$error) ? _c('span', {
    staticClass: "small help-block text-danger"
  }, [_vm._v("Новый пароль должен быть не менее 6 символов")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row",
    class: {
      'has-danger': _vm.$v.remindNewPassword.$error
    }
  }, [_c('label', {
    staticClass: "col-12 col-md-6  col-form-label",
    attrs: {
      "for": "remind-new-password"
    }
  }, [_vm._v("Повторите новый пароль")]), _vm._v(" "), _c('div', {
    staticClass: "col-12 col-md-6 "
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.remindNewPassword),
      expression: "remindNewPassword"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "firstname",
      "type": "password",
      "id": "remind-new-password"
    },
    domProps: {
      "value": (_vm.remindNewPassword)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.remindNewPassword = $event.target.value
      }, function($event) {
        _vm.$v.remindNewPassword.$touch()
      }]
    }
  }), _vm._v(" "), (_vm.$v.remindNewPassword.$error) ? _c('span', {
    staticClass: "small help-block text-danger"
  }, [_vm._v("Пароли должны совпадать")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-12 offset-md-6 col-md-6"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    class: {
      'disabled': _vm.$v.remindNewPassword.$invalid
    },
    attrs: {
      "type": "submit",
      "disabled": _vm.$v.remindNewPassword.$invalid
    }
  }, [_vm._v("Сменить пароль")])])])])])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 1057 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group row",
    class: {
      'has-danger': _vm.error
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-8"
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.cities,
      "searchable": true,
      "close-on-select": true,
      "show-labels": false,
      "value": _vm.city,
      "placeholder": "Город не выбран",
      "track-by": "id",
      "label": "name",
      "autocomplete": "off"
    },
    on: {
      "input": _vm.changeCity
    }
  }, [_c('span', {
    attrs: {
      "slot": "noResult"
    },
    slot: "noResult"
  }, [_vm._v("Город не найден.")])]), _vm._v(" "), (_vm.error) ? _c('span', {
    staticClass: "small help-block text-danger"
  }, [_vm._v("Город обязательно должен быть указан")]) : _vm._e()], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "col-4 col-form-label"
  }, [_vm._v("Город "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])])
}]}

/***/ }),
/* 1058 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('label', {
    staticClass: "col-12 form-control-label"
  }, [_vm._v("Преимущества для клиента")]), _vm._v(" "), _c('small', {
    staticClass: "col-12 text-muted"
  }, [_vm._v("Например: «Безналичный расчет»")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newAdvantage),
      expression: "newAdvantage"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "autocomplete": "off"
    },
    domProps: {
      "value": (_vm.newAdvantage)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key)) { return null; }
        _vm.addAdvantage($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newAdvantage = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon",
    attrs: {
      "id": "basic-addon1"
    },
    on: {
      "click": _vm.addAdvantage
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [(_vm.error) ? _c('span', {
    staticClass: "small help-block text-danger"
  }, [_vm._v(_vm._s(_vm.error))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "mt-1"
  }, [_c('div', {
    staticClass: "row"
  }, _vm._l((_vm.advantages), function(item) {
    return _c('div', {
      key: item.id,
      staticClass: "col-6"
    }, [_c('div', {
      staticClass: "advantage_item alert alert-info"
    }, [_vm._v("\n            " + _vm._s(item.name) + "\n            "), _c('div', {
      staticClass: "float-right text-info",
      on: {
        "click": function($event) {
          _vm.removeAdvantage(item.id)
        }
      }
    }, [_vm._v("×")])])])
  }))])])])
},staticRenderFns: []}

/***/ }),
/* 1059 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.$route.name === 'CustomFields') ? _c('div', [_c('admin-filter', {
    model: {
      value: (_vm.filterParams),
      callback: function($$v) {
        _vm.filterParams = $$v
      },
      expression: "filterParams"
    }
  }), _vm._v(" "), _c('admin-card', [_c('template', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v("\n      Список кастомных полей\n      "), _c('router-link', {
    staticClass: "pull-right btn btn-primary btn-sm",
    attrs: {
      "to": {
        name: 'CustomFieldsCreate'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" Добавить\n      ")])], 1), _vm._v(" "), _c('admin-list', {
    attrs: {
      "items": _vm.items,
      "loading": _vm.loading
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var item = ref.item;

        return [_c('div', {
          staticClass: "col-6 col-md-4"
        }, [_vm._v("\n            " + _vm._s(item.name) + "\n          ")]), _vm._v(" "), _c('div', {
          staticClass: "col-6 col-md-2"
        }, [_vm._v("\n            " + _vm._s(item.code) + "\n          ")]), _vm._v(" "), _c('div', {
          staticClass: "col-6 col-md-2"
        }, [_vm._v("\n            " + _vm._s(item.sort) + "\n          ")]), _vm._v(" "), _c('div', {
          staticClass: "col-6 col-md-3"
        }, [_c('router-link', {
          staticClass: "btn btn-primary btn-sm",
          attrs: {
            "to": {
              name: 'CustomFieldsEdit',
              params: {
                id: item.id
              }
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-edit"
        }), _vm._v(" Изменить\n            ")])], 1)]
      }
    }])
  }, [_c('template', {
    attrs: {
      "slot": "headerList"
    },
    slot: "headerList"
  }, [_c('div', {
    staticClass: "col-6 col-md-4"
  }, [_vm._v("Название")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-md-2"
  }, [_vm._v("Код")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-md-2"
  }, [_vm._v("Сортировка")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-md-3"
  }, [_vm._v("Управление")])])], 2), _vm._v(" "), _c('template', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('admin-pagination', {
    attrs: {
      "paginator": _vm.itemsPage.paginator
    },
    model: {
      value: (_vm.page),
      callback: function($$v) {
        _vm.page = $$v
      },
      expression: "page"
    }
  })], 1)], 2)], 1) : _c('router-view')
},staticRenderFns: []}

/***/ }),
/* 1060 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ol', {
    staticClass: "breadcrumb"
  }, _vm._l((_vm.list), function(item, index) {
    return _c('li', {
      staticClass: "breadcrumb-item"
    }, [(_vm.showName(item)) ? [(_vm.isLast(index)) ? _c('span', {
      staticClass: "active"
    }, [_vm._v(_vm._s(_vm.showName(item)))]) : _c('router-link', {
      attrs: {
        "to": {
          name: item.name
        }
      }
    }, [_vm._v(_vm._s(_vm.showName(item)))])] : _vm._e()], 2)
  }))
},staticRenderFns: []}

/***/ }),
/* 1061 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-modal', {
    ref: "ModalUpdatePage",
    attrs: {
      "id": "ModalUpdatePage"
    }
  }, [_c('div', {
    attrs: {
      "slot": "modal-title"
    },
    slot: "modal-title"
  }, [_c('h4', [_vm._v("Необходимо обновить страницу")])]), _vm._v(" "), _c('div', {
    staticClass: "alert alert-warning"
  }, [_c('h1', {
    staticClass: "text-center"
  }, [_c('i', {
    staticClass: "fa fa-refresh"
  })]), _vm._v(" "), _c('h4', [_vm._v("\n            Привет " + _vm._s(_vm.user.firstname) + " "), _c('br'), _vm._v(" Приятная новость - Аларм План был обновлен\n        ")]), _vm._v(" "), _c('p', [_vm._v("\n            Обновление необходимо для улучшения стабильности работы и добавления нового функционала.\n        ")]), _vm._v(" "), _c('p', [_vm._v("\n            Для стабильной работы необходимо обновить страницу. Рекомендуется обновить страницу с очисткой кеша нажав CTRL + F5 на клавиатуре.\n        ")]), _vm._v(" "), _c('p', [_vm._v("\n            Приносим свои извинения за доставленные не удобства.\n        ")])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "modal-footer"
    },
    slot: "modal-footer"
  }, [_c('b-btn', {
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.updatePage($event)
      }
    }
  }, [_vm._v("Обновить Аларм План")])], 1)])
},staticRenderFns: []}

/***/ }),
/* 1062 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.loadingTab) ? _c('loading', {
    attrs: {
      "size": 2,
      "message": "Загружаем настройки уведомлений..."
    }
  }) : _c('div', [(_vm.settingsActions.length > 0) ? _c('table', {
    staticClass: "table table-responsive"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Событие")]), _vm._v(" "), _vm._l((_vm.settingsChannels), function(channel) {
    return _c('th', [_vm._v(_vm._s(channel.name))])
  })], 2)]), _vm._v(" "), (_vm.settingsActions) ? _c('tbody', _vm._l((_vm.settingsActions), function(action) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(action.name))]), _vm._v(" "), _vm._l((_vm.getSettingsByAction(action)), function(setting) {
      return _c('td', [_c('label', {
        staticClass: "switch switch-lg switch-3d switch-primary"
      }, [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (setting.value),
          expression: "setting.value"
        }],
        staticClass: "switch-input",
        attrs: {
          "disabled": _vm.loading,
          "type": "checkbox"
        },
        domProps: {
          "checked": Array.isArray(setting.value) ? _vm._i(setting.value, null) > -1 : (setting.value)
        },
        on: {
          "change": [function($event) {
            var $$a = setting.value,
              $$el = $event.target,
              $$c = $$el.checked ? (true) : (false);
            if (Array.isArray($$a)) {
              var $$v = null,
                $$i = _vm._i($$a, $$v);
              if ($$el.checked) {
                $$i < 0 && (setting.value = $$a.concat([$$v]))
              } else {
                $$i > -1 && (setting.value = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
              }
            } else {
              _vm.$set(setting, "value", $$c)
            }
          }, function($event) {
            _vm.changeSetting(setting)
          }]
        }
      }), _vm._v(" "), _c('span', {
        staticClass: "switch-label"
      }), _vm._v(" "), _c('span', {
        staticClass: "switch-handle"
      }), _vm._v(" "), (setting.value) ? _c('small', [_vm._v("включено")]) : _c('small', [_vm._v("выключено")])])])
    })], 2)
  })) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.loading) ? _c('loading', {
    attrs: {
      "size": 2,
      "message": "Обновляем настройки..."
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 1063 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.value.length) ? _c('div', {
    staticClass: "admin__filter"
  }, [_c('div', {
    staticClass: "row"
  }, _vm._l((_vm.value), function(param, index) {
    return _c('div', {
      key: index,
      staticClass: "col-12 col-sm-6 col-md-4 col-lg-3"
    }, [_c('div', {
      staticClass: "form-group"
    }, [_c('label', {
      staticClass: "text-muted small",
      attrs: {
        "for": 'filter-param-' + index
      }
    }, [_vm._v(_vm._s(param.name))]), _vm._v(" "), (param.type === 'text') ? _c('input', {
      staticClass: "form-control",
      attrs: {
        "type": "text",
        "id": 'filter-param-' + index,
        "placeholder": param.name
      },
      domProps: {
        "value": param.value
      },
      on: {
        "input": function($event) {
          _vm.updateParams($event, param, index)
        }
      }
    }) : _vm._e(), _vm._v(" "), (param.type === 'select') ? _c('vue-multiselect', {
      attrs: {
        "options": param.options,
        "multiple": param.multiple,
        "searchable": true,
        "allow-empty": true,
        "value": _vm.getSelectedMultiselectByValue(param.value, param.options, 'value'),
        "placeholder": "Выбрать",
        "selectedLabel": "Выбрано",
        "deselectLabel": "Нажимите для удаления",
        "selectLabel": "Нажимите для выбора",
        "track-by": "value",
        "label": "name"
      },
      on: {
        "input": function($event) {
          _vm.updateParams($event, param, index)
        }
      }
    }) : _vm._e()], 1)])
  }))]) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 1064 */,
/* 1065 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.loading) ? _c('loading', {
    attrs: {
      "message": "Загружаем историю звонков..."
    }
  }) : (!_vm.order.clientPhone) ? _c('div', {
    staticClass: "alert alert-danger"
  }, [_vm._v("\n    В данном заказе не задан телефон клиента, поэтому система не может загрузить звонки. Пожалуйста укажите номер телефона клиента, отредактировав заказ\n")]) : (_vm.items && _vm.items.length > 0) ? _c('div', [_vm._l((_vm.items), function(item, index) {
    return _c('div', {
      staticClass: "row mb-1 admin__list__item admin__list__item_hover-bg-gray"
    }, [_c('div', {
      staticClass: "col-1 text-muted small"
    }, [_vm._v(_vm._s(item.date) + " в " + _vm._s(item.time))]), _vm._v(" "), _c('div', {
      staticClass: "col-2 text-muted small"
    }, [(item.virtualNumber) ? [(item.virtualNumber) ? _c('span', [_vm._v(_vm._s(item.virtualNumber.number))]) : _vm._e(), _vm._v(" "), (item.virtualNumber && item.virtualNumber.city) ? _c('span', [_c('br'), _vm._v(_vm._s(item.virtualNumber.city.name))]) : _vm._e(), _vm._v(" "), (item.virtualNumber) ? _c('span', [_c('br'), _vm._v(_vm._s(item.virtualNumber.site))]) : _vm._e()] : _vm._e()], 2), _vm._v(" "), _c('div', {
      staticClass: "col-4"
    }, [(item.internalNumber) ? [_vm._v("\n                Ответил: " + _vm._s(item.internalNumber.number) + "\n                "), _vm._l((item.internalNumber.users), function(user, index) {
      return _c('span', {
        staticClass: "badge badge-info"
      }, [(_vm.currentUser.isAdmin) ? _c('router-link', {
        attrs: {
          "to": {
            name: 'ViewProfile',
            params: {
              id: user.id
            }
          }
        }
      }, [_vm._v(_vm._s(user.fullname))]) : [_vm._v(_vm._s(user.fullname))]], 2)
    })] : [_c('span', {
      staticClass: "badge badge-danger"
    }, [_vm._v("\n                Не отвечен\n            ")])]], 2), _vm._v(" "), _c('div', {
      staticClass: "col-5 text-muted small"
    }, [(item.internalNumber) ? [(item.records) ? _vm._l((item.records), function(record) {
      return _c('audio', {
        ref: "player",
        refInFor: true,
        attrs: {
          "controls": ""
        }
      }, [_c('source', {
        attrs: {
          "src": record.url
        }
      }), _vm._v("\n                        Ваш браузер не поддрживает воспроизведение аудио записей\n                    ")])
    }) : (_vm.loadingRecords === item.pbxCallId) ? _c('loading', {
      attrs: {
        "size": 2,
        "message": "Загружаем записи..."
      }
    }) : _c('b-button', {
      attrs: {
        "size": "sm",
        "variant": "secondary"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.loadRecords(item.pbxCallId, index)
        }
      }
    }, [_vm._v("Загрузить запись")])] : [_vm._v("Запись разговора отсутсвует, т.к. звонок не был отвечен")]], 2)])
  }), _vm._v(" "), _c('b-pagination', {
    staticClass: "mb-0",
    attrs: {
      "size": "md",
      "total-rows": _vm.itemsPage.paginator.total_count,
      "per-page": _vm.itemsPage.paginator.limit
    },
    model: {
      value: (_vm.params.page),
      callback: function($$v) {
        _vm.$set(_vm.params, "page", $$v)
      },
      expression: "params.page"
    }
  })], 2) : _c('div', {
    staticClass: "alert alert-warning"
  }, [_vm._v("\n    Входящие звонки по данному заказу к сожалению не найдены.\n")])
},staticRenderFns: []}

/***/ }),
/* 1066 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "app-header navbar"
  }, [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),
/* 1067 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card admin"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_vm._t("header", [_vm._v(_vm._s(_vm.$route.meta.label))])], 2), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [_vm._t("default")], 2), _vm._v(" "), _c('div', {
    staticClass: "card-header"
  }, [_vm._t("footer")], 2)])
},staticRenderFns: []}

/***/ }),
/* 1068 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row justify-content-center"
  }, [_c('div', {
    staticClass: "mt-3"
  }, [_c('h1', {
    staticClass: "display-3"
  }, [_vm._v("Ошибка 404")]), _vm._v(" "), _c('h4', {
    staticClass: "pt-3"
  }, [_vm._v("Упс! Странца не найдена.")]), _vm._v(" "), _c('p', {
    staticClass: "text-muted"
  }, [_vm._v("Возможно вы перешли по устаревшей ссылке.")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-lg btn-blcok btn-primary",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.goHome($event)
      }
    }
  }, [_vm._v("Перейти на главную страницу")])])])
},staticRenderFns: []}

/***/ }),
/* 1069 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(!_vm.currentUser.isAdmin || _vm.currentUser.id === _vm.user.id) ? _c('div', {
    staticClass: "alert alert-warning"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1)]) : [(_vm.loadingRoles) ? _c('loading', {
    attrs: {
      "size": 2,
      "message": "Загружаем роли..."
    }
  }) : _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_vm._v("\n                Роли пользователя\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "row mb-1"
  }, _vm._l((_vm.roles), function(role) {
    return _c('div', {
      staticClass: "col-12 col-md-6 col-lg-3"
    }, [_c('div', {
      staticClass: "row  mb-2"
    }, [_c('div', {
      staticClass: "col-8"
    }, [_vm._v(_vm._s(role.description))]), _vm._v(" "), _c('div', {
      staticClass: "col-4"
    }, [(_vm.rolesChanges.indexOf(role.id) !== -1) ? _c('loading', {
      attrs: {
        "size": 2,
        "message": false
      }
    }) : _c('label', {
      staticClass: "switch switch-lg switch-3d switch-primary"
    }, [_c('input', {
      staticClass: "switch-input",
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "value": _vm.user.hasRole(role.name),
        "checked": _vm.user.hasRole(role.name)
      },
      on: {
        "change": function($event) {
          _vm.updateUserRole(_vm.user.hasRole(role.name), role.id)
        }
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "switch-label"
    }), _vm._v(" "), _c('span', {
      staticClass: "switch-handle"
    })])], 1)])])
  })), _vm._v(" "), _c('div', {
    staticClass: "row  mb-2"
  }, [_c('div', {
    staticClass: "col-8"
  }, [_vm._v("\n                        Персональные права доступа для пользователя "), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "text-warning small"
  }, [_vm._v("При активации все доступные роли пользователя будут деактивированы. Необходимо будет вручную настроить права доступа")])]), _vm._v(" "), _c('div', {
    staticClass: "col-4"
  }, [(_vm.rolesChanges.indexOf('personal') !== -1) ? _c('loading', {
    attrs: {
      "size": 2,
      "message": false
    }
  }) : (_vm.user.roles.length === 0) ? _c('label', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover.auto",
      modifiers: {
        "hover": true,
        "auto": true
      }
    }],
    staticClass: "switch switch-lg switch-3d switch-primary",
    attrs: {
      "title": "Для отключения персональных прав доступа активируйте одну из ролей"
    }
  }, [_c('input', {
    staticClass: "switch-input disabled",
    attrs: {
      "type": "checkbox",
      "disabled": ""
    },
    domProps: {
      "value": _vm.user.roles.length === 0,
      "checked": _vm.user.roles.length === 0
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-label"
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-handle"
  })]) : _c('label', {
    staticClass: "switch switch-lg switch-3d switch-primary"
  }, [_c('input', {
    staticClass: "switch-input",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "value": _vm.user.roles.length === 0,
      "checked": _vm.user.roles.length === 0
    },
    on: {
      "change": function($event) {
        _vm.clearUserRole()
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-label"
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-handle"
  })])], 1)])])]), _vm._v(" "), (_vm.loadingPermissions) ? _c('loading', {
    attrs: {
      "size": 2,
      "message": "Загружаем права доступа..."
    }
  }) : _c('div', [(_vm.user.roles.length !== 0) ? _c('div', {
    staticClass: "alert alert-warning"
  }, [_vm._v("\n                Права доступа отображаются из совокупности ролей, вы можете активировать персональные права доступа для этого пользователя, если выставите соответсующий переключатель в разделе роли\n            ")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.getPermissionsGroups()), function(group) {
    return _c('div', {
      staticClass: "card"
    }, [_c('div', {
      staticClass: "card-header"
    }, [_vm._v("\n                    " + _vm._s(_vm.getPermissionsGroupName(group)) + "\n                ")]), _vm._v(" "), _c('div', {
      staticClass: "card-block"
    }, [_c('div', {
      staticClass: "row"
    }, _vm._l((_vm.getPermissionsByGroupName(group)), function(permission) {
      return _c('div', {
        staticClass: "col-12 col-md-6 col-lg-3"
      }, [_c('div', {
        staticClass: "row  mb-2"
      }, [_c('div', {
        staticClass: "col-8"
      }, [_vm._v(_vm._s(permission.description))]), _vm._v(" "), _c('div', {
        staticClass: "col-4"
      }, [(_vm.permissionChanges.indexOf(permission.id) !== -1) ? _c('loading', {
        attrs: {
          "size": 2,
          "message": false
        }
      }) : (_vm.user.roles.length === 0) ? _c('label', {
        staticClass: "switch switch-lg switch-3d switch-primary"
      }, [_c('input', {
        staticClass: "switch-input",
        attrs: {
          "type": "checkbox"
        },
        domProps: {
          "value": _vm.user.hasPermission(permission.name),
          "checked": _vm.user.hasPermission(permission.name)
        },
        on: {
          "change": function($event) {
            _vm.updateUserPermission(_vm.user.hasPermission(permission.name), permission.id)
          }
        }
      }), _vm._v(" "), _c('span', {
        staticClass: "switch-label"
      }), _vm._v(" "), _c('span', {
        staticClass: "switch-handle"
      }), _vm._v(" "), (_vm.user.hasPermission(permission.name)) ? _c('small', [_vm._v("разрешено")]) : _c('small', [_vm._v("запрещено")])]) : (_vm.currentUser.hasPermission(permission.name)) ? _c('label', {
        directives: [{
          name: "b-tooltip",
          rawName: "v-b-tooltip.hover.auto",
          modifiers: {
            "hover": true,
            "auto": true
          }
        }],
        staticClass: "switch switch-lg switch-3d switch-primary",
        attrs: {
          "title": "Для активации отдельных разрешений переключите использование идивидуальных прав доступа в разделе роли"
        }
      }, [_c('input', {
        staticClass: "switch-input disabled",
        attrs: {
          "type": "checkbox",
          "disabled": ""
        },
        domProps: {
          "value": _vm.user.hasPermission(permission.name),
          "checked": _vm.user.hasPermission(permission.name)
        }
      }), _vm._v(" "), _c('span', {
        staticClass: "switch-label"
      }), _vm._v(" "), _c('span', {
        staticClass: "switch-handle"
      }), _vm._v(" "), (_vm.user.hasPermission(permission.name)) ? _c('small', [_vm._v("разрешено")]) : _c('small', [_vm._v("запрещено")])]) : _c('label', {
        directives: [{
          name: "b-tooltip",
          rawName: "v-b-tooltip.hover.auto",
          modifiers: {
            "hover": true,
            "auto": true
          }
        }],
        staticClass: "switch switch-lg switch-3d switch-primary",
        attrs: {
          "title": "Вы не можете разрешить данное действие пользователю, т.к. сами не имеете доступа к данным правам"
        }
      }, [_c('input', {
        staticClass: "switch-input disabled",
        attrs: {
          "type": "checkbox",
          "disabled": ""
        },
        domProps: {
          "value": _vm.user.hasPermission(permission.name),
          "checked": _vm.user.hasPermission(permission.name)
        }
      }), _vm._v(" "), _c('span', {
        staticClass: "switch-label"
      }), _vm._v(" "), _c('span', {
        staticClass: "switch-handle"
      }), _vm._v(" "), (_vm.user.hasPermission(permission.name)) ? _c('small', [_vm._v("разрешено")]) : _c('small', [_vm._v("запрещено")])])], 1)])])
    }))])])
  })], 2)]], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Только администраторы могут изменять роли и права доступа пользовалей. Если вы считаете, что у вас должно быть больше прав, пожалуйста напишите на почту "), _c('a', {
    attrs: {
      "href": "mailto:anton@alarm.ru"
    }
  }, [_vm._v("anton@alarm.ru")]), _vm._v(" с просьбой предоставить доступ.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\n            В дальнейшем руководители в компаниях и техцентрах смогут управлять пользователями и их правами в рамках своего техцентра. Данный функционал пока в разработке, по всем вопросам просьба писать на "), _c('a', {
    attrs: {
      "href": "mailto:anton@alarm.ru"
    }
  }, [_vm._v("anton@alarm.ru")]), _vm._v(".\n        ")])
}]}

/***/ }),
/* 1070 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated fadeIn"
  }, [_c('div', {
    staticClass: "card admin"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_vm._v("\n            Список городов\n            "), _c('div', {
    staticClass: "pull-right",
    staticStyle: {
      "margin-top": "7px"
    }
  }, [_c('button', {
    staticClass: "btn btn-secondary",
    class: {
      active: _vm.showFilter
    },
    attrs: {
      "data-toggle": "dropdown",
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.showFilter = !_vm.showFilter
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-filter"
  }), _vm._v(" Фильтр\n                ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.showModal($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" Добавить город\n                ")])]), _vm._v(" "), (_vm.showFilter) ? _c('div', {
    staticClass: "mt-3 mt-lg-1"
  }, [_c('div', {
    staticClass: "row col-12 col-lg-6"
  }, [_c('form', {
    attrs: {
      "сlass": "form-horizontal"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.search($event)
      }
    }
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-3 form-control-label"
  }, [_vm._v("Название")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9 col-lg-5"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.params.query),
      expression: "params.query"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.params.query)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.params, "query", $event.target.value)
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-6"
  })]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "card-block admin__list"
  }, [_vm._m(0), _vm._v(" "), (_vm.loading) ? _c('loading', {
    attrs: {
      "message": "Загружаем города..."
    }
  }) : _vm._l((_vm.items), function(item) {
    return _c('div', {
      staticClass: "row mb-1 admin__list__item admin__list__item_hover-bg-gray"
    }, [_c('div', {
      staticClass: "col-1 d-none d-md-block"
    }, [_vm._v("\n                    " + _vm._s(item.id) + "\n                ")]), _vm._v(" "), _c('div', {
      staticClass: "col-6 col-md-4"
    }, [_vm._v("\n                   " + _vm._s(item.name) + "\n                ")]), _vm._v(" "), _c('div', {
      staticClass: "col-6 col-md-2"
    }, [(item.enabled) ? _c('span', [_vm._v("Да")]) : _c('span', [_vm._v("Нет")])]), _vm._v(" "), _c('div', {
      staticClass: "col-6 col-md-2 mt-1 mt-md-0"
    }, [_vm._v("\n                    " + _vm._s(item.sort) + "\n                ")]), _vm._v(" "), _c('div', {
      staticClass: "col-6 col-md-3 mt-1 mt-md-0"
    }, [_c('button', {
      staticClass: "btn btn-primary btn-sm",
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.editItem(item)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-edit"
    }), _vm._v(" Изменить\n                    ")])])])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "card-header"
  }, [_c('b-pagination', {
    staticClass: "mb-0",
    attrs: {
      "size": "md",
      "total-rows": _vm.itemsPage.paginator.total_count,
      "per-page": _vm.itemsPage.paginator.limit
    },
    model: {
      value: (_vm.params.page),
      callback: function($$v) {
        _vm.$set(_vm.params, "page", $$v)
      },
      expression: "params.page"
    }
  })], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row mb-1 small text-muted"
  }, [_c('div', {
    staticClass: "col-1 d-none d-md-block"
  }, [_vm._v("Id")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-md-4"
  }, [_vm._v("Название")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-md-2"
  }, [_vm._v("Включен")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-md-2"
  }, [_vm._v("Сортировка")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-md-3"
  }, [_vm._v("Управление")])])
}]}

/***/ }),
/* 1071 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated fadeIn",
    attrs: {
      "id": "help__page"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 col-lg-3"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "card-block col-md-5 col-lg-12"
  }, [(_vm.loadingSidebar) ? _c('loading', {
    attrs: {
      "message": "Загружаем меню помощи..."
    }
  }) : _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.sidebar.content)
    }
  })], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: " col-12 col-lg-9"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-block"
  }, [(_vm.loadingDocument) ? _c('loading', {
    attrs: {
      "message": "Загружаем страницу помоши..."
    }
  }) : _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.document.content)
    }
  })], 1)])])])])
},staticRenderFns: []}

/***/ }),
/* 1072 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-modal', {
    attrs: {
      "visible": _vm.showAdminModal === 'addEditCity',
      "size": "lg",
      "lazy": true
    },
    on: {
      "hidden": _vm.hideModal
    }
  }, [_c('div', {
    attrs: {
      "slot": "modal-title"
    },
    slot: "modal-title"
  }, [(_vm.item) ? _c('h4', [_vm._v("Изменить город " + _vm._s(_vm.item.name))]) : _c('h4', [_vm._v("Добавить город")])]), _vm._v(" "), (_vm.loading) ? _c('loading', {
    attrs: {
      "size": 3,
      "message": "Сохраняем..."
    }
  }) : _c('form', {
    attrs: {
      "сlass": "form-horizontal"
    }
  }, [_c('div', {
    staticClass: "form-group row",
    class: {
      'has-danger': _vm.$v.newDataItem.name.$error
    }
  }, [_c('label', {
    staticClass: "col-4 col-md-2 col-form-label",
    attrs: {
      "for": "item-name"
    }
  }, [_vm._v("Название")]), _vm._v(" "), _c('div', {
    staticClass: "col-8 col-md-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.newDataItem.name),
      expression: "newDataItem.name",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "item-name"
    },
    domProps: {
      "value": (_vm.newDataItem.name)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newDataItem, "name", $event.target.value.trim())
      }, function($event) {
        _vm.$v.newDataItem.name.$touch()
      }],
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), (_vm.$v.newDataItem.name.$error) ? _c('span', {
    staticClass: "small help-block text-danger"
  }, [_vm._v("Название обязательно должно быть указано, минимум " + _vm._s(_vm.$v.newDataItem.name.$params.minLength.min) + " символа")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row",
    class: {
      'has-danger': _vm.$v.newDataItem.sort.$error
    }
  }, [_c('label', {
    staticClass: "col-4 col-md-2 col-form-label",
    attrs: {
      "for": "item-sort"
    }
  }, [_vm._v("Сортировка")]), _vm._v(" "), _c('div', {
    staticClass: "col-8 col-md-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.newDataItem.sort),
      expression: "newDataItem.sort",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "item-sort"
    },
    domProps: {
      "value": (_vm.newDataItem.sort)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newDataItem, "sort", $event.target.value.trim())
      }, function($event) {
        _vm.$v.newDataItem.sort.$touch()
      }],
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), (_vm.$v.newDataItem.sort.$error) ? _c('span', {
    staticClass: "small help-block text-danger"
  }, [_vm._v("Укажите число")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-4 col-md-2 col-form-label"
  }, [_vm._v("Активность города")]), _vm._v(" "), _c('div', {
    staticClass: "col-8 col-md-4"
  }, [_c('label', {
    staticClass: "switch switch-lg switch-3d switch-primary ml-1"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newDataItem.enabled),
      expression: "newDataItem.enabled"
    }],
    staticClass: "switch-input",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.newDataItem.enabled) ? _vm._i(_vm.newDataItem.enabled, null) > -1 : (_vm.newDataItem.enabled)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.newDataItem.enabled,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.newDataItem.enabled = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.newDataItem.enabled = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.newDataItem, "enabled", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-label"
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-handle"
  }), _vm._v(" "), (_vm.newDataItem.enabled) ? _c('small', [_vm._v("включен")]) : _c('small', [_vm._v("выключен")])])])])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "modal-footer"
    },
    slot: "modal-footer"
  }, [(!_vm.loading) ? _c('button', {
    staticClass: "btn btn-success",
    class: {
      'disabled': _vm.$v.newDataItem.$invalid
    },
    attrs: {
      "disabled": _vm.$v.newDataItem.$invalid,
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.beforeUpdateForm($event)
      }
    }
  }, [(_vm.item) ? [_vm._v("Сохранить изменения")] : [_vm._v("Добавить город")]], 2) : _vm._e()])], 1)
},staticRenderFns: []}

/***/ }),
/* 1073 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-4 col-form-label",
    attrs: {
      "for": _vm.labelId
    }
  }, [_vm._v(_vm._s(_vm.labelText) + "\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "col-8"
  }, [_c('label', {
    staticClass: "switch switch-lg switch-3d switch-primary mr-1"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.enabled),
      expression: "enabled"
    }],
    staticClass: "switch-input",
    attrs: {
      "id": _vm.labelId,
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.enabled) ? _vm._i(_vm.enabled, null) > -1 : (_vm.enabled)
    },
    on: {
      "click": function($event) {
        _vm.$emit('input', !_vm.enabled)
      },
      "change": function($event) {
        var $$a = _vm.enabled,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.enabled = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.enabled = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.enabled = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-label"
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-handle"
  })])])])
},staticRenderFns: []}

/***/ }),
/* 1074 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-4"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-8"
  }, [_c('div', {
    staticClass: "yandex-map-opener"
  }, [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.open = !_vm.open
      }
    }
  }, [_vm._v("Уточнить на карте")])])])]), _vm._v(" "), _c('div', {
    staticClass: "yandex-map-container",
    class: {
      'yandex-map-container--open': _vm.open
    }
  }, [_c('tc-input', {
    staticClass: "mt-1",
    attrs: {
      "label-text": 'Координаты'
    },
    model: {
      value: (_vm.coordsString),
      callback: function($$v) {
        _vm.coordsString = $$v
      },
      expression: "coordsString"
    }
  }), _vm._v(" "), _c('yandex-map', {
    staticStyle: {
      "width": "100%",
      "height": "400px"
    },
    attrs: {
      "coords": _vm.mapCoord,
      "placemarks": _vm.placemarks,
      "zoom": "14",
      "map-type": "map"
    },
    on: {
      "map-was-initialized": _vm.initHandler
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),
/* 1075 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-4 col-form-label",
    attrs: {
      "for": "checkActive"
    }
  }, [_vm._v("Активность техцентра\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "col-8"
  }, [_c('label', {
    staticClass: "switch switch-lg switch-3d switch-primary mr-1"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.enabled),
      expression: "enabled"
    }],
    staticClass: "switch-input",
    attrs: {
      "id": "checkActive",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.enabled) ? _vm._i(_vm.enabled, null) > -1 : (_vm.enabled)
    },
    on: {
      "click": function($event) {
        _vm.$emit('input', !_vm.enabled)
      },
      "change": function($event) {
        var $$a = _vm.enabled,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.enabled = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.enabled = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.enabled = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-label"
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-handle"
  }), _vm._v(" "), (_vm.enabled) ? _c('small', [_vm._v("включен")]) : _c('small', [_vm._v("выключен")])])])])
},staticRenderFns: []}

/***/ }),
/* 1076 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover",
      modifiers: {
        "hover": true
      }
    }],
    attrs: {
      "title": _vm.tooltipTitle
    }
  }, [_c('div', {
    staticClass: "text-muted"
  }, [_c('i', {
    staticClass: "fa fa-map-marker"
  }), _vm._v(" " + _vm._s(_vm.order.techcenter.city.name) + " - " + _vm._s(_vm.order.techcenter.company.name) + "\n        ")]), _vm._v(" "), _c('span', {
    staticClass: "badge",
    style: ({
      backgroundColor: _vm.order.techcenter.color
    }),
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.viewTechcenter($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.order.techcenter.address))])])])
},staticRenderFns: []}

/***/ }),
/* 1077 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated fadeIn"
  }, [_c('div', {
    staticClass: "card admin"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_vm._v("\n            Список компаний\n            "), _c('div', {
    staticClass: "pull-right",
    staticStyle: {
      "margin-top": "7px"
    }
  }, [_c('button', {
    staticClass: "btn btn-secondary",
    class: {
      active: _vm.showFilter
    },
    attrs: {
      "data-toggle": "dropdown",
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.showFilter = !_vm.showFilter
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-filter"
  }), _vm._v(" Фильтр\n                ")]), _vm._v(" "), (_vm.currentUser.hasPermission('company.add')) ? _c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.showModal($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" Добавить компанию\n                ")]) : _vm._e()]), _vm._v(" "), (_vm.showFilter) ? _c('div', {
    staticClass: "mt-3 mt-lg-1"
  }, [_c('div', {
    staticClass: "row col-6"
  }, [_c('form', {
    attrs: {
      "сlass": "form-horizontal"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.search($event)
      }
    }
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-3 form-control-label"
  }, [_vm._v("Название")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.params.query),
      expression: "params.query"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.params.query)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.params, "query", $event.target.value)
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-6"
  })]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "card-block admin__list"
  }, [_vm._m(0), _vm._v(" "), (_vm.loading) ? _c('loading', {
    attrs: {
      "message": "Загружаем компании..."
    }
  }) : _vm._l((_vm.items), function(item) {
    return _c('div', {
      staticClass: "row mb-1 admin__list__item admin__list__item_hover-bg-gray"
    }, [_c('div', {
      staticClass: "col-1 d-none d-md-block"
    }, [_vm._v("\n                    " + _vm._s(item.id) + "\n                ")]), _vm._v(" "), _c('div', {
      staticClass: "col-6 col-md-2"
    }, [_vm._v("\n                   " + _vm._s(item.name) + "\n                ")]), _vm._v(" "), _c('div', {
      staticClass: "col-6 col-md-3 col-lg-2"
    }, _vm._l((item.users), function(user, index) {
      return _c('span', {
        staticClass: "badge badge-info"
      }, [_c('router-link', {
        attrs: {
          "to": {
            name: 'ViewProfile',
            params: {
              id: user.id
            }
          }
        }
      }, [_vm._v(_vm._s(user.fullname))])], 1)
    })), _vm._v(" "), _c('div', {
      staticClass: "col-6 col-md-2"
    }, [(item.enabled) ? _c('span', [_vm._v("Да")]) : _c('span', [_vm._v("Нет")])]), _vm._v(" "), _c('div', {
      staticClass: "col-6 col-md-2"
    }, [_vm._v("\n                    " + _vm._s(item.sort) + "\n                ")]), _vm._v(" "), _c('div', {
      staticClass: "col-6 col-md-2 col-lg-3"
    }, [(_vm.currentUser.hasPermission('company.update')) ? _c('button', {
      staticClass: "btn btn-primary btn-sm",
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.editItem(item)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-edit"
    }), _vm._v(" Изменить\n                    ")]) : _vm._e()])])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "card-header"
  }, [_c('b-pagination', {
    staticClass: "mb-0",
    attrs: {
      "size": "md",
      "total-rows": _vm.itemsPage.paginator.total_count,
      "per-page": _vm.itemsPage.paginator.limit
    },
    model: {
      value: (_vm.params.page),
      callback: function($$v) {
        _vm.$set(_vm.params, "page", $$v)
      },
      expression: "params.page"
    }
  })], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row mb-1 small text-muted"
  }, [_c('div', {
    staticClass: "col-1 d-none d-md-block"
  }, [_vm._v("Id")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-md-2"
  }, [_vm._v("Название")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-md-3 col-lg-2"
  }, [_vm._v("Руководители")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-md-2"
  }, [_vm._v("Включена")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-md-2"
  }, [_vm._v("Сортировка")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-md-2 col-lg-3"
  }, [_vm._v("Управление")])])
}]}

/***/ }),
/* 1078 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.loading) ? _c('loading', {
    attrs: {
      "message": "Загружаем историю..."
    }
  }) : _c('div', {
    staticClass: "steamline"
  }, _vm._l((_vm.logs), function(log) {
    return _c('div', {
      staticClass: "sl-item"
    }, [_c('div', {
      staticClass: "sl-left"
    }, [_c('img', {
      staticClass: "img-circle",
      attrs: {
        "src": _vm.getAvatarPath(log.user.avatar)
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "sl-right"
    }, [_c('div', [(_vm.user.isAdmin) ? _c('router-link', {
      attrs: {
        "to": {
          name: 'ViewProfile',
          params: {
            id: log.user.id
          }
        }
      }
    }, [_vm._v(_vm._s(log.user.fullname))]) : _c('span', [_vm._v(_vm._s(log.user.fullname))]), _vm._v(" "), _c('span', {
      staticClass: "sl-date"
    }, [_vm._v(_vm._s(log.diffForHumans) + " (" + _vm._s(log.date) + " в " + _vm._s(log.time) + ")")])], 1), _vm._v(" "), _c('div', {
      staticClass: "desc"
    }, [_vm._v(_vm._s(log.text))])])])
  }))
},staticRenderFns: []}

/***/ }),
/* 1079 */,
/* 1080 */,
/* 1081 */,
/* 1082 */,
/* 1083 */,
/* 1084 */,
/* 1085 */,
/* 1086 */,
/* 1087 */,
/* 1088 */,
/* 1089 */,
/* 1090 */,
/* 1091 */,
/* 1092 */,
/* 1093 */,
/* 1094 */,
/* 1095 */,
/* 1096 */,
/* 1097 */,
/* 1098 */,
/* 1099 */,
/* 1100 */,
/* 1101 */,
/* 1102 */,
/* 1103 */,
/* 1104 */,
/* 1105 */,
/* 1106 */,
/* 1107 */,
/* 1108 */,
/* 1109 */,
/* 1110 */,
/* 1111 */,
/* 1112 */,
/* 1113 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 1114 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(286);
module.exports = __webpack_require__(285);


/***/ })
]),[1114]);


// WEBPACK FOOTER //
// static/js/app.8165aa580b33270ca6b6.js